import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type AckCount = {
  __typename?: 'AckCount';
  _id?: Maybe<Scalars['String']['output']>;
  checked: Scalars['Float']['output'];
  day?: Maybe<Scalars['Float']['output']>;
  edited?: Maybe<Scalars['Int']['output']>;
  unchecked: Scalars['Float']['output'];
};

export type AckCountPerDay = {
  __typename?: 'AckCountPerDay';
  _id?: Maybe<Scalars['ID']['output']>;
  _id_turbine?: Maybe<Scalars['String']['output']>;
  confirmed?: Maybe<Scalars['Int']['output']>;
  day?: Maybe<Scalars['Int']['output']>;
  unAcknowledged?: Maybe<Scalars['Int']['output']>;
  unConfirmed?: Maybe<Scalars['Int']['output']>;
};

export type AckCountPortfolio = {
  __typename?: 'AckCountPortfolio';
  _id: Scalars['ID']['output'];
  _id_park: Scalars['String']['output'];
  unAcknowledged?: Maybe<Scalars['Int']['output']>;
  unConfirmed?: Maybe<Scalars['Int']['output']>;
};

export type ActualPowerVsForecast = {
  __typename?: 'ActualPowerVsForecast';
  actualPower: Scalars['Float']['output'];
  dayAheadForecast: Scalars['Float']['output'];
  regularForecast: Scalars['Float']['output'];
  unixTs: Scalars['Float']['output'];
};

export type AddAssetsInput = {
  assets?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id_ticket: Scalars['ID']['input'];
};

export type AddTicketCustomFieldInput = {
  name: Scalars['String']['input'];
  parent_id: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type AdgerPpaMonthly = {
  __typename?: 'AdgerPPAMonthly';
  VPPACompensation?: Maybe<Scalars['Float']['output']>;
  acctualDeliveredVolume?: Maybe<Scalars['Float']['output']>;
  annualRevenuesVariableVolume?: Maybe<Scalars['Float']['output']>;
  estimatedAnnualCorrection?: Maybe<Scalars['Float']['output']>;
  fixedCapacity?: Maybe<Scalars['Float']['output']>;
  fixedPrice?: Maybe<Scalars['Float']['output']>;
  fixedRevenues?: Maybe<Scalars['Float']['output']>;
  fixedVolume?: Maybe<Scalars['Float']['output']>;
  fixedVolumeFromBPPA?: Maybe<Scalars['Float']['output']>;
  hour: Scalars['String']['output'];
  hourlyRevenuesVariableVolume?: Maybe<Scalars['Float']['output']>;
  hourlyVariableVolume?: Maybe<Scalars['Float']['output']>;
  invoice?: Maybe<Scalars['Float']['output']>;
  period: Scalars['String']['output'];
  preliminaryMonthlyVariablePrice?: Maybe<Scalars['Float']['output']>;
  preliminaryYearlyVariablePrice?: Maybe<Scalars['Float']['output']>;
  spotPriceNO3EUR?: Maybe<Scalars['Float']['output']>;
  spotRevenue?: Maybe<Scalars['Float']['output']>;
};

export type AdgerPpaYearly = {
  __typename?: 'AdgerPPAYearly';
  accumulatedAnnualCorrectionTermMonthly?: Maybe<Scalars['Float']['output']>;
  actualDeliveredVolume?: Maybe<Scalars['Float']['output']>;
  actualDeliveredVolumeAcc?: Maybe<Scalars['Float']['output']>;
  annualCorrectionTermMonthly?: Maybe<Scalars['Float']['output']>;
  annualVariableRevenues?: Maybe<Scalars['Float']['output']>;
  fixedCapacity?: Maybe<Scalars['Float']['output']>;
  fixedContractCostMonthly?: Maybe<Scalars['Float']['output']>;
  fixedPrice?: Maybe<Scalars['Float']['output']>;
  fixedRevenues?: Maybe<Scalars['Float']['output']>;
  fixedVolume?: Maybe<Scalars['Float']['output']>;
  monthlyVariableRevenues?: Maybe<Scalars['Float']['output']>;
  monthlyVariableVolume?: Maybe<Scalars['Float']['output']>;
  netMonthlyInvoicedAmountFromAEVK?: Maybe<Scalars['Float']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  preliminaryMonthlyVariablePrice?: Maybe<Scalars['Float']['output']>;
  preliminaryYearlyVariablePrice?: Maybe<Scalars['Float']['output']>;
  spotPriceMonthlyAverage?: Maybe<Scalars['Float']['output']>;
  totalHoursInTheMonth?: Maybe<Scalars['Float']['output']>;
};

export type AggregatedAlarms = {
  __typename?: 'AggregatedAlarms';
  avgDuration?: Maybe<Scalars['Float']['output']>;
  avgDurationText?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  durationText?: Maybe<Scalars['String']['output']>;
};

export type AggregatedAlarmsSortInput = {
  avgDuration?: InputMaybe<Sort>;
  count?: InputMaybe<Sort>;
  duration?: InputMaybe<Sort>;
};

export type Aggregation = {
  __typename?: 'Aggregation';
  avg?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  stdDevPop?: Maybe<Scalars['Float']['output']>;
  sum?: Maybe<Scalars['Float']['output']>;
};

export type Alarm = {
  __typename?: 'Alarm';
  _id: Scalars['ID']['output'];
  _id_alarm?: Maybe<Scalars['String']['output']>;
  alarmCategory: AlarmCategory;
  alarmError?: Maybe<Array<Maybe<AlarmError>>>;
  alarmStatus?: Maybe<Array<Maybe<AlarmError>>>;
  alarmWarning?: Maybe<Array<Maybe<AlarmError>>>;
  alarms?: Maybe<Array<Maybe<AlarmError>>>;
  analytics?: Maybe<AlarmAnalytics>;
  closeTS?: Maybe<Scalars['Float']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  controlroomAck?: Maybe<Scalars['Boolean']['output']>;
  controlroomAckLog?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  controlroomTicketing?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  controlroomTicketingLog?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createTS?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  durationLong?: Maybe<Scalars['String']['output']>;
  durationSince?: Maybe<Scalars['String']['output']>;
  durationSinceLong?: Maybe<Scalars['String']['output']>;
  events?: Maybe<Array<Maybe<PlannedEvent>>>;
  hasPlannedEvent: Scalars['Boolean']['output'];
  isOpen: Scalars['Boolean']['output'];
  powerLosses?: Maybe<Scalars['Float']['output']>;
  processed?: Maybe<Scalars['Boolean']['output']>;
  production?: Maybe<Scalars['Float']['output']>;
  productionLoss?: Maybe<Scalars['Float']['output']>;
  subBlocks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  theoreticalProduction?: Maybe<Scalars['Float']['output']>;
  tickets?: Maybe<Array<Maybe<AlarmTicket>>>;
  turbine: Turbine;
};

export type AlarmAnalytics = {
  __typename?: 'AlarmAnalytics';
  stats?: Maybe<Array<Maybe<AlarmStats>>>;
  turbineStats?: Maybe<AlarmTurbineStats>;
};

export type AlarmAnalyticsLink = {
  __typename?: 'AlarmAnalyticsLink';
  source?: Maybe<Scalars['Int']['output']>;
  target?: Maybe<Scalars['Int']['output']>;
  uom?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type AlarmAnalyticsNode = {
  __typename?: 'AlarmAnalyticsNode';
  name?: Maybe<Scalars['String']['output']>;
  nodeId?: Maybe<Scalars['Int']['output']>;
};

export type AlarmAnalyticsOld = {
  __typename?: 'AlarmAnalyticsOld';
  _id?: Maybe<Scalars['ID']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  links: Array<Maybe<AlarmAnalyticsLink>>;
  nodes: Array<Maybe<AlarmAnalyticsNode>>;
};

export enum AlarmCategory {
  AlarmStop = 'ALARM_STOP',
  InService = 'IN_SERVICE',
  LimitedOperation = 'LIMITED_OPERATION',
  NoData = 'NO_DATA'
}

export type AlarmDismissRule = {
  __typename?: 'AlarmDismissRule';
  _id: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  mutTS: Scalars['Float']['output'];
};

export type AlarmError = {
  __typename?: 'AlarmError';
  code: Scalars['String']['output'];
  createTS: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type AlarmFollowUpMessages = {
  __typename?: 'AlarmFollowUpMessages';
  _id: Scalars['ID']['output'];
  createTS: Scalars['Float']['output'];
  message: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type AlarmFollowUpRule = {
  __typename?: 'AlarmFollowUpRule';
  _id: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  cutOffDate: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  message: Scalars['String']['output'];
  messages: Array<Maybe<AlarmFollowUpMessages>>;
  mutTS: Scalars['Float']['output'];
  user: Scalars['String']['output'];
};

export type AlarmSortInput = {
  alarmCategory?: InputMaybe<Sort>;
  closeTS?: InputMaybe<Sort>;
  code?: InputMaybe<Sort>;
  controlroomAck?: InputMaybe<Sort>;
  controlroomTicketing?: InputMaybe<Sort>;
  createTS?: InputMaybe<Sort>;
  description?: InputMaybe<Sort>;
  duration?: InputMaybe<Sort>;
  isOpen?: InputMaybe<Sort>;
  productionLoss?: InputMaybe<Sort>;
  turbineCode?: InputMaybe<Sort>;
};

export type AlarmStats = {
  __typename?: 'AlarmStats';
  avgDuration?: Maybe<Scalars['Float']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AlarmTicket = {
  __typename?: 'AlarmTicket';
  id?: Maybe<Scalars['String']['output']>;
  number_id?: Maybe<Scalars['String']['output']>;
};

export type AlarmTurbineStats = {
  __typename?: 'AlarmTurbineStats';
  alarmCount?: Maybe<Scalars['Float']['output']>;
  alarmDuration?: Maybe<Scalars['Float']['output']>;
  durationAvg?: Maybe<Scalars['Float']['output']>;
  durationTotal?: Maybe<Scalars['Float']['output']>;
};

export type AlarmWarning = {
  __typename?: 'AlarmWarning';
  code: Scalars['String']['output'];
  createTS: Scalars['Float']['output'];
  description: Scalars['String']['output'];
};

export type AlarmsOld = {
  __typename?: 'AlarmsOld';
  alarm_code?: Maybe<Scalars['String']['output']>;
  alarm_status?: Maybe<Scalars['Int']['output']>;
  cons_alarm?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['Float']['output']>;
  event_category?: Maybe<Scalars['Int']['output']>;
  event_direction?: Maybe<Scalars['Int']['output']>;
  event_series_indicator?: Maybe<Scalars['Int']['output']>;
  park?: Maybe<Scalars['String']['output']>;
  portfolio_id?: Maybe<Scalars['Int']['output']>;
  production_losses?: Maybe<Scalars['Float']['output']>;
  resolution_progress?: Maybe<Scalars['String']['output']>;
  revenues_losses?: Maybe<Scalars['Float']['output']>;
  service_report?: Maybe<Scalars['String']['output']>;
  software_version?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['Float']['output']>;
  turbine?: Maybe<Turbine>;
  turbine_id?: Maybe<Scalars['String']['output']>;
  turbine_serial?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type AlarmsOldWhere = {
  alarm_status?: InputMaybe<Scalars['Int']['input']>;
};

export type Analyze = {
  __typename?: 'Analyze';
  /** @deprecated Use filteredDataSeriesDeviation instead */
  dataSeriesDeviation: MixedDataSeriesDeviation;
  filteredDataSeries: Array<FilteredGroupedDataSeries>;
  filteredDataSeriesDeviation?: Maybe<Array<FilteredMixedDataSeriesDeviation>>;
  performanceDataSeries: MixedGroupedDataSeries;
  performanceDataSeriesDifferentSources: MixedGroupedDataSeries;
  performanceFacts: MixedFacts;
};


export type AnalyzeDataSeriesDeviationArgs = {
  endTs: Scalars['Float']['input'];
  startTs: Scalars['Float']['input'];
};


export type AnalyzeFilteredDataSeriesArgs = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  endTime: Scalars['Float']['input'];
  hours?: InputMaybe<Scalars['Int']['input']>;
  hoursOffset?: InputMaybe<Scalars['Int']['input']>;
  requestedSignals: Array<Scalars['String']['input']>;
  scaleDown?: InputMaybe<ScaleDownInput>;
  startTime: Scalars['Float']['input'];
  useDefaultValue?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AnalyzeFilteredDataSeriesDeviationArgs = {
  endTs: Scalars['Float']['input'];
  requestedSignals: Array<Scalars['String']['input']>;
  startTs: Scalars['Float']['input'];
};


export type AnalyzePerformanceDataSeriesArgs = {
  endTs?: InputMaybe<Scalars['Float']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  hoursOffset?: InputMaybe<Scalars['Int']['input']>;
  scaleDown?: InputMaybe<ScaleDownInput>;
  startTs?: InputMaybe<Scalars['Float']['input']>;
};


export type AnalyzePerformanceDataSeriesDifferentSourcesArgs = {
  endTs?: InputMaybe<Scalars['Float']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  hoursOffset?: InputMaybe<Scalars['Int']['input']>;
  scaleDown?: InputMaybe<ScaleDownInput>;
  startTs?: InputMaybe<Scalars['Float']['input']>;
};


export type AnalyzePerformanceFactsArgs = {
  endTs: Scalars['Float']['input'];
  startTs: Scalars['Float']['input'];
};

export type AssetData = {
  __typename?: 'AssetData';
  duration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  percentageVsTheo?: Maybe<Scalars['Float']['output']>;
  prod?: Maybe<Scalars['Float']['output']>;
  rev?: Maybe<Scalars['Float']['output']>;
};

export type AssignUserToTicketInput = {
  id_ticket: Scalars['ID']['input'];
  id_user: Scalars['ID']['input'];
};

export type Attributes = {
  __typename?: 'Attributes';
  company?: Maybe<Scalars['String']['output']>;
  config_formula_write?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  hydrolog_analyze_event_write?: Maybe<Scalars['String']['output']>;
  hydrolog_forecast_write?: Maybe<Scalars['String']['output']>;
  hydrolog_report_write?: Maybe<Scalars['String']['output']>;
  is_portfolio_admin?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  managed_by?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  sunlog_report_write?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  windlog_budget_write?: Maybe<Scalars['String']['output']>;
  windlog_logbook_write?: Maybe<Scalars['String']['output']>;
  windlog_maintain_write?: Maybe<Scalars['String']['output']>;
  windlog_predictive_write?: Maybe<Scalars['String']['output']>;
  windlog_report_write?: Maybe<Scalars['String']['output']>;
  windlog_troubleshoot_controlroom_read?: Maybe<Scalars['String']['output']>;
  windlog_troubleshoot_controlroom_write?: Maybe<Scalars['String']['output']>;
  windlog_troubleshoot_write?: Maybe<Scalars['String']['output']>;
  windlog_userpreferences_write?: Maybe<Scalars['String']['output']>;
};

export type Availability = {
  __typename?: 'Availability';
  chart?: Maybe<Array<Maybe<AvailabilityChart>>>;
  description?: Maybe<Scalars['String']['output']>;
  formula?: Maybe<Scalars['String']['output']>;
  isMain?: Maybe<Scalars['Boolean']['output']>;
  kpiIndex?: Maybe<Scalars['Int']['output']>;
  kpiSummaryView?: Maybe<KpiSummaryViewEnum>;
  name?: Maybe<Scalars['String']['output']>;
  rangeResult?: Maybe<Scalars['Float']['output']>;
  target?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  units?: Maybe<Scalars['String']['output']>;
  validatedBlocksOnly?: Maybe<Scalars['Boolean']['output']>;
  ytdResult?: Maybe<Scalars['Float']['output']>;
};

export type AvailabilityChart = {
  __typename?: 'AvailabilityChart';
  name?: Maybe<Scalars['String']['output']>;
  series?: Maybe<Array<Maybe<AvailabilityChartSeries>>>;
};

export type AvailabilityChartSeries = {
  __typename?: 'AvailabilityChartSeries';
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type AvailabilityInfo = {
  __typename?: 'AvailabilityInfo';
  total?: Maybe<TotalAvailabilityInfo>;
  totalLast30Days?: Maybe<TotalAvailabilityInfo>;
  totalPrevious30Days?: Maybe<TotalAvailabilityInfo>;
};

export type AvailabilityPark = {
  __typename?: 'AvailabilityPark';
  _id?: Maybe<Scalars['String']['output']>;
  availabilities?: Maybe<Array<Maybe<Availability>>>;
  contractualTarget?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['Float']['output']>;
  dateString?: Maybe<Scalars['String']['output']>;
  fe_name?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['String']['output']>;
  kpiQuantity?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  serialNav?: Maybe<Scalars['Float']['output']>;
};

export type AvgAreaPrice = {
  __typename?: 'AvgAreaPrice';
  avgAreaPrice?: Maybe<Scalars['Float']['output']>;
  month: Scalars['String']['output'];
};

export type AvgCapturedPrice = {
  __typename?: 'AvgCapturedPrice';
  avgCapturedPrice?: Maybe<Scalars['Float']['output']>;
  month: Scalars['String']['output'];
};

export type Board = {
  __typename?: 'Board';
  _id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  statuses?: Maybe<Array<Maybe<Status>>>;
};

export type BudgetData = {
  __typename?: 'BudgetData';
  production?: Maybe<BudgetValue>;
  revenue?: Maybe<BudgetValue>;
};

export type BudgetFollowUp = {
  __typename?: 'BudgetFollowUp';
  budget?: Maybe<BudgetTotalData>;
  compensated?: Maybe<Compensated>;
  day?: Maybe<Scalars['Int']['output']>;
  delivered?: Maybe<Delivered>;
  invoiceComment?: Maybe<Comment>;
  invoiceFiles?: Maybe<Array<Maybe<InvoiceFile>>>;
  isInvoiced?: Maybe<Scalars['Boolean']['output']>;
  lastUpdate?: Maybe<LastUpdate>;
  month?: Maybe<Scalars['Int']['output']>;
  theoretical?: Maybe<BudgetTotalData>;
  total?: Maybe<BudgetTotalData>;
  year?: Maybe<Scalars['Int']['output']>;
};

export enum BudgetGranularity {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Yearly = 'YEARLY'
}

export type BudgetTotalData = {
  __typename?: 'BudgetTotalData';
  production?: Maybe<TotalValue>;
  revenue?: Maybe<TotalValue>;
};

export type BudgetTotalValue = {
  __typename?: 'BudgetTotalValue';
  accumulated?: Maybe<NumberObject>;
  total?: Maybe<NumberObject>;
};

export type BudgetValue = {
  __typename?: 'BudgetValue';
  contribution?: Maybe<NumberObject>;
  total?: Maybe<NumberObject>;
};

export enum Celcius {
  Fahrenheit = 'FAHRENHEIT',
  Kelvin = 'KELVIN'
}

export type ChangeLog = {
  action: Scalars['String']['output'];
  date: Scalars['Float']['output'];
  subject?: Maybe<Subject>;
};

export type ChangeOrderStatusInput = {
  id_board: Scalars['ID']['input'];
  id_status: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
};

export type ChangeTicketCustomFieldInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  parent_id?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ChangeTicketCustomFieldNameInput = {
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ChangeTicketPriorityInput = {
  id_ticket: Scalars['ID']['input'];
  priority: TicketPriority;
};

export type ChangeTicketStatusInput = {
  id_status: Scalars['ID']['input'];
  id_ticket: Scalars['ID']['input'];
};

export type ChangeTicketTitleInput = {
  id_ticket: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type Channel = {
  __typename?: 'Channel';
  _id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  param?: Maybe<Scalars['String']['output']>;
};

export type ChartSettings = {
  manufacturerPCs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scatterPlotPCs?: InputMaybe<ScaterPlotDataType>;
  turbinePCs?: InputMaybe<Array<InputMaybe<TurbinePcConfiguration>>>;
};

export type CmsAlarm = {
  __typename?: 'CmsAlarm';
  detectionTS?: Maybe<Scalars['Float']['output']>;
  deviation?: Maybe<Scalars['Float']['output']>;
  signal?: Maybe<Scalars['String']['output']>;
  signalName?: Maybe<Scalars['String']['output']>;
  temp?: Maybe<Scalars['Float']['output']>;
  tempAvg?: Maybe<Scalars['Float']['output']>;
  trend?: Maybe<Scalars['String']['output']>;
  turbineCode?: Maybe<Scalars['String']['output']>;
  turbineSerial?: Maybe<Scalars['String']['output']>;
  turbineSerialNav?: Maybe<Scalars['Float']['output']>;
};

export type Comment = {
  __typename?: 'Comment';
  comment?: Maybe<Scalars['String']['output']>;
  lastUpdate?: Maybe<LastUpdate>;
};

export type CommenteCreateChangeLog = ChangeLog & {
  __typename?: 'CommenteCreateChangeLog';
  action: Scalars['String']['output'];
  date: Scalars['Float']['output'];
  subject?: Maybe<Subject>;
};

export type CommenteDeleteChangeLog = ChangeLog & {
  __typename?: 'CommenteDeleteChangeLog';
  action: Scalars['String']['output'];
  date: Scalars['Float']['output'];
  subject?: Maybe<Subject>;
};

export type Compensated = {
  __typename?: 'Compensated';
  invoice?: Maybe<BudgetData>;
  isInvoiced?: Maybe<Scalars['Boolean']['output']>;
  logbook?: Maybe<BudgetData>;
  production?: Maybe<BudgetTotalValue>;
  revenue?: Maybe<BudgetTotalValue>;
};

export type ComponentAlarm = {
  __typename?: 'ComponentAlarm';
  deviation?: Maybe<Scalars['Float']['output']>;
  signal?: Maybe<Scalars['String']['output']>;
  signalName?: Maybe<Scalars['String']['output']>;
  temp?: Maybe<Scalars['Float']['output']>;
  tempAvg?: Maybe<Scalars['Float']['output']>;
};

export type ComponentCondition = {
  __typename?: 'ComponentCondition';
  WCNV1_CnvTmpChokeCoil2_avg_mag_f: ComponentConditionResult;
  WCNV1_CnvTmpChokeCoil3_avg_mag_f: ComponentConditionResult;
  WCNV1_CnvTmpChokeCoil_avg_mag_f: ComponentConditionResult;
  WCNV1_CnvTmpDclink_avg_mag_f: ComponentConditionResult;
  WCNV1_CnvTmpWater_avg_mag_f: ComponentConditionResult;
  WCNV2_CnvTmpDclink_avg_mag_f: ComponentConditionResult;
  WCNV3_CnvTmpDclink_avg_mag_f: ComponentConditionResult;
  WCNV4_CnvTmpDclink_avg_mag_f: ComponentConditionResult;
  WCNV5_CnvTmpDclink_avg_mag_f: ComponentConditionResult;
  WCNV6_CnvTmpDclink_avg_mag_f: ComponentConditionResult;
  WCNV7_CnvTmpDclink_avg_mag_f: ComponentConditionResult;
  WCNV8_CnvTmpDclink_avg_mag_f: ComponentConditionResult;
  WCNV9_CnvTmpDclink_avg_mag_f: ComponentConditionResult;
  WCNV10_CnvTmpDclink_avg_mag_f: ComponentConditionResult;
  WCNV11_CnvTmpDclink_avg_mag_f: ComponentConditionResult;
  WGEN1_GnTmpBrg1_avg_mag_f: ComponentConditionResult;
  WGEN1_GnTmpBrg2_avg_mag_f: ComponentConditionResult;
  WGEN1_GnTmpInlet_avg_mag_f: ComponentConditionResult;
  WGEN1_GnTmpOutlet_avg_mag_f: ComponentConditionResult;
  WGEN1_GnTmpPhase1_avg_mag_f: ComponentConditionResult;
  WGEN1_GnTmpPhase2_avg_mag_f: ComponentConditionResult;
  WGEN1_GnTmpPhase3_avg_mag_f: ComponentConditionResult;
  WGEN1_GnTmpRtr_avg_mag_f: ComponentConditionResult;
  WGEN1_GnTmpSlpRing1_avg_mag_f: ComponentConditionResult;
  WGEN1_GnTmpSta_avg_mag_f: ComponentConditionResult;
  WNAC1_CtrCabTmp_avg_mag_f: ComponentConditionResult;
  WNAC1_ExTmp_avg_mag_f: ComponentConditionResult;
  WNAC1_IntlTmp_avg_mag_f: ComponentConditionResult;
  WROT1_CtrCabTmp2_avg_mag_f: ComponentConditionResult;
  WROT1_CtrCabTmp3_avg_mag_f: ComponentConditionResult;
  WROT1_CtrCabTmp_avg_mag_f: ComponentConditionResult;
  WROT1_HubTmp_avg_mag_f: ComponentConditionResult;
  WROT1_PtHyOilTmp_avg_mag_f: ComponentConditionResult;
  WROT1_TmpBl1_avg_mag_f: ComponentConditionResult;
  WROT1_TmpBl2_avg_mag_f: ComponentConditionResult;
  WROT1_TmpBl3_avg_mag_f: ComponentConditionResult;
  WTOW1_CtrCabTmp_avg_mag_f: ComponentConditionResult;
  WTRF1_RoomTmp_avg_mag_f: ComponentConditionResult;
  WTRF1_TrfOilTmp_avg_mag_f: ComponentConditionResult;
  WTRF1_TrfTmpPhase1_avg_mag_f: ComponentConditionResult;
  WTRF1_TrfTmpPhase2_avg_mag_f: ComponentConditionResult;
  WTRF1_TrfTmpPhase3_avg_mag_f: ComponentConditionResult;
  WTRM1_TrmTmpGbxBrg1_avg_mag_f: ComponentConditionResult;
  WTRM1_TrmTmpGbxBrg2_avg_mag_f: ComponentConditionResult;
  WTRM1_TrmTmpGbxBrg3_avg_mag_f: ComponentConditionResult;
  WTRM1_TrmTmpGbxOil_avg_mag_f: ComponentConditionResult;
  WTRM1_TrmTmpShfBrg1_avg_mag_f: ComponentConditionResult;
  WTRM1_TrmTmpShfBrg2_avg_mag_f: ComponentConditionResult;
  WTRM1_TrmTmpShfBrk_avg_mag_f: ComponentConditionResult;
};

export type ComponentConditionAllData = {
  __typename?: 'ComponentConditionAllData';
  data?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  intervalTS?: Maybe<Scalars['Int']['output']>;
  lastTS?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startingTS?: Maybe<Scalars['Float']['output']>;
};

export type ComponentConditionResp = {
  __typename?: 'ComponentConditionResp';
  deviation?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  temp?: Maybe<Scalars['Float']['output']>;
  tempAvg?: Maybe<Scalars['Float']['output']>;
};

export type ComponentConditionResult = {
  __typename?: 'ComponentConditionResult';
  status?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type ControlSystem = {
  __typename?: 'ControlSystem';
  _id?: Maybe<Scalars['ID']['output']>;
  _id_park?: Maybe<Scalars['ID']['output']>;
  _id_portfolio?: Maybe<Scalars['ID']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  codeDisplay?: Maybe<Scalars['String']['output']>;
  dataGranularity?: Maybe<DataGranularityEnum>;
  name?: Maybe<Scalars['String']['output']>;
  signalsList?: Maybe<Array<Maybe<ControlSystemSignal>>>;
};


export type ControlSystemSignalsListArgs = {
  stream?: InputMaybe<Array<InputMaybe<Stream>>>;
};

export type ControlSystemSignal = {
  __typename?: 'ControlSystemSignal';
  _id?: Maybe<Scalars['ID']['output']>;
  dbName?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  stream?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  taxonomyName?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type ControlSystemSignalsWhereInput = {
  AND?: InputMaybe<Array<ControlSystemSignalsWhereInput>>;
  OR?: InputMaybe<Array<ControlSystemSignalsWhereInput>>;
  _id?: InputMaybe<Scalars['String']['input']>;
  dbName?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  taxonomyName?: InputMaybe<Scalars['String']['input']>;
};

export type ControlSystemWhereInput = {
  AND?: InputMaybe<Array<ControlSystemWhereInput>>;
  OR?: InputMaybe<Array<ControlSystemWhereInput>>;
  _id?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  codeDisplay?: InputMaybe<Scalars['String']['input']>;
  dataGranularity?: InputMaybe<DataGranularityEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Country = {
  __typename?: 'Country';
  _id: Scalars['ID']['output'];
  budget?: Maybe<Array<Maybe<BudgetFollowUp>>>;
  budgetYTD?: Maybe<BudgetData>;
  code: Scalars['String']['output'];
  country_image: Scalars['String']['output'];
  data: Data;
  dataSeries?: Maybe<DataSeries>;
  energyMeterAvailable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parks: Array<Park>;
  reference: Reference;
};


export type CountryBudgetArgs = {
  granularity: BudgetGranularity;
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type CountryDataSeriesArgs = {
  hours?: InputMaybe<Scalars['Int']['input']>;
  hoursOffset?: InputMaybe<Scalars['Int']['input']>;
};


export type CountryParksArgs = {
  sort?: InputMaybe<ParkSortInput>;
};

export type CountrySortInput = {
  code?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
};

export type CountryWhereInput = {
  AND?: InputMaybe<Array<CountryWhereInput>>;
  OR?: InputMaybe<Array<CountryWhereInput>>;
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Cpu = {
  __typename?: 'Cpu';
  model: Scalars['String']['output'];
  speed: Scalars['Int']['output'];
  times?: Maybe<CpuTime>;
};

export type CpuTime = {
  __typename?: 'CpuTime';
  idle?: Maybe<Scalars['Int']['output']>;
  irq?: Maybe<Scalars['Int']['output']>;
  nice?: Maybe<Scalars['Int']['output']>;
  sys?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<Scalars['Int']['output']>;
};

export type CreateDataAnalysisQueryInput = {
  endTs: Scalars['Float']['input'];
  granularity: Scalars['String']['input'];
  isSharedQuery: Scalars['Boolean']['input'];
  period: DataAnalysisPeriod;
  queryType: DataAnalysisQueryType;
  series: Array<DataAnalysisSeriesInput>;
  startTs: Scalars['Float']['input'];
  title: Scalars['String']['input'];
};

export type CreateTicketInput = {
  assets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_board: Scalars['ID']['input'];
  id_status?: InputMaybe<Scalars['ID']['input']>;
  id_template?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
};

export type CreatedChangeLog = ChangeLog & {
  __typename?: 'CreatedChangeLog';
  action: Scalars['String']['output'];
  date: Scalars['Float']['output'];
  subject?: Maybe<Subject>;
  ticketNumber: Scalars['Int']['output'];
};

export type Currency = {
  __typename?: 'Currency';
  _id: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

export type CustomChangeLog = ChangeLog & {
  __typename?: 'CustomChangeLog';
  action: Scalars['String']['output'];
  current: Scalars['String']['output'];
  date: Scalars['Float']['output'];
  field: Scalars['String']['output'];
  previous?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Subject>;
};

export type CustomField = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  parentId: Scalars['ID']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type CustomFieldCheckbox = CustomField & {
  __typename?: 'CustomFieldCheckbox';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  parentId: Scalars['ID']['output'];
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomFieldChecklist = CustomField & {
  __typename?: 'CustomFieldChecklist';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  parentId: Scalars['ID']['output'];
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Array<Maybe<CustomOption>>>;
};

export type CustomFieldDate = CustomField & {
  __typename?: 'CustomFieldDate';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  parentId: Scalars['ID']['output'];
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type CustomFieldDropdown = CustomField & {
  __typename?: 'CustomFieldDropdown';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  parentId: Scalars['ID']['output'];
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Array<Maybe<CustomOption>>>;
};

export type CustomFieldGroup = CustomField & {
  __typename?: 'CustomFieldGroup';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  parentId: Scalars['ID']['output'];
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Array<Maybe<CustomField>>>;
};

export type CustomFieldNumber = CustomField & {
  __typename?: 'CustomFieldNumber';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  parentId: Scalars['ID']['output'];
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type CustomFieldString = CustomField & {
  __typename?: 'CustomFieldString';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  parentId: Scalars['ID']['output'];
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CustomOption = {
  __typename?: 'CustomOption';
  checked?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CustomPortfolioWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  defaultPortfolio?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomProductionLossCalculation = {
  __typename?: 'CustomProductionLossCalculation';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  production_loss_calculation?: Maybe<Array<Maybe<ProductionLossCalculation>>>;
};

export type Data = {
  __typename?: 'Data';
  LDAT1_TmUTC_setTm_rounded?: Maybe<Scalars['Float']['output']>;
  LPHD1_PhyHealth_stVal?: Maybe<Aggregation>;
  MMXU1_A_phsA_cVal_mag_f?: Maybe<Aggregation>;
  MMXU1_A_phsB_cVal_mag_f?: Maybe<Aggregation>;
  MMXU1_A_phsC_cVal_mag_f?: Maybe<Aggregation>;
  MMXU1_Hz_mag_f?: Maybe<Aggregation>;
  MMXU1_PhV_phsA_cVal_mag_f?: Maybe<Aggregation>;
  MMXU1_PhV_phsB_cVal_mag_f?: Maybe<Aggregation>;
  MMXU1_PhV_phsC_cVal_mag_f?: Maybe<Aggregation>;
  MMXU1_TotPF_mag_f?: Maybe<Aggregation>;
  WCNV1_CnvTmpChokeCoil_mag_f?: Maybe<Aggregation>;
  WCNV1_CnvTmpDclink_mag_f?: Maybe<Aggregation>;
  WCNV1_CnvTmpWater_mag_f?: Maybe<Aggregation>;
  WGEN1_GnTmpBrg1_mag_f?: Maybe<Aggregation>;
  WGEN1_GnTmpBrg2_mag_f?: Maybe<Aggregation>;
  WGEN1_GnTmpInlet_mag_f?: Maybe<Aggregation>;
  WGEN1_GnTmpOutlet_mag_f?: Maybe<Aggregation>;
  WGEN1_GnTmpPhase1_mag_f?: Maybe<Aggregation>;
  WGEN1_GnTmpPhase2_mag_f?: Maybe<Aggregation>;
  WGEN1_GnTmpPhase3_mag_f?: Maybe<Aggregation>;
  WGEN1_GnTmpRtr_mag_f?: Maybe<Aggregation>;
  WGEN1_GnTmpSlpRing1_mag_f?: Maybe<Aggregation>;
  WGEN1_GnTmpSlpRing2_mag_f?: Maybe<Aggregation>;
  WGEN1_GnTmpSta_mag_f?: Maybe<Aggregation>;
  WGEN1_Spd_mag_f?: Maybe<Aggregation>;
  WNAC1_CtrCabTmp_mag_f?: Maybe<Aggregation>;
  WNAC1_Dir_mag_f?: Maybe<Aggregation>;
  WNAC1_ExTmp_mag_f?: Maybe<Aggregation>;
  WNAC1_IntlTmp_mag_f?: Maybe<Aggregation>;
  WNAC1_WdDir_mag_f?: Maybe<Aggregation>;
  WNAC1_WdSpd_c_mag_f?: Maybe<Aggregation>;
  WNAC1_WdSpd_mag_f?: Maybe<Aggregation>;
  WROT1_CtrCabTmp_mag_f?: Maybe<Aggregation>;
  WROT1_HubTmp_mag_f?: Maybe<Aggregation>;
  WROT1_PtAngValBl1_mag_f?: Maybe<Aggregation>;
  WROT1_PtAngValBl2_mag_f?: Maybe<Aggregation>;
  WROT1_PtAngValBl3_mag_f?: Maybe<Aggregation>;
  WROT1_PtHyOilTmp_mag_f?: Maybe<Aggregation>;
  WROT1_PtHyPresBl1_mag_f?: Maybe<Aggregation>;
  WROT1_PtHyPresBl2_mag_f?: Maybe<Aggregation>;
  WROT1_PtHyPresBl3_mag_f?: Maybe<Aggregation>;
  WROT1_RotSpd_mag_f?: Maybe<Aggregation>;
  WTRF1_TrfTmpPhase1_mag_f?: Maybe<Aggregation>;
  WTRF1_TrfTmpPhase2_mag_f?: Maybe<Aggregation>;
  WTRF1_TrfTmpPhase3_mag_f?: Maybe<Aggregation>;
  WTRM1_BrkHyPres_mag_f?: Maybe<Aggregation>;
  WTRM1_GbxOilPres_mag_f?: Maybe<Aggregation>;
  WTRM1_TrmTmpGbxBrg1_mag_f?: Maybe<Aggregation>;
  WTRM1_TrmTmpGbxBrg2_mag_f?: Maybe<Aggregation>;
  WTRM1_TrmTmpGbxBrg3_mag_f?: Maybe<Aggregation>;
  WTRM1_TrmTmpGbxOil_mag_f?: Maybe<Aggregation>;
  WTRM1_TrmTmpShfBrg1_mag_f?: Maybe<Aggregation>;
  WTRM1_TrmTmpShfBrg2_mag_f?: Maybe<Aggregation>;
  WTUR1_AvlTmRs_tmTot?: Maybe<Aggregation>;
  WTUR1_MW_loss?: Maybe<Aggregation>;
  WTUR1_MW_mag_f?: Maybe<Aggregation>;
  WTUR1_MW_rated?: Maybe<Aggregation>;
  WTUR1_MW_theoretical?: Maybe<Aggregation>;
  WTUR1_OpTmRs_tmTot?: Maybe<Aggregation>;
  WTUR1_TotVArh_actVal?: Maybe<Aggregation>;
  WTUR1_TotWh_actVal?: Maybe<Aggregation>;
  WTUR1_TurMaint_actSt_stVal?: Maybe<Aggregation>;
  WTUR1_TurSt_actSt_stVal?: Maybe<Aggregation>;
  WTUR1_VAr_mag_f?: Maybe<Aggregation>;
  WTUR1_W_loss?: Maybe<Aggregation>;
  WTUR1_W_mag_f?: Maybe<Aggregation>;
  WTUR1_W_rated?: Maybe<Aggregation>;
  WTUR1_W_theoretical?: Maybe<Aggregation>;
  WTUR1_kW_loss?: Maybe<Aggregation>;
  WTUR1_kW_mag_f?: Maybe<Aggregation>;
  WTUR1_kW_rated?: Maybe<Aggregation>;
  WTUR1_kW_theoretical?: Maybe<Aggregation>;
  WTUR1_per_efficiency?: Maybe<Aggregation>;
  WTUR1_per_loadFactor?: Maybe<Aggregation>;
  WTUR1_status?: Maybe<Aggregation>;
  WYAW1_BrkPres_mag_f?: Maybe<Aggregation>;
  WYAW1_CabWup_mag_f?: Maybe<Aggregation>;
  WYAW1_YawAng_mag_f?: Maybe<Aggregation>;
};

export type Data10M = {
  __typename?: 'Data10M';
  WCNV1_CnvTmpDclink_avg_mag_f?: Maybe<Aggregation>;
  WCNV2_CnvTmpDclink_avg_mag_f?: Maybe<Aggregation>;
  WCNV3_CnvTmpDclink_avg_mag_f?: Maybe<Aggregation>;
  WCNV4_CnvTmpDclink_avg_mag_f?: Maybe<Aggregation>;
  WCNV5_CnvTmpDclink_avg_mag_f?: Maybe<Aggregation>;
  WCNV6_CnvTmpDclink_avg_mag_f?: Maybe<Aggregation>;
  WCNV7_CnvTmpDclink_avg_mag_f?: Maybe<Aggregation>;
  WCNV8_CnvTmpDclink_avg_mag_f?: Maybe<Aggregation>;
  WCNV9_CnvTmpDclink_avg_mag_f?: Maybe<Aggregation>;
  WCNV10_CnvTmpDclink_avg_mag_f?: Maybe<Aggregation>;
  WCNV11_CnvTmpDclink_avg_mag_f?: Maybe<Aggregation>;
  WGEN1_GnTmpRtr_avg_mag_f?: Maybe<Aggregation>;
  WGEN1_GnTmpSta_avg_mag_f?: Maybe<Aggregation>;
  WGEN1_Spd_avg_mag_f?: Maybe<Aggregation>;
  WGEN1_Spd_max_mag_f?: Maybe<Aggregation>;
  WGEN1_Spd_min_mag_f?: Maybe<Aggregation>;
  WNAC1_CtrCabTmp_avg_mag_f?: Maybe<Aggregation>;
  WNAC1_Dir_avg_mag_f?: Maybe<Aggregation>;
  WNAC1_ExTmp_avg_mag_f?: Maybe<Aggregation>;
  WNAC1_IntlTmp_avg_mag_f?: Maybe<Aggregation>;
  WNAC1_WdDir_avg_mag_f?: Maybe<Aggregation>;
  WNAC1_WdSpd_avg_mag_f?: Maybe<Aggregation>;
  WROT1_CtrCabTmp2_avg_mag_f?: Maybe<Aggregation>;
  WROT1_CtrCabTmp3_avg_mag_f?: Maybe<Aggregation>;
  WROT1_CtrCabTmp_avg_mag_f?: Maybe<Aggregation>;
  WROT1_HubTmp_avg_mag_f?: Maybe<Aggregation>;
  WROT1_RotSpd_avg_mag_f?: Maybe<Aggregation>;
  WROT1_RotSpd_max_mag_f?: Maybe<Aggregation>;
  WROT1_RotSpd_min_mag_f?: Maybe<Aggregation>;
  WROT1_TmpBl1_avg_mag_f?: Maybe<Aggregation>;
  WROT1_TmpBl2_avg_mag_f?: Maybe<Aggregation>;
  WROT1_TmpBl3_avg_mag_f?: Maybe<Aggregation>;
  WTOW1_CtrCabTmp_avg_mag_f?: Maybe<Aggregation>;
  WTRF1_TrfTmpPhase1_avg_mag_f?: Maybe<Aggregation>;
  WTRF1_TrfTmpPhase2_avg_mag_f?: Maybe<Aggregation>;
  WTRF1_TrfTmpPhase3_avg_mag_f?: Maybe<Aggregation>;
  WTRM1_TrmTmpShfBrg1_avg_mag_f?: Maybe<Aggregation>;
  WTRM1_TrmTmpShfBrg2_avg_mag_f?: Maybe<Aggregation>;
  WTUR1_MW_avg_mag_f?: Maybe<Aggregation>;
  WTUR1_MW_avg_theoretical?: Maybe<Aggregation>;
  WTUR1_VAr_avg_mag_f?: Maybe<Aggregation>;
  WTUR1_W_avg_mag_f?: Maybe<Aggregation>;
  WTUR1_W_avg_theoretical?: Maybe<Aggregation>;
  WTUR1_kW_avg_mag_f?: Maybe<Aggregation>;
  WTUR1_kW_avg_theoretical?: Maybe<Aggregation>;
  WYAW1_CabWup_avg_mag_f?: Maybe<Aggregation>;
  WYAW1_YawAng_avg_mag_f?: Maybe<Aggregation>;
};

export enum DataAnalysisAggregation {
  Avg = 'AVG',
  Max = 'MAX',
  Min = 'MIN',
  Sum = 'SUM'
}

export enum DataAnalysisPeriod {
  Custom = 'Custom',
  Day = 'Day',
  Month = 'Month',
  Week = 'Week',
  Year = 'Year'
}

export type DataAnalysisQuery = {
  __typename?: 'DataAnalysisQuery';
  _id: Scalars['ID']['output'];
  assetIdYs?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  assetIds: Array<Maybe<Scalars['ID']['output']>>;
  createdById: Scalars['ID']['output'];
  createdByUsername: Scalars['String']['output'];
  endTs: Scalars['Float']['output'];
  granularity: Scalars['String']['output'];
  isSharedQuery: Scalars['Boolean']['output'];
  numberOfSeries: Scalars['Int']['output'];
  parkIds: Array<Maybe<Scalars['ID']['output']>>;
  period: DataAnalysisPeriod;
  queryNumber: Scalars['Int']['output'];
  queryType: DataAnalysisQueryType;
  relatedReports?: Maybe<Array<Maybe<RelatedReports>>>;
  series?: Maybe<Array<Maybe<DataAnalysisSeries>>>;
  startTs: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type DataAnalysisQueryList = {
  __typename?: 'DataAnalysisQueryList';
  dataAnalysisQueries: Array<Maybe<DataAnalysisQuery>>;
  totalCount: Scalars['Int']['output'];
};

export enum DataAnalysisQueryType {
  PowerCurve = 'POWER_CURVE',
  ScatterPlot = 'SCATTER_PLOT',
  Timeseries = 'TIMESERIES'
}

export type DataAnalysisSeries = {
  __typename?: 'DataAnalysisSeries';
  _id: Scalars['ID']['output'];
  aggregation: DataAnalysisAggregation;
  assetId: Scalars['ID']['output'];
  assetIdY?: Maybe<Scalars['ID']['output']>;
  colorHex: Scalars['String']['output'];
  deviceCode?: Maybe<Scalars['String']['output']>;
  deviceCodeY?: Maybe<Scalars['String']['output']>;
  deviceDisplayName?: Maybe<Scalars['String']['output']>;
  deviceName: Scalars['String']['output'];
  deviceNameY?: Maybe<Scalars['String']['output']>;
  deviceType: DeviceType;
  deviceTypeY?: Maybe<DeviceType>;
  granularity: Scalars['String']['output'];
  graphDashStyle?: Maybe<Scalars['String']['output']>;
  graphDataMarker: GraphDataMarker;
  graphDataType: Scalars['String']['output'];
  graphIsStep?: Maybe<Scalars['Boolean']['output']>;
  graphType: Scalars['String']['output'];
  parkDisplayName: Scalars['String']['output'];
  parkId?: Maybe<Scalars['ID']['output']>;
  parkName: Scalars['String']['output'];
  queryDataType: QueryDataTypeEnum;
  signal: Scalars['String']['output'];
  signalName: Scalars['String']['output'];
  signalNameY?: Maybe<Scalars['String']['output']>;
  signalUnit: Scalars['String']['output'];
  signalUnitY?: Maybe<Scalars['String']['output']>;
  signalY?: Maybe<Scalars['String']['output']>;
  visible: Scalars['Boolean']['output'];
  yAxisMax?: Maybe<Scalars['Float']['output']>;
  yAxisMin?: Maybe<Scalars['Float']['output']>;
};

export type DataAnalysisSeriesInput = {
  aggregation: DataAnalysisAggregation;
  assetId: Scalars['ID']['input'];
  assetIdY?: InputMaybe<Scalars['ID']['input']>;
  colorHex: Scalars['String']['input'];
  deviceType: DeviceType;
  deviceTypeY?: InputMaybe<DeviceType>;
  granularity: Scalars['String']['input'];
  graphDashStyle?: InputMaybe<Scalars['String']['input']>;
  graphDataMarker: GraphDataMarkerInput;
  graphDataType: Scalars['String']['input'];
  graphIsStep?: InputMaybe<Scalars['Boolean']['input']>;
  graphType: Scalars['String']['input'];
  parkId?: InputMaybe<Scalars['ID']['input']>;
  queryDataType: QueryDataTypeEnum;
  signal: Scalars['String']['input'];
  signalName: Scalars['String']['input'];
  signalNameY?: InputMaybe<Scalars['String']['input']>;
  signalUnit: Scalars['String']['input'];
  signalUnitY?: InputMaybe<Scalars['String']['input']>;
  signalY?: InputMaybe<Scalars['String']['input']>;
  visible: Scalars['Boolean']['input'];
  yAxisMax?: InputMaybe<Scalars['Float']['input']>;
  yAxisMin?: InputMaybe<Scalars['Float']['input']>;
};

export enum DataGranularityEnum {
  Data_10M = 'DATA_10M',
  DataLive = 'DATA_LIVE'
}

export type DataQualityFlaggedPointType = {
  __typename?: 'DataQualityFlaggedPointType';
  description: Scalars['String']['output'];
  flag: Scalars['String']['output'];
  timestamp: Scalars['Float']['output'];
  turbineId: Scalars['ID']['output'];
  windSpeedValue?: Maybe<Scalars['Float']['output']>;
};

export type DataSerieResult = {
  __typename?: 'DataSerieResult';
  data?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  intervalTS?: Maybe<Scalars['Int']['output']>;
  lastTS?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  startingTS?: Maybe<Scalars['Float']['output']>;
};

export type DataSeries = {
  __typename?: 'DataSeries';
  ALARM_STATUS: DataSerieResult;
  M02_CUS30_STATUS_BLOCK: DataSerieResult;
  WCNV1_CnvTmpChokeCoil2_avg_mag_f: DataSerieResult;
  WCNV1_CnvTmpChokeCoil3_avg_mag_f: DataSerieResult;
  WCNV1_CnvTmpChokeCoil_avg_mag_f: DataSerieResult;
  WCNV1_CnvTmpDclink_avg_mag_f: DataSerieResult;
  WCNV1_CnvTmpWater_avg_mag_f: DataSerieResult;
  WCNV2_CnvTmpDclink_avg_mag_f: DataSerieResult;
  WCNV3_CnvTmpDclink_avg_mag_f: DataSerieResult;
  WCNV4_CnvTmpDclink_avg_mag_f: DataSerieResult;
  WCNV5_CnvTmpDclink_avg_mag_f: DataSerieResult;
  WCNV6_CnvTmpDclink_avg_mag_f: DataSerieResult;
  WCNV7_CnvTmpDclink_avg_mag_f: DataSerieResult;
  WCNV8_CnvTmpDclink_avg_mag_f: DataSerieResult;
  WCNV9_CnvTmpDclink_avg_mag_f: DataSerieResult;
  WCNV10_CnvTmpDclink_avg_mag_f: DataSerieResult;
  WCNV11_CnvTmpDclink_avg_mag_f: DataSerieResult;
  WEATHER_Park_history_icon: IconDataSerieResult;
  WGEN1_GnTmpBrg1_avg_mag_f: DataSerieResult;
  WGEN1_GnTmpBrg2_avg_mag_f: DataSerieResult;
  WGEN1_GnTmpInlet_avg_mag_f: DataSerieResult;
  WGEN1_GnTmpOutlet_avg_mag_f: DataSerieResult;
  WGEN1_GnTmpPhase1_avg_mag_f: DataSerieResult;
  WGEN1_GnTmpPhase2_avg_mag_f: DataSerieResult;
  WGEN1_GnTmpPhase3_avg_mag_f: DataSerieResult;
  WGEN1_GnTmpRtr_avg_mag_f: DataSerieResult;
  WGEN1_GnTmpSlpRing1_avg_mag_f: DataSerieResult;
  WGEN1_GnTmpSta_avg_mag_f: DataSerieResult;
  WNAC1_CtrCabTmp_avg_mag_f: DataSerieResult;
  WNAC1_ExTmp_avg_mag_f: DataSerieResult;
  WNAC1_IntlTmp_avg_mag_f: DataSerieResult;
  WNAC1_WdDir_avg_mag_f: DataSerieResult;
  WNAC1_WdSpd_avg_mag_f: DataSerieResult;
  WROT1_CtrCabTmp2_avg_mag_f: DataSerieResult;
  WROT1_CtrCabTmp3_avg_mag_f: DataSerieResult;
  WROT1_CtrCabTmp_avg_mag_f: DataSerieResult;
  WROT1_HubTmp_avg_mag_f: DataSerieResult;
  WROT1_PtHyOilTmp_avg_mag_f: DataSerieResult;
  WROT1_TmpBl1_avg_mag_f: DataSerieResult;
  WROT1_TmpBl2_avg_mag_f: DataSerieResult;
  WROT1_TmpBl3_avg_mag_f: DataSerieResult;
  WTOW1_CtrCabTmp_avg_mag_f: DataSerieResult;
  WTRF1_RoomTmp_avg_mag_f: DataSerieResult;
  WTRF1_TrfOilTmp_avg_mag_f: DataSerieResult;
  WTRF1_TrfTmpPhase1_avg_mag_f: DataSerieResult;
  WTRF1_TrfTmpPhase2_avg_mag_f: DataSerieResult;
  WTRF1_TrfTmpPhase3_avg_mag_f: DataSerieResult;
  WTRM1_TrmTmpGbxBrg1_avg_mag_f: DataSerieResult;
  WTRM1_TrmTmpGbxBrg2_avg_mag_f: DataSerieResult;
  WTRM1_TrmTmpGbxBrg3_avg_mag_f: DataSerieResult;
  WTRM1_TrmTmpGbxOil_avg_mag_f: DataSerieResult;
  WTRM1_TrmTmpShfBrg1_avg_mag_f: DataSerieResult;
  WTRM1_TrmTmpShfBrg2_avg_mag_f: DataSerieResult;
  WTRM1_TrmTmpShfBrk_avg_mag_f: DataSerieResult;
  WTUR1_MW_avg_mag_f: DataSerieResult;
  WTUR1_MW_avg_theoretical: DataSerieResult;
  WTUR1_W_avg_mag_f: DataSerieResult;
  WTUR1_W_avg_theoretical: DataSerieResult;
  WTUR1_W_mag_f: DataSerieResult;
  WTUR1_W_theoretical: DataSerieResult;
  WTUR1_kW_avg_mag_f: DataSerieResult;
  WTUR1_kW_avg_theoretical: DataSerieResult;
  icon: IconDataSerieResult;
  temp: DataSerieResult;
  theoPower: DataSerieResult;
  turbinesAvailable: DataSerieResult;
  windDir: DataSerieResult;
  windSpd: DataSerieResult;
};


export type DataSeriesAlarm_StatusArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesM02_Cus30_Status_BlockArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWcnv1_CnvTmpChokeCoil2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWcnv1_CnvTmpChokeCoil3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWcnv1_CnvTmpChokeCoil_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWcnv1_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWcnv1_CnvTmpWater_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWcnv2_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWcnv3_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWcnv4_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWcnv5_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWcnv6_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWcnv7_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWcnv8_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWcnv9_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWcnv10_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWcnv11_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWgen1_GnTmpBrg1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWgen1_GnTmpBrg2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWgen1_GnTmpInlet_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWgen1_GnTmpOutlet_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWgen1_GnTmpPhase1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWgen1_GnTmpPhase2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWgen1_GnTmpPhase3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWgen1_GnTmpRtr_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWgen1_GnTmpSlpRing1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWgen1_GnTmpSta_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWnac1_CtrCabTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWnac1_ExTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWnac1_IntlTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWnac1_WdDir_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWnac1_WdSpd_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWrot1_CtrCabTmp2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWrot1_CtrCabTmp3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWrot1_CtrCabTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWrot1_HubTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWrot1_PtHyOilTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWrot1_TmpBl1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWrot1_TmpBl2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWrot1_TmpBl3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWtow1_CtrCabTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWtrf1_RoomTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWtrf1_TrfOilTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWtrf1_TrfTmpPhase1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWtrf1_TrfTmpPhase2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWtrf1_TrfTmpPhase3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWtrm1_TrmTmpGbxBrg1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWtrm1_TrmTmpGbxBrg2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWtrm1_TrmTmpGbxBrg3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWtrm1_TrmTmpGbxOil_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWtrm1_TrmTmpShfBrg1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWtrm1_TrmTmpShfBrg2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWtrm1_TrmTmpShfBrk_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWtur1_Mw_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWtur1_Mw_Avg_TheoreticalArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWtur1_W_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWtur1_W_Avg_TheoreticalArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWtur1_W_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWtur1_W_TheoreticalArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWtur1_Kw_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type DataSeriesWtur1_Kw_Avg_TheoreticalArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};

export type DataStudioFileInput = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  params: Scalars['String']['input'];
};

export type DataStudioFileRequestInput = {
  endTS: Scalars['Float']['input'];
  fileName: Scalars['String']['input'];
  fileType: DataStudioFileType;
  granularity: DataStudioGranularityType;
  queryType: DataStudioQueryType;
  signals?: InputMaybe<Array<Scalars['String']['input']>>;
  startTS: Scalars['Float']['input'];
  turbines?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum DataStudioFileType {
  Csv = 'csv',
  Xlsx = 'xlsx'
}

export type DataStudioFiles = {
  __typename?: 'DataStudioFiles';
  _id?: Maybe<Scalars['ID']['output']>;
  createDateTS?: Maybe<Scalars['Float']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Float']['output']>;
  fileType?: Maybe<Scalars['String']['output']>;
  folderName?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  params?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  queryType?: Maybe<Scalars['String']['output']>;
  signals?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['Int']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export enum DataStudioGranularityType {
  G1H = 'G1H',
  G1Mon = 'G1MON',
  G1Y = 'G1Y',
  G10M = 'G10M',
  G30S = 'G30S'
}

export type DataStudioInput = {
  endTs: Scalars['Float']['input'];
  granularity?: InputMaybe<TimeseriesSamplingUnitEnum>;
  signal?: InputMaybe<Array<Scalars['String']['input']>>;
  startTs: Scalars['Float']['input'];
  stream?: InputMaybe<Stream>;
};

export enum DataStudioQueryType {
  Live = 'live',
  Scada = 'scada',
  Tlog = 'tlog'
}

export type DataStudioUploadedFile = {
  __typename?: 'DataStudioUploadedFile';
  _id: Scalars['ID']['output'];
  deviceType: DeviceType;
  fileName?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Int']['output']>;
  fileType: FileTypeEnum;
  link?: Maybe<Scalars['String']['output']>;
  originalName: Scalars['String']['output'];
  queryType: DataStudioQueryType;
  requestedAt: Scalars['Float']['output'];
  requestedParams: FileRequestedParams;
  status: FileTrackerStatus;
};

export type Date = {
  __typename?: 'Date';
  date?: Maybe<Scalars['String']['output']>;
  dateTime?: Maybe<Scalars['String']['output']>;
  unixTimestamp?: Maybe<Scalars['Float']['output']>;
};


export type DateDateArgs = {
  locale?: InputMaybe<Locale>;
  timeZone?: InputMaybe<TimeZone>;
};


export type DateDateTimeArgs = {
  locale?: InputMaybe<Locale>;
  timeZone?: InputMaybe<TimeZone>;
};

export type DateRange = {
  __typename?: 'DateRange';
  end?: Maybe<Scalars['Float']['output']>;
  start?: Maybe<Scalars['Float']['output']>;
};

export type DeIce = {
  __typename?: 'DeIce';
  benefitBH?: Maybe<Scalars['Float']['output']>;
  bestStartTime?: Maybe<Scalars['Float']['output']>;
  efficiency?: Maybe<Scalars['Float']['output']>;
  energyWithBH?: Maybe<Scalars['Float']['output']>;
  energyWithoutBH?: Maybe<Scalars['Float']['output']>;
  forecastDuration?: Maybe<Scalars['Int']['output']>;
  ice_mass_kgm?: Maybe<Array<Maybe<DeIceDataTs>>>;
  modelledPC?: Maybe<Array<Maybe<ProductionWs>>>;
  operatingPoint?: Maybe<Array<Maybe<OperatingPoint>>>;
  powerTheor_kW?: Maybe<Array<Maybe<DeIceDataTs>>>;
  powerWithRBHS_kW?: Maybe<Array<Maybe<DeIceDataTs>>>;
  powerWithoutRBHS_kW?: Maybe<Array<Maybe<DeIceDataTs>>>;
  prodLossFactor?: Maybe<Scalars['Float']['output']>;
  production?: Maybe<Array<Maybe<ProductionWs>>>;
  referencePC?: Maybe<Array<Maybe<ProductionWs>>>;
  startRHBSNow?: Maybe<Scalars['String']['output']>;
  statusBH?: Maybe<Scalars['String']['output']>;
  temperature_celsius?: Maybe<Array<Maybe<DeIceDataTs>>>;
  wind_speed?: Maybe<Array<Maybe<DeIceDataTs>>>;
};

export type DeIceDataTs = {
  __typename?: 'DeIceDataTS';
  timestamp?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type DeleteInput = {
  id_ticket: Scalars['ID']['input'];
};

export type DeleteTicketCustomFieldInput = {
  id: Scalars['ID']['input'];
};

export type Delivered = {
  __typename?: 'Delivered';
  invoice?: Maybe<BudgetData>;
  isInvoiced?: Maybe<Scalars['Boolean']['output']>;
  meter?: Maybe<BudgetData>;
  production?: Maybe<BudgetTotalValue>;
  revenue?: Maybe<BudgetTotalValue>;
  scada?: Maybe<BudgetData>;
};

export enum DeviceType {
  ControlSystem = 'controlSystem',
  MetmastSensor = 'metmastSensor',
  Park = 'park',
  Turbine = 'turbine'
}

export type DueDateInput = {
  end?: InputMaybe<Scalars['Float']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
};

export type EnergyMeterDataseriesValue = {
  __typename?: 'EnergyMeterDataseriesValue';
  PPAElectricityPrice?: Maybe<Scalars['Float']['output']>;
  avgCapturedPrice?: Maybe<Scalars['Float']['output']>;
  consumptionGrid?: Maybe<Scalars['Float']['output']>;
  consumptionLosses?: Maybe<Scalars['Float']['output']>;
  elcertsHedgePrice?: Maybe<Scalars['Float']['output']>;
  electricitySalesRevenue?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `consumptionGrid`. */
  energyConsumption?: Maybe<Scalars['Float']['output']>;
  estimatedBalancingFee?: Maybe<Scalars['Float']['output']>;
  financialHedge?: Maybe<Scalars['Float']['output']>;
  hedgedPpaCapacity?: Maybe<Scalars['Float']['output']>;
  incentive?: Maybe<Scalars['Float']['output']>;
  incentiveRevenue?: Maybe<Scalars['Float']['output']>;
  lastUpdated?: Maybe<Scalars['Float']['output']>;
  marketPrice?: Maybe<Scalars['Float']['output']>;
  marketPriceRevenues?: Maybe<Scalars['Float']['output']>;
  monthlyPpaVolume?: Maybe<Scalars['Float']['output']>;
  neasFee?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `totalRevenue`. */
  netRevenue?: Maybe<Scalars['Float']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  powerHedgePrice?: Maybe<Scalars['Float']['output']>;
  ppaPrice?: Maybe<Scalars['Float']['output']>;
  ppaRevenue?: Maybe<Scalars['Float']['output']>;
  productionGrid?: Maybe<Scalars['Float']['output']>;
  productionGridCount?: Maybe<Scalars['Int']['output']>;
  productionLosses?: Maybe<Scalars['Float']['output']>;
  productionScada?: Maybe<Scalars['Float']['output']>;
  realizedPPA?: Maybe<Scalars['Float']['output']>;
  referencePrice?: Maybe<Scalars['Float']['output']>;
  referencePriceRevenues?: Maybe<Scalars['Float']['output']>;
  revenueLosses?: Maybe<Scalars['Float']['output']>;
  riskPremium?: Maybe<Scalars['Float']['output']>;
  scadaRevenue?: Maybe<Scalars['Float']['output']>;
  statnettFee?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `totalTariff`. */
  tariff?: Maybe<Scalars['Float']['output']>;
  totalRevenue?: Maybe<Scalars['Float']['output']>;
  totalTariff?: Maybe<Scalars['Float']['output']>;
};

export type EnergyMeterTotals = {
  __typename?: 'EnergyMeterTotals';
  PPAElectricityPrice?: Maybe<Scalars['Float']['output']>;
  consumptionGrid?: Maybe<Scalars['Float']['output']>;
  consumptionLosses?: Maybe<Scalars['Float']['output']>;
  elcertsHedgePrice?: Maybe<Scalars['Float']['output']>;
  electricitySalesRevenue?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `consumptionGrid`. */
  energyConsumption?: Maybe<Scalars['Float']['output']>;
  estimatedBalancingFee?: Maybe<Scalars['Float']['output']>;
  financialHedge?: Maybe<Scalars['Float']['output']>;
  hedgedPpaCapacity?: Maybe<Scalars['Float']['output']>;
  incentive?: Maybe<Scalars['Float']['output']>;
  incentiveRevenue?: Maybe<Scalars['Float']['output']>;
  lastUpdated?: Maybe<Scalars['Float']['output']>;
  marketPrice?: Maybe<Scalars['Float']['output']>;
  marketPriceRevenues?: Maybe<Scalars['Float']['output']>;
  monthlyPpaVolume?: Maybe<Scalars['Float']['output']>;
  neasFee?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `totalRevenue`. */
  netRevenue?: Maybe<Scalars['Float']['output']>;
  powerHedgePrice?: Maybe<Scalars['Float']['output']>;
  ppaPrice?: Maybe<Scalars['Float']['output']>;
  ppaRevenue?: Maybe<Scalars['Float']['output']>;
  productionGrid?: Maybe<Scalars['Float']['output']>;
  productionGridCount?: Maybe<Scalars['Int']['output']>;
  productionLosses?: Maybe<Scalars['Float']['output']>;
  productionScada?: Maybe<Scalars['Float']['output']>;
  realizedPPA?: Maybe<Scalars['Float']['output']>;
  referencePrice?: Maybe<Scalars['Float']['output']>;
  referencePriceRevenues?: Maybe<Scalars['Float']['output']>;
  revenueLosses?: Maybe<Scalars['Float']['output']>;
  riskPremium?: Maybe<Scalars['Float']['output']>;
  scadaRevenue?: Maybe<Scalars['Float']['output']>;
  statnettFee?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `totalTariff`. */
  tariff?: Maybe<Scalars['Float']['output']>;
  totalRevenue?: Maybe<Scalars['Float']['output']>;
  totalTariff?: Maybe<Scalars['Float']['output']>;
};

export type EpaYearly = {
  __typename?: 'EpaYearly';
  NOK_EUR?: Maybe<Scalars['Float']['output']>;
  SEK_EUR?: Maybe<Scalars['Float']['output']>;
  SKMAverageMonthlySpotPriceInEur?: Maybe<Scalars['Float']['output']>;
  SKMAverageMonthlySpotPriceInSEK?: Maybe<Scalars['Float']['output']>;
  additionalTransferedElcerts?: Maybe<Scalars['Float']['output']>;
  bakingBalance?: Maybe<Scalars['Float']['output']>;
  bankedVolume?: Maybe<Scalars['Float']['output']>;
  contractVolume?: Maybe<Scalars['Float']['output']>;
  deliveryCommitments?: Maybe<Scalars['Float']['output']>;
  difference?: Maybe<Scalars['Float']['output']>;
  elCertsFromRealizedProductionGjeitefjellet?: Maybe<Scalars['Float']['output']>;
  elCertsFromRealizedProductionHarbakksfjellet?: Maybe<Scalars['Float']['output']>;
  elCertsFromRealizedProductionHitra2?: Maybe<Scalars['Float']['output']>;
  elCertsFromRealizedProductionKvenndalsfjell?: Maybe<Scalars['Float']['output']>;
  elCertsFromRealizedProductionRoan?: Maybe<Scalars['Float']['output']>;
  elCertsFromRealizedProductionStorheia?: Maybe<Scalars['Float']['output']>;
  elCertsRealizedProductionTotal?: Maybe<Scalars['Float']['output']>;
  elcertPrice?: Maybe<Scalars['Float']['output']>;
  elcertsRrealisedProduction?: Maybe<Scalars['Float']['output']>;
  fixedElcertRevenue?: Maybe<Scalars['Float']['output']>;
  initialBankingPlan?: Maybe<Scalars['Float']['output']>;
  insufficientBankingVolume?: Maybe<Scalars['Float']['output']>;
  paymentForUnhedgedVolumeInEUR?: Maybe<Scalars['Float']['output']>;
  paymentForUnhedgedVolumeInSEK?: Maybe<Scalars['Float']['output']>;
  period: Scalars['String']['output'];
  serviceFeeInEUR?: Maybe<Scalars['Float']['output']>;
  serviceFeeInNOK?: Maybe<Scalars['Float']['output']>;
  totalBankingPlan?: Maybe<Scalars['Float']['output']>;
  totalRevenueElcerts?: Maybe<Scalars['Float']['output']>;
  totalTransferredVolume?: Maybe<Scalars['Float']['output']>;
  unhedgedVolume?: Maybe<Scalars['Float']['output']>;
};

export type Event = {
  __typename?: 'Event';
  _id: Scalars['ID']['output'];
  channel?: Maybe<Array<Maybe<Channel>>>;
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  ruleIdent: Array<RuleIdent>;
};

export type File = {
  _id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
};

export type FileRequestedParams = {
  __typename?: 'FileRequestedParams';
  deviceIds: Array<Scalars['String']['output']>;
  deviceType: DeviceType;
  endTS: Scalars['Float']['output'];
  fileName: Scalars['String']['output'];
  fileType: FileTypeEnum;
  granularity: Scalars['String']['output'];
  isNew?: Maybe<Scalars['Boolean']['output']>;
  longFormat?: Maybe<Scalars['Boolean']['output']>;
  oneTab?: Maybe<Scalars['Boolean']['output']>;
  park?: Maybe<Scalars['String']['output']>;
  queryType: Scalars['String']['output'];
  signals: Array<Scalars['String']['output']>;
  startTS: Scalars['Float']['output'];
  timeZone?: Maybe<Scalars['String']['output']>;
  timeZoneDiff: Scalars['Int']['output'];
  translatedSignals: Array<Scalars['String']['output']>;
  turbines?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  userId: Scalars['ID']['output'];
};

export enum FileTrackerStatus {
  Failed = 'FAILED',
  InProcess = 'IN_PROCESS',
  Queued = 'QUEUED',
  Successful = 'SUCCESSFUL'
}

export enum FileTypeEnum {
  Csv = 'csv',
  Xlsx = 'xlsx'
}

export type FilteredData = {
  __typename?: 'FilteredData';
  dataValue?: Maybe<FloatOrString>;
  signalName: Scalars['String']['output'];
};

export type FilteredGroupedDataSeries = {
  __typename?: 'FilteredGroupedDataSeries';
  groupedData: Array<Maybe<GroupedDataSeriesResult>>;
  signalName: Scalars['String']['output'];
};

export type FilteredMixedDataSeriesDeviation = {
  __typename?: 'FilteredMixedDataSeriesDeviation';
  dataValue: SignalGroupedDataSeriesResult;
  signalName: Scalars['String']['output'];
};

export type FindingData = {
  __typename?: 'FindingData';
  _id_park?: Maybe<Scalars['ID']['output']>;
  _id_turbine?: Maybe<Scalars['ID']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  endTs?: Maybe<Scalars['Float']['output']>;
  flagName?: Maybe<Scalars['String']['output']>;
  parentFlag?: Maybe<Scalars['String']['output']>;
  prod?: Maybe<Scalars['Float']['output']>;
  rev?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  startTs?: Maybe<Scalars['Float']['output']>;
};

export type FloatData = {
  __typename?: 'FloatData';
  numericValue?: Maybe<Scalars['Float']['output']>;
};

export type FloatOrString = FloatData | StringData;

export type ForecastAccuracy = {
  __typename?: 'ForecastAccuracy';
  actualPowerVsForecast?: Maybe<Array<Maybe<ActualPowerVsForecast>>>;
  forecastErrorEUR?: Maybe<Array<Maybe<ForecastErrorEur>>>;
  forecastErrorMWh?: Maybe<Array<Maybe<ForecastErrorMWh>>>;
  forecastErrorPercentage?: Maybe<Array<Maybe<ForecastErrorPercentage>>>;
  forecastErrorTarget?: Maybe<Array<Maybe<ForecastErrorTarget>>>;
};


export type ForecastAccuracyForecastErrorEurArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type ForecastAccuracyForecastErrorMWhArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type ForecastAccuracyForecastErrorPercentageArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type ForecastAccuracyForecastErrorTargetArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};

export type ForecastDataSeries = {
  __typename?: 'ForecastDataSeries';
  icon?: Maybe<Array<IconDataSerieResult>>;
  temp?: Maybe<Array<DataSerieResult>>;
  theoPower?: Maybe<Array<DataSerieResult>>;
  windDir?: Maybe<Array<DataSerieResult>>;
  windSpd?: Maybe<Array<DataSerieResult>>;
};

export type ForecastErrorEur = {
  __typename?: 'ForecastErrorEUR';
  totalError: Scalars['Float']['output'];
  unixTs: Scalars['Float']['output'];
};

export type ForecastErrorMWh = {
  __typename?: 'ForecastErrorMWh';
  negativeErrorMWh: Scalars['Float']['output'];
  positiveErrorMWh: Scalars['Float']['output'];
  totalErrorMWh: Scalars['Float']['output'];
  unixTs: Scalars['Float']['output'];
};

export type ForecastErrorPercentage = {
  __typename?: 'ForecastErrorPercentage';
  negativeErrorPercentage: Scalars['Float']['output'];
  positiveErrorPercentage: Scalars['Float']['output'];
  totalErrorPercentage: Scalars['Float']['output'];
  unixTs: Scalars['Float']['output'];
};

export type ForecastErrorTarget = {
  __typename?: 'ForecastErrorTarget';
  EUR: Scalars['Float']['output'];
  MWh: Scalars['Float']['output'];
  percentage: Scalars['Float']['output'];
  unixTs: Scalars['Float']['output'];
};

export enum ForecastProvidersEnum {
  DnvForecaster = 'dnv_forecaster',
  Ecmwf = 'ecmwf',
  Meteoblue = 'meteoblue',
  Meteologica = 'meteologica',
  Nems = 'nems',
  Openweather = 'openweather',
  Windlog = 'windlog'
}

export type FosenPpa = {
  __typename?: 'FosenPPA';
  NOK_EUR?: Maybe<Scalars['Float']['output']>;
  NWPActualProduction?: Maybe<Scalars['Float']['output']>;
  NWPPproQuotaMonthlyActualProduction?: Maybe<Scalars['Float']['output']>;
  NWPPproQuotaQuaterlyActualProduction?: Maybe<Scalars['Float']['output']>;
  NWPPproQuotaQuaterlyPlannedProduction?: Maybe<Scalars['Float']['output']>;
  NWPProQuotaActualMonthlyCost?: Maybe<Scalars['Float']['output']>;
  NWPProQuotaActualQuaterlyCost?: Maybe<Scalars['Float']['output']>;
  NWPProQuotaPlannedCosts?: Maybe<Scalars['Float']['output']>;
  NWPProQuotaPlannedQuaterlyCosts?: Maybe<Scalars['Float']['output']>;
  NWPQuotaPlannedProduction?: Maybe<Scalars['Float']['output']>;
  WP1PlannedProduction?: Maybe<Scalars['Float']['output']>;
  WP1PlannedProductionCost?: Maybe<Scalars['Float']['output']>;
  WP1TotalCost?: Maybe<Scalars['Float']['output']>;
  actualCostEuro?: Maybe<Scalars['Float']['output']>;
  budgetCostEuro?: Maybe<Scalars['Float']['output']>;
  period: Scalars['String']['output'];
  preliminaryNWPProQuotaQuarterlySettlements?: Maybe<Scalars['Float']['output']>;
};

export type FosenReport = {
  __typename?: 'FosenReport';
  adgerPPAMonthly?: Maybe<Array<Maybe<AdgerPpaMonthly>>>;
  adgerPPAMultiYearly?: Maybe<Array<Maybe<AdgerPpaYearly>>>;
  adgerPPAYearly?: Maybe<Array<Maybe<AdgerPpaYearly>>>;
  epaMultiYearly?: Maybe<Array<Maybe<EpaYearly>>>;
  epaYearly?: Maybe<Array<Maybe<EpaYearly>>>;
  fosenPPAMultiYearly?: Maybe<Array<Maybe<FosenPpa>>>;
  fosenPPAYearly?: Maybe<Array<Maybe<FosenPpa>>>;
};


export type FosenReportAdgerPpaMonthlyArgs = {
  yearMonth: Scalars['Float']['input'];
};


export type FosenReportAdgerPpaMultiYearlyArgs = {
  year: Array<Scalars['Float']['input']>;
};


export type FosenReportAdgerPpaYearlyArgs = {
  year: Scalars['Float']['input'];
};


export type FosenReportEpaMultiYearlyArgs = {
  year: Array<Scalars['Float']['input']>;
};


export type FosenReportEpaYearlyArgs = {
  year: Scalars['Float']['input'];
};


export type FosenReportFosenPpaMultiYearlyArgs = {
  _id_park?: InputMaybe<Scalars['String']['input']>;
  year: Array<Scalars['Float']['input']>;
};


export type FosenReportFosenPpaYearlyArgs = {
  _id_park?: InputMaybe<Scalars['String']['input']>;
  year: Scalars['Float']['input'];
};

export type GraphDataMarker = {
  __typename?: 'GraphDataMarker';
  symbol?: Maybe<Scalars['String']['output']>;
};

export type GraphDataMarkerInput = {
  symbol?: InputMaybe<Scalars['String']['input']>;
};

export enum GroupByEnum {
  Children = 'CHILDREN',
  Parent = 'PARENT'
}

export type GroupedAlarms = {
  __typename?: 'GroupedAlarms';
  _id_park: Scalars['ID']['output'];
  alarms: Array<Maybe<Alarm>>;
};

export type GroupedDataSeries = {
  __typename?: 'GroupedDataSeries';
  WCNV1_CnvTmpChokeCoil2_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WCNV1_CnvTmpChokeCoil3_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WCNV1_CnvTmpChokeCoil_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WCNV1_CnvTmpDclink_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WCNV1_CnvTmpWater_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WCNV2_CnvTmpDclink_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WCNV3_CnvTmpDclink_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WCNV4_CnvTmpDclink_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WCNV5_CnvTmpDclink_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WCNV6_CnvTmpDclink_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WCNV7_CnvTmpDclink_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WCNV8_CnvTmpDclink_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WCNV9_CnvTmpDclink_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WCNV10_CnvTmpDclink_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WCNV11_CnvTmpDclink_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WGEN1_GnTmpBrg1_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WGEN1_GnTmpBrg2_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WGEN1_GnTmpInlet_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WGEN1_GnTmpOutlet_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WGEN1_GnTmpPhase1_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WGEN1_GnTmpPhase2_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WGEN1_GnTmpPhase3_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WGEN1_GnTmpRtr_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WGEN1_GnTmpSlpRing1_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WGEN1_GnTmpSta_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WGEN1_Spd_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WGEN1_Spd_max_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WGEN1_Spd_min_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WNAC1_CtrCabTmp_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WNAC1_Dir_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WNAC1_ExTmp_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WNAC1_IntlTmp_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WNAC1_WdDir_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WNAC1_WdSpd_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WROT1_CtrCabTmp2_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WROT1_CtrCabTmp3_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WROT1_CtrCabTmp_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WROT1_HubTmp_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WROT1_PtAngValBl1_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WROT1_PtAngValBl2_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WROT1_PtAngValBl3_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WROT1_PtHyOilTmp_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WROT1_RotSpd_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WROT1_TmpBl1_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WROT1_TmpBl2_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WROT1_TmpBl3_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WTOW1_CtrCabTmp_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WTRF1_RoomTmp_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WTRF1_TrfOilTmp_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WTRF1_TrfTmpPhase1_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WTRF1_TrfTmpPhase2_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WTRF1_TrfTmpPhase3_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WTRM1_TrmTmpGbxBrg1_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WTRM1_TrmTmpGbxBrg2_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WTRM1_TrmTmpGbxBrg3_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WTRM1_TrmTmpGbxOil_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WTRM1_TrmTmpShfBrg1_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WTRM1_TrmTmpShfBrg2_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WTRM1_TrmTmpShfBrk_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WTUR1_MW_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WTUR1_MW_avg_theoretical: Array<Maybe<GroupedDataSeriesResult>>;
  WTUR1_W_avg_loss: Array<Maybe<GroupedDataSeriesResult>>;
  WTUR1_W_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WTUR1_W_avg_rated: Array<Maybe<GroupedDataSeriesResult>>;
  WTUR1_W_avg_theoretical: Array<Maybe<GroupedDataSeriesResult>>;
  WTUR1_W_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WTUR1_W_theoretical: Array<Maybe<GroupedDataSeriesResult>>;
  WTUR1_Wh_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WTUR1_Wh_avg_mag_f_corrected: Array<Maybe<GroupedDataSeriesResult>>;
  WTUR1_co2Avoided: Array<Maybe<GroupedDataSeriesResult>>;
  WTUR1_incentive: Array<Maybe<GroupedDataSeriesResult>>;
  WTUR1_incentive_avg: Array<Maybe<GroupedDataSeriesResult>>;
  WTUR1_kW_avg_mag_f: Array<Maybe<GroupedDataSeriesResult>>;
  WTUR1_kW_avg_theoretical: Array<Maybe<GroupedDataSeriesResult>>;
  WTUR1_marketPrice: Array<Maybe<GroupedDataSeriesResult>>;
  WTUR1_marketPrice_avg: Array<Maybe<GroupedDataSeriesResult>>;
  WTUR1_per_avg_availability: Array<Maybe<GroupedDataSeriesResult>>;
  WTUR1_per_avg_efficiency: Array<Maybe<GroupedDataSeriesResult>>;
  WTUR1_per_avg_loadFactor: Array<Maybe<GroupedDataSeriesResult>>;
  WTUR1_per_efficiency: Array<Maybe<GroupedDataSeriesResult>>;
  WTUR1_revenue: Array<Maybe<GroupedDataSeriesResult>>;
  WTUR1_revenueLosses: Array<Maybe<GroupedDataSeriesResult>>;
  WTUR1_revenueLosses_avg: Array<Maybe<GroupedDataSeriesResult>>;
  WTUR1_revenue_avg: Array<Maybe<GroupedDataSeriesResult>>;
  WTUR1_status: Array<Maybe<GroupedDataSeriesResult>>;
  turbinesAvailable: Array<Maybe<GroupedDataSeriesResult>>;
};


export type GroupedDataSeriesWcnv1_CnvTmpChokeCoil2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWcnv1_CnvTmpChokeCoil3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWcnv1_CnvTmpChokeCoil_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWcnv1_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWcnv1_CnvTmpWater_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWcnv2_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWcnv3_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWcnv4_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWcnv5_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWcnv6_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWcnv7_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWcnv8_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWcnv9_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWcnv10_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWcnv11_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWgen1_GnTmpBrg1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWgen1_GnTmpBrg2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWgen1_GnTmpInlet_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWgen1_GnTmpOutlet_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWgen1_GnTmpPhase1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWgen1_GnTmpPhase2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWgen1_GnTmpPhase3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWgen1_GnTmpRtr_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWgen1_GnTmpSlpRing1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWgen1_GnTmpSta_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWgen1_Spd_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWgen1_Spd_Max_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWgen1_Spd_Min_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWnac1_CtrCabTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWnac1_Dir_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWnac1_ExTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<Celcius>;
};


export type GroupedDataSeriesWnac1_IntlTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<Celcius>;
};


export type GroupedDataSeriesWnac1_WdDir_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWnac1_WdSpd_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<MeterPerSecond>;
};


export type GroupedDataSeriesWrot1_CtrCabTmp2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWrot1_CtrCabTmp3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWrot1_CtrCabTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWrot1_HubTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<Celcius>;
};


export type GroupedDataSeriesWrot1_PtAngValBl1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWrot1_PtAngValBl2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWrot1_PtAngValBl3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWrot1_PtHyOilTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWrot1_RotSpd_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWrot1_TmpBl1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWrot1_TmpBl2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWrot1_TmpBl3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtow1_CtrCabTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtrf1_RoomTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtrf1_TrfOilTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtrf1_TrfTmpPhase1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtrf1_TrfTmpPhase2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtrf1_TrfTmpPhase3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtrm1_TrmTmpGbxBrg1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtrm1_TrmTmpGbxBrg2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtrm1_TrmTmpGbxBrg3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtrm1_TrmTmpGbxOil_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtrm1_TrmTmpShfBrg1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtrm1_TrmTmpShfBrg2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtrm1_TrmTmpShfBrk_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtur1_Mw_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtur1_Mw_Avg_TheoreticalArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtur1_W_Avg_LossArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtur1_W_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<Watt>;
};


export type GroupedDataSeriesWtur1_W_Avg_RatedArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtur1_W_Avg_TheoreticalArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<Watt>;
};


export type GroupedDataSeriesWtur1_W_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<Watt>;
};


export type GroupedDataSeriesWtur1_W_TheoreticalArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<Watt>;
};


export type GroupedDataSeriesWtur1_Wh_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtur1_Wh_Avg_Mag_F_CorrectedArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtur1_Co2AvoidedArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtur1_IncentiveArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtur1_Incentive_AvgArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtur1_Kw_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtur1_Kw_Avg_TheoreticalArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtur1_MarketPriceArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtur1_MarketPrice_AvgArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtur1_Per_Avg_AvailabilityArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtur1_Per_Avg_EfficiencyArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtur1_Per_Avg_LoadFactorArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtur1_Per_EfficiencyArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtur1_RevenueArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtur1_RevenueLossesArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtur1_RevenueLosses_AvgArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtur1_Revenue_AvgArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedDataSeriesWtur1_StatusArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};

export type GroupedDataSeriesResult = {
  __typename?: 'GroupedDataSeriesResult';
  _id_park?: Maybe<Scalars['ID']['output']>;
  _id_turbine?: Maybe<Scalars['ID']['output']>;
  data?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  dataTimestamp?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  intervalTS?: Maybe<Scalars['Float']['output']>;
  lastTS?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startingTS?: Maybe<Scalars['Float']['output']>;
};

export type GroupedFacts = {
  __typename?: 'GroupedFacts';
  WCNV1_CnvTmpChokeCoil2_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WCNV1_CnvTmpChokeCoil3_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WCNV1_CnvTmpChokeCoil_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WCNV1_CnvTmpDclink_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WCNV1_CnvTmpWater_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WCNV2_CnvTmpDclink_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WCNV3_CnvTmpDclink_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WCNV4_CnvTmpDclink_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WCNV5_CnvTmpDclink_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WCNV6_CnvTmpDclink_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WCNV7_CnvTmpDclink_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WCNV8_CnvTmpDclink_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WCNV9_CnvTmpDclink_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WCNV10_CnvTmpDclink_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WCNV11_CnvTmpDclink_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WGEN1_GnTmpBrg1_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WGEN1_GnTmpBrg2_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WGEN1_GnTmpInlet_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WGEN1_GnTmpOutlet_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WGEN1_GnTmpPhase1_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WGEN1_GnTmpPhase2_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WGEN1_GnTmpPhase3_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WGEN1_GnTmpRtr_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WGEN1_GnTmpSlpRing1_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WGEN1_GnTmpSta_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WGEN1_Spd_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WGEN1_Spd_max_mag_f: Array<Maybe<GroupedFactsResult>>;
  WGEN1_Spd_min_mag_f: Array<Maybe<GroupedFactsResult>>;
  WNAC1_CtrCabTmp_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WNAC1_Dir_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WNAC1_ExTmp_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WNAC1_IntlTmp_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WNAC1_WdDir_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WNAC1_WdSpd_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WROT1_CtrCabTmp2_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WROT1_CtrCabTmp3_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WROT1_CtrCabTmp_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WROT1_HubTmp_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WROT1_PtAngValBl1_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WROT1_PtAngValBl2_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WROT1_PtAngValBl3_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WROT1_PtHyOilTmp_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WROT1_RotSpd_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WROT1_TmpBl1_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WROT1_TmpBl2_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WROT1_TmpBl3_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WTOW1_CtrCabTmp_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WTRF1_RoomTmp_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WTRF1_TrfOilTmp_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WTRF1_TrfTmpPhase1_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WTRF1_TrfTmpPhase2_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WTRF1_TrfTmpPhase3_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WTRM1_TrmTmpGbxBrg1_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WTRM1_TrmTmpGbxBrg2_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WTRM1_TrmTmpGbxBrg3_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WTRM1_TrmTmpGbxOil_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WTRM1_TrmTmpShfBrg1_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WTRM1_TrmTmpShfBrg2_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WTRM1_TrmTmpShfBrk_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WTUR1_MW_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WTUR1_MW_avg_theoretical: Array<Maybe<GroupedFactsResult>>;
  WTUR1_W_avg_loss: Array<Maybe<GroupedFactsResult>>;
  WTUR1_W_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WTUR1_W_avg_rated: Array<Maybe<GroupedFactsResult>>;
  WTUR1_W_avg_theoretical: Array<Maybe<GroupedFactsResult>>;
  WTUR1_W_mag_f: Array<Maybe<GroupedFactsResult>>;
  WTUR1_W_theoretical: Array<Maybe<GroupedFactsResult>>;
  WTUR1_Wh_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WTUR1_Wh_avg_mag_f_corrected: Array<Maybe<GroupedFactsResult>>;
  WTUR1_co2Avoided: Array<Maybe<GroupedFactsResult>>;
  WTUR1_incentive: Array<Maybe<GroupedFactsResult>>;
  WTUR1_incentive_avg: Array<Maybe<GroupedFactsResult>>;
  WTUR1_kW_avg_mag_f: Array<Maybe<GroupedFactsResult>>;
  WTUR1_kW_avg_theoretical: Array<Maybe<GroupedFactsResult>>;
  WTUR1_marketPrice: Array<Maybe<GroupedFactsResult>>;
  WTUR1_marketPrice_avg: Array<Maybe<GroupedFactsResult>>;
  WTUR1_per_avg_availability: Array<Maybe<GroupedFactsResult>>;
  WTUR1_per_avg_efficiency: Array<Maybe<GroupedFactsResult>>;
  WTUR1_per_avg_loadFactor: Array<Maybe<GroupedFactsResult>>;
  WTUR1_per_efficiency: Array<Maybe<GroupedFactsResult>>;
  WTUR1_revenue: Array<Maybe<GroupedFactsResult>>;
  WTUR1_revenueLosses: Array<Maybe<GroupedFactsResult>>;
  WTUR1_revenueLosses_avg: Array<Maybe<GroupedFactsResult>>;
  WTUR1_revenue_avg: Array<Maybe<GroupedFactsResult>>;
  WTUR1_status: Array<Maybe<GroupedFactsResult>>;
  turbinesAvailable: Array<Maybe<GroupedFactsResult>>;
};


export type GroupedFactsWcnv1_CnvTmpChokeCoil2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWcnv1_CnvTmpChokeCoil3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWcnv1_CnvTmpChokeCoil_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWcnv1_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWcnv1_CnvTmpWater_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWcnv2_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWcnv3_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWcnv4_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWcnv5_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWcnv6_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWcnv7_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWcnv8_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWcnv9_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWcnv10_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWcnv11_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWgen1_GnTmpBrg1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWgen1_GnTmpBrg2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWgen1_GnTmpInlet_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWgen1_GnTmpOutlet_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWgen1_GnTmpPhase1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWgen1_GnTmpPhase2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWgen1_GnTmpPhase3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWgen1_GnTmpRtr_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWgen1_GnTmpSlpRing1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWgen1_GnTmpSta_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWgen1_Spd_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWgen1_Spd_Max_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWgen1_Spd_Min_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWnac1_CtrCabTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWnac1_Dir_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWnac1_ExTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<Celcius>;
};


export type GroupedFactsWnac1_IntlTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<Celcius>;
};


export type GroupedFactsWnac1_WdDir_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWnac1_WdSpd_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<MeterPerSecond>;
};


export type GroupedFactsWrot1_CtrCabTmp2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWrot1_CtrCabTmp3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWrot1_CtrCabTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWrot1_HubTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<Celcius>;
};


export type GroupedFactsWrot1_PtAngValBl1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWrot1_PtAngValBl2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWrot1_PtAngValBl3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWrot1_PtHyOilTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWrot1_RotSpd_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWrot1_TmpBl1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWrot1_TmpBl2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWrot1_TmpBl3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtow1_CtrCabTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtrf1_RoomTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtrf1_TrfOilTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtrf1_TrfTmpPhase1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtrf1_TrfTmpPhase2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtrf1_TrfTmpPhase3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtrm1_TrmTmpGbxBrg1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtrm1_TrmTmpGbxBrg2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtrm1_TrmTmpGbxBrg3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtrm1_TrmTmpGbxOil_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtrm1_TrmTmpShfBrg1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtrm1_TrmTmpShfBrg2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtrm1_TrmTmpShfBrk_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtur1_Mw_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtur1_Mw_Avg_TheoreticalArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtur1_W_Avg_LossArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtur1_W_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<Watt>;
};


export type GroupedFactsWtur1_W_Avg_RatedArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtur1_W_Avg_TheoreticalArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<Watt>;
};


export type GroupedFactsWtur1_W_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<Watt>;
};


export type GroupedFactsWtur1_W_TheoreticalArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<Watt>;
};


export type GroupedFactsWtur1_Wh_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtur1_Wh_Avg_Mag_F_CorrectedArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtur1_Co2AvoidedArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtur1_IncentiveArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtur1_Incentive_AvgArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtur1_Kw_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtur1_Kw_Avg_TheoreticalArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtur1_MarketPriceArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtur1_MarketPrice_AvgArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtur1_Per_Avg_AvailabilityArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtur1_Per_Avg_EfficiencyArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtur1_Per_Avg_LoadFactorArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtur1_Per_EfficiencyArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtur1_RevenueArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtur1_RevenueLossesArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtur1_RevenueLosses_AvgArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtur1_Revenue_AvgArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type GroupedFactsWtur1_StatusArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};

export type GroupedFactsResult = {
  __typename?: 'GroupedFactsResult';
  _id_park?: Maybe<Scalars['ID']['output']>;
  _id_turbine?: Maybe<Scalars['ID']['output']>;
  dataValue?: Maybe<Scalars['Float']['output']>;
  intervalTS?: Maybe<Scalars['Float']['output']>;
  lastTS?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startingTS?: Maybe<Scalars['Float']['output']>;
};

export type GroupedResults = {
  __typename?: 'GroupedResults';
  alarmsGroupedByPark: Array<Maybe<GroupedAlarms>>;
};


export type GroupedResultsAlarmsGroupedByParkArgs = {
  alarmCategory?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  controlroomAck?: InputMaybe<Scalars['Boolean']['input']>;
  controlroomTicketing?: InputMaybe<Scalars['Boolean']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<AlarmSortInput>;
};

export type HideColumnInput = {
  id_board: Scalars['ID']['input'];
  id_status: Scalars['ID']['input'];
  isHide?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HistoricalPowercurveData = {
  __typename?: 'HistoricalPowercurveData';
  binSize?: Maybe<Scalars['Float']['output']>;
  frequency?: Maybe<Scalars['Float']['output']>;
  outPutPower?: Maybe<Scalars['Float']['output']>;
  sector?: Maybe<Scalars['String']['output']>;
  windSpeed?: Maybe<Scalars['Float']['output']>;
  windSpeedMedian?: Maybe<Scalars['Float']['output']>;
};

export type IconDataSerieResult = {
  __typename?: 'IconDataSerieResult';
  data?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  intervalTS?: Maybe<Scalars['Int']['output']>;
  lastTS?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  startingTS?: Maybe<Scalars['Float']['output']>;
};

export type IconWeather = {
  __typename?: 'IconWeather';
  icon?: Maybe<Scalars['String']['output']>;
  ts?: Maybe<Scalars['Float']['output']>;
};

export type Images = {
  __typename?: 'Images';
  _id?: Maybe<Scalars['ID']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdTs?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fileExtension?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  originalName?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type ImagesWhereInput = {
  AND?: InputMaybe<Array<ImagesWhereInput>>;
  OR?: InputMaybe<Array<ImagesWhereInput>>;
  _id?: InputMaybe<Scalars['ID']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdTs?: InputMaybe<Scalars['Float']['input']>;
  fileExtension?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type Information = {
  __typename?: 'Information';
  diameter?: Maybe<Scalars['Float']['output']>;
  hubHeight?: Maybe<Scalars['Float']['output']>;
  oem?: Maybe<Scalars['String']['output']>;
  qty?: Maybe<Scalars['Int']['output']>;
  ratedPower?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Integration = {
  _id_integration: Scalars['ID']['output'];
  dateRange?: Maybe<DateRange>;
  productionLoss?: Maybe<Scalars['Float']['output']>;
  turbineInfo?: Maybe<TurbineIntegration>;
  type?: Maybe<IntegrationType>;
};

export enum IntegrationType {
  Troubleshoot = 'TROUBLESHOOT'
}

export type InvoiceFile = {
  __typename?: 'InvoiceFile';
  _id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
};

export type InvoiceFileInput = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  file?: InputMaybe<File>;
  isNewFile?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvoiceValues = {
  isAvailable: Scalars['Boolean']['input'];
  production: Scalars['Float']['input'];
  revenue: Scalars['Float']['input'];
};

export type JsonMap = {
  __typename?: 'JsonMap';
  timestamp: Scalars['Float']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type KpiTableCustomSettings = {
  __typename?: 'KPITableCustomSettings';
  _id_park_?: Maybe<Scalars['ID']['output']>;
  _id_portfolio?: Maybe<Scalars['ID']['output']>;
  customizationTable: Scalars['String']['output'];
  tableUniqueName: Scalars['String']['output'];
};

export type KeycloakUser = {
  __typename?: 'KeycloakUser';
  _id?: Maybe<Scalars['ID']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type KeycloakUserWhereInput = {
  AND?: InputMaybe<Array<KeycloakUserWhereInput>>;
  OR?: InputMaybe<Array<KeycloakUserWhereInput>>;
  _id?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type KpiDefinition = {
  __typename?: 'KpiDefinition';
  _id: Scalars['ID']['output'];
  aggregation: KpiDefinitionAggregation;
  displayName: Scalars['String']['output'];
  isMandatory: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  targetExists: Scalars['Boolean']['output'];
  type: KpiDefinitionType;
  unit: Scalars['String']['output'];
};

export enum KpiDefinitionAggregation {
  Avg = 'AVG',
  Sum = 'SUM'
}

export enum KpiDefinitionType {
  Availability = 'AVAILABILITY',
  Reliability = 'RELIABILITY',
  Standard = 'STANDARD'
}

export type KpiFollowUp = {
  __typename?: 'KpiFollowUp';
  kpiSummary?: Maybe<Array<Maybe<KpiSummaryData>>>;
  kpiSummaryDaily?: Maybe<Array<Maybe<KpiSummaryDaily>>>;
  kpiSummaryForDailyTable?: Maybe<Array<Maybe<KpiSummaryData>>>;
  kpiSummaryMonthly?: Maybe<Array<Maybe<KpiSummaryMonthly>>>;
  kpiSummaryPerPark?: Maybe<KpiSummaryAggregaterPerPark>;
  kpiSummaryPerTurbine?: Maybe<Array<Maybe<KpiSummaryTurbinesInParkOutput>>>;
};

export type KpiSummaryAggregaterPerPark = {
  __typename?: 'KpiSummaryAggregaterPerPark';
  countries?: Maybe<Array<Maybe<KpiPerCountry>>>;
  parks?: Maybe<Array<Maybe<KpiPerPark>>>;
};

export type KpiSummaryDaily = {
  __typename?: 'KpiSummaryDaily';
  date?: Maybe<Scalars['Float']['output']>;
  dateString?: Maybe<Scalars['String']['output']>;
  kpis?: Maybe<Array<Maybe<KpiSummaryData>>>;
};

export type KpiSummaryMonthly = {
  __typename?: 'KpiSummaryMonthly';
  date?: Maybe<Scalars['Float']['output']>;
  dateString?: Maybe<Scalars['String']['output']>;
  kpis?: Maybe<Array<Maybe<KpiSummaryData>>>;
};

export type KpiSummaryParkOutput = {
  __typename?: 'KpiSummaryParkOutput';
  park?: Maybe<Array<Maybe<KpiSummaryData>>>;
  turbines?: Maybe<Array<Maybe<KpiSummaryTurbinesInParkOutput>>>;
};

export enum KpiSummaryTablePosition {
  Left = 'LEFT',
  Right = 'RIGHT'
}

export enum KpiSummaryViewEnum {
  Availability = 'AVAILABILITY',
  Custom = 'CUSTOM',
  Reliability = 'RELIABILITY',
  Standard = 'STANDARD'
}

export type KpiVsTargetTableCustomSettings = {
  __typename?: 'KpiVsTargetTableCustomSettings';
  customizationTable: Scalars['String']['output'];
  parkName?: Maybe<Scalars['String']['output']>;
  tableUniqueName: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type LastUpdate = {
  __typename?: 'LastUpdate';
  date?: Maybe<Scalars['Float']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export enum Locale {
  AfrikaansSouthAfrica = 'AfrikaansSouthAfrica',
  AlbanianAlbania = 'AlbanianAlbania',
  ArabicAlgeria = 'ArabicAlgeria',
  ArabicBahrain = 'ArabicBahrain',
  ArabicEgypt = 'ArabicEgypt',
  ArabicIraq = 'ArabicIraq',
  ArabicJordan = 'ArabicJordan',
  ArabicKuwait = 'ArabicKuwait',
  ArabicLebanon = 'ArabicLebanon',
  ArabicLibya = 'ArabicLibya',
  ArabicMorocco = 'ArabicMorocco',
  ArabicOman = 'ArabicOman',
  ArabicQatar = 'ArabicQatar',
  ArabicSaudiArabia = 'ArabicSaudiArabia',
  ArabicSyria = 'ArabicSyria',
  ArabicTunisia = 'ArabicTunisia',
  ArabicUnitedArabEmirates = 'ArabicUnitedArabEmirates',
  ArabicYemen = 'ArabicYemen',
  ArmenianArmenia = 'ArmenianArmenia',
  AzeriCyrillicAzerbaijan = 'AzeriCyrillicAzerbaijan',
  AzeriLatinAzerbaijan = 'AzeriLatinAzerbaijan',
  BasqueBasque = 'BasqueBasque',
  BelarusianBelarus = 'BelarusianBelarus',
  BulgarianBulgaria = 'BulgarianBulgaria',
  CatalanCatalan = 'CatalanCatalan',
  ChineseChina = 'ChineseChina',
  ChineseHongKongSar = 'ChineseHongKongSAR',
  ChineseMacauSar = 'ChineseMacauSAR',
  ChineseSimplified = 'ChineseSimplified',
  ChineseSingapore = 'ChineseSingapore',
  ChineseTaiwan = 'ChineseTaiwan',
  ChineseTraditional = 'ChineseTraditional',
  CroatianCroatia = 'CroatianCroatia',
  CzechCzechRepublic = 'CzechCzechRepublic',
  DanishDenmark = 'DanishDenmark',
  DhivehiMaldives = 'DhivehiMaldives',
  DutchBelgium = 'DutchBelgium',
  DutchTheNetherlands = 'DutchTheNetherlands',
  EnglishAustralia = 'EnglishAustralia',
  EnglishBelize = 'EnglishBelize',
  EnglishCanada = 'EnglishCanada',
  EnglishCaribbean = 'EnglishCaribbean',
  EnglishIreland = 'EnglishIreland',
  EnglishJamaica = 'EnglishJamaica',
  EnglishNew = 'EnglishNew',
  EnglishPhilippines = 'EnglishPhilippines',
  EnglishSouthAfrica = 'EnglishSouthAfrica',
  EnglishTrinidadTobago = 'EnglishTrinidadTobago',
  EnglishUnitedKingdom = 'EnglishUnitedKingdom',
  EnglishUnitedStates = 'EnglishUnitedStates',
  EnglishZimbabwe = 'EnglishZimbabwe',
  EstonianEstonia = 'EstonianEstonia',
  FaroeseFaroeIslands = 'FaroeseFaroeIslands',
  FarsiIran = 'FarsiIran',
  FinnishFinland = 'FinnishFinland',
  FrenchBelgium = 'FrenchBelgium',
  FrenchCanada = 'FrenchCanada',
  FrenchFrance = 'FrenchFrance',
  FrenchLuxembourg = 'FrenchLuxembourg',
  FrenchMonaco = 'FrenchMonaco',
  FrenchSwitzerland = 'FrenchSwitzerland',
  GalicianGalician = 'GalicianGalician',
  GeorgianGeorgia = 'GeorgianGeorgia',
  GermanAustria = 'GermanAustria',
  GermanGermany = 'GermanGermany',
  GermanLiechtenstein = 'GermanLiechtenstein',
  GermanLuxembourg = 'GermanLuxembourg',
  GermanSwitzerland = 'GermanSwitzerland',
  GreekGreece = 'GreekGreece',
  GujaratiIndia = 'GujaratiIndia',
  HebrewIsrael = 'HebrewIsrael',
  HindiIndia = 'HindiIndia',
  HungarianHungary = 'HungarianHungary',
  IcelandicIceland = 'IcelandicIceland',
  IndonesianIndonesia = 'IndonesianIndonesia',
  ItalianItaly = 'ItalianItaly',
  ItalianSwitzerland = 'ItalianSwitzerland',
  JapaneseJapan = 'JapaneseJapan',
  KannadaIndia = 'KannadaIndia',
  KazakhKazakhstan = 'KazakhKazakhstan',
  KonkaniIndia = 'KonkaniIndia',
  KoreanKorea = 'KoreanKorea',
  KyrgyzKazakhstan = 'KyrgyzKazakhstan',
  LatvianLatvia = 'LatvianLatvia',
  LithuanianLithuania = 'LithuanianLithuania',
  Macedonian = 'Macedonian',
  MalayBrunei = 'MalayBrunei',
  MalayMalaysia = 'MalayMalaysia',
  MarathiIndia = 'MarathiIndia',
  MongolianMongolia = 'MongolianMongolia',
  NorwegianNorway = 'NorwegianNorway',
  NorwegianNynorskNorway = 'NorwegianNynorskNorway',
  PolishPoland = 'PolishPoland',
  PortugueseBrazil = 'PortugueseBrazil',
  PortuguesePortugal = 'PortuguesePortugal',
  PunjabiIndia = 'PunjabiIndia',
  RomanianRomania = 'RomanianRomania',
  RussianRussia = 'RussianRussia',
  SanskritIndia = 'SanskritIndia',
  SerbianCyrillicSerbia = 'SerbianCyrillicSerbia',
  SerbianLatinSerbia = 'SerbianLatinSerbia',
  SlovakSlovakia = 'SlovakSlovakia',
  SlovenianSlovenia = 'SlovenianSlovenia',
  SpanishArgentina = 'SpanishArgentina',
  SpanishBolivia = 'SpanishBolivia',
  SpanishChile = 'SpanishChile',
  SpanishColombia = 'SpanishColombia',
  SpanishCostaRica = 'SpanishCostaRica',
  SpanishDominicanRepublic = 'SpanishDominicanRepublic',
  SpanishEcuador = 'SpanishEcuador',
  SpanishElSalvador = 'SpanishElSalvador',
  SpanishGuatemala = 'SpanishGuatemala',
  SpanishHonduras = 'SpanishHonduras',
  SpanishMexico = 'SpanishMexico',
  SpanishNicaragua = 'SpanishNicaragua',
  SpanishPanama = 'SpanishPanama',
  SpanishParaguay = 'SpanishParaguay',
  SpanishPeru = 'SpanishPeru',
  SpanishPuertoRico = 'SpanishPuertoRico',
  SpanishSpain = 'SpanishSpain',
  SpanishUruguay = 'SpanishUruguay',
  SpanishVenezuela = 'SpanishVenezuela',
  SwahiliKenya = 'SwahiliKenya',
  SwedishFinland = 'SwedishFinland',
  SwedishSweden = 'SwedishSweden',
  SyriacSyria = 'SyriacSyria',
  TamilIndia = 'TamilIndia',
  TatarRussia = 'TatarRussia',
  TeluguIndia = 'TeluguIndia',
  ThaiThailand = 'ThaiThailand',
  TurkishTurkey = 'TurkishTurkey',
  UkrainianUkraine = 'UkrainianUkraine',
  UrduPakistan = 'UrduPakistan',
  UzbekCyrillicUzbekistan = 'UzbekCyrillicUzbekistan',
  UzbekLatinUzbekistan = 'UzbekLatinUzbekistan',
  VietnameseVietnam = 'VietnameseVietnam',
  Zealand = 'Zealand'
}

export type Logbook = {
  __typename?: 'Logbook';
  _id: Scalars['ID']['output'];
  _id_turbine?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  createTS: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type LogbookComponent = {
  __typename?: 'LogbookComponent';
  alarm_code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type LogbookEntryLimited = {
  __typename?: 'LogbookEntryLimited';
  _id_park: Scalars['String']['output'];
  _id_process?: Maybe<Scalars['String']['output']>;
  _id_turbine?: Maybe<Scalars['String']['output']>;
  duration: Scalars['Float']['output'];
  tcu: Scalars['String']['output'];
  totalActualProduction: Scalars['Float']['output'];
  totalProductionLoss: Scalars['Float']['output'];
  totalRevenueLoss: Scalars['Float']['output'];
  windInLimits: Scalars['Float']['output'];
  windOutLimits: Scalars['Float']['output'];
};

export type LogbookFilterInput = {
  code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endTS?: InputMaybe<Scalars['Float']['input']>;
  startTS?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Array<InputMaybe<LogbookTypeEnum>>>;
};

export type LogbookSortInput = {
  code?: InputMaybe<Sort>;
  createTS?: InputMaybe<Sort>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export enum LogbookTypeEnum {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

export type LossValues = {
  __typename?: 'LossValues';
  productionLossMethodObject?: Maybe<ProductionLossMethodObject>;
  provider?: Maybe<Scalars['String']['output']>;
  subBlocks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  totalActualProductionOtherTurbines?: Maybe<Scalars['Float']['output']>;
  totalActualProductionTurbine?: Maybe<Scalars['Float']['output']>;
  totalProductionLoss: Scalars['Float']['output'];
  totalRevenue?: Maybe<Scalars['Float']['output']>;
  totalRevenueLoss: Scalars['Float']['output'];
  totalTheoProduction?: Maybe<Scalars['Float']['output']>;
};

export type LossesCount = {
  __typename?: 'LossesCount';
  count: Scalars['Int']['output'];
  day?: Maybe<Scalars['Int']['output']>;
};

export type MaintainType = {
  __typename?: 'MaintainType';
  createdOn?: Maybe<Scalars['Float']['output']>;
  endTS?: Maybe<Scalars['Float']['output']>;
  startTS?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  turbineCode?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Manufacturer = {
  __typename?: 'Manufacturer';
  _id: Scalars['ID']['output'];
  data: Data;
  name?: Maybe<Scalars['String']['output']>;
  turbineTypes?: Maybe<Array<Maybe<TurbineType>>>;
};

export type MetaData = {
  __typename?: 'MetaData';
  dataAquisitionMax?: Maybe<Date>;
  dataAquisitionMin?: Maybe<Date>;
};

export enum MeterPerSecond {
  Kmh = 'KMH'
}

export type Metmast = {
  __typename?: 'Metmast';
  _id?: Maybe<Scalars['ID']['output']>;
  _id_park?: Maybe<Scalars['ID']['output']>;
  _id_portfolio?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sensorsList?: Maybe<Array<Maybe<MetmastSensor>>>;
};


export type MetmastSensorsListArgs = {
  type?: InputMaybe<MetmastTypeEnum>;
};

export type MetmastSensor = {
  __typename?: 'MetmastSensor';
  _id?: Maybe<Scalars['ID']['output']>;
  _id_metmast?: Maybe<Scalars['ID']['output']>;
  _id_park?: Maybe<Scalars['ID']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  identification?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orientation?: Maybe<Scalars['String']['output']>;
  signalsList?: Maybe<Array<Maybe<MetmastSensorSignal>>>;
  type?: Maybe<MetmastSensorType>;
};


export type MetmastSensorSignalsListArgs = {
  stream?: InputMaybe<Array<InputMaybe<Stream>>>;
};

export type MetmastSensorSignal = {
  __typename?: 'MetmastSensorSignal';
  _id?: Maybe<Scalars['ID']['output']>;
  dbName?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  taxonomyName?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type MetmastSensorType = {
  __typename?: 'MetmastSensorType';
  _id?: Maybe<Scalars['ID']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum MetmastTypeEnum {
  Anemometer = 'anemometer',
  Barometer = 'barometer',
  Hygrometer = 'hygrometer',
  RainGauge = 'rain_gauge',
  Thermometer = 'thermometer',
  VerticalAnemometer = 'vertical_anemometer',
  WindVane = 'windVane'
}

export type MetmastWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MetricValues = {
  __typename?: 'MetricValues';
  metric?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type MixedDataSeriesDeviation = {
  __typename?: 'MixedDataSeriesDeviation';
  WCNV1_CnvTmpChokeCoil2_avg_per_deviation: SignalGroupedDataSeriesResult;
  WCNV1_CnvTmpChokeCoil3_avg_per_deviation: SignalGroupedDataSeriesResult;
  WCNV1_CnvTmpChokeCoil_avg_per_deviation: SignalGroupedDataSeriesResult;
  WCNV1_CnvTmpDclink_avg_per_deviation: SignalGroupedDataSeriesResult;
  WCNV1_CnvTmpWater_avg_per_deviation: SignalGroupedDataSeriesResult;
  WGEN1_GnTmpBrg1_avg_per_deviation: SignalGroupedDataSeriesResult;
  WGEN1_GnTmpBrg2_avg_per_deviation: SignalGroupedDataSeriesResult;
  WGEN1_GnTmpInlet_avg_per_deviation: SignalGroupedDataSeriesResult;
  WGEN1_GnTmpOutlet_avg_per_deviation: SignalGroupedDataSeriesResult;
  WGEN1_GnTmpPhase1_avg_per_deviation: SignalGroupedDataSeriesResult;
  WGEN1_GnTmpPhase2_avg_per_deviation: SignalGroupedDataSeriesResult;
  WGEN1_GnTmpPhase3_avg_per_deviation: SignalGroupedDataSeriesResult;
  WGEN1_GnTmpRtr_avg_per_deviation: SignalGroupedDataSeriesResult;
  WGEN1_GnTmpSlpRing1_avg_per_deviation: SignalGroupedDataSeriesResult;
  WGEN1_GnTmpSta2_avg_per_deviation: SignalGroupedDataSeriesResult;
  WGEN1_GnTmpSta3_avg_per_deviation: SignalGroupedDataSeriesResult;
  WGEN1_GnTmpSta4_avg_per_deviation: SignalGroupedDataSeriesResult;
  WGEN1_GnTmpSta5_avg_per_deviation: SignalGroupedDataSeriesResult;
  WGEN1_GnTmpSta6_avg_per_deviation: SignalGroupedDataSeriesResult;
  WGEN1_GnTmpSta_avg_per_deviation: SignalGroupedDataSeriesResult;
  WNAC1_CtrCabTmp_avg_per_deviation: SignalGroupedDataSeriesResult;
  WNAC1_ExTmp_avg_per_deviation: SignalGroupedDataSeriesResult;
  WNAC1_IntlTmp_avg_per_deviation: SignalGroupedDataSeriesResult;
  WNAC1_TopCtrCabTmp1_avg_per_deviation: SignalGroupedDataSeriesResult;
  WROT1_CtrCabTmp_avg_per_deviation: SignalGroupedDataSeriesResult;
  WROT1_HubTmp_avg_per_deviation: SignalGroupedDataSeriesResult;
  WROT1_PtHyOilTmp_avg_per_deviation: SignalGroupedDataSeriesResult;
  WTF1_TrfAuxTmp_avg_per_deviation: SignalGroupedDataSeriesResult;
  WTOW1_CtrCabTmp_avg_per_deviation: SignalGroupedDataSeriesResult;
  WTRF1_RoomTmp_avg_per_deviation: SignalGroupedDataSeriesResult;
  WTRF1_TrfCoreTmp1_avg_per_deviation: SignalGroupedDataSeriesResult;
  WTRF1_TrfCoreTmp2_avg_per_deviation: SignalGroupedDataSeriesResult;
  WTRF1_TrfCoreTmp3_avg_per_deviation: SignalGroupedDataSeriesResult;
  WTRF1_TrfOilTmp_avg_per_deviation: SignalGroupedDataSeriesResult;
  WTRF1_TrfTmpPhase1_avg_per_deviation: SignalGroupedDataSeriesResult;
  WTRF1_TrfTmpPhase2_avg_per_deviation: SignalGroupedDataSeriesResult;
  WTRF1_TrfTmpPhase3_avg_per_deviation: SignalGroupedDataSeriesResult;
  WTRM1_TrmTmpGbxBrg1_avg_per_deviation: SignalGroupedDataSeriesResult;
  WTRM1_TrmTmpGbxBrg2_avg_per_deviation: SignalGroupedDataSeriesResult;
  WTRM1_TrmTmpGbxBrg3_avg_per_deviation: SignalGroupedDataSeriesResult;
  WTRM1_TrmTmpGbxBrg4_avg_per_deviation: SignalGroupedDataSeriesResult;
  WTRM1_TrmTmpGbxBrg5_avg_per_deviation: SignalGroupedDataSeriesResult;
  WTRM1_TrmTmpGbxOil_avg_per_deviation: SignalGroupedDataSeriesResult;
  WTRM1_TrmTmpShfBrg1_avg_per_deviation: SignalGroupedDataSeriesResult;
  WTRM1_TrmTmpShfBrg2_avg_per_deviation: SignalGroupedDataSeriesResult;
  WTRM1_TrmTmpWtr_avg_per_deviation: SignalGroupedDataSeriesResult;
  WTUR1_TurTmpUPS_avg_per_deviation: SignalGroupedDataSeriesResult;
};

export type MixedFacts = {
  __typename?: 'MixedFacts';
  WCNV1_CnvTmpChokeCoil2_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WCNV1_CnvTmpChokeCoil3_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WCNV1_CnvTmpChokeCoil_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WCNV1_CnvTmpDclink_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WCNV1_CnvTmpWater_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WCNV2_CnvTmpDclink_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WCNV3_CnvTmpDclink_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WCNV4_CnvTmpDclink_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WCNV5_CnvTmpDclink_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WCNV6_CnvTmpDclink_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WCNV7_CnvTmpDclink_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WCNV8_CnvTmpDclink_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WCNV9_CnvTmpDclink_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WCNV10_CnvTmpDclink_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WCNV11_CnvTmpDclink_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WGEN1_GnTmpBrg1_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WGEN1_GnTmpBrg2_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WGEN1_GnTmpInlet_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WGEN1_GnTmpOutlet_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WGEN1_GnTmpPhase1_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WGEN1_GnTmpPhase2_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WGEN1_GnTmpPhase3_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WGEN1_GnTmpRtr_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WGEN1_GnTmpSlpRing1_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WGEN1_GnTmpSta_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WGEN1_Spd_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WGEN1_Spd_max_mag_f?: Maybe<SignalGroupedFactsResult>;
  WGEN1_Spd_min_mag_f?: Maybe<SignalGroupedFactsResult>;
  WNAC1_CtrCabTmp_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WNAC1_Dir_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WNAC1_ExTmp_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WNAC1_IntlTmp_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WNAC1_WdDir_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WNAC1_WdSpd_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WROT1_CtrCabTmp2_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WROT1_CtrCabTmp3_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WROT1_CtrCabTmp_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WROT1_HubTmp_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WROT1_PtAngValBl1_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WROT1_PtAngValBl2_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WROT1_PtAngValBl3_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WROT1_PtHyOilTmp_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WROT1_RotSpd_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WROT1_TmpBl1_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WROT1_TmpBl2_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WROT1_TmpBl3_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WTOW1_CtrCabTmp_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WTRF1_RoomTmp_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WTRF1_TrfOilTmp_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WTRF1_TrfTmpPhase1_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WTRF1_TrfTmpPhase2_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WTRF1_TrfTmpPhase3_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WTRM1_TrmTmpGbxBrg1_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WTRM1_TrmTmpGbxBrg2_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WTRM1_TrmTmpGbxBrg3_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WTRM1_TrmTmpGbxOil_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WTRM1_TrmTmpShfBrg1_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WTRM1_TrmTmpShfBrg2_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WTRM1_TrmTmpShfBrk_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WTUR1_W_avg_loss?: Maybe<SignalGroupedFactsResult>;
  WTUR1_W_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WTUR1_W_avg_rated?: Maybe<SignalGroupedFactsResult>;
  WTUR1_W_avg_theoretical?: Maybe<SignalGroupedFactsResult>;
  WTUR1_W_mag_f?: Maybe<SignalGroupedFactsResult>;
  WTUR1_W_theoretical?: Maybe<SignalGroupedFactsResult>;
  WTUR1_Wh_avg_mag_f?: Maybe<SignalGroupedFactsResult>;
  WTUR1_Wh_avg_mag_f_corrected?: Maybe<SignalGroupedFactsResult>;
  WTUR1_co2Avoided?: Maybe<SignalGroupedFactsResult>;
  WTUR1_incentive?: Maybe<SignalGroupedFactsResult>;
  WTUR1_incentive_avg?: Maybe<SignalGroupedFactsResult>;
  WTUR1_marketPrice?: Maybe<SignalGroupedFactsResult>;
  WTUR1_marketPrice_avg?: Maybe<SignalGroupedFactsResult>;
  WTUR1_per_avg_availability?: Maybe<SignalGroupedFactsResult>;
  WTUR1_per_avg_efficiency?: Maybe<SignalGroupedFactsResult>;
  WTUR1_per_avg_loadFactor?: Maybe<SignalGroupedFactsResult>;
  WTUR1_per_efficiency?: Maybe<SignalGroupedFactsResult>;
  WTUR1_revenue?: Maybe<SignalGroupedFactsResult>;
  WTUR1_revenueLosses?: Maybe<SignalGroupedFactsResult>;
  WTUR1_revenueLosses_avg?: Maybe<SignalGroupedFactsResult>;
  WTUR1_revenue_avg?: Maybe<SignalGroupedFactsResult>;
  WTUR1_status?: Maybe<SignalGroupedFactsResult>;
};


export type MixedFactsWcnv1_CnvTmpChokeCoil2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWcnv1_CnvTmpChokeCoil3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWcnv1_CnvTmpChokeCoil_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWcnv1_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWcnv1_CnvTmpWater_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWcnv2_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWcnv3_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWcnv4_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWcnv5_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWcnv6_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWcnv7_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWcnv8_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWcnv9_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWcnv10_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWcnv11_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWgen1_GnTmpBrg1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWgen1_GnTmpBrg2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWgen1_GnTmpInlet_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWgen1_GnTmpOutlet_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWgen1_GnTmpPhase1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWgen1_GnTmpPhase2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWgen1_GnTmpPhase3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWgen1_GnTmpRtr_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWgen1_GnTmpSlpRing1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWgen1_GnTmpSta_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWgen1_Spd_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWgen1_Spd_Max_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWgen1_Spd_Min_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWnac1_CtrCabTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWnac1_Dir_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWnac1_ExTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<Celcius>;
};


export type MixedFactsWnac1_IntlTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<Celcius>;
};


export type MixedFactsWnac1_WdDir_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWnac1_WdSpd_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<MeterPerSecond>;
};


export type MixedFactsWrot1_CtrCabTmp2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWrot1_CtrCabTmp3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWrot1_CtrCabTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWrot1_HubTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<Celcius>;
};


export type MixedFactsWrot1_PtAngValBl1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWrot1_PtAngValBl2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWrot1_PtAngValBl3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWrot1_PtHyOilTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWrot1_RotSpd_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWrot1_TmpBl1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWrot1_TmpBl2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWrot1_TmpBl3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtow1_CtrCabTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtrf1_RoomTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtrf1_TrfOilTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtrf1_TrfTmpPhase1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtrf1_TrfTmpPhase2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtrf1_TrfTmpPhase3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtrm1_TrmTmpGbxBrg1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtrm1_TrmTmpGbxBrg2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtrm1_TrmTmpGbxBrg3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtrm1_TrmTmpGbxOil_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtrm1_TrmTmpShfBrg1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtrm1_TrmTmpShfBrg2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtrm1_TrmTmpShfBrk_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtur1_W_Avg_LossArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtur1_W_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<Watt>;
};


export type MixedFactsWtur1_W_Avg_RatedArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtur1_W_Avg_TheoreticalArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<Watt>;
};


export type MixedFactsWtur1_W_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<Watt>;
};


export type MixedFactsWtur1_W_TheoreticalArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<Watt>;
};


export type MixedFactsWtur1_Wh_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtur1_Wh_Avg_Mag_F_CorrectedArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtur1_Co2AvoidedArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtur1_IncentiveArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtur1_Incentive_AvgArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtur1_MarketPriceArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtur1_MarketPrice_AvgArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtur1_Per_Avg_AvailabilityArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtur1_Per_Avg_EfficiencyArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtur1_Per_Avg_LoadFactorArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtur1_Per_EfficiencyArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtur1_RevenueArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtur1_RevenueLossesArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtur1_RevenueLosses_AvgArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtur1_Revenue_AvgArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedFactsWtur1_StatusArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};

export type MixedGroupedDataSeries = {
  __typename?: 'MixedGroupedDataSeries';
  WCNV1_CnvTmpChokeCoil2_avg_mag_f: SignalGroupedDataSeriesResult;
  WCNV1_CnvTmpChokeCoil3_avg_mag_f: SignalGroupedDataSeriesResult;
  WCNV1_CnvTmpChokeCoil_avg_mag_f: SignalGroupedDataSeriesResult;
  WCNV1_CnvTmpDclink_avg_mag_f: SignalGroupedDataSeriesResult;
  WCNV1_CnvTmpWater_avg_mag_f: SignalGroupedDataSeriesResult;
  WCNV2_CnvTmpDclink_avg_mag_f: SignalGroupedDataSeriesResult;
  WCNV3_CnvTmpDclink_avg_mag_f: SignalGroupedDataSeriesResult;
  WCNV4_CnvTmpDclink_avg_mag_f: SignalGroupedDataSeriesResult;
  WCNV5_CnvTmpDclink_avg_mag_f: SignalGroupedDataSeriesResult;
  WCNV6_CnvTmpDclink_avg_mag_f: SignalGroupedDataSeriesResult;
  WCNV7_CnvTmpDclink_avg_mag_f: SignalGroupedDataSeriesResult;
  WCNV8_CnvTmpDclink_avg_mag_f: SignalGroupedDataSeriesResult;
  WCNV9_CnvTmpDclink_avg_mag_f: SignalGroupedDataSeriesResult;
  WCNV10_CnvTmpDclink_avg_mag_f: SignalGroupedDataSeriesResult;
  WCNV11_CnvTmpDclink_avg_mag_f: SignalGroupedDataSeriesResult;
  WGEN1_GnTmpBrg1_avg_mag_f: SignalGroupedDataSeriesResult;
  WGEN1_GnTmpBrg2_avg_mag_f: SignalGroupedDataSeriesResult;
  WGEN1_GnTmpInlet_avg_mag_f: SignalGroupedDataSeriesResult;
  WGEN1_GnTmpOutlet_avg_mag_f: SignalGroupedDataSeriesResult;
  WGEN1_GnTmpPhase1_avg_mag_f: SignalGroupedDataSeriesResult;
  WGEN1_GnTmpPhase2_avg_mag_f: SignalGroupedDataSeriesResult;
  WGEN1_GnTmpPhase3_avg_mag_f: SignalGroupedDataSeriesResult;
  WGEN1_GnTmpRtr_avg_mag_f: SignalGroupedDataSeriesResult;
  WGEN1_GnTmpSlpRing1_avg_mag_f: SignalGroupedDataSeriesResult;
  WGEN1_GnTmpSta_avg_mag_f: SignalGroupedDataSeriesResult;
  WGEN1_Spd_avg_mag_f: SignalGroupedDataSeriesResult;
  WGEN1_Spd_max_mag_f: SignalGroupedDataSeriesResult;
  WGEN1_Spd_min_mag_f: SignalGroupedDataSeriesResult;
  WNAC1_CtrCabTmp_avg_mag_f: SignalGroupedDataSeriesResult;
  WNAC1_Dir_avg_mag_f: SignalGroupedDataSeriesResult;
  WNAC1_ExTmp_avg_mag_f: SignalGroupedDataSeriesResult;
  WNAC1_IntlTmp_avg_mag_f: SignalGroupedDataSeriesResult;
  WNAC1_WdDir_avg_mag_f: SignalGroupedDataSeriesResult;
  WNAC1_WdSpd_avg_mag_f: SignalGroupedDataSeriesResult;
  WROT1_CtrCabTmp2_avg_mag_f: SignalGroupedDataSeriesResult;
  WROT1_CtrCabTmp3_avg_mag_f: SignalGroupedDataSeriesResult;
  WROT1_CtrCabTmp_avg_mag_f: SignalGroupedDataSeriesResult;
  WROT1_HubTmp_avg_mag_f: SignalGroupedDataSeriesResult;
  WROT1_PtAngValBl1_avg_mag_f: SignalGroupedDataSeriesResult;
  WROT1_PtAngValBl2_avg_mag_f: SignalGroupedDataSeriesResult;
  WROT1_PtAngValBl3_avg_mag_f: SignalGroupedDataSeriesResult;
  WROT1_PtHyOilTmp_avg_mag_f: SignalGroupedDataSeriesResult;
  WROT1_RotSpd_avg_mag_f: SignalGroupedDataSeriesResult;
  WROT1_TmpBl1_avg_mag_f: SignalGroupedDataSeriesResult;
  WROT1_TmpBl2_avg_mag_f: SignalGroupedDataSeriesResult;
  WROT1_TmpBl3_avg_mag_f: SignalGroupedDataSeriesResult;
  WTOW1_CtrCabTmp_avg_mag_f: SignalGroupedDataSeriesResult;
  WTRF1_RoomTmp_avg_mag_f: SignalGroupedDataSeriesResult;
  WTRF1_TrfOilTmp_avg_mag_f: SignalGroupedDataSeriesResult;
  WTRF1_TrfTmpPhase1_avg_mag_f: SignalGroupedDataSeriesResult;
  WTRF1_TrfTmpPhase2_avg_mag_f: SignalGroupedDataSeriesResult;
  WTRF1_TrfTmpPhase3_avg_mag_f: SignalGroupedDataSeriesResult;
  WTRM1_TrmTmpGbxBrg1_avg_mag_f: SignalGroupedDataSeriesResult;
  WTRM1_TrmTmpGbxBrg2_avg_mag_f: SignalGroupedDataSeriesResult;
  WTRM1_TrmTmpGbxBrg3_avg_mag_f: SignalGroupedDataSeriesResult;
  WTRM1_TrmTmpGbxOil_avg_mag_f: SignalGroupedDataSeriesResult;
  WTRM1_TrmTmpShfBrg1_avg_mag_f: SignalGroupedDataSeriesResult;
  WTRM1_TrmTmpShfBrg2_avg_mag_f: SignalGroupedDataSeriesResult;
  WTRM1_TrmTmpShfBrk_avg_mag_f: SignalGroupedDataSeriesResult;
  WTUR1_W_avg_loss: SignalGroupedDataSeriesResult;
  WTUR1_W_avg_mag_f: SignalGroupedDataSeriesResult;
  WTUR1_W_avg_rated: SignalGroupedDataSeriesResult;
  WTUR1_W_avg_theoretical: SignalGroupedDataSeriesResult;
  WTUR1_W_mag_f: SignalGroupedDataSeriesResult;
  WTUR1_W_theoretical: SignalGroupedDataSeriesResult;
  WTUR1_Wh_avg_mag_f: SignalGroupedDataSeriesResult;
  WTUR1_Wh_avg_mag_f_corrected: SignalGroupedDataSeriesResult;
  WTUR1_co2Avoided: SignalGroupedDataSeriesResult;
  WTUR1_incentive: SignalGroupedDataSeriesResult;
  WTUR1_incentive_avg: SignalGroupedDataSeriesResult;
  WTUR1_marketPrice: SignalGroupedDataSeriesResult;
  WTUR1_marketPrice_avg: SignalGroupedDataSeriesResult;
  WTUR1_per_avg_availability: SignalGroupedDataSeriesResult;
  WTUR1_per_avg_efficiency: SignalGroupedDataSeriesResult;
  WTUR1_per_avg_loadFactor: SignalGroupedDataSeriesResult;
  WTUR1_per_efficiency: SignalGroupedDataSeriesResult;
  WTUR1_revenue: SignalGroupedDataSeriesResult;
  WTUR1_revenueLosses: SignalGroupedDataSeriesResult;
  WTUR1_revenueLosses_avg: SignalGroupedDataSeriesResult;
  WTUR1_revenue_avg: SignalGroupedDataSeriesResult;
  WTUR1_status: SignalGroupedDataSeriesResult;
};


export type MixedGroupedDataSeriesWcnv1_CnvTmpChokeCoil2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWcnv1_CnvTmpChokeCoil3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWcnv1_CnvTmpChokeCoil_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWcnv1_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWcnv1_CnvTmpWater_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWcnv2_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWcnv3_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWcnv4_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWcnv5_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWcnv6_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWcnv7_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWcnv8_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWcnv9_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWcnv10_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWcnv11_CnvTmpDclink_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWgen1_GnTmpBrg1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWgen1_GnTmpBrg2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWgen1_GnTmpInlet_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWgen1_GnTmpOutlet_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWgen1_GnTmpPhase1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWgen1_GnTmpPhase2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWgen1_GnTmpPhase3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWgen1_GnTmpRtr_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWgen1_GnTmpSlpRing1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWgen1_GnTmpSta_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWgen1_Spd_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWgen1_Spd_Max_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWgen1_Spd_Min_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWnac1_CtrCabTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWnac1_Dir_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWnac1_ExTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<Celcius>;
};


export type MixedGroupedDataSeriesWnac1_IntlTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<Celcius>;
};


export type MixedGroupedDataSeriesWnac1_WdDir_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWnac1_WdSpd_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<MeterPerSecond>;
};


export type MixedGroupedDataSeriesWrot1_CtrCabTmp2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWrot1_CtrCabTmp3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWrot1_CtrCabTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWrot1_HubTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<Celcius>;
};


export type MixedGroupedDataSeriesWrot1_PtAngValBl1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWrot1_PtAngValBl2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWrot1_PtAngValBl3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWrot1_PtHyOilTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWrot1_RotSpd_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWrot1_TmpBl1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWrot1_TmpBl2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWrot1_TmpBl3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWtow1_CtrCabTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWtrf1_RoomTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWtrf1_TrfOilTmp_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWtrf1_TrfTmpPhase1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWtrf1_TrfTmpPhase2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWtrf1_TrfTmpPhase3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWtrm1_TrmTmpGbxBrg1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWtrm1_TrmTmpGbxBrg2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWtrm1_TrmTmpGbxBrg3_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWtrm1_TrmTmpGbxOil_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWtrm1_TrmTmpShfBrg1_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWtrm1_TrmTmpShfBrg2_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWtrm1_TrmTmpShfBrk_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWtur1_W_Avg_LossArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWtur1_W_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<Watt>;
};


export type MixedGroupedDataSeriesWtur1_W_Avg_RatedArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWtur1_W_Avg_TheoreticalArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<Watt>;
};


export type MixedGroupedDataSeriesWtur1_W_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<Watt>;
};


export type MixedGroupedDataSeriesWtur1_W_TheoreticalArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<Watt>;
};


export type MixedGroupedDataSeriesWtur1_Wh_Avg_Mag_FArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<Watt_Hour>;
};


export type MixedGroupedDataSeriesWtur1_Wh_Avg_Mag_F_CorrectedArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  convert?: InputMaybe<Watt_Hour>;
};


export type MixedGroupedDataSeriesWtur1_Co2AvoidedArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWtur1_IncentiveArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWtur1_Incentive_AvgArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWtur1_MarketPriceArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWtur1_MarketPrice_AvgArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWtur1_Per_Avg_AvailabilityArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWtur1_Per_Avg_EfficiencyArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWtur1_Per_Avg_LoadFactorArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWtur1_Per_EfficiencyArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWtur1_RevenueArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWtur1_RevenueLossesArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWtur1_RevenueLosses_AvgArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWtur1_Revenue_AvgArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};


export type MixedGroupedDataSeriesWtur1_StatusArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
};

export enum Module {
  Analyze = 'Analyze',
  Budget = 'Budget',
  Forecast = 'Forecast',
  Maintain = 'Maintain',
  Monitor = 'Monitor',
  Troubleshoot = 'Troubleshoot'
}

export type MultiUpdatedChangeLog = ChangeLog & {
  __typename?: 'MultiUpdatedChangeLog';
  action: Scalars['String']['output'];
  date: Scalars['Float']['output'];
  field: Scalars['String']['output'];
  subject?: Maybe<Subject>;
};

export type MultipleTicketsMultipleIntegrationsInput = {
  id_devices: Array<InputMaybe<Scalars['ID']['input']>>;
  id_integrations: Array<InputMaybe<Scalars['ID']['input']>>;
  id_tickets: Array<InputMaybe<Scalars['ID']['input']>>;
  type: IntegrationType;
};

export type Mutation = {
  __typename?: 'Mutation';
  acknowledgeAlarm: Scalars['Boolean']['output'];
  acknowledgeAlarmByCode: Scalars['Boolean']['output'];
  addAssets?: Maybe<Ticket>;
  addTicketAttachment: Scalars['Boolean']['output'];
  addTicketComment?: Maybe<TicketComment>;
  addTicketCustomField?: Maybe<TicketInformation>;
  assingUserToTicket?: Maybe<Ticket>;
  bindUser: Scalars['Boolean']['output'];
  changeArchState?: Maybe<Ticket>;
  changeFavState?: Maybe<Ticket>;
  changeStatusOrder?: Maybe<Board>;
  changeTicketCustomField?: Maybe<TicketInformation>;
  changeTicketCustomFieldName?: Maybe<Scalars['Boolean']['output']>;
  changeTicketPriority?: Maybe<Ticket>;
  changeTicketStatus?: Maybe<Ticket>;
  changeTicketTitle?: Maybe<Ticket>;
  controlroomAck: Scalars['Boolean']['output'];
  controlroomCreateTicket: Scalars['Boolean']['output'];
  createDataAnalysisQuery: DataAnalysisQuery;
  createDismissRule: Scalars['Boolean']['output'];
  createEventRule: Scalars['Boolean']['output'];
  createFollowUpComment: Scalars['Boolean']['output'];
  createFollowUpRule: Scalars['Boolean']['output'];
  createReport: Reportb;
  createReportTemplate: ReportTemplateResponse;
  createTicket: Ticket;
  createUserCustomPortfolio?: Maybe<UserPortfolio>;
  deleteDataAnalysisQuery: Scalars['Boolean']['output'];
  /** @deprecated Field is deprecated! */
  deleteDataStudioFile: Scalars['Boolean']['output'];
  deleteEventRule: Scalars['Boolean']['output'];
  deleteReport: Scalars['Boolean']['output'];
  deleteReportTemplate: ReportTemplateResponse;
  deleteTicket: Scalars['Boolean']['output'];
  deleteTicketAttachment: Scalars['Boolean']['output'];
  deleteTicketComment?: Maybe<Scalars['Boolean']['output']>;
  deleteTicketCustomField?: Maybe<TicketInformation>;
  deleteTicketIntegration?: Maybe<Scalars['Boolean']['output']>;
  deleteUserCustomPortfolio?: Maybe<Scalars['Boolean']['output']>;
  editEventRule: Scalars['Boolean']['output'];
  editReportTemplate: ReportTemplateResponse;
  fosenReportSaveBudgetValues: Scalars['Boolean']['output'];
  fosenReportSaveCost: Scalars['Boolean']['output'];
  hideColumn?: Maybe<Board>;
  logoutDeviceToken: Scalars['Boolean']['output'];
  removeAssets?: Maybe<Ticket>;
  removeConfiguredTopt: Scalars['Boolean']['output'];
  removeDismissRule: Scalars['Boolean']['output'];
  removeFollowUpRule: Scalars['Boolean']['output'];
  requestOtpConfigEmail: Scalars['Boolean']['output'];
  requestPasswordResetEmail: Scalars['Boolean']['output'];
  saveDeviceToken: Scalars['Boolean']['output'];
  saveInvoice: Scalars['Boolean']['output'];
  saveParkHeatmapThresholds: Scalars['Boolean']['output'];
  saveTurbineHeatmapThresholds: Scalars['Boolean']['output'];
  saveTurbineLogbookEntry: Scalars['Boolean']['output'];
  sendReportEmail: Scalars['Boolean']['output'];
  setAlarmTickets: Scalars['Boolean']['output'];
  setDefaultCustomPortfolio?: Maybe<Scalars['Boolean']['output']>;
  setDeleteTicketState?: Maybe<Ticket>;
  setEventActiveState: Scalars['Boolean']['output'];
  setKPITableCustomSettings?: Maybe<Scalars['Boolean']['output']>;
  setKpiVsTargetTableCustomSettings?: Maybe<Scalars['Boolean']['output']>;
  setMultipleTicketsToMultipleIntegrations?: Maybe<Scalars['Boolean']['output']>;
  setPreferences: PreferenceList;
  setTicketAssignees?: Maybe<Ticket>;
  setTicketDescription?: Maybe<TicketInformation>;
  setTicketIntegration: Array<Maybe<Integration>>;
  setTicketModules?: Maybe<Ticket>;
  unassignProcessToTurbineLogbook: Scalars['Boolean']['output'];
  unassignUserFromTicket?: Maybe<Ticket>;
  updateDataAnalysisQuery: Scalars['Boolean']['output'];
  updateDueDate?: Maybe<Ticket>;
  updateNotification?: Maybe<Notification>;
  updateReport: Scalars['Boolean']['output'];
  updateTicketBoard?: Maybe<Ticket>;
  updateTicketTemplate?: Maybe<Ticket>;
  updateUserCustomPortfolio?: Maybe<UserPortfolio>;
};


export type MutationAcknowledgeAlarmArgs = {
  _id: Scalars['String']['input'];
  _id_turbine: Scalars['String']['input'];
};


export type MutationAcknowledgeAlarmByCodeArgs = {
  _id_turbine: Scalars['String']['input'];
  code: Scalars['String']['input'];
};


export type MutationAddAssetsArgs = {
  input?: InputMaybe<AddAssetsInput>;
};


export type MutationAddTicketAttachmentArgs = {
  input?: InputMaybe<TicketAttachmentInput>;
};


export type MutationAddTicketCommentArgs = {
  input?: InputMaybe<TicketCommentInput>;
};


export type MutationAddTicketCustomFieldArgs = {
  input?: InputMaybe<AddTicketCustomFieldInput>;
};


export type MutationAssingUserToTicketArgs = {
  input?: InputMaybe<AssignUserToTicketInput>;
};


export type MutationChangeArchStateArgs = {
  input?: InputMaybe<TicketArchInput>;
};


export type MutationChangeFavStateArgs = {
  input?: InputMaybe<TicketFavInput>;
};


export type MutationChangeStatusOrderArgs = {
  input?: InputMaybe<ChangeOrderStatusInput>;
};


export type MutationChangeTicketCustomFieldArgs = {
  input?: InputMaybe<ChangeTicketCustomFieldInput>;
};


export type MutationChangeTicketCustomFieldNameArgs = {
  input?: InputMaybe<ChangeTicketCustomFieldNameInput>;
};


export type MutationChangeTicketPriorityArgs = {
  input?: InputMaybe<ChangeTicketPriorityInput>;
};


export type MutationChangeTicketStatusArgs = {
  input?: InputMaybe<ChangeTicketStatusInput>;
};


export type MutationChangeTicketTitleArgs = {
  input?: InputMaybe<ChangeTicketTitleInput>;
};


export type MutationControlroomAckArgs = {
  _id_alarm?: InputMaybe<Scalars['String']['input']>;
  turbineCode?: InputMaybe<Scalars['String']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationControlroomCreateTicketArgs = {
  _id_alarm?: InputMaybe<Scalars['String']['input']>;
  alarmCategory?: InputMaybe<Scalars['Int']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createTS?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  turbineCode?: InputMaybe<Scalars['String']['input']>;
  turbineStatus?: InputMaybe<Scalars['String']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateDataAnalysisQueryArgs = {
  query: CreateDataAnalysisQueryInput;
};


export type MutationCreateDismissRuleArgs = {
  _id_turbine: Scalars['String']['input'];
  code: Scalars['String']['input'];
};


export type MutationCreateEventRuleArgs = {
  eventRule?: InputMaybe<UserEventInput>;
};


export type MutationCreateFollowUpCommentArgs = {
  _id: Scalars['String']['input'];
  message: Scalars['String']['input'];
};


export type MutationCreateFollowUpRuleArgs = {
  _id_turbine: Scalars['String']['input'];
  code: Scalars['String']['input'];
  cutOffDate: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  message: Scalars['String']['input'];
};


export type MutationCreateReportArgs = {
  report?: InputMaybe<ReportSchemaInput>;
};


export type MutationCreateReportTemplateArgs = {
  isDefaultTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateTicketArgs = {
  input?: InputMaybe<CreateTicketInput>;
};


export type MutationCreateUserCustomPortfolioArgs = {
  userPortfolios: UserCustomPortfolioInput;
};


export type MutationDeleteDataAnalysisQueryArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteDataStudioFileArgs = {
  fileLink: Scalars['String']['input'];
};


export type MutationDeleteEventRuleArgs = {
  _id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteReportArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteReportTemplateArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTicketArgs = {
  input?: InputMaybe<DeleteInput>;
};


export type MutationDeleteTicketAttachmentArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteTicketCommentArgs = {
  input?: InputMaybe<TicketCommentDelInput>;
};


export type MutationDeleteTicketCustomFieldArgs = {
  input?: InputMaybe<DeleteTicketCustomFieldInput>;
};


export type MutationDeleteTicketIntegrationArgs = {
  input?: InputMaybe<TicketIntegrationDelInput>;
};


export type MutationDeleteUserCustomPortfolioArgs = {
  _id: Scalars['String']['input'];
};


export type MutationEditEventRuleArgs = {
  _id: Scalars['ID']['input'];
  eventRule?: InputMaybe<UserEventInput>;
};


export type MutationEditReportTemplateArgs = {
  id: Scalars['String']['input'];
  isDefaultTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<Scalars['String']['input']>;
};


export type MutationFosenReportSaveBudgetValuesArgs = {
  WP1PlannedProduction: Scalars['Float']['input'];
  WP1TotalCost: Scalars['Float']['input'];
  _id_park: Scalars['String']['input'];
  yearMonth: Scalars['Int']['input'];
};


export type MutationFosenReportSaveCostArgs = {
  NWPProQuotaActualQuaterlyCost: Scalars['Float']['input'];
  _id_park: Scalars['String']['input'];
  yearMonth: Scalars['Int']['input'];
};


export type MutationHideColumnArgs = {
  input?: InputMaybe<HideColumnInput>;
};


export type MutationRemoveAssetsArgs = {
  input?: InputMaybe<RemoveAssetsInput>;
};


export type MutationRemoveDismissRuleArgs = {
  _id: Scalars['String']['input'];
};


export type MutationRemoveFollowUpRuleArgs = {
  _id: Scalars['String']['input'];
};


export type MutationSaveDeviceTokenArgs = {
  os: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSaveInvoiceArgs = {
  _id_park: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  compensated?: InputMaybe<InvoiceValues>;
  delivered?: InputMaybe<InvoiceValues>;
  files?: InputMaybe<Array<InputMaybe<File>>>;
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type MutationSaveParkHeatmapThresholdsArgs = {
  _id_park: Scalars['ID']['input'];
  turbineTypes: Array<ParkTurbineTypeThresholdInput>;
};


export type MutationSaveTurbineHeatmapThresholdsArgs = {
  _id_park?: InputMaybe<Scalars['ID']['input']>;
  _id_turbine: Scalars['ID']['input'];
  thresholds: Array<TurbineSignalThresholdInput>;
};


export type MutationSaveTurbineLogbookEntryArgs = {
  endTS?: InputMaybe<Scalars['Float']['input']>;
  input?: InputMaybe<Array<InputMaybe<TurbineLogbookEntryInput>>>;
  inputEvent?: InputMaybe<Array<InputMaybe<TurbineLogbookEventInput>>>;
  level?: InputMaybe<Scalars['String']['input']>;
  originalBlocks?: InputMaybe<Array<InputMaybe<TurbineLogbookEntryInput>>>;
  processAssignment?: InputMaybe<ProcessAssignment>;
  startTS?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationSendReportEmailArgs = {
  emails: Array<InputMaybe<Scalars['String']['input']>>;
  reportId: Scalars['String']['input'];
};


export type MutationSetAlarmTicketsArgs = {
  _id: Scalars['String']['input'];
  _id_turbine: Scalars['String']['input'];
  tickets: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationSetDefaultCustomPortfolioArgs = {
  _id: Scalars['String']['input'];
};


export type MutationSetDeleteTicketStateArgs = {
  input?: InputMaybe<DeleteInput>;
};


export type MutationSetEventActiveStateArgs = {
  _id?: InputMaybe<Scalars['String']['input']>;
  active: Scalars['Boolean']['input'];
};


export type MutationSetKpiTableCustomSettingsArgs = {
  _id_park_?: InputMaybe<Scalars['ID']['input']>;
  _id_portfolio?: InputMaybe<Scalars['ID']['input']>;
  customizationTable: Scalars['String']['input'];
  tableUniqueName: Scalars['String']['input'];
};


export type MutationSetKpiVsTargetTableCustomSettingsArgs = {
  customizationTable: Scalars['String']['input'];
  parkName?: InputMaybe<Scalars['String']['input']>;
  tableUniqueName?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationSetMultipleTicketsToMultipleIntegrationsArgs = {
  input?: InputMaybe<MultipleTicketsMultipleIntegrationsInput>;
};


export type MutationSetPreferencesArgs = {
  preferences: PreferencesInput;
};


export type MutationSetTicketAssigneesArgs = {
  input?: InputMaybe<SetTicketAssigneesInput>;
};


export type MutationSetTicketDescriptionArgs = {
  input?: InputMaybe<SetTicketDescriptionInput>;
};


export type MutationSetTicketIntegrationArgs = {
  input?: InputMaybe<TicketIntegrationInput>;
};


export type MutationSetTicketModulesArgs = {
  input?: InputMaybe<SetTicketModulesInput>;
};


export type MutationUnassignProcessToTurbineLogbookArgs = {
  _id?: InputMaybe<Scalars['String']['input']>;
  blockActionsLog?: InputMaybe<Scalars['String']['input']>;
  mutTS?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUnassignUserFromTicketArgs = {
  input?: InputMaybe<AssignUserToTicketInput>;
};


export type MutationUpdateDataAnalysisQueryArgs = {
  query: UpdateDataAnalysisQueryInput;
};


export type MutationUpdateDueDateArgs = {
  input?: InputMaybe<UpdateDueDateInput>;
};


export type MutationUpdateNotificationArgs = {
  input?: InputMaybe<NotificationInput>;
};


export type MutationUpdateReportArgs = {
  report?: InputMaybe<ReportSchemaInput>;
};


export type MutationUpdateTicketBoardArgs = {
  input?: InputMaybe<UpdateTicketBoardInput>;
};


export type MutationUpdateTicketTemplateArgs = {
  input?: InputMaybe<TicketTemplateInput>;
};


export type MutationUpdateUserCustomPortfolioArgs = {
  userPortfolios: UserCustomPortfolioInput;
};

export type NeighbouringWindparkData = {
  __typename?: 'NeighbouringWindparkData';
  _id?: Maybe<Scalars['String']['output']>;
  dataQuality?: Maybe<Scalars['Float']['output']>;
  distance?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  production?: Maybe<Scalars['Float']['output']>;
};

export type Notification = {
  __typename?: 'Notification';
  id: Scalars['ID']['output'];
  notify_assignee: Scalars['Boolean']['output'];
  notify_comment: Scalars['Boolean']['output'];
  notify_status: Scalars['Boolean']['output'];
};

export type NotificationInput = {
  id_notification: Scalars['ID']['input'];
  notify_assignee: Scalars['Boolean']['input'];
  notify_comment: Scalars['Boolean']['input'];
  notify_status: Scalars['Boolean']['input'];
};

export type NumberObject = {
  __typename?: 'NumberObject';
  value?: Maybe<Scalars['Float']['output']>;
};

export type NumberOptionsInput = {
  op_eq?: InputMaybe<Scalars['Float']['input']>;
  op_gt?: InputMaybe<Scalars['Float']['input']>;
  op_gte?: InputMaybe<Scalars['Float']['input']>;
  op_lt?: InputMaybe<Scalars['Float']['input']>;
  op_lte?: InputMaybe<Scalars['Float']['input']>;
};

export type OperatingPoint = {
  __typename?: 'OperatingPoint';
  ambientTemperature?: Maybe<Scalars['Float']['output']>;
  rawWindSpeed?: Maybe<Scalars['Float']['output']>;
};

export type Park = {
  __typename?: 'Park';
  _id: Scalars['ID']['output'];
  ackAndConfirmedCount?: Maybe<ParkAckAndConfirmedCount>;
  ackCount?: Maybe<AckCount>;
  ackCountPerDay?: Maybe<Array<Maybe<AckCountPerDay>>>;
  aggregatedAlarms?: Maybe<Array<Maybe<AggregatedAlarms>>>;
  alarmCount: Scalars['Int']['output'];
  alarms?: Maybe<Array<Maybe<Alarm>>>;
  alarmsCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  alarmsOld: Array<Maybe<AlarmsOld>>;
  analyze: Analyze;
  anualProdEst?: Maybe<Scalars['Float']['output']>;
  availabilityInfo?: Maybe<AvailabilityInfo>;
  availableSignalCount: Scalars['Int']['output'];
  avgAreaPrice?: Maybe<Array<Maybe<AvgAreaPrice>>>;
  avgCapturedPrice?: Maybe<Array<Maybe<AvgCapturedPrice>>>;
  budget: Scalars['Float']['output'];
  budget2?: Maybe<Array<Maybe<BudgetFollowUp>>>;
  budgetYTD?: Maybe<BudgetData>;
  cmsAlarms?: Maybe<Array<Maybe<CmsAlarm>>>;
  co2: Scalars['Float']['output'];
  code: Scalars['String']['output'];
  commissioned?: Maybe<Scalars['String']['output']>;
  controlSystem?: Maybe<Array<ControlSystem>>;
  country: Country;
  currentWeather?: Maybe<IconWeather>;
  dailyAvailabilities?: Maybe<Array<Maybe<AvailabilityPark>>>;
  data: Data;
  data10M: Data10M;
  data30sAvailable: Scalars['Boolean']['output'];
  dataDebbug: Data;
  dataGranularity: Scalars['Int']['output'];
  dataSeries?: Maybe<DataSeries>;
  dataStudio?: Maybe<Array<Maybe<DataSerieResult>>>;
  displayCode?: Maybe<Scalars['String']['output']>;
  energyMeterAvailable: Scalars['Boolean']['output'];
  energyMeterDataseries?: Maybe<Array<Maybe<EnergyMeterDataseriesValue>>>;
  energyMeterTotals?: Maybe<EnergyMeterTotals>;
  fe_name: Scalars['String']['output'];
  filteredData: Array<ParkFilteredData>;
  filteredGroupedDataSeries: Array<FilteredGroupedDataSeries>;
  firstAvailableTS?: Maybe<Scalars['Float']['output']>;
  forecastAccuracy?: Maybe<ForecastAccuracy>;
  forecastDataSeries?: Maybe<ForecastDataSeries>;
  groupedDataSeries: GroupedDataSeries;
  groupedFacts: GroupedFacts;
  hasMissingBlocks: Array<Turbine>;
  hasPerformanceWatchdogTrainingData: Scalars['Boolean']['output'];
  initialData?: Maybe<Scalars['String']['output']>;
  isDNVForecastAvailable: Scalars['Boolean']['output'];
  isGreen: Scalars['Boolean']['output'];
  isMeteologicaForecastAvailable: Scalars['Boolean']['output'];
  isWindlogForecastAvailable: Scalars['Boolean']['output'];
  kpiFollowUp?: Maybe<KpiFollowUp>;
  lat: Scalars['Float']['output'];
  logbook: Array<Maybe<Logbook>>;
  logbookCount: Scalars['Float']['output'];
  lon: Scalars['Float']['output'];
  lossesCount?: Maybe<LossesCount>;
  metaData: MetaData;
  metmasts?: Maybe<Array<Metmast>>;
  monthlyAvailabilities?: Maybe<Array<Maybe<AvailabilityPark>>>;
  name: Scalars['String']['output'];
  parkGridCurtailments?: Maybe<Array<Maybe<ParkLogbookEntry>>>;
  parkLogbook?: Maybe<Array<Maybe<ParkLogbookEntry>>>;
  parkLogbookByTCU?: Maybe<Array<Maybe<LogbookEntryLimited>>>;
  parkLogbookLosses?: Maybe<Array<Maybe<ParkLogbookEntry>>>;
  parkLogbookSummary?: Maybe<Array<Maybe<ParkLogbookEntry>>>;
  parkLogbookSummaryExport?: Maybe<Array<Maybe<ParkLogbookEntry>>>;
  parkSubType: Array<ParkSubType>;
  performanceAnalytics: PerformanceAnalytics;
  periodAvailabilitiesPerTurbine?: Maybe<Array<Maybe<AvailabilityPark>>>;
  portfolio: Portfolio;
  rangeWindrose?: Maybe<Array<Maybe<WindRoseDataType>>>;
  reference: Reference;
  revenuesDataseries?: Maybe<Array<Maybe<RevenuesDataseriesValue>>>;
  signalList?: Maybe<Array<Maybe<ParkSignal>>>;
  t3_1_bkw?: Maybe<T31BkwRule>;
  targetCaptureRatio?: Maybe<Array<Maybe<TargetCaptureRatio>>>;
  targetPrice?: Maybe<Array<Maybe<TargetPrice>>>;
  tickets?: Maybe<Array<Maybe<Ticket>>>;
  ticketsCount: Scalars['Int']['output'];
  timeseries: Timeseries;
  timezone: Scalars['String']['output'];
  totalSignalCount: Scalars['Int']['output'];
  turbines: Array<Turbine>;
  turbinesPowerCurveSelection?: Maybe<Array<Maybe<TurbinePowercurveData>>>;
  windCaptureRatio?: Maybe<Array<Maybe<WindCaptureRatio>>>;
  windRose?: Maybe<Array<Maybe<WindRoseDataType>>>;
  windRoseDataQuality: WindRoseDataQualityType;
  windRoseDataQualityFullInfo: WindRoseDataQualityFullInfoType;
};


export type ParkAckAndConfirmedCountArgs = {
  endTS: Scalars['Float']['input'];
  startTS: Scalars['Float']['input'];
};


export type ParkAckCountPerDayArgs = {
  endTS?: InputMaybe<Scalars['Float']['input']>;
  startTS?: InputMaybe<Scalars['Float']['input']>;
};


export type ParkAggregatedAlarmsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AggregatedAlarmsSortInput>;
};


export type ParkAlarmCountArgs = {
  alarmCategory?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  controlroomAck?: InputMaybe<Scalars['Boolean']['input']>;
  controlroomTicketing?: InputMaybe<Scalars['Boolean']['input']>;
  fromTS?: InputMaybe<Scalars['Float']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  toTS?: InputMaybe<Scalars['Float']['input']>;
};


export type ParkAlarmsArgs = {
  alarmCategory?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  controlroomAck?: InputMaybe<Scalars['Boolean']['input']>;
  controlroomTicketing?: InputMaybe<Scalars['Boolean']['input']>;
  fromTS?: InputMaybe<Scalars['Float']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<AlarmSortInput>;
  toTS?: InputMaybe<Scalars['Float']['input']>;
};


export type ParkAlarmsOldArgs = {
  where?: InputMaybe<AlarmsOldWhere>;
};


export type ParkAvgAreaPriceArgs = {
  from: Scalars['Float']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Float']['input'];
};


export type ParkAvgCapturedPriceArgs = {
  from: Scalars['Float']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Float']['input'];
};


export type ParkBudgetArgs = {
  endTS: Scalars['Float']['input'];
  startTS: Scalars['Float']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type ParkBudget2Args = {
  granularity: BudgetGranularity;
  month: Scalars['Int']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  year: Scalars['Int']['input'];
};


export type ParkCmsAlarmsArgs = {
  endTS?: InputMaybe<Scalars['Float']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
  startTS?: InputMaybe<Scalars['Float']['input']>;
};


export type ParkControlSystemArgs = {
  where?: InputMaybe<ControlSystemWhereInput>;
};


export type ParkDailyAvailabilitiesArgs = {
  endTS: Scalars['Float']['input'];
  startTS: Scalars['Float']['input'];
};


export type ParkDataSeriesArgs = {
  defaultValue?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['Float']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  hoursOffset?: InputMaybe<Scalars['Int']['input']>;
  scaleDown?: InputMaybe<ScaleDownInput>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
};


export type ParkDataStudioArgs = {
  dataStudioParams?: InputMaybe<DataStudioInput>;
};


export type ParkEnergyMeterDataseriesArgs = {
  from: Scalars['Float']['input'];
  granularity: TimeGranularityEnum;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Float']['input'];
};


export type ParkEnergyMeterTotalsArgs = {
  from: Scalars['Float']['input'];
  to: Scalars['Float']['input'];
};


export type ParkFilteredDataArgs = {
  aggregation: ParkAggregation;
  requestedSignals: Array<Scalars['String']['input']>;
};


export type ParkFilteredGroupedDataSeriesArgs = {
  defaultValue?: InputMaybe<Scalars['Float']['input']>;
  endTime: Scalars['Float']['input'];
  hours?: InputMaybe<Scalars['Int']['input']>;
  hoursOffset?: InputMaybe<Scalars['Int']['input']>;
  requestedSignals: Array<Scalars['String']['input']>;
  scaleDown?: InputMaybe<ScaleDownInput>;
  startTime: Scalars['Float']['input'];
  useDefaultValue?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ParkForecastAccuracyArgs = {
  endTs?: InputMaybe<Scalars['Float']['input']>;
  startTs?: InputMaybe<Scalars['Float']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};


export type ParkForecastDataSeriesArgs = {
  hours?: InputMaybe<Scalars['Int']['input']>;
  provider: Array<InputMaybe<ForecastProvidersEnum>>;
};


export type ParkGroupedDataSeriesArgs = {
  aggregation?: InputMaybe<TimeseriesAggregation>;
  defaultValue?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['Float']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  hoursOffset?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type ParkGroupedFactsArgs = {
  defaultValue?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['Float']['input']>;
  scaleDown?: InputMaybe<ScaleDownInput>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
};


export type ParkHasMissingBlocksArgs = {
  endTS: Scalars['Float']['input'];
  startTS: Scalars['Float']['input'];
};


export type ParkKpiFollowUpArgs = {
  endTS: Scalars['Float']['input'];
  startTS: Scalars['Float']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  turbineList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ytdAndLastYear?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ParkLogbookArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  sort?: InputMaybe<LogbookSortInput>;
  where?: InputMaybe<LogbookFilterInput>;
};


export type ParkLogbookCountArgs = {
  where?: InputMaybe<LogbookFilterInput>;
};


export type ParkMetmastsArgs = {
  where?: InputMaybe<MetmastWhereInput>;
};


export type ParkMonthlyAvailabilitiesArgs = {
  endTS: Scalars['Float']['input'];
  startTS: Scalars['Float']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type ParkParkGridCurtailmentsArgs = {
  endTS: Scalars['Float']['input'];
  startTS: Scalars['Float']['input'];
};


export type ParkParkLogbookArgs = {
  endTS: Scalars['Float']['input'];
  startTS: Scalars['Float']['input'];
};


export type ParkParkLogbookByTcuArgs = {
  endTS: Scalars['Float']['input'];
  startTS: Scalars['Float']['input'];
};


export type ParkParkLogbookLossesArgs = {
  endTS: Scalars['Float']['input'];
  startTS: Scalars['Float']['input'];
};


export type ParkParkLogbookSummaryArgs = {
  endTS: Scalars['Float']['input'];
  startTS: Scalars['Float']['input'];
};


export type ParkParkLogbookSummaryExportArgs = {
  endTS: Scalars['Float']['input'];
  startTS: Scalars['Float']['input'];
};


export type ParkPerformanceAnalyticsArgs = {
  endTS: Scalars['Float']['input'];
  startTS: Scalars['Float']['input'];
};


export type ParkPeriodAvailabilitiesPerTurbineArgs = {
  endTS: Scalars['Float']['input'];
  startTS: Scalars['Float']['input'];
};


export type ParkRangeWindroseArgs = {
  endTS: Scalars['Float']['input'];
  startTS: Scalars['Float']['input'];
};


export type ParkRevenuesDataseriesArgs = {
  from: Scalars['Float']['input'];
  granularity?: InputMaybe<RevenuesGranularityEnum>;
  groupBy?: InputMaybe<GroupByEnum>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Float']['input'];
};


export type ParkTargetCaptureRatioArgs = {
  from: Scalars['Float']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Float']['input'];
};


export type ParkTargetPriceArgs = {
  from: Scalars['Float']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Float']['input'];
};


export type ParkTicketsArgs = {
  boardId: Scalars['ID']['input'];
  ifArchive?: InputMaybe<Scalars['Boolean']['input']>;
  ifDelete?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ParkTimeseriesArgs = {
  range?: InputMaybe<TimeseriesRangeInput>;
};


export type ParkTurbinesArgs = {
  sort?: InputMaybe<TurbineSortInput>;
  where?: InputMaybe<TurbineWhereInput>;
};


export type ParkTurbinesPowerCurveSelectionArgs = {
  settings?: InputMaybe<ChartSettings>;
};


export type ParkWindCaptureRatioArgs = {
  from: Scalars['Float']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Float']['input'];
};


export type ParkWindRoseArgs = {
  from: Scalars['Float']['input'];
  period?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Float']['input'];
};


export type ParkWindRoseDataQualityArgs = {
  from: Scalars['Float']['input'];
  period?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Float']['input'];
};


export type ParkWindRoseDataQualityFullInfoArgs = {
  from: Scalars['Float']['input'];
  period?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Float']['input'];
};

export type ParkAckAndConfirmedCount = {
  __typename?: 'ParkAckAndConfirmedCount';
  confirmed?: Maybe<Scalars['Int']['output']>;
  unAcknowledged?: Maybe<Scalars['Int']['output']>;
  unConfirmed?: Maybe<Scalars['Int']['output']>;
};

export enum ParkAggregation {
  Avg = 'avg',
  Sum = 'sum'
}

export type ParkDataSeries = {
  __typename?: 'ParkDataSeries';
  WEATHER_Park_history_icon: IconDataSerieResult;
  WNAC1_ExTmp_avg_mag_f: DataSerieResult;
  WNAC1_WdDir_avg_mag_f: DataSerieResult;
  WNAC1_WdSpd_avg_mag_f: DataSerieResult;
  WTUR1_MW_avg_mag_f: DataSerieResult;
  WTUR1_MW_avg_theoretical: DataSerieResult;
  WTUR1_W_avg_mag_f: DataSerieResult;
  WTUR1_W_avg_theoretical: DataSerieResult;
  WTUR1_kW_avg_mag_f: DataSerieResult;
  WTUR1_kW_avg_theoretical: DataSerieResult;
  icon: IconDataSerieResult;
  temp: DataSerieResult;
  theoPower: DataSerieResult;
  turbinesAvailable: DataSerieResult;
  windDir: DataSerieResult;
  windSpd: DataSerieResult;
};

export type ParkFilteredData = {
  __typename?: 'ParkFilteredData';
  dataValue?: Maybe<Scalars['Float']['output']>;
  signalName: Scalars['String']['output'];
};

export type ParkHeatmapThresholds = {
  __typename?: 'ParkHeatmapThresholds';
  parkThresholds: Array<ParkTurbineTypeThreshold>;
};

export type ParkLogbookEntry = {
  __typename?: 'ParkLogbookEntry';
  _id?: Maybe<Scalars['String']['output']>;
  _id_alarm?: Maybe<Scalars['String']['output']>;
  _id_park: Scalars['String']['output'];
  _id_process?: Maybe<Scalars['String']['output']>;
  _id_turbine?: Maybe<Scalars['String']['output']>;
  ack?: Maybe<Scalars['Boolean']['output']>;
  amLossesComment?: Maybe<Scalars['String']['output']>;
  blockActionsLog?: Maybe<Scalars['String']['output']>;
  component?: Maybe<Scalars['String']['output']>;
  controlroomAck?: Maybe<Scalars['Boolean']['output']>;
  controlroomAckLog?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  controlroomTicketing?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  controlroomTicketingLog?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  customEvent?: Maybe<Scalars['Boolean']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  edited?: Maybe<Scalars['Boolean']['output']>;
  endTS: Scalars['Float']['output'];
  eventCode?: Maybe<Scalars['String']['output']>;
  eventDescription?: Maybe<Scalars['String']['output']>;
  isOpen?: Maybe<Scalars['Boolean']['output']>;
  log?: Maybe<Scalars['String']['output']>;
  lossesConfirmed?: Maybe<Scalars['Boolean']['output']>;
  lossesMethod?: Maybe<Scalars['String']['output']>;
  mutTS?: Maybe<Scalars['Float']['output']>;
  startTS: Scalars['Float']['output'];
  subBlocks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tc?: Maybe<Scalars['String']['output']>;
  tcmLossesComment?: Maybe<Scalars['String']['output']>;
  tcu: Scalars['String']['output'];
  totalProductionLoss: Scalars['Float']['output'];
  totalRevenueLoss: Scalars['Float']['output'];
  turbine: Turbine;
  userComment?: Maybe<Scalars['String']['output']>;
};

export type ParkLogbookEntryInput = {
  __typename?: 'ParkLogbookEntryInput';
  _id?: Maybe<Scalars['String']['output']>;
  _id_alarm?: Maybe<Scalars['String']['output']>;
  _id_process?: Maybe<Scalars['String']['output']>;
  _id_turbine?: Maybe<Scalars['String']['output']>;
  ack?: Maybe<Scalars['Boolean']['output']>;
  amLossesComment?: Maybe<Scalars['String']['output']>;
  component?: Maybe<Scalars['String']['output']>;
  controlroomAck?: Maybe<Scalars['Boolean']['output']>;
  controlroomAckLog?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  controlroomTicketing?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  controlroomTicketingLog?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  customEvent?: Maybe<Scalars['Boolean']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  edited?: Maybe<Scalars['Boolean']['output']>;
  endTS: Scalars['Float']['output'];
  eventCode?: Maybe<Scalars['String']['output']>;
  eventDescription?: Maybe<Scalars['String']['output']>;
  isOpen?: Maybe<Scalars['Boolean']['output']>;
  log?: Maybe<Scalars['String']['output']>;
  lossesConfirmed?: Maybe<Scalars['Boolean']['output']>;
  lossesMethod?: Maybe<Scalars['String']['output']>;
  startTS: Scalars['Float']['output'];
  subBlocks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tc: Scalars['String']['output'];
  tcmLossesComment?: Maybe<Scalars['String']['output']>;
  tcu: Scalars['String']['output'];
  totalProductionLoss: Scalars['Float']['output'];
  totalRevenueLoss: Scalars['Float']['output'];
  userComment?: Maybe<Scalars['String']['output']>;
};

export type ParkSignal = {
  __typename?: 'ParkSignal';
  _id: Scalars['ID']['output'];
  currency?: Maybe<Scalars['Boolean']['output']>;
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  signalGroupType: Scalars['String']['output'];
  unit: Scalars['String']['output'];
};

export type ParkSortInput = {
  code?: InputMaybe<Sort>;
  country?: InputMaybe<Sort>;
  fe_name?: InputMaybe<Sort>;
  lat?: InputMaybe<Sort>;
  lon?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
};

export type ParkSubType = {
  __typename?: 'ParkSubType';
  _id: Scalars['ID']['output'];
  componentConditionDataSeries?: Maybe<ComponentConditionAllData>;
  info?: Maybe<Information>;
  name?: Maybe<Scalars['String']['output']>;
  park: Park;
  turbineSubType?: Maybe<TurbineSubType>;
  turbines: Array<Turbine>;
};


export type ParkSubTypeComponentConditionDataSeriesArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  signal: Scalars['String']['input'];
};

export type ParkTurbineTypeThreshold = {
  __typename?: 'ParkTurbineTypeThreshold';
  thresholds: Array<TurbineSignalThreshold>;
  turbineType: Scalars['String']['output'];
};

export type ParkTurbineTypeThresholdInput = {
  thresholds: Array<TurbineSignalThresholdInput>;
  turbineType: Scalars['String']['input'];
};

export type ParkWhereInput = {
  AND?: InputMaybe<Array<ParkWhereInput>>;
  OR?: InputMaybe<Array<ParkWhereInput>>;
  _id?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  energyMeterAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  fe_name?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PerformanceAnalytics = {
  __typename?: 'PerformanceAnalytics';
  assets: Array<Maybe<AssetData>>;
  findings: Array<Maybe<FindingData>>;
  waterfall: WaterfallData;
};


export type PerformanceAnalyticsAssetsArgs = {
  flag: Scalars['String']['input'];
};


export type PerformanceAnalyticsFindingsArgs = {
  flag?: InputMaybe<Scalars['String']['input']>;
};

export type Pexapark = {
  __typename?: 'Pexapark';
  forwardPPAPricesData?: Maybe<PexaparkDataSeries>;
  historicalPPAPricesData?: Maybe<PexaparkDataSeries>;
  ppaPriceMarketData?: Maybe<PexaparkMarketData>;
  spotPriceMarketData?: Maybe<PexaparkMarketData>;
  spotPricesData?: Maybe<PexaparkDataSeries>;
};


export type PexaparkForwardPpaPricesDataArgs = {
  _id_market?: InputMaybe<Scalars['Int']['input']>;
  granularity?: InputMaybe<PexaparkForwardGranularity>;
  years?: InputMaybe<Scalars['Int']['input']>;
};


export type PexaparkHistoricalPpaPricesDataArgs = {
  _id_market?: InputMaybe<Scalars['Int']['input']>;
  endTS?: InputMaybe<Scalars['Float']['input']>;
  startTS?: InputMaybe<Scalars['Float']['input']>;
  tenorYears?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type PexaparkSpotPricesDataArgs = {
  _id_market?: InputMaybe<Scalars['String']['input']>;
  endTS?: InputMaybe<Scalars['Float']['input']>;
  isDayAhead?: InputMaybe<Scalars['Boolean']['input']>;
  isMainMarket?: InputMaybe<Scalars['Boolean']['input']>;
  startTS?: InputMaybe<Scalars['Float']['input']>;
  utcOffset?: InputMaybe<Scalars['Float']['input']>;
};

export type PexaparkDataSeries = {
  __typename?: 'PexaparkDataSeries';
  data?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  kpiData?: Maybe<PexaparkKpiData>;
  timestamps?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export enum PexaparkForwardGranularity {
  Month = 'MONTH',
  Year = 'YEAR'
}

export type PexaparkKpiData = {
  __typename?: 'PexaparkKPIData';
  actualValue?: Maybe<Scalars['Float']['output']>;
  actualValueDiff?: Maybe<Scalars['Float']['output']>;
  actualValueDiffPercentage?: Maybe<Scalars['Float']['output']>;
  actualValueTimestamp?: Maybe<Scalars['Float']['output']>;
  average?: Maybe<Scalars['Float']['output']>;
  first?: Maybe<Scalars['Float']['output']>;
  last?: Maybe<Scalars['Float']['output']>;
  lastValue?: Maybe<Scalars['Float']['output']>;
  lastValueTimestamp?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

export type PexaparkMarketData = {
  __typename?: 'PexaparkMarketData';
  granularities?: Maybe<Array<Maybe<PexaparkForwardGranularity>>>;
  marketList?: Maybe<Array<Maybe<PexaparkMarketList>>>;
};

export type PexaparkMarketDetail = {
  __typename?: 'PexaparkMarketDetail';
  tenorYears?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  types?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PexaparkMarketList = {
  __typename?: 'PexaparkMarketList';
  countryCode?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<PexaparkMarketDetail>;
  lastUpdateTS?: Maybe<Scalars['Float']['output']>;
  marketID?: Maybe<Scalars['String']['output']>;
  nameEN?: Maybe<Scalars['String']['output']>;
};

export type PlannedEvent = {
  __typename?: 'PlannedEvent';
  _id?: Maybe<Scalars['String']['output']>;
  _id_alarm?: Maybe<Scalars['String']['output']>;
  _id_group?: Maybe<Scalars['String']['output']>;
  _id_park?: Maybe<Scalars['String']['output']>;
  _id_process?: Maybe<Scalars['String']['output']>;
  _id_turbine?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  creationTs?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endTs?: Maybe<Scalars['Float']['output']>;
  fromMaintain?: Maybe<Scalars['Int']['output']>;
  isDeleted?: Maybe<Scalars['Int']['output']>;
  isRecurring?: Maybe<Scalars['Int']['output']>;
  lastEditedBy?: Maybe<Scalars['String']['output']>;
  lastEditedTs?: Maybe<Scalars['Int']['output']>;
  lastUpdatedTs?: Maybe<Scalars['Int']['output']>;
  limitedTo?: Maybe<Scalars['Float']['output']>;
  notificationTime?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  productionLoss?: Maybe<Scalars['Float']['output']>;
  productionLossArr?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  recipients?: Maybe<Scalars['String']['output']>;
  reminderStatus?: Maybe<Scalars['Int']['output']>;
  revenueLoss?: Maybe<Scalars['Float']['output']>;
  revenueLossArr?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  startTs?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Portfolio Entity */
export type Portfolio = {
  __typename?: 'Portfolio';
  _id: Scalars['ID']['output'];
  ackCount?: Maybe<Array<Maybe<AckCountPortfolio>>>;
  alarmCount: Scalars['Int']['output'];
  alarms?: Maybe<Array<Maybe<Alarm>>>;
  alarmsCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  alarmsOld: Array<Maybe<AlarmsOld>>;
  analyze: Analyze;
  availabilityFormulas?: Maybe<Array<Maybe<AvailabilityPark>>>;
  availabilityInfo?: Maybe<AvailabilityInfo>;
  availableSignalCount: Scalars['Int']['output'];
  budget?: Maybe<Array<Maybe<BudgetFollowUp>>>;
  budgetYTD?: Maybe<BudgetData>;
  cmsAlarms?: Maybe<Array<Maybe<CmsAlarm>>>;
  currency: Currency;
  data: Data;
  dataAnalysisQueries: DataAnalysisQueryList;
  dataDebbug: Data;
  dataSeries: DataSeries;
  energyMeterDataseries?: Maybe<Array<Maybe<EnergyMeterDataseriesValue>>>;
  energyMeterTotals?: Maybe<EnergyMeterTotals>;
  firstAvailableTS?: Maybe<Scalars['Float']['output']>;
  forecastDataSeries?: Maybe<ForecastDataSeries>;
  groupedDataSeries: GroupedDataSeries;
  groupedFacts: GroupedFacts;
  groupedResults: GroupedResults;
  hasAvailabilityFormulas: Scalars['Boolean']['output'];
  kpiFollowUp?: Maybe<KpiFollowUp>;
  metaData: MetaData;
  mobileName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parks: Array<Park>;
  performanceAnalytics: PerformanceAnalytics;
  portfolioGridCurtailments?: Maybe<Array<Maybe<ParkLogbookEntry>>>;
  reference?: Maybe<Reference>;
  reportTemplates?: Maybe<Array<Maybe<ReportTemplate>>>;
  revenuesDataseries?: Maybe<Array<Maybe<RevenuesDataseriesValue>>>;
  tickets?: Maybe<Array<Maybe<Ticket>>>;
  totalSignalCount: Scalars['Int']['output'];
};


/** Portfolio Entity */
export type PortfolioAckCountArgs = {
  endTS: Scalars['Float']['input'];
  startTS: Scalars['Float']['input'];
};


/** Portfolio Entity */
export type PortfolioAlarmCountArgs = {
  alarmCategory?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  controlroomAck?: InputMaybe<Scalars['Boolean']['input']>;
  controlroomTicketing?: InputMaybe<Scalars['Boolean']['input']>;
  fromTS?: InputMaybe<Scalars['Float']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  toTS?: InputMaybe<Scalars['Float']['input']>;
};


/** Portfolio Entity */
export type PortfolioAlarmsArgs = {
  alarmCategory?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  controlroomAck?: InputMaybe<Scalars['Boolean']['input']>;
  controlroomTicketing?: InputMaybe<Scalars['Boolean']['input']>;
  fromTS?: InputMaybe<Scalars['Float']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<AlarmSortInput>;
  toTS?: InputMaybe<Scalars['Float']['input']>;
};


/** Portfolio Entity */
export type PortfolioAlarmsOldArgs = {
  where?: InputMaybe<AlarmsOldWhere>;
};


/** Portfolio Entity */
export type PortfolioAvailabilityFormulasArgs = {
  endTS?: InputMaybe<Scalars['Float']['input']>;
  startTS?: InputMaybe<Scalars['Float']['input']>;
};


/** Portfolio Entity */
export type PortfolioBudgetArgs = {
  granularity: BudgetGranularity;
  month: Scalars['Int']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  year: Scalars['Int']['input'];
};


/** Portfolio Entity */
export type PortfolioCmsAlarmsArgs = {
  endTS?: InputMaybe<Scalars['Float']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
  startTS?: InputMaybe<Scalars['Float']['input']>;
};


/** Portfolio Entity */
export type PortfolioDataAnalysisQueriesArgs = {
  isSharedQuery?: InputMaybe<Scalars['Boolean']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  titleFilter?: InputMaybe<Scalars['String']['input']>;
};


/** Portfolio Entity */
export type PortfolioDataSeriesArgs = {
  endTime?: InputMaybe<Scalars['Float']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  hoursOffset?: InputMaybe<Scalars['Int']['input']>;
  scaleDown?: InputMaybe<ScaleDownInput>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
};


/** Portfolio Entity */
export type PortfolioEnergyMeterDataseriesArgs = {
  from: Scalars['Float']['input'];
  granularity: TimeGranularityEnum;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Float']['input'];
};


/** Portfolio Entity */
export type PortfolioEnergyMeterTotalsArgs = {
  from: Scalars['Float']['input'];
  to: Scalars['Float']['input'];
};


/** Portfolio Entity */
export type PortfolioForecastDataSeriesArgs = {
  hours?: InputMaybe<Scalars['Int']['input']>;
  provider: Array<InputMaybe<ForecastProvidersEnum>>;
};


/** Portfolio Entity */
export type PortfolioGroupedDataSeriesArgs = {
  aggregation?: InputMaybe<TimeseriesAggregation>;
  endTime?: InputMaybe<Scalars['Float']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  hoursOffset?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Portfolio Entity */
export type PortfolioGroupedFactsArgs = {
  endTime?: InputMaybe<Scalars['Float']['input']>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
};


/** Portfolio Entity */
export type PortfolioKpiFollowUpArgs = {
  endTS: Scalars['Float']['input'];
  startTS: Scalars['Float']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Portfolio Entity */
export type PortfolioParksArgs = {
  sort?: InputMaybe<ParkSortInput>;
  turbines?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  where?: InputMaybe<ParkWhereInput>;
};


/** Portfolio Entity */
export type PortfolioPerformanceAnalyticsArgs = {
  endTS: Scalars['Float']['input'];
  startTS: Scalars['Float']['input'];
};


/** Portfolio Entity */
export type PortfolioPortfolioGridCurtailmentsArgs = {
  endTS: Scalars['Float']['input'];
  startTS: Scalars['Float']['input'];
};


/** Portfolio Entity */
export type PortfolioReportTemplatesArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  id_portfolio?: InputMaybe<Scalars['String']['input']>;
  isDefaultTemplate?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Portfolio Entity */
export type PortfolioRevenuesDataseriesArgs = {
  from: Scalars['Float']['input'];
  granularity?: InputMaybe<RevenuesGranularityEnum>;
  groupBy?: InputMaybe<GroupByEnum>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Float']['input'];
};


/** Portfolio Entity */
export type PortfolioTicketsArgs = {
  boardId: Scalars['ID']['input'];
  ifArchive?: InputMaybe<Scalars['Boolean']['input']>;
  ifDelete?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PortfolioDataSeries = {
  __typename?: 'PortfolioDataSeries';
  WNAC1_ExTmp_avg_mag_f: DataSerieResult;
  WNAC1_WdDir_avg_mag_f: DataSerieResult;
  WNAC1_WdSpd_avg_mag_f: DataSerieResult;
  WTUR1_MW_avg_mag_f: DataSerieResult;
  WTUR1_MW_avg_theoretical: DataSerieResult;
  WTUR1_W_avg_mag_f: DataSerieResult;
  WTUR1_W_avg_theoretical: DataSerieResult;
  WTUR1_kW_avg_mag_f: DataSerieResult;
  WTUR1_kW_avg_theoretical: DataSerieResult;
  theoPower: DataSerieResult;
  turbinesAvailable: DataSerieResult;
};

export type PortfolioSortInput = {
  name?: InputMaybe<Sort>;
};

export type PortfolioWhereInput = {
  AND?: InputMaybe<Array<PortfolioWhereInput>>;
  OR?: InputMaybe<Array<PortfolioWhereInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PowerCurveDataTypes = {
  __typename?: 'PowerCurveDataTypes';
  powerCurveData?: Maybe<Array<Maybe<HistoricalPowercurveData>>>;
  windRose?: Maybe<Array<Maybe<WindRoseDataType>>>;
};

export type PowerCurves = {
  __typename?: 'PowerCurves';
  historicalPC?: Maybe<PowerCurveDataTypes>;
  manufacturerPC?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  monthlyPC?: Maybe<PowerCurveDataTypes>;
  scatterPlot?: Maybe<Array<Maybe<ScaterPlotData>>>;
  statisticalMonthlyPC: Array<Maybe<StatisticalPowerCurveDataTypes>>;
};


export type PowerCurvesHistoricalPcArgs = {
  sector: SectorCategoryEnum;
};


export type PowerCurvesMonthlyPcArgs = {
  date: Scalars['Int']['input'];
  sector: SectorCategoryEnum;
};


export type PowerCurvesScatterPlotArgs = {
  end?: InputMaybe<Scalars['Float']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
};


export type PowerCurvesStatisticalMonthlyPcArgs = {
  date: Scalars['Int']['input'];
};

export enum PowerUnitEnum {
  Gw = 'GW',
  Mw = 'MW',
  KW = 'kW'
}

export type PreferenceLabels = {
  __typename?: 'PreferenceLabels';
  active?: Maybe<PreferencesValues>;
  options: Array<PreferencesValues>;
};

export type PreferenceList = {
  __typename?: 'PreferenceList';
  _id_user: Scalars['String']['output'];
  checkPPAAgderMonthlyColumnConfiguration?: Maybe<PreferenceLabels>;
  checkPPAAgderMultiYearColumnConfiguration?: Maybe<PreferenceLabels>;
  checkPPAAgderYearlyColumnConfiguration?: Maybe<PreferenceLabels>;
  checkPPAEpaColumnConfiguration?: Maybe<PreferenceLabels>;
  checkPPAFosenMultiYearColumnConfiguration?: Maybe<PreferenceLabels>;
  checkPPAFosenYearlyColumnConfiguration?: Maybe<PreferenceLabels>;
  checkPPAOverviewAgderColumnConfiguration?: Maybe<PreferenceLabels>;
  checkPPAOverviewEPAColumnConfiguration?: Maybe<PreferenceLabels>;
  checkPPAOverviewFosenColumnConfiguration?: Maybe<PreferenceLabels>;
  headerDropdownColorType?: Maybe<PreferenceLabels>;
  logbookColumnConfiguration?: Maybe<PreferenceLabels>;
  overviewBoardSortingConfiguration?: Maybe<PreferenceLabels>;
  parkMenu?: Maybe<PreferenceLabels>;
  unitFormatPreferences?: Maybe<PreferenceLabels>;
};

export type Preferences = {
  __typename?: 'Preferences';
  _id_user: Scalars['String']['output'];
  parkMenu: Scalars['String']['output'];
};

export type PreferencesInput = {
  checkPPAAgderMonthlyColumnConfiguration?: InputMaybe<Scalars['String']['input']>;
  checkPPAAgderMultiYearColumnConfiguration?: InputMaybe<Scalars['String']['input']>;
  checkPPAAgderYearlyColumnConfiguration?: InputMaybe<Scalars['String']['input']>;
  checkPPAEpaColumnConfiguration?: InputMaybe<Scalars['String']['input']>;
  checkPPAFosenMultiYearColumnConfiguration?: InputMaybe<Scalars['String']['input']>;
  checkPPAFosenYearlyColumnConfiguration?: InputMaybe<Scalars['String']['input']>;
  checkPPAOverviewAgderColumnConfiguration?: InputMaybe<Scalars['String']['input']>;
  checkPPAOverviewEPAColumnConfiguration?: InputMaybe<Scalars['String']['input']>;
  checkPPAOverviewFosenColumnConfiguration?: InputMaybe<Scalars['String']['input']>;
  headerDropdownColorType?: InputMaybe<Scalars['String']['input']>;
  logbookColumnConfiguration?: InputMaybe<Scalars['String']['input']>;
  overviewBoardSortingConfiguration?: InputMaybe<Scalars['String']['input']>;
  parkMenu?: InputMaybe<Scalars['String']['input']>;
  unitFormatPreferences?: InputMaybe<Scalars['String']['input']>;
};

export type PreferencesValues = {
  __typename?: 'PreferencesValues';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ProcessAssignment = {
  _id_process?: InputMaybe<Scalars['String']['input']>;
  operation?: InputMaybe<ProcessOperationEnum>;
};

export enum ProcessOperationEnum {
  Assign = 'ASSIGN',
  None = 'NONE',
  Unassign = 'UNASSIGN'
}

export type ProductionLossCalculation = {
  __typename?: 'ProductionLossCalculation';
  calculation_method?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  references?: Maybe<Array<Maybe<ProductionLossCalculationReferences>>>;
};

export type ProductionLossCalculationReferences = {
  __typename?: 'ProductionLossCalculationReferences';
  _id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ProductionLossMethodData = {
  __typename?: 'ProductionLossMethodData';
  _id?: Maybe<Scalars['String']['output']>;
  _id_park?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  custom_production_loss_calculation?: Maybe<CustomProductionLossCalculation>;
  name?: Maybe<Scalars['String']['output']>;
  production_loss_calculation?: Maybe<ProductionLossCalculation>;
  serial?: Maybe<Scalars['String']['output']>;
  serialNav?: Maybe<Scalars['String']['output']>;
};

export type ProductionLossMethodObject = {
  __typename?: 'ProductionLossMethodObject';
  selectedOption?: Maybe<Scalars['Int']['output']>;
  selectedPark?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  selectedSuboption?: Maybe<Scalars['Int']['output']>;
  selectedTurbines?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  waterfall?: Maybe<Scalars['Boolean']['output']>;
};

export type ProductionWs = {
  __typename?: 'ProductionWS';
  power?: Maybe<Scalars['Float']['output']>;
  wind_speed?: Maybe<Scalars['Float']['output']>;
};

export type Query = {
  __typename?: 'Query';
  countries: Array<Country>;
  dataAnalysisQuery?: Maybe<DataAnalysisQuery>;
  dataStudioUploadedFileStatus: UploadedFileStatus;
  dataStudioUploadedFiles: Array<DataStudioUploadedFile>;
  events?: Maybe<Array<Maybe<Event>>>;
  fosenReport?: Maybe<FosenReport>;
  getKPITableCustomSettings?: Maybe<KpiTableCustomSettings>;
  images?: Maybe<Array<Maybe<Images>>>;
  kpiDefinition: Array<KpiDefinition>;
  manufacturers: Array<Manufacturer>;
  parkHeatmapThresholds?: Maybe<ParkHeatmapThresholds>;
  parks: Array<Park>;
  pexapark?: Maybe<Pexapark>;
  portfolios: Array<Portfolio>;
  queryExecTS: Scalars['Float']['output'];
  reportTemplates?: Maybe<Array<Maybe<ReportTemplate>>>;
  reports?: Maybe<Array<Maybe<Reportb>>>;
  system: System;
  ticket?: Maybe<Ticket>;
  turbineHeatmapThresholds?: Maybe<TurbineHeatmapThresholds>;
  turbineTypes: Array<TurbineType>;
  turbines: Array<Turbine>;
  user?: Maybe<User>;
};


export type QueryCountriesArgs = {
  parks?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  sort?: InputMaybe<CountrySortInput>;
  where?: InputMaybe<CountryWhereInput>;
};


export type QueryDataAnalysisQueryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDataStudioUploadedFileStatusArgs = {
  trackerId: Scalars['ID']['input'];
};


export type QueryDataStudioUploadedFilesArgs = {
  deviceType?: InputMaybe<DeviceType>;
  queryType?: InputMaybe<DataStudioQueryType>;
};


export type QueryGetKpiTableCustomSettingsArgs = {
  _id_park_?: InputMaybe<Scalars['ID']['input']>;
  _id_portfolio?: InputMaybe<Scalars['ID']['input']>;
  tableUniqueName: Scalars['String']['input'];
};


export type QueryImagesArgs = {
  where?: InputMaybe<ImagesWhereInput>;
};


export type QueryKpiDefinitionArgs = {
  targetExists?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<KpiDefinitionType>;
};


export type QueryManufacturersArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryParkHeatmapThresholdsArgs = {
  _id_park: Scalars['ID']['input'];
};


export type QueryParksArgs = {
  sort?: InputMaybe<ParkSortInput>;
  turbines?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  where?: InputMaybe<ParkWhereInput>;
};


export type QueryPortfoliosArgs = {
  parks?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  sort?: InputMaybe<PortfolioSortInput>;
  when?: InputMaybe<CustomPortfolioWhereInput>;
  where?: InputMaybe<PortfolioWhereInput>;
};


export type QueryReportTemplatesArgs = {
  where?: InputMaybe<ReportTemplateWhereInput>;
};


export type QueryReportsArgs = {
  where?: InputMaybe<ReportWhereInput>;
};


export type QueryTicketArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTurbineHeatmapThresholdsArgs = {
  _id_park?: InputMaybe<Scalars['ID']['input']>;
  _id_turbine: Scalars['ID']['input'];
};


export type QueryTurbineTypesArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTurbinesArgs = {
  deIcing?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TurbineFilterDataInput>;
  settings?: InputMaybe<ChartSettings>;
  sort?: InputMaybe<TurbineSortInput>;
  where?: InputMaybe<TurbineWhereInput>;
};

export enum QueryDataTypeEnum {
  Parkdata = 'parkdata',
  Scada = 'scada'
}

export type RawData = {
  __typename?: 'RawData';
  LDAT1_TmUTC_setTm?: Maybe<Scalars['String']['output']>;
  LDAT1_TmUTC_setTm_rounded?: Maybe<Scalars['String']['output']>;
  LPHD1_PhyHealth_stVal?: Maybe<Scalars['Float']['output']>;
  MMXU1_A_phsA_cVal_mag_f?: Maybe<Scalars['Float']['output']>;
  MMXU1_A_phsB_cVal_mag_f?: Maybe<Scalars['Float']['output']>;
  MMXU1_A_phsC_cVal_mag_f?: Maybe<Scalars['Float']['output']>;
  MMXU1_Hz_mag_f?: Maybe<Scalars['Float']['output']>;
  MMXU1_PhV_phsA_cVal_mag_f?: Maybe<Scalars['Float']['output']>;
  MMXU1_PhV_phsB_cVal_mag_f?: Maybe<Scalars['Float']['output']>;
  MMXU1_PhV_phsC_cVal_mag_f?: Maybe<Scalars['Float']['output']>;
  MMXU1_TotPF_mag_f?: Maybe<Scalars['Float']['output']>;
  WCNV1_CnvTmpChokeCoil_mag_f?: Maybe<Scalars['Float']['output']>;
  WCNV1_CnvTmpDclink_mag_f?: Maybe<Scalars['Float']['output']>;
  WCNV1_CnvTmpWater_mag_f?: Maybe<Scalars['Float']['output']>;
  WGEN1_GnTmpBrg1_mag_f?: Maybe<Scalars['Float']['output']>;
  WGEN1_GnTmpBrg2_mag_f?: Maybe<Scalars['Float']['output']>;
  WGEN1_GnTmpInlet_mag_f?: Maybe<Scalars['Float']['output']>;
  WGEN1_GnTmpOutlet_mag_f?: Maybe<Scalars['Float']['output']>;
  WGEN1_GnTmpPhase1_mag_f?: Maybe<Scalars['Float']['output']>;
  WGEN1_GnTmpPhase2_mag_f?: Maybe<Scalars['Float']['output']>;
  WGEN1_GnTmpPhase3_mag_f?: Maybe<Scalars['Float']['output']>;
  WGEN1_GnTmpRtr_mag_f?: Maybe<Scalars['Float']['output']>;
  WGEN1_GnTmpSlpRing1_mag_f?: Maybe<Scalars['Float']['output']>;
  WGEN1_GnTmpSlpRing2_mag_f?: Maybe<Scalars['Float']['output']>;
  WGEN1_GnTmpSta_mag_f?: Maybe<Scalars['Float']['output']>;
  WGEN1_Spd_mag_f?: Maybe<Scalars['Float']['output']>;
  WNAC1_CtrCabTmp_mag_f?: Maybe<Scalars['Float']['output']>;
  WNAC1_Dir_mag_f?: Maybe<Scalars['Float']['output']>;
  WNAC1_ExTmp_mag_f?: Maybe<Scalars['Float']['output']>;
  WNAC1_IntlTmp_mag_f?: Maybe<Scalars['Float']['output']>;
  WNAC1_WdDir_mag_f?: Maybe<Scalars['Float']['output']>;
  WNAC1_WdSpd_c_mag_f?: Maybe<Scalars['Float']['output']>;
  WNAC1_WdSpd_mag_f?: Maybe<Scalars['Float']['output']>;
  WROT1_CtrCabTmp_mag_f?: Maybe<Scalars['Float']['output']>;
  WROT1_HubTmp_mag_f?: Maybe<Scalars['Float']['output']>;
  WROT1_PtAngValAvg_mag_f?: Maybe<Scalars['Float']['output']>;
  WROT1_PtAngValBl1_mag_f?: Maybe<Scalars['Float']['output']>;
  WROT1_PtAngValBl2_mag_f?: Maybe<Scalars['Float']['output']>;
  WROT1_PtAngValBl3_mag_f?: Maybe<Scalars['Float']['output']>;
  WROT1_PtHyOilTmp_mag_f?: Maybe<Scalars['Float']['output']>;
  WROT1_PtHyPresAvg_mag_f?: Maybe<Scalars['Float']['output']>;
  WROT1_PtHyPresBl1_mag_f?: Maybe<Scalars['Float']['output']>;
  WROT1_PtHyPresBl2_mag_f?: Maybe<Scalars['Float']['output']>;
  WROT1_PtHyPresBl3_mag_f?: Maybe<Scalars['Float']['output']>;
  WROT1_RotSpd_mag_f?: Maybe<Scalars['Float']['output']>;
  WTRF1_TrfTmpPhase1_mag_f?: Maybe<Scalars['Float']['output']>;
  WTRF1_TrfTmpPhase2_mag_f?: Maybe<Scalars['Float']['output']>;
  WTRF1_TrfTmpPhase3_mag_f?: Maybe<Scalars['Float']['output']>;
  WTRM1_BrkHyPres_mag_f?: Maybe<Scalars['Float']['output']>;
  WTRM1_GbxOilPres_mag_f?: Maybe<Scalars['Float']['output']>;
  WTRM1_TrmTmpGbxBrg1_mag_f?: Maybe<Scalars['Float']['output']>;
  WTRM1_TrmTmpGbxBrg2_mag_f?: Maybe<Scalars['Float']['output']>;
  WTRM1_TrmTmpGbxBrg3_mag_f?: Maybe<Scalars['Float']['output']>;
  WTRM1_TrmTmpGbxOil_mag_f?: Maybe<Scalars['Float']['output']>;
  WTRM1_TrmTmpShfBrg1_mag_f?: Maybe<Scalars['Float']['output']>;
  WTRM1_TrmTmpShfBrg2_mag_f?: Maybe<Scalars['Float']['output']>;
  WTUR1_AvlTmRs_tmTot?: Maybe<Scalars['Float']['output']>;
  WTUR1_MW_loss?: Maybe<Scalars['Float']['output']>;
  WTUR1_MW_mag_f?: Maybe<Scalars['Float']['output']>;
  WTUR1_MW_rated?: Maybe<Scalars['Float']['output']>;
  WTUR1_MW_theoretical?: Maybe<Scalars['Float']['output']>;
  WTUR1_OpTmRs_tmTot?: Maybe<Scalars['Float']['output']>;
  WTUR1_TotVArh_actVal?: Maybe<Scalars['Float']['output']>;
  WTUR1_TotWh_actVal?: Maybe<Scalars['Float']['output']>;
  WTUR1_TurMaint_actSt_stVal?: Maybe<Scalars['Float']['output']>;
  WTUR1_TurSt_actSt_stVal?: Maybe<Scalars['Float']['output']>;
  WTUR1_VAr_mag_f?: Maybe<Scalars['Float']['output']>;
  WTUR1_W_loss?: Maybe<Scalars['Float']['output']>;
  WTUR1_W_mag_f?: Maybe<Scalars['Float']['output']>;
  WTUR1_W_rated?: Maybe<Scalars['Float']['output']>;
  WTUR1_W_theoretical?: Maybe<Scalars['Float']['output']>;
  WTUR1_kW_loss?: Maybe<Scalars['Float']['output']>;
  WTUR1_kW_mag_f?: Maybe<Scalars['Float']['output']>;
  WTUR1_kW_rated?: Maybe<Scalars['Float']['output']>;
  WTUR1_kW_theoretical?: Maybe<Scalars['Float']['output']>;
  WTUR1_per_efficiency?: Maybe<Scalars['Float']['output']>;
  WTUR1_per_loadFactor?: Maybe<Scalars['Float']['output']>;
  WTUR1_status?: Maybe<Scalars['Float']['output']>;
  WYAW1_BrkPres_mag_f?: Maybe<Scalars['Float']['output']>;
  WYAW1_CabWup_mag_f?: Maybe<Scalars['Float']['output']>;
  WYAW1_YawAng_mag_f?: Maybe<Scalars['Float']['output']>;
};

export type RawData10M = {
  __typename?: 'RawData10M';
  WCNV1_CnvTmpDclink_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WCNV2_CnvTmpDclink_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WCNV3_CnvTmpDclink_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WCNV4_CnvTmpDclink_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WCNV5_CnvTmpDclink_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WCNV6_CnvTmpDclink_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WCNV7_CnvTmpDclink_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WCNV8_CnvTmpDclink_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WCNV9_CnvTmpDclink_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WCNV10_CnvTmpDclink_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WCNV11_CnvTmpDclink_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WGEN1_GnTmpRtr_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WGEN1_GnTmpSta_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WGEN1_Spd_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WNAC1_CtrCabTmp_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WNAC1_Dir_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WNAC1_ExTmp_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WNAC1_IntlTmp_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WNAC1_WdDir_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WNAC1_WdSpd_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WROT1_CtrCabTmp2_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WROT1_CtrCabTmp3_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WROT1_CtrCabTmp_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WROT1_HubTmp_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WROT1_RotSpd_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WROT1_TmpBl1_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WROT1_TmpBl2_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WROT1_TmpBl3_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WTOW1_CtrCabTmp_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WTRF1_TrfTmpPhase1_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WTRF1_TrfTmpPhase2_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WTRF1_TrfTmpPhase3_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WTRM1_TrmTmpShfBrg1_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WTRM1_TrmTmpShfBrg2_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WTUR1_MW_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WTUR1_MW_avg_theoretical?: Maybe<Scalars['Float']['output']>;
  WTUR1_VAr_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WTUR1_W_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WTUR1_W_avg_theoretical?: Maybe<Scalars['Float']['output']>;
  WTUR1_kW_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WTUR1_kW_avg_theoretical?: Maybe<Scalars['Float']['output']>;
  WYAW1_CabWup_avg_mag_f?: Maybe<Scalars['Float']['output']>;
  WYAW1_YawAng_avg_mag_f?: Maybe<Scalars['Float']['output']>;
};

export type RawDataInput = {
  LDAT1_TmUTC_setTm?: InputMaybe<Scalars['String']['input']>;
  LDAT1_TmUTC_setTm_rounded?: InputMaybe<Scalars['String']['input']>;
  LPHD1_PhyHealth_stVal?: InputMaybe<Scalars['Float']['input']>;
  MMXU1_A_phsA_cVal_mag_f?: InputMaybe<Scalars['Float']['input']>;
  MMXU1_A_phsB_cVal_mag_f?: InputMaybe<Scalars['Float']['input']>;
  MMXU1_A_phsC_cVal_mag_f?: InputMaybe<Scalars['Float']['input']>;
  MMXU1_Hz_mag_f?: InputMaybe<Scalars['Float']['input']>;
  MMXU1_PhV_phsA_cVal_mag_f?: InputMaybe<Scalars['Float']['input']>;
  MMXU1_PhV_phsB_cVal_mag_f?: InputMaybe<Scalars['Float']['input']>;
  MMXU1_PhV_phsC_cVal_mag_f?: InputMaybe<Scalars['Float']['input']>;
  MMXU1_TotPF_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WCNV1_CnvTmpChokeCoil_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WCNV1_CnvTmpDclink_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WCNV1_CnvTmpWater_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WGEN1_GnTmpBrg1_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WGEN1_GnTmpBrg2_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WGEN1_GnTmpInlet_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WGEN1_GnTmpOutlet_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WGEN1_GnTmpPhase1_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WGEN1_GnTmpPhase2_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WGEN1_GnTmpPhase3_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WGEN1_GnTmpRtr_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WGEN1_GnTmpSlpRing1_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WGEN1_GnTmpSlpRing2_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WGEN1_GnTmpSta_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WGEN1_Spd_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WNAC1_CtrCabTmp_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WNAC1_Dir_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WNAC1_ExTmp_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WNAC1_IntlTmp_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WNAC1_WdDir_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WNAC1_WdSpd_c_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WNAC1_WdSpd_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WROT1_CtrCabTmp_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WROT1_HubTmp_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WROT1_PtAngValAvg_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WROT1_PtAngValBl1_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WROT1_PtAngValBl2_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WROT1_PtAngValBl3_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WROT1_PtHyOilTmp_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WROT1_PtHyPresAvg_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WROT1_PtHyPresBl1_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WROT1_PtHyPresBl2_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WROT1_PtHyPresBl3_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WROT1_RotSpd_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WTRF1_TrfTmpPhase1_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WTRF1_TrfTmpPhase2_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WTRF1_TrfTmpPhase3_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WTRM1_BrkHyPres_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WTRM1_GbxOilPres_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WTRM1_TrmTmpGbxBrg1_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WTRM1_TrmTmpGbxBrg2_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WTRM1_TrmTmpGbxBrg3_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WTRM1_TrmTmpGbxOil_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WTRM1_TrmTmpShfBrg1_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WTRM1_TrmTmpShfBrg2_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WTUR1_AvlTmRs_tmTot?: InputMaybe<Scalars['Float']['input']>;
  WTUR1_MW_loss?: InputMaybe<Scalars['Float']['input']>;
  WTUR1_MW_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WTUR1_MW_rated?: InputMaybe<Scalars['Float']['input']>;
  WTUR1_MW_theoretical?: InputMaybe<Scalars['Float']['input']>;
  WTUR1_OpTmRs_tmTot?: InputMaybe<Scalars['Float']['input']>;
  WTUR1_TotVArh_actVal?: InputMaybe<Scalars['Float']['input']>;
  WTUR1_TotWh_actVal?: InputMaybe<Scalars['Float']['input']>;
  WTUR1_TurMaint_actSt_stVal?: InputMaybe<Scalars['Float']['input']>;
  WTUR1_TurSt_actSt_stVal?: InputMaybe<Scalars['Float']['input']>;
  WTUR1_VAr_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WTUR1_W_loss?: InputMaybe<Scalars['Float']['input']>;
  WTUR1_W_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WTUR1_W_rated?: InputMaybe<Scalars['Float']['input']>;
  WTUR1_W_theoretical?: InputMaybe<Scalars['Float']['input']>;
  WTUR1_kW_loss?: InputMaybe<Scalars['Float']['input']>;
  WTUR1_kW_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WTUR1_kW_rated?: InputMaybe<Scalars['Float']['input']>;
  WTUR1_kW_theoretical?: InputMaybe<Scalars['Float']['input']>;
  WTUR1_per_efficiency?: InputMaybe<Scalars['Float']['input']>;
  WTUR1_per_loadFactor?: InputMaybe<Scalars['Float']['input']>;
  WTUR1_status?: InputMaybe<Scalars['Float']['input']>;
  WYAW1_BrkPres_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WYAW1_CabWup_mag_f?: InputMaybe<Scalars['Float']['input']>;
  WYAW1_YawAng_mag_f?: InputMaybe<Scalars['Float']['input']>;
};

export enum ReactivePowerUnitEnum {
  GVar = 'GVar',
  MVar = 'MVar',
  KVar = 'kVar'
}

export type Reference = {
  __typename?: 'Reference';
  parks: Array<Park>;
  portfolios: Array<Portfolio>;
  turbineController: Array<Maybe<TurbineController>>;
  turbineSubTypes: Array<TurbineSubType>;
  turbines: Array<Turbine>;
};


export type ReferenceParksArgs = {
  sort?: InputMaybe<ParkSortInput>;
  where?: InputMaybe<ParkWhereInput>;
};


export type ReferencePortfoliosArgs = {
  sort?: InputMaybe<PortfolioSortInput>;
  where?: InputMaybe<PortfolioWhereInput>;
};


export type ReferenceTurbinesArgs = {
  sort?: InputMaybe<TurbineSortInput>;
  where?: InputMaybe<TurbineWhereInput>;
};

export type RelatedReports = {
  __typename?: 'RelatedReports';
  reportId: Scalars['String']['output'];
  reportName: Scalars['String']['output'];
};

export type RemoveAssetsInput = {
  assets?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id_ticket: Scalars['ID']['input'];
};

export type Report = {
  __typename?: 'Report';
  CREATED_BY: Scalars['String']['output'];
  CREATED_TS: Scalars['Float']['output'];
  EDITED_BY?: Maybe<Scalars['String']['output']>;
  EDITED_TS?: Maybe<Scalars['Float']['output']>;
  FK_ID_PORTFOLIO: Scalars['Int']['output'];
  NAME: Scalars['String']['output'];
  REPORT?: Maybe<Scalars['String']['output']>;
  SCHEDULE?: Maybe<Scalars['String']['output']>;
  _id: Scalars['ID']['output'];
  isDefaultTemplate?: Maybe<Scalars['Boolean']['output']>;
};

export type ReportSchemaInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdTs?: InputMaybe<Scalars['Float']['input']>;
  creatorName?: InputMaybe<Scalars['String']['input']>;
  editedBy?: InputMaybe<Scalars['String']['input']>;
  editedTs?: InputMaybe<Scalars['Float']['input']>;
  fkPortfolio_id?: InputMaybe<Scalars['String']['input']>;
  isDefaultTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<Scalars['String']['input']>;
  report_id?: InputMaybe<Scalars['String']['input']>;
  schedule: Scalars['String']['input'];
  shared?: InputMaybe<Scalars['Int']['input']>;
};

export type ReportTemplate = {
  __typename?: 'ReportTemplate';
  _id: Scalars['ID']['output'];
  _id_portfolio?: Maybe<Scalars['ID']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdTs?: Maybe<Scalars['Float']['output']>;
  creatorName?: Maybe<Scalars['String']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  editedTs?: Maybe<Scalars['Float']['output']>;
  isDefaultTemplate?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  report?: Maybe<Scalars['String']['output']>;
  schedule?: Maybe<Scalars['String']['output']>;
};

export type ReportTemplateResponse = {
  __typename?: 'ReportTemplateResponse';
  message: Scalars['String']['output'];
  reportTemplate?: Maybe<ReportTemplate>;
  success: Scalars['Boolean']['output'];
};

export type ReportTemplateWhereInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  isDefaultTemplate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReportWhereInput = {
  AND?: InputMaybe<Array<ReportWhereInput>>;
  OR?: InputMaybe<Array<ReportWhereInput>>;
  _id?: InputMaybe<Scalars['ID']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdTs?: InputMaybe<Scalars['String']['input']>;
  editedBy?: InputMaybe<Scalars['String']['input']>;
  editedTs?: InputMaybe<Scalars['String']['input']>;
  fkPortfolio_id?: InputMaybe<Scalars['String']['input']>;
  isDefaultTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<Scalars['String']['input']>;
  report_id?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<ReportWhereScheduleInput>;
  shared?: InputMaybe<Scalars['Int']['input']>;
};

export type ReportWhereScheduleInput = {
  daily?: InputMaybe<Scalars['Boolean']['input']>;
  emailList?: InputMaybe<Scalars['String']['input']>;
  firstDays?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  footer?: InputMaybe<Scalars['String']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  park?: InputMaybe<Scalars['String']['input']>;
  parkId?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<Scalars['String']['input']>;
  weekDays?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type Reportb = {
  __typename?: 'Reportb';
  _id: Scalars['ID']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdTs?: Maybe<Scalars['Float']['output']>;
  creatorName?: Maybe<Scalars['String']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  editedTs?: Maybe<Scalars['Float']['output']>;
  fkPortfolio_id?: Maybe<Scalars['String']['output']>;
  isDefaultTemplate?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  report?: Maybe<Scalars['String']['output']>;
  report_id?: Maybe<Scalars['String']['output']>;
  schedule?: Maybe<Scalars['String']['output']>;
  shared?: Maybe<Scalars['Int']['output']>;
};

export type RevenuesDataseriesValue = {
  __typename?: 'RevenuesDataseriesValue';
  _id_park?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<MetricValues>>>;
  marketPrice?: Maybe<Scalars['Float']['output']>;
  productionGrid?: Maybe<Scalars['Float']['output']>;
  productionGridCount?: Maybe<Scalars['Int']['output']>;
  productionLosses?: Maybe<Scalars['Float']['output']>;
  productionScada?: Maybe<Scalars['Float']['output']>;
  timestamp?: Maybe<Scalars['Float']['output']>;
};

export enum RevenuesGranularityEnum {
  Daily = 'DAILY',
  Hourly = 'HOURLY',
  Monthly = 'MONTHLY',
  No = 'NO',
  QuarterHourly = 'QUARTER_HOURLY',
  Total = 'TOTAL'
}

export type RuleIdent = {
  __typename?: 'RuleIdent';
  _id: Scalars['ID']['output'];
  mandatory: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type ScaleDownInput = {
  unit: TimeUnitEnum;
  value: Scalars['Int']['input'];
};

export type ScaterPlotData = {
  __typename?: 'ScaterPlotData';
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
};

export type ScaterPlotDataType = {
  end?: InputMaybe<Scalars['Float']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
};

export enum SectorCategoryEnum {
  All = 'ALL',
  Eight = 'EIGHT',
  Eleven = 'ELEVEN',
  Five = 'FIVE',
  Four = 'FOUR',
  Join = 'JOIN',
  Nine = 'NINE',
  One = 'ONE',
  Seven = 'SEVEN',
  Six = 'SIX',
  Ten = 'TEN',
  Three = 'THREE',
  Twelve = 'TWELVE',
  Two = 'TWO'
}

export type SecurityPreferences = {
  __typename?: 'SecurityPreferences';
  isTotpEnabled: Scalars['Boolean']['output'];
};

export type SetTicketAssigneesInput = {
  id_ticket: Scalars['ID']['input'];
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type SetTicketDescriptionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id_ticket: Scalars['ID']['input'];
};

export type SetTicketModulesInput = {
  id_ticket: Scalars['ID']['input'];
  modules: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type Signal = {
  __typename?: 'Signal';
  _id?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  displayShortName?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  signalGroupType?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export enum SignalGroupEnum {
  All = 'all',
  Ambient = 'ambient',
  Electrical = 'electrical',
  Technical = 'technical',
  Temperature = 'temperature'
}

export type SignalGroupedDataSeriesResult = {
  __typename?: 'SignalGroupedDataSeriesResult';
  absValues?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  avgValues?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  data?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  intervalTS?: Maybe<Scalars['Int']['output']>;
  lastTS?: Maybe<Scalars['Float']['output']>;
  startingTS?: Maybe<Scalars['Float']['output']>;
};

export type SignalGroupedFactsResult = {
  __typename?: 'SignalGroupedFactsResult';
  dataValue?: Maybe<Scalars['Float']['output']>;
  endTS?: Maybe<Scalars['Float']['output']>;
  interval?: Maybe<Scalars['Float']['output']>;
  startTS?: Maybe<Scalars['Float']['output']>;
};

export enum SignalType {
  Wcnv1 = 'WCNV1',
  Wgen1 = 'WGEN1',
  Wmxu1 = 'WMXU1',
  Wnac1 = 'WNAC1',
  Wrot1 = 'WROT1',
  Wtrf1 = 'WTRF1',
  Wtrm1 = 'WTRM1',
  Wtur1 = 'WTUR1',
  Wyaw1 = 'WYAW1',
  All = 'all',
  Tmp = 'tmp'
}

export enum Sort {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StatisticalPowerCurveDataTypes = {
  __typename?: 'StatisticalPowerCurveDataTypes';
  outPutPower: Scalars['Float']['output'];
  windSpeed: Scalars['Float']['output'];
};

export type Status = {
  __typename?: 'Status';
  _id: Scalars['ID']['output'];
  color: Scalars['String']['output'];
  hide: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

export enum Stream {
  S10m = 's10m',
  S30s = 's30s'
}

export type StringData = {
  __typename?: 'StringData';
  stringValue?: Maybe<Scalars['String']['output']>;
};

export type Subject = {
  __typename?: 'Subject';
  id: Scalars['ID']['output'];
  username: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  countries: Array<Country>;
  getAppWarnings?: Maybe<Array<Maybe<Warning>>>;
  parks: Array<Park>;
  portfolios: Array<Portfolio>;
  turbines: Array<Turbine>;
  user?: Maybe<User>;
};


export type SubscriptionCountriesArgs = {
  parks?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  sort?: InputMaybe<CountrySortInput>;
  subscriptionInterval?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CountryWhereInput>;
};


export type SubscriptionGetAppWarningsArgs = {
  module?: InputMaybe<Module>;
  subscriptionInterval?: InputMaybe<Scalars['Int']['input']>;
};


export type SubscriptionParksArgs = {
  sort?: InputMaybe<ParkSortInput>;
  subscriptionInterval?: InputMaybe<Scalars['Int']['input']>;
  turbines?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  where?: InputMaybe<ParkWhereInput>;
};


export type SubscriptionPortfoliosArgs = {
  parks?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  sort?: InputMaybe<PortfolioSortInput>;
  subscriptionInterval?: InputMaybe<Scalars['Int']['input']>;
  when?: InputMaybe<CustomPortfolioWhereInput>;
  where?: InputMaybe<PortfolioWhereInput>;
};


export type SubscriptionTurbinesArgs = {
  sort?: InputMaybe<TurbineSortInput>;
  subscriptionInterval?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TurbineWhereInput>;
};


export type SubscriptionUserArgs = {
  subscriptionInterval?: InputMaybe<Scalars['Int']['input']>;
};

/** System Information */
export type System = {
  __typename?: 'System';
  /** CPU Information */
  cpu: Array<Maybe<Cpu>>;
  /** Free Memory */
  freeMemory: Scalars['String']['output'];
  /** Name of Instance (Dev __ Int __ Prod) */
  instance: Scalars['String']['output'];
  /** Internal IP Address */
  ip: Scalars['String']['output'];
  /** Name of the container (Kubernetes POD) */
  name: Scalars['String']['output'];
  /** Name of the node (Kubernetes node) */
  nodeName: Scalars['String']['output'];
  /** Total Memory */
  totalMemory: Scalars['String']['output'];
  /** API Server version */
  version: Scalars['String']['output'];
};

export type T31BkwRule = {
  __typename?: 'T31BkwRule';
  day: Scalars['Int']['output'];
  limit: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
};

export type TargetCaptureRatio = {
  __typename?: 'TargetCaptureRatio';
  month: Scalars['Int']['output'];
  targetCaptureRatio?: Maybe<Scalars['Float']['output']>;
};

export type TargetPrice = {
  __typename?: 'TargetPrice';
  month: Scalars['Int']['output'];
  targetPrice?: Maybe<Scalars['Float']['output']>;
};

export type TemplateCustomField = {
  __typename?: 'TemplateCustomField';
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Ticket = {
  __typename?: 'Ticket';
  _id: Scalars['ID']['output'];
  _id_board: Scalars['ID']['output'];
  _id_status: Scalars['ID']['output'];
  _id_template?: Maybe<Scalars['ID']['output']>;
  assets?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  assignees?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  attachments?: Maybe<Array<Maybe<TicketAttachment>>>;
  changeLogs?: Maybe<Array<Maybe<ChangeLog>>>;
  comments?: Maybe<Array<Maybe<TicketComment>>>;
  createdBy_id: Scalars['ID']['output'];
  createdBy_username: Scalars['String']['output'];
  createdOn: Scalars['Float']['output'];
  dueDate?: Maybe<TicketDueDate>;
  information?: Maybe<TicketInformation>;
  integrations?: Maybe<Array<Maybe<Integration>>>;
  isArchive: Scalars['Boolean']['output'];
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  modifiedBy_id: Scalars['ID']['output'];
  modifiedBy_username: Scalars['String']['output'];
  modifiedOn: Scalars['Float']['output'];
  modules?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  notification?: Maybe<Notification>;
  number: Scalars['Int']['output'];
  priority?: Maybe<TicketPriority>;
  timeToDelete: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  totalComments: Scalars['Int']['output'];
  updated?: Maybe<LastUpdate>;
};

export type TicketArchInput = {
  id_ticket: Scalars['ID']['input'];
  isArchive: Scalars['Boolean']['input'];
};

export type TicketAttachment = {
  __typename?: 'TicketAttachment';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdTs?: Maybe<Scalars['Float']['output']>;
  fileExtension?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  id_comment?: Maybe<Scalars['String']['output']>;
  id_ticket?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  originalName?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type TicketAttachmentInput = {
  fileExtension: Scalars['String']['input'];
  id_comment?: InputMaybe<Scalars['ID']['input']>;
  id_ticket: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  originalName: Scalars['String']['input'];
  size: Scalars['Int']['input'];
};

export type TicketComment = {
  __typename?: 'TicketComment';
  _id: Scalars['ID']['output'];
  _id_user: Scalars['ID']['output'];
  attachments?: Maybe<Array<Maybe<TicketAttachment>>>;
  content: Scalars['String']['output'];
  createTs?: Maybe<Scalars['Float']['output']>;
  username: Scalars['String']['output'];
};

export type TicketCommentDelInput = {
  id: Scalars['ID']['input'];
  id_ticket: Scalars['ID']['input'];
};

export type TicketCommentInput = {
  content: Scalars['String']['input'];
  id_ticket: Scalars['ID']['input'];
};

export type TicketDeleteAttachmentInput = {
  id: Scalars['ID']['input'];
};

export type TicketDueDate = {
  __typename?: 'TicketDueDate';
  end?: Maybe<Scalars['Float']['output']>;
  start?: Maybe<Scalars['Float']['output']>;
};

export type TicketFavInput = {
  id_ticket: Scalars['ID']['input'];
  isFavorite: Scalars['Boolean']['input'];
};

export type TicketInformation = {
  __typename?: 'TicketInformation';
  attachments?: Maybe<Array<Maybe<TicketAttachment>>>;
  customFields?: Maybe<Array<Maybe<CustomField>>>;
  description?: Maybe<Scalars['String']['output']>;
};

export type TicketIntegrationDelInput = {
  id_integration: Scalars['ID']['input'];
  id_ticket: Scalars['ID']['input'];
};

export type TicketIntegrationInput = {
  id_ticket: Scalars['ID']['input'];
  integrations: Array<InputMaybe<Scalars['ID']['input']>>;
  type: IntegrationType;
};

export type TicketModule = {
  __typename?: 'TicketModule';
  _id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
};

export enum TicketPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type TicketTemplate = {
  __typename?: 'TicketTemplate';
  _id: Scalars['ID']['output'];
  customFields?: Maybe<Array<Maybe<TemplateCustomField>>>;
  name: Scalars['String']['output'];
};

export type TicketTemplateInput = {
  id_template: Scalars['ID']['input'];
  id_ticket: Scalars['ID']['input'];
};

export enum TimeGranularityEnum {
  Day = 'DAY',
  Hour = 'HOUR',
  Month = 'MONTH',
  Year = 'YEAR'
}

export enum TimeUnitEnum {
  Hours = 'hours',
  Minutes = 'minutes',
  Seconds = 'seconds'
}

export enum TimeZone {
  AfricaAbidjan = 'Africa__Abidjan',
  AfricaAccra = 'Africa__Accra',
  AfricaAlgiers = 'Africa__Algiers',
  AfricaBissau = 'Africa__Bissau',
  AfricaCairo = 'Africa__Cairo',
  AfricaCasablanca = 'Africa__Casablanca',
  AfricaCeuta = 'Africa__Ceuta',
  AfricaElAaiun = 'Africa__El_Aaiun',
  AfricaJohannesburg = 'Africa__Johannesburg',
  AfricaJuba = 'Africa__Juba',
  AfricaKhartoum = 'Africa__Khartoum',
  AfricaLagos = 'Africa__Lagos',
  AfricaMaputo = 'Africa__Maputo',
  AfricaMonrovia = 'Africa__Monrovia',
  AfricaNairobi = 'Africa__Nairobi',
  AfricaNdjamena = 'Africa__Ndjamena',
  AfricaSaoTome = 'Africa__Sao_Tome',
  AfricaTripoli = 'Africa__Tripoli',
  AfricaTunis = 'Africa__Tunis',
  AfricaWindhoek = 'Africa__Windhoek',
  AmericaAdak = 'America__Adak',
  AmericaAnchorage = 'America__Anchorage',
  AmericaAraguaina = 'America__Araguaina',
  AmericaArgentinaBuenosAires = 'America__Argentina__Buenos_Aires',
  AmericaArgentinaCatamarca = 'America__Argentina__Catamarca',
  AmericaArgentinaCordoba = 'America__Argentina__Cordoba',
  AmericaArgentinaJujuy = 'America__Argentina__Jujuy',
  AmericaArgentinaLaRioja = 'America__Argentina__La_Rioja',
  AmericaArgentinaMendoza = 'America__Argentina__Mendoza',
  AmericaArgentinaRioGallegos = 'America__Argentina__Rio_Gallegos',
  AmericaArgentinaSalta = 'America__Argentina__Salta',
  AmericaArgentinaSanJuan = 'America__Argentina__San_Juan',
  AmericaArgentinaSanLuis = 'America__Argentina__San_Luis',
  AmericaArgentinaTucuman = 'America__Argentina__Tucuman',
  AmericaArgentinaUshuaia = 'America__Argentina__Ushuaia',
  AmericaAsuncion = 'America__Asuncion',
  AmericaAtikokan = 'America__Atikokan',
  AmericaBahia = 'America__Bahia',
  AmericaBahiaBanderas = 'America__Bahia_Banderas',
  AmericaBarbados = 'America__Barbados',
  AmericaBelem = 'America__Belem',
  AmericaBelize = 'America__Belize',
  AmericaBoaVista = 'America__Boa_Vista',
  AmericaBogota = 'America__Bogota',
  AmericaBoise = 'America__Boise',
  AmericaCambridgeBay = 'America__Cambridge_Bay',
  AmericaCampoGrande = 'America__Campo_Grande',
  AmericaCancun = 'America__Cancun',
  AmericaCaracas = 'America__Caracas',
  AmericaCayenne = 'America__Cayenne',
  AmericaChicago = 'America__Chicago',
  AmericaChihuahua = 'America__Chihuahua',
  AmericaCostaRica = 'America__Costa_Rica',
  AmericaCreston = 'America__Creston',
  AmericaCuiaba = 'America__Cuiaba',
  AmericaCuracao = 'America__Curacao',
  AmericaDanmarkshavn = 'America__Danmarkshavn',
  AmericaDawson = 'America__Dawson',
  AmericaDawsonCreek = 'America__Dawson_Creek',
  AmericaDenver = 'America__Denver',
  AmericaDetroit = 'America__Detroit',
  AmericaEdmonton = 'America__Edmonton',
  AmericaEirunepe = 'America__Eirunepe',
  AmericaElSalvador = 'America__El_Salvador',
  AmericaFortNelson = 'America__Fort_Nelson',
  AmericaFortaleza = 'America__Fortaleza',
  AmericaGlaceBay = 'America__Glace_Bay',
  AmericaGodthab = 'America__Godthab',
  AmericaGooseBay = 'America__Goose_Bay',
  AmericaGrandTurk = 'America__Grand_Turk',
  AmericaGuatemala = 'America__Guatemala',
  AmericaGuayaquil = 'America__Guayaquil',
  AmericaGuyana = 'America__Guyana',
  AmericaHalifax = 'America__Halifax',
  AmericaHavana = 'America__Havana',
  AmericaHermosillo = 'America__Hermosillo',
  AmericaIndianaIndianapolis = 'America__Indiana__Indianapolis',
  AmericaIndianaKnox = 'America__Indiana__Knox',
  AmericaIndianaMarengo = 'America__Indiana__Marengo',
  AmericaIndianaPetersburg = 'America__Indiana__Petersburg',
  AmericaIndianaTellCity = 'America__Indiana__Tell_City',
  AmericaIndianaVevay = 'America__Indiana__Vevay',
  AmericaIndianaVincennes = 'America__Indiana__Vincennes',
  AmericaIndianaWinamac = 'America__Indiana__Winamac',
  AmericaInuvik = 'America__Inuvik',
  AmericaIqaluit = 'America__Iqaluit',
  AmericaJamaica = 'America__Jamaica',
  AmericaJuneau = 'America__Juneau',
  AmericaKentuckyLouisville = 'America__Kentucky__Louisville',
  AmericaKentuckyMonticello = 'America__Kentucky__Monticello',
  AmericaLaPaz = 'America__La_Paz',
  AmericaLima = 'America__Lima',
  AmericaLosAngeles = 'America__Los_Angeles',
  AmericaMaceio = 'America__Maceio',
  AmericaManagua = 'America__Managua',
  AmericaManaus = 'America__Manaus',
  AmericaMartinique = 'America__Martinique',
  AmericaMatamoros = 'America__Matamoros',
  AmericaMazatlan = 'America__Mazatlan',
  AmericaMenominee = 'America__Menominee',
  AmericaMerida = 'America__Merida',
  AmericaMetlakatla = 'America__Metlakatla',
  AmericaMexicoCity = 'America__Mexico_City',
  AmericaMiquelon = 'America__Miquelon',
  AmericaMoncton = 'America__Moncton',
  AmericaMonterrey = 'America__Monterrey',
  AmericaMontevideo = 'America__Montevideo',
  AmericaNassau = 'America__Nassau',
  AmericaNewYork = 'America__New_York',
  AmericaNipigon = 'America__Nipigon',
  AmericaNome = 'America__Nome',
  AmericaNoronha = 'America__Noronha',
  AmericaNorthDakotaBeulah = 'America__North_Dakota__Beulah',
  AmericaNorthDakotaCenter = 'America__North_Dakota__Center',
  AmericaNorthDakotaNewSalem = 'America__North_Dakota__New_Salem',
  AmericaOjinaga = 'America__Ojinaga',
  AmericaPanama = 'America__Panama',
  AmericaPangnirtung = 'America__Pangnirtung',
  AmericaParamaribo = 'America__Paramaribo',
  AmericaPhoenix = 'America__Phoenix',
  AmericaPortOfSpain = 'America__Port_of_Spain',
  AmericaPortoVelho = 'America__Porto_Velho',
  AmericaPuertoRico = 'America__Puerto_Rico',
  AmericaPuntaArenas = 'America__Punta_Arenas',
  AmericaRainyRiver = 'America__Rainy_River',
  AmericaRankinInlet = 'America__Rankin_Inlet',
  AmericaRecife = 'America__Recife',
  AmericaRegina = 'America__Regina',
  AmericaResolute = 'America__Resolute',
  AmericaRioBranco = 'America__Rio_Branco',
  AmericaSantarem = 'America__Santarem',
  AmericaSantiago = 'America__Santiago',
  AmericaSantoDomingo = 'America__Santo_Domingo',
  AmericaSaoPaulo = 'America__Sao_Paulo',
  AmericaScoresbysund = 'America__Scoresbysund',
  AmericaSitka = 'America__Sitka',
  AmericaStJohns = 'America__St_Johns',
  AmericaSwiftCurrent = 'America__Swift_Current',
  AmericaTegucigalpa = 'America__Tegucigalpa',
  AmericaThule = 'America__Thule',
  AmericaThunderBay = 'America__Thunder_Bay',
  AmericaTijuana = 'America__Tijuana',
  AmericaToronto = 'America__Toronto',
  AmericaVancouver = 'America__Vancouver',
  AmericaWhitehorse = 'America__Whitehorse',
  AmericaWinnipeg = 'America__Winnipeg',
  AmericaYakutat = 'America__Yakutat',
  AmericaYellowknife = 'America__Yellowknife',
  AntarcticaCasey = 'Antarctica__Casey',
  AntarcticaDavis = 'Antarctica__Davis',
  AntarcticaDumontDUrville = 'Antarctica__DumontDUrville',
  AntarcticaMacquarie = 'Antarctica__Macquarie',
  AntarcticaMawson = 'Antarctica__Mawson',
  AntarcticaPalmer = 'Antarctica__Palmer',
  AntarcticaRothera = 'Antarctica__Rothera',
  AntarcticaSyowa = 'Antarctica__Syowa',
  AntarcticaTroll = 'Antarctica__Troll',
  AntarcticaVostok = 'Antarctica__Vostok',
  AsiaAlmaty = 'Asia__Almaty',
  AsiaAmman = 'Asia__Amman',
  AsiaAnadyr = 'Asia__Anadyr',
  AsiaAqtau = 'Asia__Aqtau',
  AsiaAqtobe = 'Asia__Aqtobe',
  AsiaAshgabat = 'Asia__Ashgabat',
  AsiaAtyrau = 'Asia__Atyrau',
  AsiaBaghdad = 'Asia__Baghdad',
  AsiaBaku = 'Asia__Baku',
  AsiaBangkok = 'Asia__Bangkok',
  AsiaBarnaul = 'Asia__Barnaul',
  AsiaBeirut = 'Asia__Beirut',
  AsiaBishkek = 'Asia__Bishkek',
  AsiaBrunei = 'Asia__Brunei',
  AsiaChita = 'Asia__Chita',
  AsiaChoibalsan = 'Asia__Choibalsan',
  AsiaColombo = 'Asia__Colombo',
  AsiaDamascus = 'Asia__Damascus',
  AsiaDhaka = 'Asia__Dhaka',
  AsiaDili = 'Asia__Dili',
  AsiaDubai = 'Asia__Dubai',
  AsiaDushanbe = 'Asia__Dushanbe',
  AsiaFamagusta = 'Asia__Famagusta',
  AsiaGaza = 'Asia__Gaza',
  AsiaHebron = 'Asia__Hebron',
  AsiaHoChiMinh = 'Asia__Ho_Chi_Minh',
  AsiaHongKong = 'Asia__Hong_Kong',
  AsiaHovd = 'Asia__Hovd',
  AsiaIrkutsk = 'Asia__Irkutsk',
  AsiaJakarta = 'Asia__Jakarta',
  AsiaJayapura = 'Asia__Jayapura',
  AsiaJerusalem = 'Asia__Jerusalem',
  AsiaKabul = 'Asia__Kabul',
  AsiaKamchatka = 'Asia__Kamchatka',
  AsiaKarachi = 'Asia__Karachi',
  AsiaKathmandu = 'Asia__Kathmandu',
  AsiaKhandyga = 'Asia__Khandyga',
  AsiaKolkata = 'Asia__Kolkata',
  AsiaKrasnoyarsk = 'Asia__Krasnoyarsk',
  AsiaKualaLumpur = 'Asia__Kuala_Lumpur',
  AsiaKuching = 'Asia__Kuching',
  AsiaMacau = 'Asia__Macau',
  AsiaMagadan = 'Asia__Magadan',
  AsiaMakassar = 'Asia__Makassar',
  AsiaManila = 'Asia__Manila',
  AsiaNicosia = 'Asia__Nicosia',
  AsiaNovokuznetsk = 'Asia__Novokuznetsk',
  AsiaNovosibirsk = 'Asia__Novosibirsk',
  AsiaOmsk = 'Asia__Omsk',
  AsiaOral = 'Asia__Oral',
  AsiaPontianak = 'Asia__Pontianak',
  AsiaPyongyang = 'Asia__Pyongyang',
  AsiaQatar = 'Asia__Qatar',
  AsiaQostanay = 'Asia__Qostanay',
  AsiaQyzylorda = 'Asia__Qyzylorda',
  AsiaRiyadh = 'Asia__Riyadh',
  AsiaSakhalin = 'Asia__Sakhalin',
  AsiaSamarkand = 'Asia__Samarkand',
  AsiaSeoul = 'Asia__Seoul',
  AsiaShanghai = 'Asia__Shanghai',
  AsiaSingapore = 'Asia__Singapore',
  AsiaSrednekolymsk = 'Asia__Srednekolymsk',
  AsiaTaipei = 'Asia__Taipei',
  AsiaTashkent = 'Asia__Tashkent',
  AsiaTbilisi = 'Asia__Tbilisi',
  AsiaTehran = 'Asia__Tehran',
  AsiaThimphu = 'Asia__Thimphu',
  AsiaTokyo = 'Asia__Tokyo',
  AsiaTomsk = 'Asia__Tomsk',
  AsiaUlaanbaatar = 'Asia__Ulaanbaatar',
  AsiaUrumqi = 'Asia__Urumqi',
  AsiaVladivostok = 'Asia__Vladivostok',
  AsiaYakutsk = 'Asia__Yakutsk',
  AsiaYangon = 'Asia__Yangon',
  AsiaYekaterinburg = 'Asia__Yekaterinburg',
  AsiaYerevan = 'Asia__Yerevan',
  AtlanticAzores = 'Atlantic__Azores',
  AtlanticBermuda = 'Atlantic__Bermuda',
  AtlanticCanary = 'Atlantic__Canary',
  AtlanticCapeVerde = 'Atlantic__Cape_Verde',
  AtlanticFaroe = 'Atlantic__Faroe',
  AtlanticMadeira = 'Atlantic__Madeira',
  AtlanticReykjavik = 'Atlantic__Reykjavik',
  AtlanticSouthGeorgia = 'Atlantic__South_Georgia',
  AtlanticStanley = 'Atlantic__Stanley',
  AustraliaAdelaide = 'Australia__Adelaide',
  AustraliaBrisbane = 'Australia__Brisbane',
  AustraliaBrokenHill = 'Australia__Broken_Hill',
  AustraliaCurrie = 'Australia__Currie',
  AustraliaDarwin = 'Australia__Darwin',
  AustraliaEucla = 'Australia__Eucla',
  AustraliaHobart = 'Australia__Hobart',
  AustraliaLindeman = 'Australia__Lindeman',
  AustraliaLordHowe = 'Australia__Lord_Howe',
  AustraliaMelbourne = 'Australia__Melbourne',
  AustraliaPerth = 'Australia__Perth',
  AustraliaSydney = 'Australia__Sydney',
  EuropeAmsterdam = 'Europe__Amsterdam',
  EuropeAndorra = 'Europe__Andorra',
  EuropeAstrakhan = 'Europe__Astrakhan',
  EuropeAthens = 'Europe__Athens',
  EuropeBelgrade = 'Europe__Belgrade',
  EuropeBerlin = 'Europe__Berlin',
  EuropeBrussels = 'Europe__Brussels',
  EuropeBucharest = 'Europe__Bucharest',
  EuropeBudapest = 'Europe__Budapest',
  EuropeChisinau = 'Europe__Chisinau',
  EuropeCopenhagen = 'Europe__Copenhagen',
  EuropeDublin = 'Europe__Dublin',
  EuropeGibraltar = 'Europe__Gibraltar',
  EuropeHelsinki = 'Europe__Helsinki',
  EuropeIstanbul = 'Europe__Istanbul',
  EuropeKaliningrad = 'Europe__Kaliningrad',
  EuropeKiev = 'Europe__Kiev',
  EuropeKirov = 'Europe__Kirov',
  EuropeLisbon = 'Europe__Lisbon',
  EuropeLondon = 'Europe__London',
  EuropeLuxembourg = 'Europe__Luxembourg',
  EuropeMadrid = 'Europe__Madrid',
  EuropeMalta = 'Europe__Malta',
  EuropeMinsk = 'Europe__Minsk',
  EuropeMonaco = 'Europe__Monaco',
  EuropeMoscow = 'Europe__Moscow',
  EuropeOslo = 'Europe__Oslo',
  EuropeParis = 'Europe__Paris',
  EuropePrague = 'Europe__Prague',
  EuropeRiga = 'Europe__Riga',
  EuropeRome = 'Europe__Rome',
  EuropeSamara = 'Europe__Samara',
  EuropeSaratov = 'Europe__Saratov',
  EuropeSimferopol = 'Europe__Simferopol',
  EuropeSofia = 'Europe__Sofia',
  EuropeStockholm = 'Europe__Stockholm',
  EuropeTallinn = 'Europe__Tallinn',
  EuropeTirane = 'Europe__Tirane',
  EuropeUlyanovsk = 'Europe__Ulyanovsk',
  EuropeUzhgorod = 'Europe__Uzhgorod',
  EuropeVienna = 'Europe__Vienna',
  EuropeVilnius = 'Europe__Vilnius',
  EuropeVolgograd = 'Europe__Volgograd',
  EuropeWarsaw = 'Europe__Warsaw',
  EuropeZaporozhye = 'Europe__Zaporozhye',
  EuropeZurich = 'Europe__Zurich',
  IndianChagos = 'Indian__Chagos',
  IndianChristmas = 'Indian__Christmas',
  IndianCocos = 'Indian__Cocos',
  IndianKerguelen = 'Indian__Kerguelen',
  IndianMahe = 'Indian__Mahe',
  IndianMaldives = 'Indian__Maldives',
  IndianMauritius = 'Indian__Mauritius',
  IndianReunion = 'Indian__Reunion',
  PacificApia = 'Pacific__Apia',
  PacificAuckland = 'Pacific__Auckland',
  PacificBougainville = 'Pacific__Bougainville',
  PacificChatham = 'Pacific__Chatham',
  PacificChuuk = 'Pacific__Chuuk',
  PacificEaster = 'Pacific__Easter',
  PacificEfate = 'Pacific__Efate',
  PacificEnderbury = 'Pacific__Enderbury',
  PacificFakaofo = 'Pacific__Fakaofo',
  PacificFiji = 'Pacific__Fiji',
  PacificFunafuti = 'Pacific__Funafuti',
  PacificGalapagos = 'Pacific__Galapagos',
  PacificGambier = 'Pacific__Gambier',
  PacificGuadalcanal = 'Pacific__Guadalcanal',
  PacificGuam = 'Pacific__Guam',
  PacificHonolulu = 'Pacific__Honolulu',
  PacificKiritimati = 'Pacific__Kiritimati',
  PacificKosrae = 'Pacific__Kosrae',
  PacificKwajalein = 'Pacific__Kwajalein',
  PacificMajuro = 'Pacific__Majuro',
  PacificMarquesas = 'Pacific__Marquesas',
  PacificNauru = 'Pacific__Nauru',
  PacificNiue = 'Pacific__Niue',
  PacificNorfolk = 'Pacific__Norfolk',
  PacificNoumea = 'Pacific__Noumea',
  PacificPagoPago = 'Pacific__Pago_Pago',
  PacificPalau = 'Pacific__Palau',
  PacificPitcairn = 'Pacific__Pitcairn',
  PacificPohnpei = 'Pacific__Pohnpei',
  PacificPortMoresby = 'Pacific__Port_Moresby',
  PacificRarotonga = 'Pacific__Rarotonga',
  PacificTahiti = 'Pacific__Tahiti',
  PacificTarawa = 'Pacific__Tarawa',
  PacificTongatapu = 'Pacific__Tongatapu',
  PacificWake = 'Pacific__Wake',
  PacificWallis = 'Pacific__Wallis'
}

export type Timeseries = {
  __typename?: 'Timeseries';
  alarmMain?: Maybe<Array<Maybe<TimeseriesResult>>>;
  alarmStatus?: Maybe<Array<Maybe<TimeseriesResult>>>;
};


export type TimeseriesAlarmMainArgs = {
  aggregation: Array<InputMaybe<TimeseriesAggregationInput>>;
  filter?: InputMaybe<Array<InputMaybe<TimeseriesFilterInput>>>;
  groupBy?: InputMaybe<TimeseriesGroupByInput>;
};


export type TimeseriesAlarmStatusArgs = {
  aggregation: Array<InputMaybe<TimeseriesAggregationInput>>;
  filter?: InputMaybe<Array<InputMaybe<TimeseriesFilterInput>>>;
  groupBy?: InputMaybe<TimeseriesGroupByInput>;
};

export enum TimeseriesAggregation {
  Daily = 'DAILY',
  Hourly = 'HOURLY',
  Monthly = 'MONTHLY'
}

export type TimeseriesAggregationInput = {
  aggregation: TimeseriesAggregatorEnum;
  align?: InputMaybe<TimeseriesAlignEnum>;
  samplingUnit: TimeseriesSamplingUnitEnum;
  samplingValue: Scalars['Int']['input'];
};

export enum TimeseriesAggregatorEnum {
  Avg = 'AVG',
  AvgDegree = 'AVG_DEGREE',
  Count = 'COUNT',
  Max = 'MAX',
  Min = 'MIN',
  Sum = 'SUM'
}

export enum TimeseriesAlignEnum {
  End = 'END',
  Start = 'START'
}

export type TimeseriesFilterInput = {
  filterKey: Scalars['String']['input'];
  filterValues: Array<InputMaybe<Scalars['String']['input']>>;
};

export type TimeseriesGroupByInput = {
  key: Scalars['String']['input'];
  values: Array<InputMaybe<Scalars['String']['input']>>;
};

export type TimeseriesRangeInput = {
  endTS?: InputMaybe<Scalars['Float']['input']>;
  startTS?: InputMaybe<Scalars['Float']['input']>;
};

export type TimeseriesResult = {
  __typename?: 'TimeseriesResult';
  dataJSON?: Maybe<Array<Maybe<JsonMap>>>;
  dataKeyValue?: Maybe<Array<Maybe<Array<Maybe<Scalars['Float']['output']>>>>>;
  dataTimestamp?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  dataValue?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  endTS?: Maybe<Scalars['Float']['output']>;
  groupBy?: Maybe<Scalars['String']['output']>;
  startTS?: Maybe<Scalars['Float']['output']>;
};

export enum TimeseriesSamplingUnitEnum {
  Days = 'DAYS',
  Hours = 'HOURS',
  Milliseconds = 'MILLISECONDS',
  Minutes = 'MINUTES',
  Months = 'MONTHS',
  Seconds = 'SECONDS',
  Weeks = 'WEEKS',
  Years = 'YEARS'
}

export type TotalAvailabilityInfo = {
  __typename?: 'TotalAvailabilityInfo';
  alarmCountTotal?: Maybe<Scalars['Float']['output']>;
  alarmDurationTotal?: Maybe<Scalars['Float']['output']>;
  durationDurationAvg?: Maybe<Scalars['Float']['output']>;
  durationTotal?: Maybe<Scalars['Float']['output']>;
};

export type TotalValue = {
  __typename?: 'TotalValue';
  accumulated?: Maybe<NumberObject>;
  expected?: Maybe<NumberObject>;
  total?: Maybe<NumberObject>;
};

export type Troubleshoot = Integration & {
  __typename?: 'Troubleshoot';
  _id_integration: Scalars['ID']['output'];
  assetId?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  dateRange?: Maybe<DateRange>;
  description?: Maybe<Scalars['String']['output']>;
  isOpen?: Maybe<Scalars['Boolean']['output']>;
  productionLoss?: Maybe<Scalars['Float']['output']>;
  turbineInfo?: Maybe<TurbineIntegration>;
  type?: Maybe<IntegrationType>;
};

export type Turbine = {
  __typename?: 'Turbine';
  _id: Scalars['ID']['output'];
  ackAndConfirmedCount?: Maybe<ParkAckAndConfirmedCount>;
  ackCount?: Maybe<AckCount>;
  ackCountPerDay?: Maybe<Array<Maybe<AckCount>>>;
  ackCountPerTimeRange?: Maybe<Array<Maybe<AckCount>>>;
  aggregatedAlarms?: Maybe<Array<Maybe<AggregatedAlarms>>>;
  alarmCount: Scalars['Int']['output'];
  alarmDismissRules?: Maybe<Array<Maybe<AlarmDismissRule>>>;
  alarmFollowUpCompletedRules?: Maybe<Array<Maybe<AlarmFollowUpRule>>>;
  alarmFollowUpRules?: Maybe<Array<Maybe<AlarmFollowUpRule>>>;
  alarmStatsByCode?: Maybe<Array<Maybe<AlarmStartsByCode>>>;
  alarms: Array<Maybe<Alarm>>;
  alarmsCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  alarmsMonitor?: Maybe<Array<Maybe<Alarm>>>;
  alarmsOld: Array<Maybe<AlarmsOld>>;
  analyze: Analyze;
  availabilityInfo?: Maybe<AvailabilityInfo>;
  basementHeight: Scalars['Float']['output'];
  blockEventCodeFilter?: Maybe<Array<Maybe<TurbineLogbookEntry>>>;
  cmsAlarms?: Maybe<Array<Maybe<CmsAlarm>>>;
  code: Scalars['String']['output'];
  codeDisplay: Scalars['String']['output'];
  comissioningDate: Scalars['String']['output'];
  componentCondition?: Maybe<Array<Maybe<ComponentConditionResp>>>;
  componentConditionDataSeries?: Maybe<ComponentConditionAllData>;
  componentModel?: Maybe<Array<Maybe<TurbineComponent>>>;
  customWaterfallProductionLoss?: Maybe<LossValues>;
  data?: Maybe<RawData>;
  data10M?: Maybe<RawData10M>;
  dataDebbug?: Maybe<RawData>;
  dataSeries?: Maybe<DataSeries>;
  dataStudio?: Maybe<Array<Maybe<DataSerieResult>>>;
  deIcingData?: Maybe<DeIce>;
  diameter: Scalars['Float']['output'];
  filteredData: Array<Maybe<FilteredData>>;
  filteredData10M: Array<Maybe<FilteredData>>;
  hasMissingBlocks: Array<Turbine>;
  hasOpenAlarm: Scalars['Boolean']['output'];
  hasPerformanceWatchdogTrainingData: Scalars['Boolean']['output'];
  hubHeight: Scalars['Float']['output'];
  isT3_1?: Maybe<Scalars['Boolean']['output']>;
  kpiFollowUp?: Maybe<KpiFollowUp>;
  lat: Scalars['Float']['output'];
  logbook: Array<Maybe<Logbook>>;
  logbookByTCU?: Maybe<Array<Maybe<LogbookEntryLimited>>>;
  logbookCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  logbookComponentsByAlarmCode?: Maybe<LogbookComponent>;
  logbookCount: Scalars['Float']['output'];
  lon: Scalars['Float']['output'];
  lossValues?: Maybe<LossValues>;
  lossesCount?: Maybe<LossesCount>;
  lossesCountPerDay?: Maybe<Array<Maybe<LossesCount>>>;
  metaData: MetaData;
  modelType: Scalars['String']['output'];
  monthlyAvailabilities?: Maybe<Array<Maybe<AvailabilityPark>>>;
  name: Scalars['String']['output'];
  neighbouringWindparkData?: Maybe<Array<Maybe<NeighbouringWindparkData>>>;
  networkSwitch?: Maybe<Scalars['String']['output']>;
  park: Park;
  parkAvailabilities?: Maybe<KpiSummaryParkOutput>;
  parkSubType: ParkSubType;
  performanceAnalytics: PerformanceAnalytics;
  powerCurve?: Maybe<PowerCurves>;
  productionLossCalculationActualProd?: Maybe<Array<Maybe<TurbineProductionLoss>>>;
  productionLossCalculationHistoricalTheoProd?: Maybe<Array<Maybe<TurbineProductionLoss>>>;
  productionLossCalculationManufacturerTheoProd?: Maybe<Array<Maybe<TurbineProductionLoss>>>;
  productionLossMethod?: Maybe<ProductionLossMethodData>;
  rangeWindrose?: Maybe<Array<Maybe<WindRoseDataType>>>;
  ratedPower: Scalars['Int']['output'];
  reference: Reference;
  serial: Scalars['String']['output'];
  serialDisplay: Scalars['String']['output'];
  serialNav: Scalars['Float']['output'];
  signalsList?: Maybe<Array<Maybe<Signal>>>;
  temporaryUpdateCounterCorrected?: Maybe<TemporaryLossValues>;
  tickets?: Maybe<Array<Maybe<Ticket>>>;
  ticketsCount: Scalars['Int']['output'];
  timeseries: Timeseries;
  turbineLogbook: TurbineLogbook;
  turbineLogbookExport: TurbineLogbook;
  turbineManufacturer?: Maybe<TurbineManufacturer>;
  turbineType: TurbineType;
  type: Scalars['String']['output'];
  waterfallProductionLoss?: Maybe<LossValues>;
  windRose?: Maybe<Array<Maybe<WindRoseDataType>>>;
  windRoseDataQuality: WindRoseDataQualityType;
  windRoseDataQualityFullInfo: WindRoseDataQualityFullInfoType;
  windSpeedCutIn?: Maybe<Scalars['Float']['output']>;
  windSpeedCutOut?: Maybe<Scalars['Float']['output']>;
};


export type TurbineAckAndConfirmedCountArgs = {
  endTS: Scalars['Float']['input'];
  startTS: Scalars['Float']['input'];
};


export type TurbineAckCountPerTimeRangeArgs = {
  from: Scalars['Float']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Float']['input'];
};


export type TurbineAggregatedAlarmsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AggregatedAlarmsSortInput>;
};


export type TurbineAlarmCountArgs = {
  alarmCategory?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  controlroomAck?: InputMaybe<Scalars['Boolean']['input']>;
  controlroomTicketing?: InputMaybe<Scalars['Boolean']['input']>;
  fromTS?: InputMaybe<Scalars['Float']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  toTS?: InputMaybe<Scalars['Float']['input']>;
};


export type TurbineAlarmDismissRulesArgs = {
  _id?: InputMaybe<Scalars['String']['input']>;
};


export type TurbineAlarmFollowUpCompletedRulesArgs = {
  _id?: InputMaybe<Scalars['String']['input']>;
};


export type TurbineAlarmFollowUpRulesArgs = {
  _id?: InputMaybe<Scalars['String']['input']>;
};


export type TurbineAlarmStatsByCodeArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
};


export type TurbineAlarmsArgs = {
  _id?: InputMaybe<Scalars['String']['input']>;
  alarmCategory?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  controlroomAck?: InputMaybe<Scalars['Boolean']['input']>;
  controlroomTicketing?: InputMaybe<Scalars['Boolean']['input']>;
  fromTS?: InputMaybe<Scalars['Float']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  processed?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<AlarmSortInput>;
  toTS?: InputMaybe<Scalars['Float']['input']>;
};


export type TurbineAlarmsMonitorArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<AlarmSortInput>;
};


export type TurbineAlarmsOldArgs = {
  where?: InputMaybe<AlarmsOldWhere>;
};


export type TurbineBlockEventCodeFilterArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  endTS: Scalars['Float']['input'];
  startTS: Scalars['Float']['input'];
};


export type TurbineCmsAlarmsArgs = {
  endTS?: InputMaybe<Scalars['Float']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
  startTS?: InputMaybe<Scalars['Float']['input']>;
};


export type TurbineComponentConditionDataSeriesArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  signal: Scalars['String']['input'];
};


export type TurbineCustomWaterfallProductionLossArgs = {
  from?: InputMaybe<Scalars['Float']['input']>;
  to?: InputMaybe<Scalars['Float']['input']>;
};


export type TurbineDataSeriesArgs = {
  endTime?: InputMaybe<Scalars['Float']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  hoursOffset?: InputMaybe<Scalars['Int']['input']>;
  scaleDown?: InputMaybe<ScaleDownInput>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
};


export type TurbineDataStudioArgs = {
  dataStudioParams?: InputMaybe<DataStudioInput>;
};


export type TurbineFilteredDataArgs = {
  requestedSignals: Array<Scalars['String']['input']>;
};


export type TurbineFilteredData10MArgs = {
  requestedSignals: Array<Scalars['String']['input']>;
};


export type TurbineHasMissingBlocksArgs = {
  endTS: Scalars['Float']['input'];
  startTS: Scalars['Float']['input'];
};


export type TurbineIsT3_1Args = {
  block?: InputMaybe<TurbineLogbookEntryInput>;
};


export type TurbineKpiFollowUpArgs = {
  endTS: Scalars['Float']['input'];
  startTS: Scalars['Float']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type TurbineLogbookArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  sort?: InputMaybe<LogbookSortInput>;
  where?: InputMaybe<LogbookFilterInput>;
};


export type TurbineLogbookByTcuArgs = {
  endTS: Scalars['Float']['input'];
  startTS: Scalars['Float']['input'];
};


export type TurbineLogbookComponentsByAlarmCodeArgs = {
  alarm_code: Scalars['String']['input'];
};


export type TurbineLogbookCountArgs = {
  where?: InputMaybe<LogbookFilterInput>;
};


export type TurbineLossValuesArgs = {
  from?: InputMaybe<Scalars['Float']['input']>;
  method?: InputMaybe<Scalars['Int']['input']>;
  productionLossInput?: InputMaybe<Scalars['Float']['input']>;
  provider?: InputMaybe<ForecastProvidersEnum>;
  revenueLossInput?: InputMaybe<Scalars['Float']['input']>;
  selection?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submethod?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Float']['input']>;
};


export type TurbineMonthlyAvailabilitiesArgs = {
  endTS: Scalars['Float']['input'];
  startTS: Scalars['Float']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type TurbineNeighbouringWindparkDataArgs = {
  from?: InputMaybe<Scalars['Float']['input']>;
  to?: InputMaybe<Scalars['Float']['input']>;
};


export type TurbineParkAvailabilitiesArgs = {
  endTS: Scalars['Float']['input'];
  startTS: Scalars['Float']['input'];
};


export type TurbinePerformanceAnalyticsArgs = {
  endTS: Scalars['Float']['input'];
  startTS: Scalars['Float']['input'];
};


export type TurbineProductionLossCalculationActualProdArgs = {
  from: Scalars['Float']['input'];
  to: Scalars['Float']['input'];
};


export type TurbineProductionLossCalculationHistoricalTheoProdArgs = {
  from: Scalars['Float']['input'];
  to: Scalars['Float']['input'];
};


export type TurbineProductionLossCalculationManufacturerTheoProdArgs = {
  from: Scalars['Float']['input'];
  to: Scalars['Float']['input'];
};


export type TurbineRangeWindroseArgs = {
  endTS: Scalars['Float']['input'];
  startTS: Scalars['Float']['input'];
};


export type TurbineSignalsListArgs = {
  filter: Array<InputMaybe<SignalType>>;
  signalGroup?: InputMaybe<SignalGroupEnum>;
  stream: Array<InputMaybe<Stream>>;
};


export type TurbineTemporaryUpdateCounterCorrectedArgs = {
  from?: InputMaybe<Scalars['Float']['input']>;
  to?: InputMaybe<Scalars['Float']['input']>;
};


export type TurbineTicketsArgs = {
  boardId: Scalars['ID']['input'];
  ifArchive?: InputMaybe<Scalars['Boolean']['input']>;
  ifDelete?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TurbineTimeseriesArgs = {
  range?: InputMaybe<TimeseriesRangeInput>;
};


export type TurbineTurbineLogbookArgs = {
  capped?: InputMaybe<Scalars['Boolean']['input']>;
  endTS: Scalars['Float']['input'];
  eventCodeExceptionFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventCodeExcludeFilter?: InputMaybe<Scalars['String']['input']>;
  eventCodeFilter?: InputMaybe<Scalars['String']['input']>;
  lastPage?: InputMaybe<Scalars['Boolean']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  startTS: Scalars['Float']['input'];
};


export type TurbineTurbineLogbookExportArgs = {
  capped?: InputMaybe<Scalars['Boolean']['input']>;
  endTS: Scalars['Float']['input'];
  eventCodeExceptionFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventCodeExcludeFilter?: InputMaybe<Scalars['String']['input']>;
  eventCodeFilter?: InputMaybe<Scalars['String']['input']>;
  lastPage?: InputMaybe<Scalars['Boolean']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  startTS: Scalars['Float']['input'];
};


export type TurbineWaterfallProductionLossArgs = {
  from?: InputMaybe<Scalars['Float']['input']>;
  to?: InputMaybe<Scalars['Float']['input']>;
};


export type TurbineWindRoseArgs = {
  from: Scalars['Float']['input'];
  period?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Float']['input'];
};


export type TurbineWindRoseDataQualityArgs = {
  from: Scalars['Float']['input'];
  period?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Float']['input'];
};


export type TurbineWindRoseDataQualityFullInfoArgs = {
  from: Scalars['Float']['input'];
  period?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Float']['input'];
};

export type TurbineComponent = {
  __typename?: 'TurbineComponent';
  alarms?: Maybe<Array<Maybe<ComponentAlarm>>>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TurbineController = {
  __typename?: 'TurbineController';
  name: Scalars['String']['output'];
  signals: Array<Maybe<Scalars['String']['output']>>;
};

export type TurbineFilterDataInput = {
  AND?: InputMaybe<Array<TurbineFilterDataInput>>;
  LDAT1_TmUTC_setTm?: InputMaybe<Scalars['String']['input']>;
  LDAT1_TmUTC_setTm_rounded?: InputMaybe<Scalars['String']['input']>;
  LPHD1_PhyHealth_stVal?: InputMaybe<NumberOptionsInput>;
  MMXU1_A_phsA_cVal_mag_f?: InputMaybe<NumberOptionsInput>;
  MMXU1_A_phsB_cVal_mag_f?: InputMaybe<NumberOptionsInput>;
  MMXU1_A_phsC_cVal_mag_f?: InputMaybe<NumberOptionsInput>;
  MMXU1_Hz_mag_f?: InputMaybe<NumberOptionsInput>;
  MMXU1_PhV_phsA_cVal_mag_f?: InputMaybe<NumberOptionsInput>;
  MMXU1_PhV_phsB_cVal_mag_f?: InputMaybe<NumberOptionsInput>;
  MMXU1_PhV_phsC_cVal_mag_f?: InputMaybe<NumberOptionsInput>;
  MMXU1_TotPF_mag_f?: InputMaybe<NumberOptionsInput>;
  OR?: InputMaybe<Array<TurbineFilterDataInput>>;
  WCNV1_CnvTmpChokeCoil_mag_f?: InputMaybe<NumberOptionsInput>;
  WCNV1_CnvTmpDclink_mag_f?: InputMaybe<NumberOptionsInput>;
  WCNV1_CnvTmpWater_mag_f?: InputMaybe<NumberOptionsInput>;
  WGEN1_GnTmpBrg1_mag_f?: InputMaybe<NumberOptionsInput>;
  WGEN1_GnTmpBrg2_mag_f?: InputMaybe<NumberOptionsInput>;
  WGEN1_GnTmpInlet_mag_f?: InputMaybe<NumberOptionsInput>;
  WGEN1_GnTmpOutlet_mag_f?: InputMaybe<NumberOptionsInput>;
  WGEN1_GnTmpPhase1_mag_f?: InputMaybe<NumberOptionsInput>;
  WGEN1_GnTmpPhase2_mag_f?: InputMaybe<NumberOptionsInput>;
  WGEN1_GnTmpPhase3_mag_f?: InputMaybe<NumberOptionsInput>;
  WGEN1_GnTmpRtr_mag_f?: InputMaybe<NumberOptionsInput>;
  WGEN1_GnTmpSlpRing1_mag_f?: InputMaybe<NumberOptionsInput>;
  WGEN1_GnTmpSlpRing2_mag_f?: InputMaybe<NumberOptionsInput>;
  WGEN1_GnTmpSta_mag_f?: InputMaybe<NumberOptionsInput>;
  WGEN1_Spd_mag_f?: InputMaybe<NumberOptionsInput>;
  WNAC1_CtrCabTmp_mag_f?: InputMaybe<NumberOptionsInput>;
  WNAC1_Dir_mag_f?: InputMaybe<NumberOptionsInput>;
  WNAC1_ExTmp_mag_f?: InputMaybe<NumberOptionsInput>;
  WNAC1_IntlTmp_mag_f?: InputMaybe<NumberOptionsInput>;
  WNAC1_WdDir_mag_f?: InputMaybe<NumberOptionsInput>;
  WNAC1_WdSpd_c_mag_f?: InputMaybe<NumberOptionsInput>;
  WNAC1_WdSpd_mag_f?: InputMaybe<NumberOptionsInput>;
  WROT1_CtrCabTmp_mag_f?: InputMaybe<NumberOptionsInput>;
  WROT1_HubTmp_mag_f?: InputMaybe<NumberOptionsInput>;
  WROT1_PtAngValAvg_mag_f?: InputMaybe<NumberOptionsInput>;
  WROT1_PtAngValBl1_mag_f?: InputMaybe<NumberOptionsInput>;
  WROT1_PtAngValBl2_mag_f?: InputMaybe<NumberOptionsInput>;
  WROT1_PtAngValBl3_mag_f?: InputMaybe<NumberOptionsInput>;
  WROT1_PtHyOilTmp_mag_f?: InputMaybe<NumberOptionsInput>;
  WROT1_PtHyPresAvg_mag_f?: InputMaybe<NumberOptionsInput>;
  WROT1_PtHyPresBl1_mag_f?: InputMaybe<NumberOptionsInput>;
  WROT1_PtHyPresBl2_mag_f?: InputMaybe<NumberOptionsInput>;
  WROT1_PtHyPresBl3_mag_f?: InputMaybe<NumberOptionsInput>;
  WROT1_RotSpd_mag_f?: InputMaybe<NumberOptionsInput>;
  WTRF1_TrfTmpPhase1_mag_f?: InputMaybe<NumberOptionsInput>;
  WTRF1_TrfTmpPhase2_mag_f?: InputMaybe<NumberOptionsInput>;
  WTRF1_TrfTmpPhase3_mag_f?: InputMaybe<NumberOptionsInput>;
  WTRM1_BrkHyPres_mag_f?: InputMaybe<NumberOptionsInput>;
  WTRM1_GbxOilPres_mag_f?: InputMaybe<NumberOptionsInput>;
  WTRM1_TrmTmpGbxBrg1_mag_f?: InputMaybe<NumberOptionsInput>;
  WTRM1_TrmTmpGbxBrg2_mag_f?: InputMaybe<NumberOptionsInput>;
  WTRM1_TrmTmpGbxBrg3_mag_f?: InputMaybe<NumberOptionsInput>;
  WTRM1_TrmTmpGbxOil_mag_f?: InputMaybe<NumberOptionsInput>;
  WTRM1_TrmTmpShfBrg1_mag_f?: InputMaybe<NumberOptionsInput>;
  WTRM1_TrmTmpShfBrg2_mag_f?: InputMaybe<NumberOptionsInput>;
  WTUR1_AvlTmRs_tmTot?: InputMaybe<NumberOptionsInput>;
  WTUR1_MW_loss?: InputMaybe<NumberOptionsInput>;
  WTUR1_MW_mag_f?: InputMaybe<NumberOptionsInput>;
  WTUR1_MW_rated?: InputMaybe<NumberOptionsInput>;
  WTUR1_MW_theoretical?: InputMaybe<NumberOptionsInput>;
  WTUR1_OpTmRs_tmTot?: InputMaybe<NumberOptionsInput>;
  WTUR1_TotVArh_actVal?: InputMaybe<NumberOptionsInput>;
  WTUR1_TotWh_actVal?: InputMaybe<NumberOptionsInput>;
  WTUR1_TurMaint_actSt_stVal?: InputMaybe<NumberOptionsInput>;
  WTUR1_TurSt_actSt_stVal?: InputMaybe<NumberOptionsInput>;
  WTUR1_VAr_mag_f?: InputMaybe<NumberOptionsInput>;
  WTUR1_W_loss?: InputMaybe<NumberOptionsInput>;
  WTUR1_W_mag_f?: InputMaybe<NumberOptionsInput>;
  WTUR1_W_rated?: InputMaybe<NumberOptionsInput>;
  WTUR1_W_theoretical?: InputMaybe<NumberOptionsInput>;
  WTUR1_kW_loss?: InputMaybe<NumberOptionsInput>;
  WTUR1_kW_mag_f?: InputMaybe<NumberOptionsInput>;
  WTUR1_kW_rated?: InputMaybe<NumberOptionsInput>;
  WTUR1_kW_theoretical?: InputMaybe<NumberOptionsInput>;
  WTUR1_per_efficiency?: InputMaybe<NumberOptionsInput>;
  WTUR1_per_loadFactor?: InputMaybe<NumberOptionsInput>;
  WTUR1_status?: InputMaybe<NumberOptionsInput>;
  WYAW1_BrkPres_mag_f?: InputMaybe<NumberOptionsInput>;
  WYAW1_CabWup_mag_f?: InputMaybe<NumberOptionsInput>;
  WYAW1_YawAng_mag_f?: InputMaybe<NumberOptionsInput>;
};

export type TurbineHeatmapThresholds = {
  __typename?: 'TurbineHeatmapThresholds';
  parkThresholds?: Maybe<Array<ParkTurbineTypeThreshold>>;
  turbineThresholds: Array<TurbineSignalThreshold>;
};

export type TurbineIntegration = {
  __typename?: 'TurbineIntegration';
  code?: Maybe<Scalars['String']['output']>;
  codeDisplay?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  serial?: Maybe<Scalars['String']['output']>;
};

export type TurbineLogbook = {
  __typename?: 'TurbineLogbook';
  parkMaintainType?: Maybe<Array<Maybe<MaintainType>>>;
  turbineLogbookEntries?: Maybe<Array<Maybe<TurbineLogbookEntry>>>;
  turbineLogbookEvents?: Maybe<TurbineLogbookEvents>;
  turbineLogbookVersions?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  turbineMaintainType?: Maybe<Array<Maybe<MaintainType>>>;
};

export type TurbineLogbookEntry = {
  __typename?: 'TurbineLogbookEntry';
  _id: Scalars['ID']['output'];
  _id_alarm?: Maybe<Scalars['String']['output']>;
  _id_original: Scalars['String']['output'];
  _id_process?: Maybe<Scalars['String']['output']>;
  _id_turbine?: Maybe<Scalars['String']['output']>;
  ack?: Maybe<Scalars['Boolean']['output']>;
  amLossesComment?: Maybe<Scalars['String']['output']>;
  blockActionsLog?: Maybe<Scalars['String']['output']>;
  component?: Maybe<Scalars['String']['output']>;
  controlroomAck?: Maybe<Scalars['Boolean']['output']>;
  controlroomAckLog?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  controlroomTicketing?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  controlroomTicketingLog?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  customEvent?: Maybe<Scalars['Boolean']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  edited?: Maybe<Scalars['Boolean']['output']>;
  endTS: Scalars['Float']['output'];
  eventCode?: Maybe<Scalars['String']['output']>;
  eventDescription?: Maybe<Scalars['String']['output']>;
  isOpen?: Maybe<Scalars['Boolean']['output']>;
  log?: Maybe<Scalars['String']['output']>;
  lossesConfirmed?: Maybe<Scalars['Boolean']['output']>;
  lossesMethod?: Maybe<Scalars['String']['output']>;
  mutTS?: Maybe<Scalars['Float']['output']>;
  startTS: Scalars['Float']['output'];
  subBlocks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tc: Scalars['String']['output'];
  tcmLossesComment?: Maybe<Scalars['String']['output']>;
  tcu: Scalars['String']['output'];
  totalProductionLoss: Scalars['Float']['output'];
  totalRevenueLoss: Scalars['Float']['output'];
  userComment?: Maybe<Scalars['String']['output']>;
  validFromTS: Scalars['Float']['output'];
  validToTS: Scalars['Float']['output'];
};

export type TurbineLogbookEntryInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  _id_alarm?: InputMaybe<Scalars['String']['input']>;
  _id_original?: InputMaybe<Scalars['String']['input']>;
  _id_process?: InputMaybe<Scalars['String']['input']>;
  _id_turbine: Scalars['String']['input'];
  ack?: InputMaybe<Scalars['Boolean']['input']>;
  amLossesComment?: InputMaybe<Scalars['String']['input']>;
  blockActionsLog?: InputMaybe<Scalars['String']['input']>;
  component?: InputMaybe<Scalars['String']['input']>;
  controlroomAck?: InputMaybe<Scalars['Boolean']['input']>;
  controlroomAckLog?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  controlroomTicketing?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  controlroomTicketingLog?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customEvent?: InputMaybe<Scalars['Boolean']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  edited?: InputMaybe<Scalars['Boolean']['input']>;
  endTS: Scalars['Float']['input'];
  eventCode?: InputMaybe<Scalars['String']['input']>;
  eventDescription?: InputMaybe<Scalars['String']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  log?: InputMaybe<Scalars['String']['input']>;
  lossesConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  lossesMethod?: InputMaybe<Scalars['String']['input']>;
  mutTS?: InputMaybe<Scalars['Float']['input']>;
  startTS: Scalars['Float']['input'];
  subBlocks?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tc?: InputMaybe<Scalars['String']['input']>;
  tcmLossesComment?: InputMaybe<Scalars['String']['input']>;
  tcu: Scalars['String']['input'];
  totalProductionLoss?: InputMaybe<Scalars['Float']['input']>;
  totalRevenueLoss?: InputMaybe<Scalars['Float']['input']>;
  userComment?: InputMaybe<Scalars['String']['input']>;
};

export type TurbineLogbookEventInput = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  _id_turbine: Scalars['String']['input'];
  code: Scalars['String']['input'];
  createTS: Scalars['Float']['input'];
  delete: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TurbineLogbookEvents = {
  __typename?: 'TurbineLogbookEvents';
  events: Array<Maybe<Logbook>>;
  totalCount: Scalars['Int']['output'];
};

export type TurbineManufacturer = {
  __typename?: 'TurbineManufacturer';
  name?: Maybe<Scalars['String']['output']>;
};

export type TurbinePcConfiguration = {
  _id?: InputMaybe<Scalars['String']['input']>;
  historicalPCSelected?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturerPCSelected?: InputMaybe<Scalars['Boolean']['input']>;
  monthPCSelected?: InputMaybe<Scalars['Boolean']['input']>;
  scatterPlotSelected?: InputMaybe<Scalars['Boolean']['input']>;
  turbineCode?: InputMaybe<Scalars['String']['input']>;
};

export type TurbinePowercurveData = {
  __typename?: 'TurbinePowercurveData';
  code?: Maybe<Scalars['String']['output']>;
  historicalPC?: Maybe<Array<Maybe<HistoricalPowercurveData>>>;
  manufacturerPC?: Maybe<Scalars['String']['output']>;
  monthPC?: Maybe<Scalars['Boolean']['output']>;
  scatterPlot?: Maybe<Array<Maybe<ScaterPlotData>>>;
};

export type TurbineProductionLoss = {
  __typename?: 'TurbineProductionLoss';
  _id?: Maybe<Scalars['ID']['output']>;
  availability?: Maybe<Scalars['Float']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  codeDisplay?: Maybe<Scalars['String']['output']>;
  dataQuality?: Maybe<Scalars['Float']['output']>;
  production?: Maybe<Scalars['Float']['output']>;
  windSpeed?: Maybe<Scalars['Float']['output']>;
};

export type TurbineSignalThreshold = {
  __typename?: 'TurbineSignalThreshold';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  signal: Scalars['String']['output'];
};

export type TurbineSignalThresholdInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  signal: Scalars['String']['input'];
};

export type TurbineSortInput = {
  code?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
  serial?: InputMaybe<Sort>;
};

export type TurbineSubType = {
  __typename?: 'TurbineSubType';
  _id: Scalars['ID']['output'];
  componentConditionDataSeries?: Maybe<ComponentConditionAllData>;
  name: Scalars['String']['output'];
  reference: Reference;
  turbines: Array<Turbine>;
};


export type TurbineSubTypeComponentConditionDataSeriesArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  signal: Scalars['String']['input'];
};

export type TurbineType = {
  __typename?: 'TurbineType';
  _id: Scalars['ID']['output'];
  data: Data;
  manufacturer: Manufacturer;
  name: Scalars['String']['output'];
  ratedPower: Scalars['Int']['output'];
  rotorDiameter: Scalars['Int']['output'];
  turbines: Array<Turbine>;
};

export type TurbineWhereInput = {
  AND?: InputMaybe<Array<TurbineWhereInput>>;
  OR?: InputMaybe<Array<TurbineWhereInput>>;
  _id?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  serial?: InputMaybe<Scalars['String']['input']>;
  serialNav?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDataAnalysisQueryInput = {
  _id: Scalars['ID']['input'];
  endTs: Scalars['Float']['input'];
  granularity: Scalars['String']['input'];
  isSharedQuery: Scalars['Boolean']['input'];
  period: DataAnalysisPeriod;
  queryNumber: Scalars['Int']['input'];
  queryType: DataAnalysisQueryType;
  series: Array<DataAnalysisSeriesInput>;
  startTs: Scalars['Float']['input'];
  title: Scalars['String']['input'];
};

export type UpdateDueDateInput = {
  dueDate?: InputMaybe<DueDateInput>;
  id_ticket: Scalars['ID']['input'];
};

export type UpdateTicketBoardInput = {
  id_board: Scalars['ID']['input'];
  id_ticket: Scalars['ID']['input'];
};

export type UpdatedChangeLog = ChangeLog & {
  __typename?: 'UpdatedChangeLog';
  action: Scalars['String']['output'];
  current: Scalars['String']['output'];
  date: Scalars['Float']['output'];
  field: Scalars['String']['output'];
  previous?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Subject>;
};

export type UploadedFileStatus = {
  __typename?: 'UploadedFileStatus';
  _id: Scalars['ID']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  originalName: Scalars['String']['output'];
  queryType: DataStudioQueryType;
  status: FileTrackerStatus;
};

export type User = {
  __typename?: 'User';
  _id?: Maybe<Scalars['String']['output']>;
  _id_main_portfolio?: Maybe<Scalars['ID']['output']>;
  attributes?: Maybe<Attributes>;
  available_parks?: Maybe<Array<Maybe<Park>>>;
  boards?: Maybe<Array<Maybe<Board>>>;
  collegues?: Maybe<Array<Maybe<User>>>;
  dataStudioFiles?: Maybe<Array<Maybe<DataStudioFiles>>>;
  dataStudioUploadedFiles?: Maybe<Array<Maybe<DataStudioUploadedFile>>>;
  email?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  getKpiVsTargetTableCustomSettings?: Maybe<KpiVsTargetTableCustomSettings>;
  last_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  portfolioRights?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<PreferenceList>;
  securityPreferences: SecurityPreferences;
  ticketModules?: Maybe<Array<Maybe<TicketModule>>>;
  ticketTemplates?: Maybe<Array<Maybe<TicketTemplate>>>;
  userEvent: Array<Maybe<UserEvent>>;
  user_portfolios?: Maybe<Array<Maybe<UserPortfolio>>>;
  username?: Maybe<Scalars['String']['output']>;
};


export type UserGetKpiVsTargetTableCustomSettingsArgs = {
  parkName?: InputMaybe<Scalars['String']['input']>;
  tableUniqueName?: InputMaybe<Scalars['String']['input']>;
};


export type UserUser_PortfoliosArgs = {
  when?: InputMaybe<CustomPortfolioWhereInput>;
};

export type UserChannelInput = {
  _id: Scalars['String']['input'];
  param: Scalars['String']['input'];
};

export type UserCustomPortfolioInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  defaultPortfolio?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parks: Array<InputMaybe<Scalars['String']['input']>>;
};

export type UserEvent = {
  __typename?: 'UserEvent';
  _id: Scalars['ID']['output'];
  _id_event: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  channels: Array<Maybe<Channel>>;
  eventRule: Array<Maybe<UserEventRule>>;
  name: Scalars['String']['output'];
};

export type UserEventInput = {
  _id_event: Scalars['String']['input'];
  active: Scalars['Boolean']['input'];
  channel: Array<InputMaybe<UserChannelInput>>;
  eventRule: Array<InputMaybe<UserEventRuleInput>>;
  name: Scalars['String']['input'];
};

export type UserEventRule = {
  __typename?: 'UserEventRule';
  _id: Scalars['ID']['output'];
  _id_rule: Scalars['String']['output'];
  _id_rule_ident: Scalars['String']['output'];
  inclusive: Scalars['Boolean']['output'];
  match?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UserEventRuleInput = {
  _id_rule_ident: Scalars['String']['input'];
  inclusive: Scalars['Boolean']['input'];
  match: Array<Scalars['String']['input']>;
};

export type UserPortfolio = {
  __typename?: 'UserPortfolio';
  _id?: Maybe<Scalars['String']['output']>;
  defaultPortfolio?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parks?: Maybe<Array<Maybe<Park>>>;
};

export type Warning = {
  __typename?: 'Warning';
  description?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['Float']['output']>;
  modules?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['Float']['output']>;
};

export type WaterfallData = {
  __typename?: 'WaterfallData';
  actualPower: WaterfallDataFlag;
  availabilityPower: WaterfallDataFlag;
  budget: WaterfallDataFlag;
  curtailmentPower: WaterfallDataFlag;
  delta: WaterfallDataFlag;
  deratingPower: WaterfallDataFlag;
  hysteresisPower: WaterfallDataFlag;
  lostPower: WaterfallDataFlag;
  otherUnderperformancePower: WaterfallDataFlag;
  overratingPower: WaterfallDataFlag;
  partialPerformancePower: WaterfallDataFlag;
  theoreticalPower: WaterfallDataFlag;
};

export type WaterfallDataFlag = {
  __typename?: 'WaterfallDataFlag';
  energy?: Maybe<Scalars['Float']['output']>;
  flagName?: Maybe<Scalars['String']['output']>;
  parentFlag?: Maybe<Scalars['String']['output']>;
  percentEnergy?: Maybe<Scalars['Float']['output']>;
  percentRevenue?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
};

export enum Watt {
  Gw = 'GW',
  Kw = 'KW',
  Mw = 'MW'
}

export enum Watt_Hour {
  GWh = 'GWh',
  KWh = 'KWh',
  MWh = 'MWh'
}

export type WindCaptureRatio = {
  __typename?: 'WindCaptureRatio';
  month: Scalars['String']['output'];
  windCaptureRatio?: Maybe<Scalars['Float']['output']>;
};

export type WindRose = {
  __typename?: 'WindRose';
  actual_power_kw?: Maybe<Scalars['Float']['output']>;
  frequency?: Maybe<Scalars['Float']['output']>;
  wind_direction?: Maybe<Scalars['Int']['output']>;
};

export type WindRoseDataQualityFullInfoType = {
  __typename?: 'WindRoseDataQualityFullInfoType';
  flaggedPoints: Array<Maybe<DataQualityFlaggedPointType>>;
  flaggedPointsCount: Scalars['Float']['output'];
  qualityInPercentage: Scalars['Float']['output'];
  totalPoints: Scalars['Float']['output'];
  unflaggedPointsCount: Scalars['Float']['output'];
};

export type WindRoseDataQualityType = {
  __typename?: 'WindRoseDataQualityType';
  qualityInPercentage: Scalars['Float']['output'];
};

export type WindRoseDataType = {
  __typename?: 'WindRoseDataType';
  sector?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type AlarmStartsByCode = {
  __typename?: 'alarmStartsByCode';
  _id_park?: Maybe<Scalars['String']['output']>;
  _id_turbine?: Maybe<Scalars['String']['output']>;
  avgDuration?: Maybe<Scalars['Float']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  turbineCode?: Maybe<Scalars['String']['output']>;
  turbineCodeDisplay?: Maybe<Scalars['String']['output']>;
};

export type KpiPerCountry = {
  __typename?: 'kpiPerCountry';
  _id?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  kpis?: Maybe<Array<Maybe<KpiSummaryData>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type KpiPerPark = {
  __typename?: 'kpiPerPark';
  _id?: Maybe<Scalars['String']['output']>;
  _id_country?: Maybe<Scalars['String']['output']>;
  fe_name?: Maybe<Scalars['String']['output']>;
  kpis?: Maybe<Array<Maybe<KpiSummaryData>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type KpiSummaryData = {
  __typename?: 'kpiSummaryData';
  codeDisplay?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  isAvailability?: Maybe<Scalars['Boolean']['output']>;
  isCustomReliability?: Maybe<Scalars['Boolean']['output']>;
  kpiSummaryView?: Maybe<KpiSummaryViewEnum>;
  name?: Maybe<Scalars['String']['output']>;
  parkOrTurbineName?: Maybe<Scalars['String']['output']>;
  serialNav?: Maybe<Scalars['Float']['output']>;
  standard?: Maybe<Scalars['Boolean']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
  tablePosition?: Maybe<KpiSummaryTablePosition>;
  target?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  valueYtd?: Maybe<Scalars['Float']['output']>;
};

export type KpiSummaryTurbinesInParkOutput = {
  __typename?: 'kpiSummaryTurbinesInParkOutput';
  kpis?: Maybe<Array<Maybe<KpiSummaryData>>>;
};

export type TemporaryLossValues = {
  __typename?: 'temporaryLossValues';
  subBlocks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  totalActualProductionTurbine?: Maybe<Scalars['Float']['output']>;
};

export type ParkMetadataQueryVariables = Exact<{
  parkId: Scalars['ID']['input'];
}>;


export type ParkMetadataQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', co2: number }> };

export type TurbineMetadataQueryVariables = Exact<{
  turbineId: Scalars['Float']['input'];
}>;


export type TurbineMetadataQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', park: { __typename?: 'Park', co2: number } }> };

export type TurbineDataTableQueryVariables = Exact<{
  date: Scalars['Int']['input'];
  serialNav: Scalars['Float']['input'];
  sector?: InputMaybe<SectorCategoryEnum>;
  historical: Scalars['Boolean']['input'];
}>;


export type TurbineDataTableQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, code: string, powerCurve?: { __typename?: 'PowerCurves', manufacturerPC?: Array<number | null> | null, monthlyPC?: { __typename?: 'PowerCurveDataTypes', powerCurveData?: Array<{ __typename?: 'HistoricalPowercurveData', windSpeed?: number | null, sector?: string | null, outPutPower?: number | null, binSize?: number | null, frequency?: number | null } | null> | null } | null, historicalPC?: { __typename?: 'PowerCurveDataTypes', powerCurveData?: Array<{ __typename?: 'HistoricalPowercurveData', windSpeed?: number | null, sector?: string | null, outPutPower?: number | null, binSize?: number | null, frequency?: number | null } | null> | null } | null } | null }> };

export type PowerCurveQueryVariables = Exact<{
  historicalFilter?: InputMaybe<Array<TurbineWhereInput> | TurbineWhereInput>;
  monthlyFilter?: InputMaybe<Array<TurbineWhereInput> | TurbineWhereInput>;
  manufacturerFilter?: InputMaybe<Array<TurbineWhereInput> | TurbineWhereInput>;
  scatterPlotFilter?: InputMaybe<Array<TurbineWhereInput> | TurbineWhereInput>;
  monthlyStatFilter?: InputMaybe<Array<TurbineWhereInput> | TurbineWhereInput>;
  scatterplotStarTs: Scalars['Float']['input'];
  scatterploteEndTs: Scalars['Float']['input'];
  sector: SectorCategoryEnum;
  date: Scalars['Int']['input'];
}>;


export type PowerCurveQuery = { __typename?: 'Query', forMonthly: Array<{ __typename?: 'Turbine', code: string, id: string, powerCurve?: { __typename?: 'PowerCurves', monthlyPC?: { __typename?: 'PowerCurveDataTypes', powerCurveData?: Array<{ __typename?: 'HistoricalPowercurveData', windSpeed?: number | null, outPutPower?: number | null, sector?: string | null } | null> | null } | null } | null }>, forMonthlyStat: Array<{ __typename?: 'Turbine', code: string, id: string, powerCurve?: { __typename?: 'PowerCurves', statisticalMonthlyPC: Array<{ __typename?: 'StatisticalPowerCurveDataTypes', windSpeed: number, outPutPower: number } | null> } | null }>, forHistorical: Array<{ __typename?: 'Turbine', code: string, id: string, powerCurve?: { __typename?: 'PowerCurves', historicalPC?: { __typename?: 'PowerCurveDataTypes', powerCurveData?: Array<{ __typename?: 'HistoricalPowercurveData', windSpeed?: number | null, outPutPower?: number | null, sector?: string | null } | null> | null } | null } | null }>, forScatterPlot: Array<{ __typename?: 'Turbine', code: string, id: string, powerCurve?: { __typename?: 'PowerCurves', scatterPlot?: Array<{ __typename?: 'ScaterPlotData', x?: number | null, y?: number | null } | null> | null } | null }>, forManufacturer: Array<{ __typename?: 'Turbine', code: string, id: string, powerCurve?: { __typename?: 'PowerCurves', manufacturerPC?: Array<number | null> | null } | null }> };

export type TurbineRatedPowerQueryVariables = Exact<{
  serialNav: Scalars['Float']['input'];
}>;


export type TurbineRatedPowerQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', ratedPower: number }> };

export type ParkRatedPowerQueryVariables = Exact<{
  parkName: Scalars['String']['input'];
}>;


export type ParkRatedPowerQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', dataDebbug: { __typename?: 'Data', WTUR1_kW_rated?: { __typename?: 'Aggregation', avg?: number | null } | null } }> };

export type GetTurbinesByParkQueryVariables = Exact<{
  parkName: Scalars['String']['input'];
  turbines?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type GetTurbinesByParkQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', turbines: Array<{ __typename?: 'Turbine', _id: string, hubHeight: number, type: string, code: string, codeDisplay: string }> }> };

export type GetTurbineBySerialQueryVariables = Exact<{
  serialNav: Scalars['Float']['input'];
}>;


export type GetTurbineBySerialQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', _id: string, hubHeight: number, type: string, code: string, codeDisplay: string }> };

export type GetSignalsListQueryVariables = Exact<{
  serialNav?: InputMaybe<Scalars['Float']['input']>;
}>;


export type GetSignalsListQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', name: string, signalsList?: Array<{ __typename?: 'Signal', name?: string | null, displayName?: string | null } | null> | null }> };

export type GetParkTemperatureListQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetParkTemperatureListQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', turbines: Array<{ __typename?: 'Turbine', type: string, signalsList?: Array<{ __typename?: 'Signal', name?: string | null, displayName?: string | null } | null> | null }> }> };

export type GetTemperatureLimitsSettingsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  idPark: Scalars['ID']['input'];
}>;


export type GetTemperatureLimitsSettingsQuery = { __typename?: 'Query', turbineHeatmapThresholds?: { __typename?: 'TurbineHeatmapThresholds', turbineThresholds: Array<{ __typename?: 'TurbineSignalThreshold', signal: string, max?: number | null, min?: number | null }> } | null, parkHeatmapThresholds?: { __typename?: 'ParkHeatmapThresholds', parkThresholds: Array<{ __typename?: 'ParkTurbineTypeThreshold', turbineType: string, thresholds: Array<{ __typename?: 'TurbineSignalThreshold', signal: string, min?: number | null, max?: number | null }> }> } | null };

export type UpdateTemperatureLimitsSettingsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  limits: Array<TurbineSignalThresholdInput> | TurbineSignalThresholdInput;
  parkLimits: Array<ParkTurbineTypeThresholdInput> | ParkTurbineTypeThresholdInput;
  parkId: Scalars['ID']['input'];
}>;


export type UpdateTemperatureLimitsSettingsMutation = { __typename?: 'Mutation', saveTurbineHeatmapThresholds: boolean, saveParkHeatmapThresholds: boolean };

export type WindDirectionTurbineQueryVariables = Exact<{
  serialNav: Scalars['Float']['input'];
  sector?: InputMaybe<SectorCategoryEnum>;
  date: Scalars['Int']['input'];
  historical: Scalars['Boolean']['input'];
}>;


export type WindDirectionTurbineQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', powerCurve?: { __typename?: 'PowerCurves', monthlyPC?: { __typename?: 'PowerCurveDataTypes', windRose?: Array<{ __typename?: 'WindRoseDataType', sector?: string | null, values?: Array<number | null> | null } | null> | null } | null, historicalPC?: { __typename?: 'PowerCurveDataTypes', windRose?: Array<{ __typename?: 'WindRoseDataType', sector?: string | null, values?: Array<number | null> | null } | null> | null } | null } | null }> };

export type WindSpeedDistributionTurbineQueryVariables = Exact<{
  date: Scalars['Int']['input'];
  serialNav: Scalars['Float']['input'];
  historical: Scalars['Boolean']['input'];
}>;


export type WindSpeedDistributionTurbineQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', code: string, powerCurve?: { __typename?: 'PowerCurves', monthlyPC?: { __typename?: 'PowerCurveDataTypes', powerCurveData?: Array<{ __typename?: 'HistoricalPowercurveData', frequency?: number | null, windSpeed?: number | null } | null> | null } | null, historicalPC?: { __typename?: 'PowerCurveDataTypes', powerCurveData?: Array<{ __typename?: 'HistoricalPowercurveData', frequency?: number | null, windSpeed?: number | null } | null> | null } | null } | null }> };

export type ForecastAccuracyActualQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  timeZone: Scalars['String']['input'];
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
}>;


export type ForecastAccuracyActualQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', _id: string, forecastAccuracy?: { __typename?: 'ForecastAccuracy', actualPowerVsForecast?: Array<{ __typename?: 'ActualPowerVsForecast', actualPower: number, regularForecast: number, dayAheadForecast: number, unixTs: number } | null> | null } | null }> };

export type ForecastAccuracyErrorPercentageQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  timeZone: Scalars['String']['input'];
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  aggregation?: InputMaybe<Scalars['String']['input']>;
}>;


export type ForecastAccuracyErrorPercentageQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', _id: string, forecastAccuracy?: { __typename?: 'ForecastAccuracy', forecastErrorTarget?: Array<{ __typename?: 'ForecastErrorTarget', percentage: number, unixTs: number } | null> | null, forecastErrorPercentage?: Array<{ __typename?: 'ForecastErrorPercentage', positiveErrorPercentage: number, negativeErrorPercentage: number, totalErrorPercentage: number, unixTs: number } | null> | null } | null }> };

export type ForecastAccuracyErrorValueQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  timeZone: Scalars['String']['input'];
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  aggregation?: InputMaybe<Scalars['String']['input']>;
}>;


export type ForecastAccuracyErrorValueQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', _id: string, forecastAccuracy?: { __typename?: 'ForecastAccuracy', forecastErrorTarget?: Array<{ __typename?: 'ForecastErrorTarget', MWh: number, unixTs: number } | null> | null, forecastErrorMWh?: Array<{ __typename?: 'ForecastErrorMWh', positiveErrorMWh: number, negativeErrorMWh: number, totalErrorMWh: number, unixTs: number } | null> | null } | null }> };

export type ForecastAccuracyErrorRevenueQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  timeZone: Scalars['String']['input'];
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  aggregation?: InputMaybe<Scalars['String']['input']>;
}>;


export type ForecastAccuracyErrorRevenueQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', _id: string, forecastAccuracy?: { __typename?: 'ForecastAccuracy', forecastErrorTarget?: Array<{ __typename?: 'ForecastErrorTarget', EUR: number, unixTs: number } | null> | null, forecastErrorEUR?: Array<{ __typename?: 'ForecastErrorEUR', totalError: number, unixTs: number } | null> | null } | null }> };

export type PortfolioWaterfallQueryVariables = Exact<{
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  parks?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type PortfolioWaterfallQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', performanceAnalytics: { __typename?: 'PerformanceAnalytics', waterfall: { __typename?: 'WaterfallData', actualPower: { __typename?: 'WaterfallDataFlag', flagName?: string | null, energy?: number | null, percentEnergy?: number | null, revenue?: number | null, percentRevenue?: number | null, parentFlag?: string | null }, delta: { __typename?: 'WaterfallDataFlag', flagName?: string | null, energy?: number | null, percentEnergy?: number | null, revenue?: number | null, percentRevenue?: number | null, parentFlag?: string | null }, theoreticalPower: { __typename?: 'WaterfallDataFlag', flagName?: string | null, energy?: number | null, percentEnergy?: number | null, revenue?: number | null, percentRevenue?: number | null, parentFlag?: string | null }, lostPower: { __typename?: 'WaterfallDataFlag', flagName?: string | null, energy?: number | null, percentEnergy?: number | null, revenue?: number | null, percentRevenue?: number | null, parentFlag?: string | null }, availabilityPower: { __typename?: 'WaterfallDataFlag', flagName?: string | null, energy?: number | null, percentEnergy?: number | null, revenue?: number | null, percentRevenue?: number | null, parentFlag?: string | null }, curtailmentPower: { __typename?: 'WaterfallDataFlag', flagName?: string | null, energy?: number | null, percentEnergy?: number | null, revenue?: number | null, percentRevenue?: number | null, parentFlag?: string | null }, partialPerformancePower: { __typename?: 'WaterfallDataFlag', flagName?: string | null, energy?: number | null, percentEnergy?: number | null, revenue?: number | null, percentRevenue?: number | null, parentFlag?: string | null }, deratingPower: { __typename?: 'WaterfallDataFlag', flagName?: string | null, energy?: number | null, percentEnergy?: number | null, revenue?: number | null, percentRevenue?: number | null, parentFlag?: string | null }, otherUnderperformancePower: { __typename?: 'WaterfallDataFlag', flagName?: string | null, energy?: number | null, percentEnergy?: number | null, revenue?: number | null, percentRevenue?: number | null, parentFlag?: string | null }, overratingPower: { __typename?: 'WaterfallDataFlag', flagName?: string | null, energy?: number | null, percentEnergy?: number | null, revenue?: number | null, percentRevenue?: number | null, parentFlag?: string | null }, hysteresisPower: { __typename?: 'WaterfallDataFlag', flagName?: string | null, energy?: number | null, percentEnergy?: number | null, revenue?: number | null, percentRevenue?: number | null, parentFlag?: string | null }, budget: { __typename?: 'WaterfallDataFlag', flagName?: string | null, energy?: number | null, percentEnergy?: number | null, revenue?: number | null, percentRevenue?: number | null, parentFlag?: string | null } } } }> };

export type ParkWaterfallQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbines: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type ParkWaterfallQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', name: string, performanceAnalytics: { __typename?: 'PerformanceAnalytics', waterfall: { __typename?: 'WaterfallData', actualPower: { __typename?: 'WaterfallDataFlag', flagName?: string | null, energy?: number | null, percentEnergy?: number | null, revenue?: number | null, percentRevenue?: number | null, parentFlag?: string | null }, delta: { __typename?: 'WaterfallDataFlag', flagName?: string | null, energy?: number | null, percentEnergy?: number | null, revenue?: number | null, percentRevenue?: number | null, parentFlag?: string | null }, theoreticalPower: { __typename?: 'WaterfallDataFlag', flagName?: string | null, energy?: number | null, percentEnergy?: number | null, revenue?: number | null, percentRevenue?: number | null, parentFlag?: string | null }, lostPower: { __typename?: 'WaterfallDataFlag', flagName?: string | null, energy?: number | null, percentEnergy?: number | null, revenue?: number | null, percentRevenue?: number | null, parentFlag?: string | null }, availabilityPower: { __typename?: 'WaterfallDataFlag', flagName?: string | null, energy?: number | null, percentEnergy?: number | null, revenue?: number | null, percentRevenue?: number | null, parentFlag?: string | null }, curtailmentPower: { __typename?: 'WaterfallDataFlag', flagName?: string | null, energy?: number | null, percentEnergy?: number | null, revenue?: number | null, percentRevenue?: number | null, parentFlag?: string | null }, partialPerformancePower: { __typename?: 'WaterfallDataFlag', flagName?: string | null, energy?: number | null, percentEnergy?: number | null, revenue?: number | null, percentRevenue?: number | null, parentFlag?: string | null }, deratingPower: { __typename?: 'WaterfallDataFlag', flagName?: string | null, energy?: number | null, percentEnergy?: number | null, revenue?: number | null, percentRevenue?: number | null, parentFlag?: string | null }, otherUnderperformancePower: { __typename?: 'WaterfallDataFlag', flagName?: string | null, energy?: number | null, percentEnergy?: number | null, revenue?: number | null, percentRevenue?: number | null, parentFlag?: string | null }, overratingPower: { __typename?: 'WaterfallDataFlag', flagName?: string | null, energy?: number | null, percentEnergy?: number | null, revenue?: number | null, percentRevenue?: number | null, parentFlag?: string | null }, hysteresisPower: { __typename?: 'WaterfallDataFlag', flagName?: string | null, energy?: number | null, percentEnergy?: number | null, revenue?: number | null, percentRevenue?: number | null, parentFlag?: string | null }, budget: { __typename?: 'WaterfallDataFlag', flagName?: string | null, energy?: number | null, percentEnergy?: number | null, revenue?: number | null, percentRevenue?: number | null, parentFlag?: string | null } } } }> };

export type PortfolioAssetQueryVariables = Exact<{
  flag: Scalars['String']['input'];
  start: Scalars['Float']['input'];
  end: Scalars['Float']['input'];
  idParks: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type PortfolioAssetQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', name: string, performanceAnalytics: { __typename?: 'PerformanceAnalytics', assets: Array<{ __typename?: 'AssetData', id?: string | null, prod?: number | null, rev?: number | null, percentageVsTheo?: number | null, duration?: number | null } | null> }, parks: Array<{ __typename?: 'Park', _id: string, code: string, displayCode?: string | null, name: string }> }> };

export type ParkAssetQueryVariables = Exact<{
  idPark?: InputMaybe<Scalars['ID']['input']>;
  flag: Scalars['String']['input'];
  start: Scalars['Float']['input'];
  end: Scalars['Float']['input'];
  idTurbines: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type ParkAssetQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', name: string, performanceAnalytics: { __typename?: 'PerformanceAnalytics', assets: Array<{ __typename?: 'AssetData', id?: string | null, prod?: number | null, rev?: number | null, percentageVsTheo?: number | null, duration?: number | null } | null> }, turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, code: string }> }> };

export type FindingsByFlagQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  flag: Scalars['String']['input'];
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbines: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type FindingsByFlagQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', code: string, name: string, performanceAnalytics: { __typename?: 'PerformanceAnalytics', findings: Array<{ __typename?: 'FindingData', prod?: number | null, startTs?: number | null, startDate?: string | null, endTs?: number | null, endDate?: string | null, flagName?: string | null, parentFlag?: string | null, duration?: number | null, _id_turbine?: string | null, rev?: number | null } | null> }, turbines: Array<{ __typename?: 'Turbine', name: string, _id: string, code: string }> }> };

export type FindingsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbines: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type FindingsQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', code: string, name: string, performanceAnalytics: { __typename?: 'PerformanceAnalytics', findings: Array<{ __typename?: 'FindingData', prod?: number | null, startTs?: number | null, endTs?: number | null, flagName?: string | null, parentFlag?: string | null, duration?: number | null, rev?: number | null, _id_turbine?: string | null } | null> }, turbines: Array<{ __typename?: 'Turbine', name: string, _id: string, code: string }> }> };

export type RevenuesFragment = { __typename?: 'RevenuesDataseriesValue', timestamp?: number | null, productionScada?: number | null, productionGrid?: number | null, productionLosses?: number | null, productionGridCount?: number | null, marketPrice?: number | null, data?: Array<{ __typename?: 'MetricValues', metric?: string | null, value?: number | null } | null> | null };

export type RevenuesFactsParkByPeriodQueryVariables = Exact<{
  name: Scalars['String']['input'];
  dayFrom: Scalars['Float']['input'];
  dayTo: Scalars['Float']['input'];
  monthFrom: Scalars['Float']['input'];
  monthTo: Scalars['Float']['input'];
  monthToEnd: Scalars['Float']['input'];
  yearFrom: Scalars['Float']['input'];
  yearTo: Scalars['Float']['input'];
  yearToEnd: Scalars['Float']['input'];
}>;


export type RevenuesFactsParkByPeriodQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', _id: string, name: string, fe_name: string, country: { __typename?: 'Country', name: string, code: string }, ratedPower: { __typename?: 'Data', WTUR1_MW_rated?: { __typename?: 'Aggregation', sum?: number | null } | null }, dayTotals?: Array<{ __typename?: 'RevenuesDataseriesValue', timestamp?: number | null, productionScada?: number | null, productionGrid?: number | null, productionLosses?: number | null, productionGridCount?: number | null, marketPrice?: number | null, data?: Array<{ __typename?: 'MetricValues', metric?: string | null, value?: number | null } | null> | null } | null> | null, monthTotals?: Array<{ __typename?: 'RevenuesDataseriesValue', timestamp?: number | null, productionScada?: number | null, productionGrid?: number | null, productionLosses?: number | null, productionGridCount?: number | null, marketPrice?: number | null, data?: Array<{ __typename?: 'MetricValues', metric?: string | null, value?: number | null } | null> | null } | null> | null, monthEndTotals?: Array<{ __typename?: 'RevenuesDataseriesValue', timestamp?: number | null, productionScada?: number | null, productionGrid?: number | null, productionLosses?: number | null, productionGridCount?: number | null, marketPrice?: number | null, data?: Array<{ __typename?: 'MetricValues', metric?: string | null, value?: number | null } | null> | null } | null> | null, yearTotals?: Array<{ __typename?: 'RevenuesDataseriesValue', timestamp?: number | null, productionScada?: number | null, productionGrid?: number | null, productionLosses?: number | null, productionGridCount?: number | null, marketPrice?: number | null, data?: Array<{ __typename?: 'MetricValues', metric?: string | null, value?: number | null } | null> | null } | null> | null, yearMonthEndTotals?: Array<{ __typename?: 'RevenuesDataseriesValue', timestamp?: number | null, productionScada?: number | null, productionGrid?: number | null, productionLosses?: number | null, productionGridCount?: number | null, marketPrice?: number | null, data?: Array<{ __typename?: 'MetricValues', metric?: string | null, value?: number | null } | null> | null } | null> | null, yearEndTotals?: Array<{ __typename?: 'RevenuesDataseriesValue', timestamp?: number | null, productionScada?: number | null, productionGrid?: number | null, productionLosses?: number | null, productionGridCount?: number | null, marketPrice?: number | null, data?: Array<{ __typename?: 'MetricValues', metric?: string | null, value?: number | null } | null> | null } | null> | null }> };

export type RevenuesDataSeriesParkByPeriodQueryVariables = Exact<{
  name: Scalars['String']['input'];
  dayFrom: Scalars['Float']['input'];
  dayTo: Scalars['Float']['input'];
  granularity: RevenuesGranularityEnum;
  timezone: Scalars['String']['input'];
}>;


export type RevenuesDataSeriesParkByPeriodQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', _id: string, name: string, fe_name: string, country: { __typename?: 'Country', name: string, code: string }, revenuesDataseries?: Array<{ __typename?: 'RevenuesDataseriesValue', timestamp?: number | null, productionScada?: number | null, productionGrid?: number | null, productionLosses?: number | null, productionGridCount?: number | null, marketPrice?: number | null, data?: Array<{ __typename?: 'MetricValues', metric?: string | null, value?: number | null } | null> | null } | null> | null }> };

export type RevenuesDataSeriesPortfolioByPeriodQueryVariables = Exact<{
  monthFrom: Scalars['Float']['input'];
  monthTo: Scalars['Float']['input'];
  granularity: RevenuesGranularityEnum;
  timezone: Scalars['String']['input'];
  portfolioId?: InputMaybe<Scalars['String']['input']>;
  parks?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type RevenuesDataSeriesPortfolioByPeriodQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', revenuesDataseries?: Array<{ __typename?: 'RevenuesDataseriesValue', timestamp?: number | null, productionScada?: number | null, productionGrid?: number | null, productionLosses?: number | null, productionGridCount?: number | null, marketPrice?: number | null, data?: Array<{ __typename?: 'MetricValues', metric?: string | null, value?: number | null } | null> | null } | null> | null, parks: Array<{ __typename?: 'Park', _id: string, code: string, name: string, fe_name: string }> }> };

export type RevenuesDataSeriesPortfolioByPeriodAndParkQueryVariables = Exact<{
  monthFrom: Scalars['Float']['input'];
  monthTo: Scalars['Float']['input'];
  granularity: RevenuesGranularityEnum;
  timezone: Scalars['String']['input'];
  portfolioId?: InputMaybe<Scalars['String']['input']>;
  parks?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type RevenuesDataSeriesPortfolioByPeriodAndParkQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', parks: Array<{ __typename?: 'Park', _id: string, code: string, name: string, fe_name: string }>, revenuesDataseries?: Array<{ __typename?: 'RevenuesDataseriesValue', _id_park?: string | null, timestamp?: number | null, productionScada?: number | null, productionGrid?: number | null, productionLosses?: number | null, productionGridCount?: number | null, marketPrice?: number | null, data?: Array<{ __typename?: 'MetricValues', metric?: string | null, value?: number | null } | null> | null } | null> | null }> };

export type RevenuesFactsPortfolioByPeriodQueryVariables = Exact<{
  dayFrom: Scalars['Float']['input'];
  dayTo: Scalars['Float']['input'];
  monthFrom: Scalars['Float']['input'];
  monthTo: Scalars['Float']['input'];
  monthToEnd: Scalars['Float']['input'];
  yearFrom: Scalars['Float']['input'];
  yearTo: Scalars['Float']['input'];
  yearToEnd: Scalars['Float']['input'];
  portfolioId?: InputMaybe<Scalars['String']['input']>;
  parks?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type RevenuesFactsPortfolioByPeriodQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', parks: Array<{ __typename?: 'Park', _id: string, name: string, fe_name: string, code: string, ratedPower: { __typename?: 'Data', WTUR1_MW_rated?: { __typename?: 'Aggregation', sum?: number | null } | null }, country: { __typename?: 'Country', name: string }, dayTotals?: Array<{ __typename?: 'RevenuesDataseriesValue', timestamp?: number | null, productionScada?: number | null, productionGrid?: number | null, productionLosses?: number | null, productionGridCount?: number | null, marketPrice?: number | null, data?: Array<{ __typename?: 'MetricValues', metric?: string | null, value?: number | null } | null> | null } | null> | null, monthTotals?: Array<{ __typename?: 'RevenuesDataseriesValue', timestamp?: number | null, productionScada?: number | null, productionGrid?: number | null, productionLosses?: number | null, productionGridCount?: number | null, marketPrice?: number | null, data?: Array<{ __typename?: 'MetricValues', metric?: string | null, value?: number | null } | null> | null } | null> | null, monthEndTotals?: Array<{ __typename?: 'RevenuesDataseriesValue', timestamp?: number | null, productionScada?: number | null, productionGrid?: number | null, productionLosses?: number | null, productionGridCount?: number | null, marketPrice?: number | null, data?: Array<{ __typename?: 'MetricValues', metric?: string | null, value?: number | null } | null> | null } | null> | null, yearTotals?: Array<{ __typename?: 'RevenuesDataseriesValue', timestamp?: number | null, productionScada?: number | null, productionGrid?: number | null, productionLosses?: number | null, productionGridCount?: number | null, marketPrice?: number | null, data?: Array<{ __typename?: 'MetricValues', metric?: string | null, value?: number | null } | null> | null } | null> | null, yearEndTotals?: Array<{ __typename?: 'RevenuesDataseriesValue', timestamp?: number | null, productionScada?: number | null, productionGrid?: number | null, productionLosses?: number | null, productionGridCount?: number | null, marketPrice?: number | null, data?: Array<{ __typename?: 'MetricValues', metric?: string | null, value?: number | null } | null> | null } | null> | null, yearMonthEndTotals?: Array<{ __typename?: 'RevenuesDataseriesValue', timestamp?: number | null, productionScada?: number | null, productionGrid?: number | null, productionLosses?: number | null, productionGridCount?: number | null, marketPrice?: number | null, data?: Array<{ __typename?: 'MetricValues', metric?: string | null, value?: number | null } | null> | null } | null> | null }> }> };

export type ParkCapturedPriceQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  from: Scalars['Float']['input'];
  to: Scalars['Float']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
}>;


export type ParkCapturedPriceQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', targetPrice?: Array<{ __typename?: 'TargetPrice', month: number, targetPrice?: number | null } | null> | null, windCaptureRatio?: Array<{ __typename?: 'WindCaptureRatio', month: string, windCaptureRatio?: number | null } | null> | null, targetCaptureRatio?: Array<{ __typename?: 'TargetCaptureRatio', month: number, targetCaptureRatio?: number | null } | null> | null, revenuesDataseries?: Array<{ __typename?: 'RevenuesDataseriesValue', timestamp?: number | null, productionScada?: number | null, productionGrid?: number | null, productionLosses?: number | null, productionGridCount?: number | null, marketPrice?: number | null, data?: Array<{ __typename?: 'MetricValues', metric?: string | null, value?: number | null } | null> | null } | null> | null }> };

export type RevenuesParkFormulasQueryVariables = Exact<{
  name: Scalars['String']['input'];
  from: Scalars['Float']['input'];
  to: Scalars['Float']['input'];
  timezone: Scalars['String']['input'];
}>;


export type RevenuesParkFormulasQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', revenuesDataseries?: Array<{ __typename?: 'RevenuesDataseriesValue', data?: Array<{ __typename?: 'MetricValues', metric?: string | null, value?: number | null, order?: number | null } | null> | null } | null> | null }> };

export type RevenuesPortfolioFormulasQueryVariables = Exact<{
  portfolioId: Scalars['String']['input'];
  parks?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  from: Scalars['Float']['input'];
  to: Scalars['Float']['input'];
  timezone: Scalars['String']['input'];
}>;


export type RevenuesPortfolioFormulasQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', revenuesDataseries?: Array<{ __typename?: 'RevenuesDataseriesValue', data?: Array<{ __typename?: 'MetricValues', metric?: string | null, value?: number | null, order?: number | null } | null> | null } | null> | null }> };

export type PortfolioCurrencyQueryVariables = Exact<{ [key: string]: never; }>;


export type PortfolioCurrencyQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', currency: { __typename?: 'Currency', _id: string, name: string, code: string, symbol: string } }> };

export type WindSpeedQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type WindSpeedQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', name: string, code: string, turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, serialNav: number, code: string }>, groupedDataSeries: { __typename?: 'GroupedDataSeries', windSpeed: Array<{ __typename?: 'GroupedDataSeriesResult', _id_turbine?: string | null, data?: Array<number | null> | null } | null> } }> };

export type WindDirQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type WindDirQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', name: string, code: string, turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, serialNav: number, code: string }>, groupedDataSeries: { __typename?: 'GroupedDataSeries', windDir: Array<{ __typename?: 'GroupedDataSeriesResult', _id_turbine?: string | null, data?: Array<number | null> | null } | null> } }> };

export type NacDirQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type NacDirQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', name: string, code: string, turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, serialNav: number, code: string }>, groupedDataSeries: { __typename?: 'GroupedDataSeries', nacDir: Array<{ __typename?: 'GroupedDataSeriesResult', _id_turbine?: string | null, data?: Array<number | null> | null } | null> } }> };

export type AmbTempQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type AmbTempQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', name: string, code: string, turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, serialNav: number, code: string }>, groupedDataSeries: { __typename?: 'GroupedDataSeries', ambTemp: Array<{ __typename?: 'GroupedDataSeriesResult', _id_turbine?: string | null, data?: Array<number | null> | null } | null> } }> };

export type RotorSpeedQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type RotorSpeedQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', name: string, code: string, turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, serialNav: number, code: string }>, groupedDataSeries: { __typename?: 'GroupedDataSeries', rotorSpeed: Array<{ __typename?: 'GroupedDataSeriesResult', _id_turbine?: string | null, data?: Array<number | null> | null } | null> } }> };

export type GeneratorSpeedQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GeneratorSpeedQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', name: string, code: string, turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, serialNav: number, code: string }>, groupedDataSeries: { __typename?: 'GroupedDataSeries', generatorSpeed: Array<{ __typename?: 'GroupedDataSeriesResult', _id_turbine?: string | null, data?: Array<number | null> | null } | null> } }> };

export type PitchAngleParkQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type PitchAngleParkQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', name: string, code: string, turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, serialNav: number, code: string }>, groupedDataSeries: { __typename?: 'GroupedDataSeries', pitchAngle1: Array<{ __typename?: 'GroupedDataSeriesResult', _id_turbine?: string | null, data?: Array<number | null> | null } | null>, pitchAngle2: Array<{ __typename?: 'GroupedDataSeriesResult', _id_turbine?: string | null, data?: Array<number | null> | null } | null>, pitchAngle3: Array<{ __typename?: 'GroupedDataSeriesResult', _id_turbine?: string | null, data?: Array<number | null> | null } | null> } }> };

export type ScatterPlotChartsDataQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbine: Scalars['String']['input'];
}>;


export type ScatterPlotChartsDataQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', serial: string, code: string, analyze: { __typename?: 'Analyze', performanceDataSeries: { __typename?: 'MixedGroupedDataSeries', actualPower: { __typename?: 'SignalGroupedDataSeriesResult', startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null, data?: Array<number | null> | null }, theoPower: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, status: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, ambTemp: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, windSpeed: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, windDir: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, nacDir: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, rotorSpeed: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, pitchAngle1: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, pitchAngle2: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, pitchAngle3: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null } } } }> };

export type ScatterPlotChartsDataPerformanceAnalyticsQueryVariables = Exact<{
  startTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbine: Scalars['String']['input'];
}>;


export type ScatterPlotChartsDataPerformanceAnalyticsQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', serial: string, code: string, analyze: { __typename?: 'Analyze', performanceDataSeries: { __typename?: 'MixedGroupedDataSeries', actualPower: { __typename?: 'SignalGroupedDataSeriesResult', startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null, data?: Array<number | null> | null }, windSpeed: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, rotorSpeed: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, pitchAngle1: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, pitchAngle2: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, pitchAngle3: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null } } } }> };

export type PortfolioKpiQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
  parkIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type PortfolioKpiQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', _id: string, parks: Array<{ __typename?: 'Park', _id: string, code: string, displayCode?: string | null, name: string }>, analyze: { __typename?: 'Analyze', performanceFacts: { __typename?: 'MixedFacts', WTUR1_W_avg_loss?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null, WTUR1_revenueLosses_avg?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null, WTUR1_per_avg_availability?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null, WTUR1_per_avg_efficiency?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null } }, groupedFacts: { __typename?: 'GroupedFacts', WTUR1_W_avg_loss: Array<{ __typename?: 'GroupedFactsResult', _id_park?: string | null, dataValue?: number | null } | null>, WTUR1_revenueLosses_avg: Array<{ __typename?: 'GroupedFactsResult', _id_park?: string | null, dataValue?: number | null } | null>, WTUR1_per_avg_availability: Array<{ __typename?: 'GroupedFactsResult', _id_park?: string | null, dataValue?: number | null } | null>, WTUR1_per_avg_efficiency: Array<{ __typename?: 'GroupedFactsResult', _id_park?: string | null, dataValue?: number | null } | null> } }> };

export type ParksKpiQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ParksKpiQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', code: string, turbines: Array<{ __typename?: 'Turbine', _id: string, serialNav: number, code: string }>, analyze: { __typename?: 'Analyze', performanceFacts: { __typename?: 'MixedFacts', WTUR1_W_avg_loss?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null, WTUR1_revenueLosses_avg?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null, WTUR1_per_avg_availability?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null, WTUR1_per_avg_efficiency?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null } }, groupedFacts: { __typename?: 'GroupedFacts', WTUR1_W_avg_loss: Array<{ __typename?: 'GroupedFactsResult', _id_turbine?: string | null, dataValue?: number | null } | null>, WTUR1_revenueLosses_avg: Array<{ __typename?: 'GroupedFactsResult', _id_turbine?: string | null, dataValue?: number | null } | null>, WTUR1_per_avg_availability: Array<{ __typename?: 'GroupedFactsResult', _id_turbine?: string | null, dataValue?: number | null } | null>, WTUR1_per_avg_efficiency: Array<{ __typename?: 'GroupedFactsResult', _id_turbine?: string | null, dataValue?: number | null } | null> } }> };

export type RevPortfolioQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
}>;


export type RevPortfolioQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', _id: string, parks: Array<{ __typename?: 'Park', _id: string, code: string, displayCode?: string | null, name: string }>, groupedFacts: { __typename?: 'GroupedFacts', WTUR1_revenue_avg: Array<{ __typename?: 'GroupedFactsResult', _id_park?: string | null, dataValue?: number | null } | null> } }> };

export type ComparativeTableReportPortfolioQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
}>;


export type ComparativeTableReportPortfolioQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', _id: string, parks: Array<{ __typename?: 'Park', _id: string, name: string, code: string, displayCode?: string | null }>, groupedFacts: { __typename?: 'GroupedFacts', WTUR1_revenue_avg: Array<{ __typename?: 'GroupedFactsResult', _id_park?: string | null, dataValue?: number | null } | null>, WTUR1_revenueLosses_avg: Array<{ __typename?: 'GroupedFactsResult', _id_park?: string | null, dataValue?: number | null } | null>, Wh_avg_mag_f: Array<{ __typename?: 'GroupedFactsResult', _id_park?: string | null, dataValue?: number | null } | null>, WTUR1_W_avg_theoretical: Array<{ __typename?: 'GroupedFactsResult', _id_park?: string | null, dataValue?: number | null } | null>, WTUR1_W_avg_loss: Array<{ __typename?: 'GroupedFactsResult', _id_park?: string | null, dataValue?: number | null } | null>, WTUR1_per_avg_availability: Array<{ __typename?: 'GroupedFactsResult', _id_park?: string | null, dataValue?: number | null } | null>, WTUR1_per_avg_efficiency: Array<{ __typename?: 'GroupedFactsResult', _id_park?: string | null, dataValue?: number | null } | null> } }> };

export type ComparativeTableReportParkQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ComparativeTableReportParkQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', name: string, turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, serial: string, code: string }>, groupedFacts: { __typename?: 'GroupedFacts', WTUR1_revenue_avg: Array<{ __typename?: 'GroupedFactsResult', _id_turbine?: string | null, dataValue?: number | null } | null>, WTUR1_revenueLosses_avg: Array<{ __typename?: 'GroupedFactsResult', _id_turbine?: string | null, dataValue?: number | null } | null>, Wh_avg_mag_f: Array<{ __typename?: 'GroupedFactsResult', _id_turbine?: string | null, dataValue?: number | null } | null>, WTUR1_W_avg_theoretical: Array<{ __typename?: 'GroupedFactsResult', _id_turbine?: string | null, dataValue?: number | null } | null>, WTUR1_W_avg_loss: Array<{ __typename?: 'GroupedFactsResult', _id_turbine?: string | null, dataValue?: number | null } | null>, WTUR1_per_avg_availability: Array<{ __typename?: 'GroupedFactsResult', _id_turbine?: string | null, dataValue?: number | null } | null>, WTUR1_per_avg_efficiency: Array<{ __typename?: 'GroupedFactsResult', _id_turbine?: string | null, dataValue?: number | null } | null> } }> };

export type ProdPortfolioQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
}>;


export type ProdPortfolioQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', _id: string, parks: Array<{ __typename?: 'Park', _id: string, name: string, code: string, displayCode?: string | null }>, groupedFacts: { __typename?: 'GroupedFacts', Wh_avg_mag_f: Array<{ __typename?: 'GroupedFactsResult', _id_park?: string | null, dataValue?: number | null } | null> } }> };

export type AvailabilityPortfolioQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
}>;


export type AvailabilityPortfolioQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', _id: string, parks: Array<{ __typename?: 'Park', _id: string, name: string, code: string, displayCode?: string | null }>, groupedFacts: { __typename?: 'GroupedFacts', WTUR1_per_avg_availability: Array<{ __typename?: 'GroupedFactsResult', _id_park?: string | null, dataValue?: number | null } | null> } }> };

export type ProdLossPortfolioQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
}>;


export type ProdLossPortfolioQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', _id: string, parks: Array<{ __typename?: 'Park', _id: string, name: string, code: string, displayCode?: string | null }>, groupedFacts: { __typename?: 'GroupedFacts', WTUR1_W_avg_loss: Array<{ __typename?: 'GroupedFactsResult', _id_park?: string | null, dataValue?: number | null } | null> } }> };

export type RevLossPortfolioQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
}>;


export type RevLossPortfolioQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', _id: string, parks: Array<{ __typename?: 'Park', _id: string, name: string, code: string, displayCode?: string | null }>, groupedFacts: { __typename?: 'GroupedFacts', WTUR1_revenueLosses_avg: Array<{ __typename?: 'GroupedFactsResult', _id_park?: string | null, dataValue?: number | null } | null> } }> };

export type RevLossParkQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type RevLossParkQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', _id: string, turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, serial: string, code: string }>, groupedFacts: { __typename?: 'GroupedFacts', WTUR1_revenueLosses_avg: Array<{ __typename?: 'GroupedFactsResult', _id_turbine?: string | null, dataValue?: number | null } | null> } }> };

export type ProdParkQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ProdParkQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', _id: string, turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, serial: string, code: string }>, groupedFacts: { __typename?: 'GroupedFacts', Wh_avg_mag_f: Array<{ __typename?: 'GroupedFactsResult', _id_turbine?: string | null, dataValue?: number | null } | null> } }> };

export type AvailabilityParkQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type AvailabilityParkQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', _id: string, turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, serial: string, code: string }>, groupedFacts: { __typename?: 'GroupedFacts', WTUR1_per_avg_availability: Array<{ __typename?: 'GroupedFactsResult', _id_turbine?: string | null, dataValue?: number | null } | null> } }> };

export type ProdLossParkQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ProdLossParkQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', _id: string, turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, serial: string, code: string }>, groupedFacts: { __typename?: 'GroupedFacts', WTUR1_W_avg_loss: Array<{ __typename?: 'GroupedFactsResult', _id_turbine?: string | null, dataValue?: number | null } | null> } }> };

export type RevParkQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type RevParkQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', _id: string, turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, serial: string, code: string }>, groupedFacts: { __typename?: 'GroupedFacts', WTUR1_revenue_avg: Array<{ __typename?: 'GroupedFactsResult', _id_turbine?: string | null, dataValue?: number | null } | null> } }> };

export type PerformanceGroupedByTurbineQueryVariables = Exact<{
  startTime: Scalars['Float']['input'];
  endTime: Scalars['Float']['input'];
  parkName: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type PerformanceGroupedByTurbineQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', name: string, turbines: Array<{ __typename?: 'Turbine', _id: string, ratedPower: number, name: string, serialNav: number, code: string }>, groupedDataSeries: { __typename?: 'GroupedDataSeries', WTUR1_W_avg_mag_f: Array<{ __typename?: 'GroupedDataSeriesResult', _id_turbine?: string | null, data?: Array<number | null> | null } | null> } }> };

export type PerformanceGroupedByParkQueryVariables = Exact<{
  startTime: Scalars['Float']['input'];
  endTime: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
  parkIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type PerformanceGroupedByParkQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', _id: string, dataDebbug: { __typename?: 'Data', WTUR1_kW_rated?: { __typename?: 'Aggregation', sum?: number | null } | null }, groupedDataSeries: { __typename?: 'GroupedDataSeries', WTUR1_W_avg_mag_f: Array<{ __typename?: 'GroupedDataSeriesResult', _id_park?: string | null, data?: Array<number | null> | null } | null> } }> };

export type QualityPortfolioQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
  parkIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type QualityPortfolioQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', parks: Array<{ __typename?: 'Park', turbines: Array<{ __typename?: 'Turbine', code: string }> }>, analyze: { __typename?: 'Analyze', performanceFacts: { __typename?: 'MixedFacts', WTUR1_W_avg_mag_f?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null } } }> };

export type FactsPortfolioQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
  parkIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type FactsPortfolioQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', analyze: { __typename?: 'Analyze', performanceFacts: { __typename?: 'MixedFacts', WTUR1_Wh_avg_mag_f?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null, WTUR1_W_avg_theoretical?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null, WTUR1_W_avg_loss?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null, WTUR1_co2Avoided?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null, WTUR1_per_avg_loadFactor?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null, WTUR1_revenue_avg?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null, WTUR1_revenueLosses_avg?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null } } }> };

export type FactsParkQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type FactsParkQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', turbines: Array<{ __typename?: 'Turbine', comissioningDate: string }>, analyze: { __typename?: 'Analyze', performanceFacts: { __typename?: 'MixedFacts', WTUR1_Wh_avg_mag_f?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null, WTUR1_W_avg_theoretical?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null, WTUR1_W_avg_loss?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null, WTUR1_co2Avoided?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null, WTUR1_per_avg_loadFactor?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null, WTUR1_revenue_avg?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null, WTUR1_revenueLosses_avg?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null } } }> };

export type QualityParkQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type QualityParkQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', code: string, turbines: Array<{ __typename?: 'Turbine', code: string }>, analyze: { __typename?: 'Analyze', performanceFacts: { __typename?: 'MixedFacts', WTUR1_W_avg_mag_f?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null } } }> };

export type PerformancePortfolioQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
  parkIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type PerformancePortfolioQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', _id: string, reference?: { __typename?: 'Reference', turbines: Array<{ __typename?: 'Turbine', ratedPower: number }> } | null, analyze: { __typename?: 'Analyze', performanceDataSeries: { __typename?: 'MixedGroupedDataSeries', WTUR1_W_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WTUR1_W_avg_theoretical: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null } } } }> };

export type StatusLoadByParkQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
  parkIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type StatusLoadByParkQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', _id: string, parks: Array<{ __typename?: 'Park', _id: string, code: string, displayCode?: string | null, name: string, fe_name: string }>, groupedFacts: { __typename?: 'GroupedFacts', WTUR1_per_avg_loadFactor: Array<{ __typename?: 'GroupedFactsResult', _id_park?: string | null, dataValue?: number | null } | null> } }> };

export type ProductionByParkQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
  parkIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ProductionByParkQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', _id: string, parks: Array<{ __typename?: 'Park', _id: string, code: string, displayCode?: string | null, name: string, fe_name: string }>, groupedFacts: { __typename?: 'GroupedFacts', WTUR1_W_avg_loss: Array<{ __typename?: 'GroupedFactsResult', _id_park?: string | null, dataValue?: number | null, startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null } | null>, WTUR1_Wh_avg_mag_f: Array<{ __typename?: 'GroupedFactsResult', _id_park?: string | null, dataValue?: number | null, startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null } | null>, WTUR1_W_avg_theoretical: Array<{ __typename?: 'GroupedFactsResult', _id_park?: string | null, dataValue?: number | null, startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null } | null> } }> };

export type RevenuesByParkQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
  parkIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type RevenuesByParkQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', _id: string, parks: Array<{ __typename?: 'Park', _id: string, code: string, displayCode?: string | null, name: string, fe_name: string }>, groupedFacts: { __typename?: 'GroupedFacts', WTUR1_revenueLosses_avg: Array<{ __typename?: 'GroupedFactsResult', _id_park?: string | null, dataValue?: number | null, startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null } | null>, WTUR1_revenue_avg: Array<{ __typename?: 'GroupedFactsResult', _id_park?: string | null, dataValue?: number | null, startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null } | null> } }> };

export type EfficiencyByParkQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
  parkIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type EfficiencyByParkQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', _id: string, parks: Array<{ __typename?: 'Park', _id: string, code: string, displayCode?: string | null, name: string, fe_name: string }>, groupedFacts: { __typename?: 'GroupedFacts', WTUR1_per_avg_efficiency: Array<{ __typename?: 'GroupedFactsResult', _id_park?: string | null, dataValue?: number | null, startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null } | null> } }> };

export type PerformanceParksQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type PerformanceParksQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', name: string, fe_name: string, turbines: Array<{ __typename?: 'Turbine', ratedPower: number }>, analyze: { __typename?: 'Analyze', performanceDataSeries: { __typename?: 'MixedGroupedDataSeries', WTUR1_W_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WTUR1_W_avg_theoretical: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WNAC1_WdSpd_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null } } } }> };

export type PerformanceTurbineOneQueryQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park?: InputMaybe<Scalars['String']['input']>;
  turbines?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type PerformanceTurbineOneQueryQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', _id: string, code: string, name: string, fe_name: string, turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, serial: string, serialNav: number, ratedPower: number, code: string, analyze: { __typename?: 'Analyze', performanceDataSeries: { __typename?: 'MixedGroupedDataSeries', WTUR1_W_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WTUR1_W_avg_theoretical: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WTUR1_status: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WNAC1_ExTmp_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WNAC1_WdSpd_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WNAC1_WdDir_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WROT1_RotSpd_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WNAC1_Dir_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null } } } }> }> };

export type PerformanceTurbineOneQueryPerTurbineQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
}>;


export type PerformanceTurbineOneQueryPerTurbineQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', _id: string, code: string, name: string, serial: string, serialNav: number, ratedPower: number, analyze: { __typename?: 'Analyze', performanceDataSeries: { __typename?: 'MixedGroupedDataSeries', WTUR1_W_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WTUR1_W_avg_theoretical: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WTUR1_status: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WNAC1_ExTmp_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WNAC1_WdSpd_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WNAC1_WdDir_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WROT1_RotSpd_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WNAC1_Dir_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null } } } }> };

export type PerformanceParksOneQueryQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
  parkIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type PerformanceParksOneQueryQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', _id: string, parks: Array<{ __typename?: 'Park', _id: string, code: string, name: string, fe_name: string, turbines: Array<{ __typename?: 'Turbine', ratedPower: number }>, analyze: { __typename?: 'Analyze', performanceDataSeries: { __typename?: 'MixedGroupedDataSeries', WTUR1_W_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WTUR1_W_avg_theoretical: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null } } } }> }> };

export type PerformanceParksGroupedQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
  parkIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type PerformanceParksGroupedQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', _id: string, parks: Array<{ __typename?: 'Park', _id: string, code: string, name: string, turbines: Array<{ __typename?: 'Turbine', ratedPower: number }> }>, groupedDataSeries: { __typename?: 'GroupedDataSeries', WTUR1_W_avg_mag_f: Array<{ __typename?: 'GroupedDataSeriesResult', _id_park?: string | null, data?: Array<number | null> | null } | null>, WTUR1_W_avg_theoretical: Array<{ __typename?: 'GroupedDataSeriesResult', _id_park?: string | null, data?: Array<number | null> | null } | null> } }> };

export type PerformanceTurbineQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  serial: Scalars['String']['input'];
}>;


export type PerformanceTurbineQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', ratedPower: number, analyze: { __typename?: 'Analyze', performanceDataSeries: { __typename?: 'MixedGroupedDataSeries', WTUR1_W_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WTUR1_W_avg_theoretical: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WNAC1_WdSpd_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null } } } }> };

export type FactsTurbineQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbine: Scalars['String']['input'];
}>;


export type FactsTurbineQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', type: string, ratedPower: number, comissioningDate: string, code: string, analyze: { __typename?: 'Analyze', performanceFacts: { __typename?: 'MixedFacts', WTUR1_Wh_avg_mag_f?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null, WTUR1_W_avg_theoretical?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null, WTUR1_W_avg_loss?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null, WTUR1_co2Avoided?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null, WTUR1_per_avg_loadFactor?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null, WTUR1_revenue_avg?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null, WTUR1_revenueLosses_avg?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null } }, data?: { __typename?: 'RawData', WTUR1_TotWh_actVal?: number | null } | null }> };

export type QualityTurbineQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbine: Scalars['String']['input'];
}>;


export type QualityTurbineQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', analyze: { __typename?: 'Analyze', performanceFacts: { __typename?: 'MixedFacts', WTUR1_W_avg_mag_f?: { __typename?: 'SignalGroupedFactsResult', dataValue?: number | null } | null } } }> };

export type PerformanceGraphTurbineQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbine: Scalars['String']['input'];
}>;


export type PerformanceGraphTurbineQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', name: string, code: string, codeDisplay: string, serial: string, serialDisplay: string, serialNav: number, ratedPower: number, analyze: { __typename?: 'Analyze', performanceDataSeries: { __typename?: 'MixedGroupedDataSeries', WTUR1_W_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WTUR1_W_avg_theoretical: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WTUR1_status: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WNAC1_ExTmp_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WNAC1_WdSpd_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WNAC1_WdDir_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WROT1_RotSpd_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WNAC1_Dir_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null } } } }> };

export type LoadByTurbineQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type LoadByTurbineQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', code: string, name: string, turbines: Array<{ __typename?: 'Turbine', _id: string, serial: string, serialNav: number, name: string, code: string }>, groupedFacts: { __typename?: 'GroupedFacts', WTUR1_per_avg_loadFactor: Array<{ __typename?: 'GroupedFactsResult', _id_turbine?: string | null, dataValue?: number | null } | null> } }> };

export type RevenuesByTurbineQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type RevenuesByTurbineQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', code: string, name: string, turbines: Array<{ __typename?: 'Turbine', _id: string, serial: string, serialNav: number, name: string, code: string }>, groupedFacts: { __typename?: 'GroupedFacts', WTUR1_revenueLosses_avg: Array<{ __typename?: 'GroupedFactsResult', _id_turbine?: string | null, dataValue?: number | null, startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null } | null>, WTUR1_revenue_avg: Array<{ __typename?: 'GroupedFactsResult', _id_turbine?: string | null, dataValue?: number | null, startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null } | null> } }> };

export type EfficiencyByTurbineQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type EfficiencyByTurbineQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', code: string, name: string, turbines: Array<{ __typename?: 'Turbine', _id: string, serial: string, serialNav: number, name: string, code: string }>, groupedFacts: { __typename?: 'GroupedFacts', WTUR1_per_avg_efficiency: Array<{ __typename?: 'GroupedFactsResult', _id_turbine?: string | null, dataValue?: number | null, startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null } | null> } }> };

export type ProductionByTurbineQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ProductionByTurbineQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', code: string, name: string, turbines: Array<{ __typename?: 'Turbine', _id: string, serial: string, serialNav: number, name: string, code: string }>, groupedFacts: { __typename?: 'GroupedFacts', WTUR1_W_avg_loss: Array<{ __typename?: 'GroupedFactsResult', _id_turbine?: string | null, dataValue?: number | null, startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null } | null>, WTUR1_Wh_avg_mag_f: Array<{ __typename?: 'GroupedFactsResult', _id_turbine?: string | null, dataValue?: number | null, startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null } | null>, WTUR1_W_avg_theoretical: Array<{ __typename?: 'GroupedFactsResult', _id_turbine?: string | null, dataValue?: number | null, startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null } | null> } }> };

export type PowerCurveFlagByTurbineReportQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbine: Scalars['String']['input'];
}>;


export type PowerCurveFlagByTurbineReportQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', analyze: { __typename?: 'Analyze', performanceDataSeries: { __typename?: 'MixedGroupedDataSeries', WTUR1_W_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null, data?: Array<number | null> | null }, WNAC1_WdSpd_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null } } } }> };

export type PowerCurveFlagByTurbineQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbine: Scalars['String']['input'];
}>;


export type PowerCurveFlagByTurbineQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', analyze: { __typename?: 'Analyze', performanceDataSeries: { __typename?: 'MixedGroupedDataSeries', WTUR1_W_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null, data?: Array<number | null> | null }, WTUR1_W_avg_theoretical: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WTUR1_status: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WNAC1_ExTmp_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WNAC1_WdSpd_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WNAC1_WdDir_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WNAC1_Dir_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WROT1_RotSpd_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WROT1_PtAngValBl1_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WROT1_PtAngValBl2_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null }, WROT1_PtAngValBl3_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null } } } }> };

export type StatusPortfolioQueryVariables = Exact<{
  startTime: Scalars['Float']['input'];
  endTime: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
  parkIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type StatusPortfolioQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', name: string, parks: Array<{ __typename?: 'Park', _id: string, name: string, fe_name: string, code: string, displayCode?: string | null }>, groupedDataSeries: { __typename?: 'GroupedDataSeries', WTUR1_status: Array<{ __typename?: 'GroupedDataSeriesResult', _id_park?: string | null, data?: Array<number | null> | null } | null> } }> };

export type StatusParkQueryVariables = Exact<{
  startTime: Scalars['Float']['input'];
  endTime: Scalars['Float']['input'];
  parkName: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type StatusParkQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', name: string, turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, serialNav: number, serialDisplay: string, code: string }>, groupedDataSeries: { __typename?: 'GroupedDataSeries', WTUR1_status: Array<{ __typename?: 'GroupedDataSeriesResult', _id_turbine?: string | null, data?: Array<number | null> | null } | null> } }> };

export type LoadStatusPortfolioQueryVariables = Exact<{
  startTime: Scalars['Float']['input'];
  endTime: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
  parkIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  aggregation?: InputMaybe<TimeseriesAggregation>;
  timezone?: InputMaybe<Scalars['String']['input']>;
}>;


export type LoadStatusPortfolioQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', name: string, parks: Array<{ __typename?: 'Park', _id: string, name: string, fe_name: string, code: string, displayCode?: string | null }>, groupedDataSeries: { __typename?: 'GroupedDataSeries', WTUR1_per_avg_loadFactor: Array<{ __typename?: 'GroupedDataSeriesResult', _id_park?: string | null, data?: Array<number | null> | null } | null> } }> };

export type LoadStatusParkQueryVariables = Exact<{
  startTime: Scalars['Float']['input'];
  endTime: Scalars['Float']['input'];
  parkName: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  aggregation?: InputMaybe<TimeseriesAggregation>;
  timezone?: InputMaybe<Scalars['String']['input']>;
}>;


export type LoadStatusParkQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', name: string, turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, serialNav: number, serialDisplay: string, code: string }>, groupedDataSeries: { __typename?: 'GroupedDataSeries', WTUR1_per_avg_loadFactor: Array<{ __typename?: 'GroupedDataSeriesResult', _id_turbine?: string | null, data?: Array<number | null> | null } | null> } }> };

export type ProductionPortfolioQueryVariables = Exact<{
  startTime: Scalars['Float']['input'];
  endTime: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
  parkIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  aggregation?: InputMaybe<TimeseriesAggregation>;
  timezone?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductionPortfolioQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', name: string, parks: Array<{ __typename?: 'Park', _id: string, name: string, fe_name: string, code: string, displayCode?: string | null }>, groupedDataSeries: { __typename?: 'GroupedDataSeries', WTUR1_Wh_avg_mag_f: Array<{ __typename?: 'GroupedDataSeriesResult', _id_park?: string | null, data?: Array<number | null> | null } | null> } }> };

export type ProductionParkQueryVariables = Exact<{
  startTime: Scalars['Float']['input'];
  endTime: Scalars['Float']['input'];
  parkName: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  aggregation?: InputMaybe<TimeseriesAggregation>;
  timezone?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductionParkQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', name: string, turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, serialNav: number, serialDisplay: string, code: string }>, groupedDataSeries: { __typename?: 'GroupedDataSeries', WTUR1_Wh_avg_mag_f_corrected: Array<{ __typename?: 'GroupedDataSeriesResult', _id_turbine?: string | null, data?: Array<number | null> | null } | null> } }> };

export type RevenuesPortfolioQueryVariables = Exact<{
  startTime: Scalars['Float']['input'];
  endTime: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
  parkIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  aggregation?: InputMaybe<TimeseriesAggregation>;
  timezone?: InputMaybe<Scalars['String']['input']>;
}>;


export type RevenuesPortfolioQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', name: string, parks: Array<{ __typename?: 'Park', _id: string, name: string, fe_name: string, code: string, displayCode?: string | null }>, groupedDataSeries: { __typename?: 'GroupedDataSeries', WTUR1_revenue_avg: Array<{ __typename?: 'GroupedDataSeriesResult', _id_park?: string | null, data?: Array<number | null> | null } | null> } }> };

export type RevenuesParkQueryVariables = Exact<{
  startTime: Scalars['Float']['input'];
  endTime: Scalars['Float']['input'];
  parkName: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  aggregation?: InputMaybe<TimeseriesAggregation>;
  timezone?: InputMaybe<Scalars['String']['input']>;
}>;


export type RevenuesParkQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', name: string, turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, serialNav: number, serialDisplay: string, code: string }>, groupedDataSeries: { __typename?: 'GroupedDataSeries', WTUR1_revenue_avg: Array<{ __typename?: 'GroupedDataSeriesResult', _id_turbine?: string | null, data?: Array<number | null> | null } | null> } }> };

export type EfficiencyPortfolioQueryVariables = Exact<{
  startTime: Scalars['Float']['input'];
  endTime: Scalars['Float']['input'];
  portfolioId: Scalars['String']['input'];
  parkIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  aggregation?: InputMaybe<TimeseriesAggregation>;
  timezone?: InputMaybe<Scalars['String']['input']>;
}>;


export type EfficiencyPortfolioQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', name: string, parks: Array<{ __typename?: 'Park', _id: string, name: string, fe_name: string, code: string, displayCode?: string | null }>, groupedDataSeries: { __typename?: 'GroupedDataSeries', WTUR1_per_avg_efficiency: Array<{ __typename?: 'GroupedDataSeriesResult', _id_park?: string | null, data?: Array<number | null> | null } | null> } }> };

export type EfficiencyParkQueryVariables = Exact<{
  startTime: Scalars['Float']['input'];
  endTime: Scalars['Float']['input'];
  parkName: Scalars['String']['input'];
  turbines?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  aggregation?: InputMaybe<TimeseriesAggregation>;
  timezone?: InputMaybe<Scalars['String']['input']>;
}>;


export type EfficiencyParkQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', name: string, turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, serialNav: number, serialDisplay: string, code: string }>, groupedDataSeries: { __typename?: 'GroupedDataSeries', WTUR1_per_avg_efficiency: Array<{ __typename?: 'GroupedDataSeriesResult', _id_turbine?: string | null, data?: Array<number | null> | null } | null> } }> };

export type HeatmapQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbine: Scalars['Float']['input'];
  requestedSignals: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type HeatmapQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, serial: string, serialNav: number, ratedPower: number, code: string, analyze: { __typename?: 'Analyze', filteredDataSeriesDeviation?: Array<{ __typename?: 'FilteredMixedDataSeriesDeviation', signalName: string, dataValue: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null, avgValues?: Array<number | null> | null, absValues?: Array<number | null> | null } }> | null } }> };

export type GetTemperatureQueryVariables = Exact<{
  startTime: Scalars['Float']['input'];
  endTime: Scalars['Float']['input'];
  serialNav: Scalars['Float']['input'];
  requestedSignals: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetTemperatureQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', park: { __typename?: 'Park', name: string, turbines: Array<{ __typename?: 'Turbine', _id: string, serialNav: number, code: string }>, filteredGroupedDataSeries: Array<{ __typename?: 'FilteredGroupedDataSeries', signalName: string, groupedData: Array<{ __typename?: 'GroupedDataSeriesResult', startingTS?: number | null, _id_park?: string | null, _id_turbine?: string | null, data?: Array<number | null> | null } | null> }>, analyze: { __typename?: 'Analyze', filteredDataSeries: Array<{ __typename?: 'FilteredGroupedDataSeries', signalName: string, groupedData: Array<{ __typename?: 'GroupedDataSeriesResult', startingTS?: number | null, _id_park?: string | null, _id_turbine?: string | null, data?: Array<number | null> | null } | null> }> } } }> };

export type WindRoseParkQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  period: Scalars['String']['input'];
  turbines?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type WindRoseParkQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', name: string, windRose?: Array<{ __typename?: 'WindRoseDataType', sector?: string | null, values?: Array<number | null> | null } | null> | null }> };

export type WindRoseTurbineQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbine: Scalars['Float']['input'];
  period: Scalars['String']['input'];
}>;


export type WindRoseTurbineQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', name: string, code: string, windRose?: Array<{ __typename?: 'WindRoseDataType', sector?: string | null, values?: Array<number | null> | null } | null> | null }> };

export type WindRoseTurbineFlaggedPointsQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  turbine: Scalars['Float']['input'];
  period: Scalars['String']['input'];
}>;


export type WindRoseTurbineFlaggedPointsQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', windRoseDataQualityFullInfo: { __typename?: 'WindRoseDataQualityFullInfoType', qualityInPercentage: number, totalPoints: number, flaggedPointsCount: number, unflaggedPointsCount: number, flaggedPoints: Array<{ __typename?: 'DataQualityFlaggedPointType', timestamp: number, turbineId: string, flag: string, description: string, windSpeedValue?: number | null } | null> } }> };

export type WindRoseParkFlaggedPointsQueryVariables = Exact<{
  starTs: Scalars['Float']['input'];
  endTs: Scalars['Float']['input'];
  park: Scalars['String']['input'];
  period: Scalars['String']['input'];
  turbines?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type WindRoseParkFlaggedPointsQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', windRoseDataQualityFullInfo: { __typename?: 'WindRoseDataQualityFullInfoType', qualityInPercentage: number, totalPoints: number, flaggedPointsCount: number, unflaggedPointsCount: number, flaggedPoints: Array<{ __typename?: 'DataQualityFlaggedPointType', timestamp: number, turbineId: string, flag: string, description: string, windSpeedValue?: number | null } | null> } }> };

export type GetPortfolioParksBfuQueryVariables = Exact<{
  id: Scalars['String']['input'];
  parkIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetPortfolioParksBfuQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', parks: Array<{ __typename?: 'Park', _id: string }> }> };

export type TotalsFragment = { __typename?: 'EnergyMeterTotals', productionGrid?: number | null, productionGridCount?: number | null, productionScada?: number | null, productionLosses?: number | null, scadaRevenue?: number | null, revenueLosses?: number | null, consumptionLosses?: number | null, totalRevenue?: number | null, marketPrice?: number | null, electricitySalesRevenue?: number | null, incentiveRevenue?: number | null, consumptionGrid?: number | null, marketPriceRevenues?: number | null, referencePrice?: number | null, referencePriceRevenues?: number | null, PPAElectricityPrice?: number | null, incentive?: number | null, totalTariff?: number | null, realizedPPA?: number | null };

export type SeriesTotalsFragment = { __typename?: 'EnergyMeterDataseriesValue', period?: string | null, productionGrid?: number | null, productionGridCount?: number | null, productionScada?: number | null, productionLosses?: number | null, scadaRevenue?: number | null, revenueLosses?: number | null, consumptionLosses?: number | null, totalRevenue?: number | null, marketPrice?: number | null, electricitySalesRevenue?: number | null, incentiveRevenue?: number | null, consumptionGrid?: number | null, marketPriceRevenues?: number | null, referencePrice?: number | null, referencePriceRevenues?: number | null, PPAElectricityPrice?: number | null, incentive?: number | null, totalTariff?: number | null, realizedPPA?: number | null };

export type CheckRevenuesFactsParkByPeriodQueryVariables = Exact<{
  name: Scalars['String']['input'];
  dayFrom: Scalars['Float']['input'];
  dayTo: Scalars['Float']['input'];
  monthFrom: Scalars['Float']['input'];
  monthTo: Scalars['Float']['input'];
  monthToEnd: Scalars['Float']['input'];
  yearFrom: Scalars['Float']['input'];
  yearTo: Scalars['Float']['input'];
  yearToEnd: Scalars['Float']['input'];
}>;


export type CheckRevenuesFactsParkByPeriodQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', _id: string, isGreen: boolean, name: string, fe_name: string, country: { __typename?: 'Country', name: string, code: string }, ratedPower: { __typename?: 'Data', WTUR1_MW_rated?: { __typename?: 'Aggregation', sum?: number | null } | null }, dayTotals?: { __typename?: 'EnergyMeterTotals', lastUpdated?: number | null, productionGrid?: number | null, productionGridCount?: number | null, productionScada?: number | null, productionLosses?: number | null, scadaRevenue?: number | null, revenueLosses?: number | null, consumptionLosses?: number | null, totalRevenue?: number | null, marketPrice?: number | null, electricitySalesRevenue?: number | null, incentiveRevenue?: number | null, consumptionGrid?: number | null, marketPriceRevenues?: number | null, referencePrice?: number | null, referencePriceRevenues?: number | null, PPAElectricityPrice?: number | null, incentive?: number | null, totalTariff?: number | null, realizedPPA?: number | null } | null, monthTotals?: { __typename?: 'EnergyMeterTotals', productionGrid?: number | null, productionGridCount?: number | null, productionScada?: number | null, productionLosses?: number | null, scadaRevenue?: number | null, revenueLosses?: number | null, consumptionLosses?: number | null, totalRevenue?: number | null, marketPrice?: number | null, electricitySalesRevenue?: number | null, incentiveRevenue?: number | null, consumptionGrid?: number | null, marketPriceRevenues?: number | null, referencePrice?: number | null, referencePriceRevenues?: number | null, PPAElectricityPrice?: number | null, incentive?: number | null, totalTariff?: number | null, realizedPPA?: number | null } | null, monthEndTotals?: { __typename?: 'EnergyMeterTotals', productionGrid?: number | null, productionGridCount?: number | null, productionScada?: number | null, productionLosses?: number | null, scadaRevenue?: number | null, revenueLosses?: number | null, consumptionLosses?: number | null, totalRevenue?: number | null, marketPrice?: number | null, electricitySalesRevenue?: number | null, incentiveRevenue?: number | null, consumptionGrid?: number | null, marketPriceRevenues?: number | null, referencePrice?: number | null, referencePriceRevenues?: number | null, PPAElectricityPrice?: number | null, incentive?: number | null, totalTariff?: number | null, realizedPPA?: number | null } | null, yearTotals?: { __typename?: 'EnergyMeterTotals', productionGrid?: number | null, productionGridCount?: number | null, productionScada?: number | null, productionLosses?: number | null, scadaRevenue?: number | null, revenueLosses?: number | null, consumptionLosses?: number | null, totalRevenue?: number | null, marketPrice?: number | null, electricitySalesRevenue?: number | null, incentiveRevenue?: number | null, consumptionGrid?: number | null, marketPriceRevenues?: number | null, referencePrice?: number | null, referencePriceRevenues?: number | null, PPAElectricityPrice?: number | null, incentive?: number | null, totalTariff?: number | null, realizedPPA?: number | null } | null, yearMonthEndTotals?: { __typename?: 'EnergyMeterTotals', productionGrid?: number | null, productionGridCount?: number | null, productionScada?: number | null, productionLosses?: number | null, scadaRevenue?: number | null, revenueLosses?: number | null, consumptionLosses?: number | null, totalRevenue?: number | null, marketPrice?: number | null, electricitySalesRevenue?: number | null, incentiveRevenue?: number | null, consumptionGrid?: number | null, marketPriceRevenues?: number | null, referencePrice?: number | null, referencePriceRevenues?: number | null, PPAElectricityPrice?: number | null, incentive?: number | null, totalTariff?: number | null, realizedPPA?: number | null } | null, yearEndTotals?: { __typename?: 'EnergyMeterTotals', productionGrid?: number | null, productionGridCount?: number | null, productionScada?: number | null, productionLosses?: number | null, scadaRevenue?: number | null, revenueLosses?: number | null, consumptionLosses?: number | null, totalRevenue?: number | null, marketPrice?: number | null, electricitySalesRevenue?: number | null, incentiveRevenue?: number | null, consumptionGrid?: number | null, marketPriceRevenues?: number | null, referencePrice?: number | null, referencePriceRevenues?: number | null, PPAElectricityPrice?: number | null, incentive?: number | null, totalTariff?: number | null, realizedPPA?: number | null } | null }> };

export type CheckRevenuesDataSeriesParkByPeriodQueryVariables = Exact<{
  name: Scalars['String']['input'];
  dayFrom: Scalars['Float']['input'];
  dayTo: Scalars['Float']['input'];
  granularity: TimeGranularityEnum;
  timezone: Scalars['String']['input'];
}>;


export type CheckRevenuesDataSeriesParkByPeriodQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', _id: string, isGreen: boolean, name: string, fe_name: string, country: { __typename?: 'Country', name: string, code: string }, energyMeterDataseries?: Array<{ __typename?: 'EnergyMeterDataseriesValue', neasFee?: number | null, statnettFee?: number | null, estimatedBalancingFee?: number | null, elcertsHedgePrice?: number | null, hedgedPpaCapacity?: number | null, monthlyPpaVolume?: number | null, financialHedge?: number | null, powerHedgePrice?: number | null, ppaPrice?: number | null, ppaRevenue?: number | null, riskPremium?: number | null, period?: string | null, productionGrid?: number | null, productionGridCount?: number | null, productionScada?: number | null, productionLosses?: number | null, scadaRevenue?: number | null, revenueLosses?: number | null, consumptionLosses?: number | null, totalRevenue?: number | null, marketPrice?: number | null, electricitySalesRevenue?: number | null, incentiveRevenue?: number | null, consumptionGrid?: number | null, marketPriceRevenues?: number | null, referencePrice?: number | null, referencePriceRevenues?: number | null, PPAElectricityPrice?: number | null, incentive?: number | null, totalTariff?: number | null, realizedPPA?: number | null } | null> | null }> };

export type CheckRevenuesFactsPortfolioByPeriodQueryVariables = Exact<{
  monthFrom: Scalars['Float']['input'];
  monthTo: Scalars['Float']['input'];
  monthToEnd: Scalars['Float']['input'];
  yearFrom: Scalars['Float']['input'];
  yearTo: Scalars['Float']['input'];
  yearToEnd: Scalars['Float']['input'];
  portfolioId?: InputMaybe<Scalars['String']['input']>;
  parks?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type CheckRevenuesFactsPortfolioByPeriodQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', parks: Array<{ __typename?: 'Park', _id: string, isGreen: boolean, name: string, fe_name: string, code: string, ratedPower: { __typename?: 'Data', WTUR1_MW_rated?: { __typename?: 'Aggregation', sum?: number | null } | null }, country: { __typename?: 'Country', name: string }, monthTotals?: { __typename?: 'EnergyMeterTotals', lastUpdated?: number | null, productionGrid?: number | null, productionGridCount?: number | null, productionScada?: number | null, productionLosses?: number | null, scadaRevenue?: number | null, revenueLosses?: number | null, consumptionLosses?: number | null, totalRevenue?: number | null, marketPrice?: number | null, electricitySalesRevenue?: number | null, incentiveRevenue?: number | null, consumptionGrid?: number | null, marketPriceRevenues?: number | null, referencePrice?: number | null, referencePriceRevenues?: number | null, PPAElectricityPrice?: number | null, incentive?: number | null, totalTariff?: number | null, realizedPPA?: number | null } | null, monthEndTotals?: { __typename?: 'EnergyMeterTotals', productionGrid?: number | null, productionGridCount?: number | null, productionScada?: number | null, productionLosses?: number | null, scadaRevenue?: number | null, revenueLosses?: number | null, consumptionLosses?: number | null, totalRevenue?: number | null, marketPrice?: number | null, electricitySalesRevenue?: number | null, incentiveRevenue?: number | null, consumptionGrid?: number | null, marketPriceRevenues?: number | null, referencePrice?: number | null, referencePriceRevenues?: number | null, PPAElectricityPrice?: number | null, incentive?: number | null, totalTariff?: number | null, realizedPPA?: number | null } | null, yearTotals?: { __typename?: 'EnergyMeterTotals', productionGrid?: number | null, productionGridCount?: number | null, productionScada?: number | null, productionLosses?: number | null, scadaRevenue?: number | null, revenueLosses?: number | null, consumptionLosses?: number | null, totalRevenue?: number | null, marketPrice?: number | null, electricitySalesRevenue?: number | null, incentiveRevenue?: number | null, consumptionGrid?: number | null, marketPriceRevenues?: number | null, referencePrice?: number | null, referencePriceRevenues?: number | null, PPAElectricityPrice?: number | null, incentive?: number | null, totalTariff?: number | null, realizedPPA?: number | null } | null, yearEndTotals?: { __typename?: 'EnergyMeterTotals', productionGrid?: number | null, productionGridCount?: number | null, productionScada?: number | null, productionLosses?: number | null, scadaRevenue?: number | null, revenueLosses?: number | null, consumptionLosses?: number | null, totalRevenue?: number | null, marketPrice?: number | null, electricitySalesRevenue?: number | null, incentiveRevenue?: number | null, consumptionGrid?: number | null, marketPriceRevenues?: number | null, referencePrice?: number | null, referencePriceRevenues?: number | null, PPAElectricityPrice?: number | null, incentive?: number | null, totalTariff?: number | null, realizedPPA?: number | null } | null, yearMonthEndTotals?: { __typename?: 'EnergyMeterTotals', productionGrid?: number | null, productionGridCount?: number | null, productionScada?: number | null, productionLosses?: number | null, scadaRevenue?: number | null, revenueLosses?: number | null, consumptionLosses?: number | null, totalRevenue?: number | null, marketPrice?: number | null, electricitySalesRevenue?: number | null, incentiveRevenue?: number | null, consumptionGrid?: number | null, marketPriceRevenues?: number | null, referencePrice?: number | null, referencePriceRevenues?: number | null, PPAElectricityPrice?: number | null, incentive?: number | null, totalTariff?: number | null, realizedPPA?: number | null } | null }> }> };

export type CheckRevenuesDataSeriesPortfolioByPeriodQueryVariables = Exact<{
  monthFrom: Scalars['Float']['input'];
  monthTo: Scalars['Float']['input'];
  granularity: TimeGranularityEnum;
  timezone: Scalars['String']['input'];
  portfolioId?: InputMaybe<Scalars['String']['input']>;
  parks?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type CheckRevenuesDataSeriesPortfolioByPeriodQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', energyMeterDataseries?: Array<{ __typename?: 'EnergyMeterDataseriesValue', period?: string | null, productionGrid?: number | null, productionGridCount?: number | null, productionScada?: number | null, productionLosses?: number | null, scadaRevenue?: number | null, revenueLosses?: number | null, consumptionLosses?: number | null, totalRevenue?: number | null, marketPrice?: number | null, electricitySalesRevenue?: number | null, incentiveRevenue?: number | null, consumptionGrid?: number | null, marketPriceRevenues?: number | null, referencePrice?: number | null, referencePriceRevenues?: number | null, PPAElectricityPrice?: number | null, incentive?: number | null, totalTariff?: number | null, realizedPPA?: number | null } | null> | null, parks: Array<{ __typename?: 'Park', _id: string, code: string, isGreen: boolean, name: string, fe_name: string }> }> };

export type CheckRevenuesDataSeriesPortfolioByPeriodAndParkQueryVariables = Exact<{
  monthFrom: Scalars['Float']['input'];
  monthTo: Scalars['Float']['input'];
  granularity: TimeGranularityEnum;
  timezone: Scalars['String']['input'];
  portfolioId?: InputMaybe<Scalars['String']['input']>;
  parks?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type CheckRevenuesDataSeriesPortfolioByPeriodAndParkQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', parks: Array<{ __typename?: 'Park', _id: string, code: string, isGreen: boolean, name: string, fe_name: string, energyMeterDataseries?: Array<{ __typename?: 'EnergyMeterDataseriesValue', period?: string | null, productionGrid?: number | null, productionGridCount?: number | null, productionScada?: number | null, productionLosses?: number | null, scadaRevenue?: number | null, revenueLosses?: number | null, consumptionLosses?: number | null, totalRevenue?: number | null, marketPrice?: number | null, electricitySalesRevenue?: number | null, incentiveRevenue?: number | null, consumptionGrid?: number | null, marketPriceRevenues?: number | null, referencePrice?: number | null, referencePriceRevenues?: number | null, PPAElectricityPrice?: number | null, incentive?: number | null, totalTariff?: number | null, realizedPPA?: number | null } | null> | null }> }> };

export type ParksAndCountriesQueryVariables = Exact<{
  portfolioId?: InputMaybe<Scalars['String']['input']>;
  parkIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ParksAndCountriesQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', parks: Array<{ __typename?: 'Park', _id: string, name: string, fe_name: string, code: string, energyMeterAvailable: boolean, country: { __typename?: 'Country', name: string, code: string, country_image: string, energyMeterAvailable: boolean } }> }> };

export type ParksCapturedPriceQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  from: Scalars['Float']['input'];
  to: Scalars['Float']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
}>;


export type ParksCapturedPriceQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', avgCapturedPrice?: Array<{ __typename?: 'AvgCapturedPrice', month: string, avgCapturedPrice?: number | null } | null> | null, avgAreaPrice?: Array<{ __typename?: 'AvgAreaPrice', month: string, avgAreaPrice?: number | null } | null> | null, targetPrice?: Array<{ __typename?: 'TargetPrice', month: number, targetPrice?: number | null } | null> | null, windCaptureRatio?: Array<{ __typename?: 'WindCaptureRatio', month: string, windCaptureRatio?: number | null } | null> | null, targetCaptureRatio?: Array<{ __typename?: 'TargetCaptureRatio', month: number, targetCaptureRatio?: number | null } | null> | null }> };

export type GetParksAndTurbinesDataStudioQueryVariables = Exact<{ [key: string]: never; }>;


export type GetParksAndTurbinesDataStudioQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', name: string, code: string, fe_name: string, data30sAvailable: boolean, energyMeterAvailable: boolean, turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, type: string, serialNav: number, code: string }>, controlSystem?: Array<{ __typename?: 'ControlSystem', _id?: string | null, name?: string | null, code?: string | null }> | null, metmasts?: Array<{ __typename?: 'Metmast', _id?: string | null, name?: string | null, code?: string | null, sensorsList?: Array<{ __typename?: 'MetmastSensor', _id?: string | null, name?: string | null, code?: string | null } | null> | null }> | null }> };

export type AllTurbinesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTurbinesQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, type: string, serialNav: number, code: string }> };

export type GetAllTurbineByTypesDataStudioQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTurbineByTypesDataStudioQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', turbines: Array<{ __typename?: 'Turbine', type: string }> }> };

export type SignalsByTurbineDsQueryVariables = Exact<{
  name: Scalars['String']['input'];
  streamType: Array<InputMaybe<Stream>> | InputMaybe<Stream>;
}>;


export type SignalsByTurbineDsQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', signalsList?: Array<{ __typename?: 'Signal', name?: string | null, displayName?: string | null, displayShortName?: string | null, signalGroupType?: string | null, description?: string | null, unit?: string | null } | null> | null }> };

export type GetSignalsByTurbineTypesQueryVariables = Exact<{
  turbineType: Scalars['String']['input'];
  streamType: Array<InputMaybe<Stream>> | InputMaybe<Stream>;
}>;


export type GetSignalsByTurbineTypesQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, type: string, serialNav: number, code: string, temperature?: Array<{ __typename?: 'Signal', name?: string | null, displayName?: string | null, displayShortName?: string | null, signalGroupType?: string | null, description?: string | null, unit?: string | null } | null> | null, ambient?: Array<{ __typename?: 'Signal', name?: string | null, displayName?: string | null, displayShortName?: string | null, signalGroupType?: string | null, description?: string | null, unit?: string | null } | null> | null, electrical?: Array<{ __typename?: 'Signal', name?: string | null, displayName?: string | null, displayShortName?: string | null, signalGroupType?: string | null, description?: string | null, unit?: string | null } | null> | null, technical?: Array<{ __typename?: 'Signal', name?: string | null, displayName?: string | null, displayShortName?: string | null, signalGroupType?: string | null, description?: string | null, unit?: string | null } | null> | null }> };

export type GetSignalsByParkNameQueryVariables = Exact<{
  parkname: Scalars['String']['input'];
  streamType: Array<InputMaybe<Stream>> | InputMaybe<Stream>;
}>;


export type GetSignalsByParkNameQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, type: string, serialNav: number, code: string, temperature?: Array<{ __typename?: 'Signal', name?: string | null, displayName?: string | null, displayShortName?: string | null, signalGroupType?: string | null, description?: string | null, type?: string | null, unit?: string | null } | null> | null, ambient?: Array<{ __typename?: 'Signal', name?: string | null, displayName?: string | null, displayShortName?: string | null, signalGroupType?: string | null, description?: string | null, type?: string | null, unit?: string | null } | null> | null, electrical?: Array<{ __typename?: 'Signal', name?: string | null, displayName?: string | null, displayShortName?: string | null, signalGroupType?: string | null, description?: string | null, type?: string | null, unit?: string | null } | null> | null, technical?: Array<{ __typename?: 'Signal', name?: string | null, displayName?: string | null, displayShortName?: string | null, signalGroupType?: string | null, description?: string | null, type?: string | null, unit?: string | null } | null> | null }> }> };

export type GetCsSignalsParkNameQueryVariables = Exact<{
  parkname: Scalars['String']['input'];
}>;


export type GetCsSignalsParkNameQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', controlSystem?: Array<{ __typename?: 'ControlSystem', _id?: string | null, code?: string | null, codeDisplay?: string | null, signalsList?: Array<{ __typename?: 'ControlSystemSignal', displayName?: string | null, dbName?: string | null, unit?: string | null } | null> | null }> | null }> };

export type GetMetMastsSignalsParkNameQueryVariables = Exact<{
  parkname: Scalars['String']['input'];
}>;


export type GetMetMastsSignalsParkNameQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', metmasts?: Array<{ __typename?: 'Metmast', _id?: string | null, name?: string | null, code?: string | null, sensorsList?: Array<{ __typename?: 'MetmastSensor', _id?: string | null, _id_metmast?: string | null, name?: string | null, signalsList?: Array<{ __typename?: 'MetmastSensorSignal', dbName?: string | null, displayName?: string | null, unit?: string | null } | null> | null } | null> | null }> | null }> };

export type GetSignalsByTurbineNameQueryVariables = Exact<{
  turbinename: Scalars['String']['input'];
  streamType: Array<InputMaybe<Stream>> | InputMaybe<Stream>;
}>;


export type GetSignalsByTurbineNameQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, type: string, serialNav: number, code: string, temperature?: Array<{ __typename?: 'Signal', name?: string | null, displayName?: string | null, displayShortName?: string | null, signalGroupType?: string | null, description?: string | null, unit?: string | null } | null> | null, ambient?: Array<{ __typename?: 'Signal', name?: string | null, displayName?: string | null, displayShortName?: string | null, signalGroupType?: string | null, description?: string | null, unit?: string | null } | null> | null, electrical?: Array<{ __typename?: 'Signal', name?: string | null, displayName?: string | null, displayShortName?: string | null, signalGroupType?: string | null, description?: string | null, unit?: string | null } | null> | null, technical?: Array<{ __typename?: 'Signal', name?: string | null, displayName?: string | null, displayShortName?: string | null, signalGroupType?: string | null, description?: string | null, unit?: string | null } | null> | null }> };

export type GetMetadataByParkNameQueryVariables = Exact<{
  parkname: Scalars['String']['input'];
}>;


export type GetMetadataByParkNameQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', energyMeterAvailable: boolean, data30sAvailable: boolean, timezone: string, lat: number, lon: number, dataGranularity: number, co2: number, turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, type: string, serialNav: number, modelType: string, diameter: number, hubHeight: number, basementHeight: number, lat: number, lon: number, windSpeedCutIn?: number | null, windSpeedCutOut?: number | null, networkSwitch?: string | null, serial: string, code: string, turbineManufacturer?: { __typename?: 'TurbineManufacturer', name?: string | null } | null }> }> };

export type FileListSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type FileListSubscription = { __typename?: 'Subscription', user?: { __typename?: 'User', dataStudioFiles?: Array<{ __typename?: 'DataStudioFiles', fileName?: string | null, fileSize?: number | null, link?: string | null, state?: number | null, fileType?: string | null, path?: string | null, _id?: string | null, from?: string | null, to?: string | null, params?: string | null, signals?: string | null, queryType?: string | null } | null> | null } | null };

export type FileListNewSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type FileListNewSubscription = { __typename?: 'Subscription', user?: { __typename?: 'User', dataStudioUploadedFiles?: Array<{ __typename?: 'DataStudioUploadedFile', _id: string, originalName: string, fileType: FileTypeEnum, fileName?: string | null, link?: string | null, status: FileTrackerStatus, fileSize?: number | null, queryType: DataStudioQueryType, requestedAt: number, requestedParams: { __typename?: 'FileRequestedParams', signals: Array<string>, translatedSignals: Array<string>, granularity: string, queryType: string, startTS: number, endTS: number } } | null> | null } | null };

export type GetFileRequestStatusQueryVariables = Exact<{
  trackerId: Scalars['ID']['input'];
}>;


export type GetFileRequestStatusQuery = { __typename?: 'Query', dataStudioUploadedFileStatus: { __typename?: 'UploadedFileStatus', status: FileTrackerStatus, fileName?: string | null, link?: string | null } };

export type DeleteFileMutationVariables = Exact<{
  fileLink: Scalars['String']['input'];
}>;


export type DeleteFileMutation = { __typename?: 'Mutation', deleteDataStudioFile: boolean };

export type GetDataAnalysisParkTurbineSignalQueryVariables = Exact<{
  streamType: Array<InputMaybe<Stream>> | InputMaybe<Stream>;
}>;


export type GetDataAnalysisParkTurbineSignalQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', _id: string, name: string, code: string, fe_name: string, data30sAvailable: boolean, signalList?: Array<{ __typename?: 'ParkSignal', _id: string, name: string, displayName: string, unit: string, currency?: boolean | null, signalGroupType: string } | null> | null, turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, type: string, serialNav: number, code: string, signalsList?: Array<{ __typename?: 'Signal', name?: string | null, displayName?: string | null, displayShortName?: string | null, signalGroupType?: string | null, description?: string | null, unit?: string | null } | null> | null }>, controlSystem?: Array<{ __typename?: 'ControlSystem', _id?: string | null, name?: string | null, code?: string | null, fe_name?: string | null, signalsList?: Array<{ __typename?: 'ControlSystemSignal', _id?: string | null, displayName?: string | null, unit?: string | null, name?: string | null } | null> | null }> | null, metmasts?: Array<{ __typename?: 'Metmast', _id?: string | null, name?: string | null, code?: string | null, sensorsList?: Array<{ __typename?: 'MetmastSensor', _id?: string | null, _id_metmast?: string | null, name?: string | null, signalsList?: Array<{ __typename?: 'MetmastSensorSignal', dbName?: string | null, displayName?: string | null, unit?: string | null } | null> | null } | null> | null }> | null }> };

export type GetControlSystemListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetControlSystemListQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', controlSystem?: Array<{ __typename?: 'ControlSystem', _id?: string | null, name?: string | null, code?: string | null, fe_name?: string | null }> | null }> };

export type GetMetmastListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMetmastListQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', metmasts?: Array<{ __typename?: 'Metmast', _id?: string | null, sensorsList?: Array<{ __typename?: 'MetmastSensor', _id?: string | null, name?: string | null } | null> | null }> | null }> };

export type GetQueriesListQueryVariables = Exact<{
  pageSize: Scalars['Int']['input'];
  pageNumber: Scalars['Int']['input'];
  isSharedQuery?: InputMaybe<Scalars['Boolean']['input']>;
  titleFilter?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetQueriesListQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', dataAnalysisQueries: { __typename?: 'DataAnalysisQueryList', totalCount: number, dataAnalysisQueries: Array<{ __typename?: 'DataAnalysisQuery', _id: string, queryNumber: number, title: string, period: DataAnalysisPeriod, granularity: string, startTs: number, endTs: number, assetIds: Array<string | null>, assetIdYs?: Array<string | null> | null, parkIds: Array<string | null>, isSharedQuery: boolean, numberOfSeries: number, createdByUsername: string, queryType: DataAnalysisQueryType, relatedReports?: Array<{ __typename?: 'RelatedReports', reportName: string } | null> | null } | null> } }> };

export type GetQueriesListForReportQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQueriesListForReportQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', dataAnalysisQueries: { __typename?: 'DataAnalysisQueryList', dataAnalysisQueries: Array<{ __typename?: 'DataAnalysisQuery', _id: string, queryNumber: number, title: string, queryType: DataAnalysisQueryType } | null> } }> };

export type GetDataAnalysisQueryDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDataAnalysisQueryDetailsQuery = { __typename?: 'Query', dataAnalysisQuery?: { __typename?: 'DataAnalysisQuery', title: string, period: DataAnalysisPeriod, startTs: number, endTs: number, parkIds: Array<string | null>, assetIds: Array<string | null>, granularity: string, numberOfSeries: number, queryNumber: number, series?: Array<{ __typename?: 'DataAnalysisSeries', assetId: string, assetIdY?: string | null, deviceCode?: string | null, deviceCodeY?: string | null, parkId?: string | null, parkName: string, parkDisplayName: string, deviceType: DeviceType, deviceTypeY?: DeviceType | null, signal: string, signalName: string, signalUnit: string, signalY?: string | null, yAxisMin?: number | null, yAxisMax?: number | null, signalNameY?: string | null, signalUnitY?: string | null, granularity: string, visible: boolean, aggregation: DataAnalysisAggregation, colorHex: string, graphType: string, queryDataType: QueryDataTypeEnum, deviceName: string, deviceNameY?: string | null, graphDataType: string, graphDashStyle?: string | null, graphIsStep?: boolean | null, query_id: string, graphDataMarker: { __typename?: 'GraphDataMarker', symbol?: string | null } } | null> | null } | null };

export type CreateDataAnalysisQueryMutationVariables = Exact<{
  query: CreateDataAnalysisQueryInput;
}>;


export type CreateDataAnalysisQueryMutation = { __typename?: 'Mutation', createDataAnalysisQuery: { __typename?: 'DataAnalysisQuery', _id: string, queryNumber: number, title: string, series?: Array<{ __typename?: 'DataAnalysisSeries', _id: string } | null> | null } };

export type UpdateDataAnalysisQueryMutationVariables = Exact<{
  query: UpdateDataAnalysisQueryInput;
}>;


export type UpdateDataAnalysisQueryMutation = { __typename?: 'Mutation', updateDataAnalysisQuery: boolean };

export type DeleteDataAnalysisQueryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteDataAnalysisQueryMutation = { __typename?: 'Mutation', deleteDataAnalysisQuery: boolean };

export type DeIceSubscriptionVariables = Exact<{
  serialNav: Scalars['Float']['input'];
}>;


export type DeIceSubscription = { __typename?: 'Subscription', turbines: Array<{ __typename?: 'Turbine', deIcingData?: { __typename?: 'DeIce', forecastDuration?: number | null, energyWithBH?: number | null, energyWithoutBH?: number | null, startRHBSNow?: string | null, benefitBH?: number | null, efficiency?: number | null, statusBH?: string | null, bestStartTime?: number | null, prodLossFactor?: number | null, wind_speed?: Array<{ __typename?: 'DeIceDataTS', value?: number | null, timestamp?: number | null } | null> | null, ice_mass_kgm?: Array<{ __typename?: 'DeIceDataTS', value?: number | null, timestamp?: number | null } | null> | null, powerTheor_kW?: Array<{ __typename?: 'DeIceDataTS', value?: number | null, timestamp?: number | null } | null> | null, temperature_celsius?: Array<{ __typename?: 'DeIceDataTS', value?: number | null, timestamp?: number | null } | null> | null, powerWithRBHS_kW?: Array<{ __typename?: 'DeIceDataTS', value?: number | null, timestamp?: number | null } | null> | null, powerWithoutRBHS_kW?: Array<{ __typename?: 'DeIceDataTS', value?: number | null, timestamp?: number | null } | null> | null, referencePC?: Array<{ __typename?: 'ProductionWS', wind_speed?: number | null, power?: number | null } | null> | null, modelledPC?: Array<{ __typename?: 'ProductionWS', wind_speed?: number | null, power?: number | null } | null> | null, production?: Array<{ __typename?: 'ProductionWS', wind_speed?: number | null, power?: number | null } | null> | null, operatingPoint?: Array<{ __typename?: 'OperatingPoint', rawWindSpeed?: number | null, ambientTemperature?: number | null } | null> | null } | null }> };

export type DeIceTurbinesQueryVariables = Exact<{ [key: string]: never; }>;


export type DeIceTurbinesQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', serialNav: number, code: string }> };

export type ActualPowerPortfolioSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ActualPowerPortfolioSubscription = { __typename?: 'Subscription', portfolios: Array<{ __typename?: 'Portfolio', dataSeries: { __typename?: 'DataSeries', WTUR1_MW_avg_mag_f: { __typename?: 'DataSerieResult', data?: Array<number | null> | null, startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null, name?: string | null } } }> };

export type ActualPowerCountrySubscriptionVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type ActualPowerCountrySubscription = { __typename?: 'Subscription', countries: Array<{ __typename?: 'Country', dataSeries?: { __typename?: 'DataSeries', WTUR1_MW_avg_mag_f: { __typename?: 'DataSerieResult', data?: Array<number | null> | null, startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null, name?: string | null } } | null }> };

export type ActualPowerParkSubscriptionVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type ActualPowerParkSubscription = { __typename?: 'Subscription', parks: Array<{ __typename?: 'Park', dataSeries?: { __typename?: 'DataSeries', WTUR1_MW_avg_mag_f: { __typename?: 'DataSerieResult', data?: Array<number | null> | null, startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null, name?: string | null } } | null }> };

export type ActualPowerTurbineSubscriptionVariables = Exact<{
  serialNav: Scalars['Float']['input'];
}>;


export type ActualPowerTurbineSubscription = { __typename?: 'Subscription', turbines: Array<{ __typename?: 'Turbine', dataSeries?: { __typename?: 'DataSeries', WTUR1_MW_avg_mag_f: { __typename?: 'DataSerieResult', data?: Array<number | null> | null, startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null, name?: string | null } } | null }> };

export type WindlogForecastAvailableQueryVariables = Exact<{ [key: string]: never; }>;


export type WindlogForecastAvailableQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', _id: string, name: string, fe_name: string, isWindlogForecastAvailable: boolean, isMeteologicaForecastAvailable: boolean, isDNVForecastAvailable: boolean, country: { __typename?: 'Country', code: string, name: string } }> };

export type FirstAvailableDataTimeStampQueryVariables = Exact<{ [key: string]: never; }>;


export type FirstAvailableDataTimeStampQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', code: string, initialData?: string | null }> };

export type FirstAvailableDataTimeStampByParkQueryVariables = Exact<{
  parkname: Scalars['String']['input'];
}>;


export type FirstAvailableDataTimeStampByParkQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', initialData?: string | null }> };

export type TurbinesMonthlyAvailabilitiesQueryVariables = Exact<{
  startTS: Scalars['Float']['input'];
  endTS: Scalars['Float']['input'];
  _id?: InputMaybe<Scalars['ID']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
}>;


export type TurbinesMonthlyAvailabilitiesQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', turbines: Array<{ __typename?: 'Turbine', code: string, monthlyAvailabilities?: Array<{ __typename?: 'AvailabilityPark', date?: number | null, availabilities?: Array<{ __typename?: 'Availability', name?: string | null, rangeResult?: number | null } | null> | null } | null> | null }> }> };

export type ParksMonthlyAvailabilitiesQueryVariables = Exact<{
  startTS: Scalars['Float']['input'];
  endTS: Scalars['Float']['input'];
  _id?: InputMaybe<Scalars['String']['input']>;
}>;


export type ParksMonthlyAvailabilitiesQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', parks: Array<{ __typename?: 'Park', code: string, monthlyAvailabilities?: Array<{ __typename?: 'AvailabilityPark', date?: number | null, availabilities?: Array<{ __typename?: 'Availability', name?: string | null, rangeResult?: number | null } | null> | null } | null> | null }> }> };

export type AlarmsPortfolioCustomSubscriptionVariables = Exact<{
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
  portfolioId: Scalars['String']['input'];
  hours?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AlarmSortInput>;
  parkIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type AlarmsPortfolioCustomSubscription = { __typename?: 'Subscription', portfolios: Array<{ __typename?: 'Portfolio', alarms?: Array<{ __typename?: 'Alarm', _id: string, createTS?: number | null, closeTS?: number | null, duration?: string | null, code?: string | null, description?: string | null, isOpen: boolean, productionLoss?: number | null, alarmCategory: AlarmCategory, turbine: { __typename?: 'Turbine', _id: string, serialNav: number, code: string } } | null> | null, parks: Array<{ __typename?: 'Park', name: string }> }> };

export type AlarmsPortfolioSubscriptionVariables = Exact<{
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
  parkIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type AlarmsPortfolioSubscription = { __typename?: 'Subscription', portfolios: Array<{ __typename?: 'Portfolio', alarms?: Array<{ __typename?: 'Alarm', _id: string, createTS?: number | null, closeTS?: number | null, duration?: string | null, code?: string | null, description?: string | null, isOpen: boolean, productionLoss?: number | null, alarmCategory: AlarmCategory, turbine: { __typename?: 'Turbine', _id: string, serialNav: number, code: string } } | null> | null, parks: Array<{ __typename?: 'Park', name: string }> }> };

export type AlarmsParkSubscriptionVariables = Exact<{
  name: Scalars['String']['input'];
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AlarmSortInput>;
  turbineIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type AlarmsParkSubscription = { __typename?: 'Subscription', parks: Array<{ __typename?: 'Park', alarms?: Array<{ __typename?: 'Alarm', _id: string, createTS?: number | null, closeTS?: number | null, duration?: string | null, code?: string | null, description?: string | null, isOpen: boolean, productionLoss?: number | null, alarmCategory: AlarmCategory, turbine: { __typename?: 'Turbine', _id: string, serialNav: number, code: string } } | null> | null, turbines: Array<{ __typename?: 'Turbine', name: string }> }> };

export type AlarmsTurbineSubscriptionVariables = Exact<{
  serialNav: Scalars['Float']['input'];
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AlarmSortInput>;
}>;


export type AlarmsTurbineSubscription = { __typename?: 'Subscription', turbines: Array<{ __typename?: 'Turbine', alarms: Array<{ __typename?: 'Alarm', _id: string, createTS?: number | null, closeTS?: number | null, duration?: string | null, code?: string | null, description?: string | null, isOpen: boolean, productionLoss?: number | null, alarmCategory: AlarmCategory, turbine: { __typename?: 'Turbine', _id: string, serialNav: number, code: string } } | null> }> };

export type AlarmsPortfolioReportQueryVariables = Exact<{
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AlarmsPortfolioReportQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', alarms?: Array<{ __typename?: 'Alarm', _id: string, createTS?: number | null, closeTS?: number | null, duration?: string | null, code?: string | null, description?: string | null, isOpen: boolean, productionLoss?: number | null, alarmCategory: AlarmCategory, turbine: { __typename?: 'Turbine', _id: string, serialNav: number, code: string } } | null> | null, parks: Array<{ __typename?: 'Park', name: string }> }> };

export type AlarmsParkReportQueryVariables = Exact<{
  name: Scalars['String']['input'];
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AlarmSortInput>;
}>;


export type AlarmsParkReportQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', alarms?: Array<{ __typename?: 'Alarm', _id: string, createTS?: number | null, closeTS?: number | null, duration?: string | null, code?: string | null, description?: string | null, isOpen: boolean, productionLoss?: number | null, alarmCategory: AlarmCategory, turbine: { __typename?: 'Turbine', _id: string, serialNav: number, code: string } } | null> | null, turbines: Array<{ __typename?: 'Turbine', name: string }> }> };

export type AlarmsTurbineReportQueryVariables = Exact<{
  serialNav: Scalars['Float']['input'];
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AlarmSortInput>;
}>;


export type AlarmsTurbineReportQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', alarms: Array<{ __typename?: 'Alarm', _id: string, createTS?: number | null, closeTS?: number | null, duration?: string | null, code?: string | null, description?: string | null, isOpen: boolean, productionLoss?: number | null, alarmCategory: AlarmCategory, turbine: { __typename?: 'Turbine', _id: string, serialNav: number, code: string } } | null> }> };

export type BudgetFollowUpPortfolioQueryVariables = Exact<{
  portfolioId: Scalars['String']['input'];
  year: Scalars['Int']['input'];
  parksIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type BudgetFollowUpPortfolioQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', name: string, budget?: Array<{ __typename?: 'BudgetFollowUp', month?: number | null, budget?: { __typename?: 'BudgetTotalData', production?: { __typename?: 'TotalValue', total?: { __typename?: 'NumberObject', value?: number | null } | null } | null } | null, total?: { __typename?: 'BudgetTotalData', production?: { __typename?: 'TotalValue', total?: { __typename?: 'NumberObject', value?: number | null } | null } | null } | null, delivered?: { __typename?: 'Delivered', scada?: { __typename?: 'BudgetData', production?: { __typename?: 'BudgetValue', total?: { __typename?: 'NumberObject', value?: number | null } | null } | null } | null } | null } | null> | null }> };

export type BudgetFollowUpParkQueryVariables = Exact<{
  name: Scalars['String']['input'];
  year: Scalars['Int']['input'];
}>;


export type BudgetFollowUpParkQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', name: string, budget2?: Array<{ __typename?: 'BudgetFollowUp', month?: number | null, budget?: { __typename?: 'BudgetTotalData', production?: { __typename?: 'TotalValue', total?: { __typename?: 'NumberObject', value?: number | null } | null } | null } | null, total?: { __typename?: 'BudgetTotalData', production?: { __typename?: 'TotalValue', total?: { __typename?: 'NumberObject', value?: number | null } | null } | null } | null, delivered?: { __typename?: 'Delivered', scada?: { __typename?: 'BudgetData', production?: { __typename?: 'BudgetValue', total?: { __typename?: 'NumberObject', value?: number | null } | null } | null } | null } | null } | null> | null }> };

export type BudgetFollowUpTurbineMonitorQueryVariables = Exact<{
  serialNav: Scalars['Float']['input'];
  year: Scalars['Int']['input'];
}>;


export type BudgetFollowUpTurbineMonitorQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', name: string, park: { __typename?: 'Park', turbines: Array<{ __typename?: 'Turbine', name: string }>, budget2?: Array<{ __typename?: 'BudgetFollowUp', month?: number | null, budget?: { __typename?: 'BudgetTotalData', production?: { __typename?: 'TotalValue', total?: { __typename?: 'NumberObject', value?: number | null } | null } | null } | null, total?: { __typename?: 'BudgetTotalData', production?: { __typename?: 'TotalValue', total?: { __typename?: 'NumberObject', value?: number | null } | null } | null } | null, delivered?: { __typename?: 'Delivered', scada?: { __typename?: 'BudgetData', production?: { __typename?: 'BudgetValue', total?: { __typename?: 'NumberObject', value?: number | null } | null } | null } | null } | null } | null> | null } }> };

export type BudgetFollowUpTurbineQueryVariables = Exact<{
  serialNav: Scalars['Float']['input'];
}>;


export type BudgetFollowUpTurbineQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', name: string }> };

export type BudgetFollowUpReportModuleQueryVariables = Exact<{
  actualYear: Scalars['Int']['input'];
  lastYear: Scalars['Int']['input'];
}>;


export type BudgetFollowUpReportModuleQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', name: string, fe_name: string, code: string, country: { __typename?: 'Country', code: string }, actual?: Array<{ __typename?: 'BudgetFollowUp', budget?: { __typename?: 'BudgetTotalData', production?: { __typename?: 'TotalValue', total?: { __typename?: 'NumberObject', value?: number | null } | null } | null, revenue?: { __typename?: 'TotalValue', total?: { __typename?: 'NumberObject', value?: number | null } | null } | null } | null, delivered?: { __typename?: 'Delivered', production?: { __typename?: 'BudgetTotalValue', total?: { __typename?: 'NumberObject', value?: number | null } | null } | null, revenue?: { __typename?: 'BudgetTotalValue', total?: { __typename?: 'NumberObject', value?: number | null } | null } | null } | null, theoretical?: { __typename?: 'BudgetTotalData', production?: { __typename?: 'TotalValue', total?: { __typename?: 'NumberObject', value?: number | null } | null } | null, revenue?: { __typename?: 'TotalValue', total?: { __typename?: 'NumberObject', value?: number | null } | null } | null } | null } | null> | null, last?: Array<{ __typename?: 'BudgetFollowUp', budget?: { __typename?: 'BudgetTotalData', production?: { __typename?: 'TotalValue', total?: { __typename?: 'NumberObject', value?: number | null } | null } | null, revenue?: { __typename?: 'TotalValue', total?: { __typename?: 'NumberObject', value?: number | null } | null } | null } | null, delivered?: { __typename?: 'Delivered', production?: { __typename?: 'BudgetTotalValue', total?: { __typename?: 'NumberObject', value?: number | null } | null } | null, revenue?: { __typename?: 'BudgetTotalValue', total?: { __typename?: 'NumberObject', value?: number | null } | null } | null } | null, theoretical?: { __typename?: 'BudgetTotalData', production?: { __typename?: 'TotalValue', total?: { __typename?: 'NumberObject', value?: number | null } | null } | null, revenue?: { __typename?: 'TotalValue', total?: { __typename?: 'NumberObject', value?: number | null } | null } | null } | null } | null> | null }> };

export type CmsAlarmsPortfolioCustomSubscriptionVariables = Exact<{
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  portfolioId: Scalars['String']['input'];
  parkIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type CmsAlarmsPortfolioCustomSubscription = { __typename?: 'Subscription', portfolios: Array<{ __typename?: 'Portfolio', parks: Array<{ __typename?: 'Park', name: string }>, cmsAlarms?: Array<{ __typename?: 'CmsAlarm', signal?: string | null, signalName?: string | null, turbineCode?: string | null, turbineSerial?: string | null, trend?: string | null, deviation?: number | null, tempAvg?: number | null, temp?: number | null, detectionTS?: number | null, turbineSerialNav?: number | null } | null> | null }> };

export type CmsAlarmsPortfolioSubscriptionVariables = Exact<{
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
  startTS?: InputMaybe<Scalars['Float']['input']>;
  endTS?: InputMaybe<Scalars['Float']['input']>;
  parkIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type CmsAlarmsPortfolioSubscription = { __typename?: 'Subscription', portfolios: Array<{ __typename?: 'Portfolio', parks: Array<{ __typename?: 'Park', name: string }>, cmsAlarms?: Array<{ __typename?: 'CmsAlarm', signal?: string | null, signalName?: string | null, turbineCode?: string | null, turbineSerial?: string | null, trend?: string | null, deviation?: number | null, tempAvg?: number | null, temp?: number | null, detectionTS?: number | null, turbineSerialNav?: number | null } | null> | null }> };

export type CmsAlarmsParkSubscriptionVariables = Exact<{
  name: Scalars['String']['input'];
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  turbineIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type CmsAlarmsParkSubscription = { __typename?: 'Subscription', parks: Array<{ __typename?: 'Park', cmsAlarms?: Array<{ __typename?: 'CmsAlarm', signal?: string | null, signalName?: string | null, turbineCode?: string | null, turbineSerial?: string | null, trend?: string | null, deviation?: number | null, tempAvg?: number | null, temp?: number | null, detectionTS?: number | null, turbineSerialNav?: number | null } | null> | null, turbines: Array<{ __typename?: 'Turbine', name: string }> }> };

export type CmsAlarmsTurbineSubscriptionVariables = Exact<{
  serialNav: Scalars['Float']['input'];
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CmsAlarmsTurbineSubscription = { __typename?: 'Subscription', turbines: Array<{ __typename?: 'Turbine', cmsAlarms?: Array<{ __typename?: 'CmsAlarm', signal?: string | null, signalName?: string | null, turbineCode?: string | null, turbineSerial?: string | null, trend?: string | null, deviation?: number | null, tempAvg?: number | null, temp?: number | null, detectionTS?: number | null, turbineSerialNav?: number | null } | null> | null }> };

export type CmsAlarmsPortfolioReportQueryVariables = Exact<{
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
  startTS?: InputMaybe<Scalars['Float']['input']>;
  endTS?: InputMaybe<Scalars['Float']['input']>;
  portfolioId: Scalars['String']['input'];
}>;


export type CmsAlarmsPortfolioReportQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', parks: Array<{ __typename?: 'Park', name: string }>, cmsAlarms?: Array<{ __typename?: 'CmsAlarm', signal?: string | null, signalName?: string | null, turbineCode?: string | null, turbineSerial?: string | null, trend?: string | null, deviation?: number | null, tempAvg?: number | null, temp?: number | null, detectionTS?: number | null, turbineSerialNav?: number | null } | null> | null }> };

export type CmsAlarmsParkReportQueryVariables = Exact<{
  name: Scalars['String']['input'];
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
  startTS?: InputMaybe<Scalars['Float']['input']>;
  endTS?: InputMaybe<Scalars['Float']['input']>;
  turbineIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type CmsAlarmsParkReportQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', cmsAlarms?: Array<{ __typename?: 'CmsAlarm', signal?: string | null, signalName?: string | null, turbineCode?: string | null, turbineSerial?: string | null, trend?: string | null, deviation?: number | null, tempAvg?: number | null, temp?: number | null, detectionTS?: number | null, turbineSerialNav?: number | null } | null> | null, turbines: Array<{ __typename?: 'Turbine', name: string }> }> };

export type ComponentModelSubscriptionVariables = Exact<{
  serialNav: Scalars['Float']['input'];
}>;


export type ComponentModelSubscription = { __typename?: 'Subscription', turbines: Array<{ __typename?: 'Turbine', name: string, serialNav: number, type: string, modelType: string, code: string, componentModel?: Array<{ __typename?: 'TurbineComponent', id?: string | null, name?: string | null, alarms?: Array<{ __typename?: 'ComponentAlarm', signal?: string | null, signalName?: string | null, temp?: number | null, tempAvg?: number | null, deviation?: number | null } | null> | null } | null> | null }> };

export type TurbineSignalsQueryVariables = Exact<{
  serialNav: Scalars['Float']['input'];
}>;


export type TurbineSignalsQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', serialNav: number, code: string, signalsList?: Array<{ __typename?: 'Signal', name?: string | null, displayName?: string | null } | null> | null }> };

export type TurbineSignalDataSeriesSubscriptionVariables = Exact<{
  serialNav: Scalars['Float']['input'];
  signal: Scalars['String']['input'];
  hours: Scalars['Int']['input'];
}>;


export type TurbineSignalDataSeriesSubscription = { __typename?: 'Subscription', turbines: Array<{ __typename?: 'Turbine', reference: { __typename?: 'Reference', turbineSubTypes: Array<{ __typename?: 'TurbineSubType', componentConditionDataSeries?: { __typename?: 'ComponentConditionAllData', data?: Array<number | null> | null } | null }> }, parkSubType: { __typename?: 'ParkSubType', turbines: Array<{ __typename?: 'Turbine', serialNav: number, code: string, componentConditionDataSeries?: { __typename?: 'ComponentConditionAllData', name?: string | null, startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null, data?: Array<number | null> | null } | null }> } }> };

export type ConditionComponentSubscriptionVariables = Exact<{
  serialNav: Scalars['Float']['input'];
}>;


export type ConditionComponentSubscription = { __typename?: 'Subscription', turbines: Array<{ __typename?: 'Turbine', parkSubType: { __typename?: 'ParkSubType', turbines: Array<{ __typename?: 'Turbine', serialNav: number, code: string, componentCondition?: Array<{ __typename?: 'ComponentConditionResp', name?: string | null, deviation?: number | null, status?: number | null } | null> | null }> } }> };

export type MapPortfolioSubscriptionVariables = Exact<{
  portfolioId: Scalars['String']['input'];
  parkIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type MapPortfolioSubscription = { __typename?: 'Subscription', portfolios: Array<{ __typename?: 'Portfolio', parks: Array<{ __typename?: 'Park', name: string, fe_name: string, code: string, displayCode?: string | null, lat: number, lon: number, dataDebbug: { __typename?: 'Data', WTUR1_W_rated?: { __typename?: 'Aggregation', sum?: number | null } | null }, data: { __typename?: 'Data', WTUR1_status?: { __typename?: 'Aggregation', min?: number | null } | null, WTUR1_W_mag_f?: { __typename?: 'Aggregation', sum?: number | null } | null, WTUR1_W_loss?: { __typename?: 'Aggregation', sum?: number | null } | null, WTUR1_W_rated?: { __typename?: 'Aggregation', sum?: number | null } | null, WTUR1_W_theoretical?: { __typename?: 'Aggregation', sum?: number | null } | null }, turbines: Array<{ __typename?: 'Turbine', name: string, serial: string, hubHeight: number, serialNav: number, type: string, code: string, data?: { __typename?: 'RawData', WTUR1_status?: number | null } | null }> }> }> };

export type MapParkSubscriptionVariables = Exact<{
  name: Scalars['String']['input'];
  turbineIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type MapParkSubscription = { __typename?: 'Subscription', parks: Array<{ __typename?: 'Park', lat: number, lon: number, fe_name: string, name: string, code: string, portfolio: { __typename?: 'Portfolio', name: string }, data: { __typename?: 'Data', WNAC1_WdDir_mag_f?: { __typename?: 'Aggregation', avg?: number | null } | null, WNAC1_Dir_mag_f?: { __typename?: 'Aggregation', avg?: number | null } | null }, turbines: Array<{ __typename?: 'Turbine', lat: number, lon: number, serial: string, serialNav: number, serialDisplay: string, code: string, data?: { __typename?: 'RawData', WTUR1_W_mag_f?: number | null, WTUR1_status?: number | null, WNAC1_Dir_mag_f?: number | null, WTUR1_W_theoretical?: number | null, WNAC1_WdDir_mag_f?: number | null, WNAC1_WdSpd_mag_f?: number | null, WROT1_RotSpd_mag_f?: number | null } | null }> }> };

export type OverviewPortfolioSubscriptionVariables = Exact<{
  portfolioId: Scalars['String']['input'];
  parkIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type OverviewPortfolioSubscription = { __typename?: 'Subscription', portfolios: Array<{ __typename?: 'Portfolio', parks: Array<{ __typename?: 'Park', name: string, fe_name: string, currentWeather?: { __typename?: 'IconWeather', icon?: string | null } | null, metaData: { __typename?: 'MetaData', dataAquisitionMax?: { __typename?: 'Date', unixTimestamp?: number | null } | null }, dataDebbug: { __typename?: 'Data', WTUR1_MW_rated?: { __typename?: 'Aggregation', sum?: number | null } | null }, data: { __typename?: 'Data', WTUR1_MW_theoretical?: { __typename?: 'Aggregation', sum?: number | null } | null, WTUR1_MW_mag_f?: { __typename?: 'Aggregation', sum?: number | null } | null, WNAC1_WdSpd_mag_f?: { __typename?: 'Aggregation', avg?: number | null } | null, WNAC1_WdDir_mag_f?: { __typename?: 'Aggregation', avg?: number | null } | null, WNAC1_ExTmp_mag_f?: { __typename?: 'Aggregation', avg?: number | null } | null, WTUR1_MW_loss?: { __typename?: 'Aggregation', sum?: number | null } | null, WTUR1_per_efficiency?: { __typename?: 'Aggregation', avg?: number | null } | null, WTUR1_per_loadFactor?: { __typename?: 'Aggregation', avg?: number | null } | null, WNAC1_Dir_mag_f?: { __typename?: 'Aggregation', avg?: number | null } | null, WTUR1_status?: { __typename?: 'Aggregation', min?: number | null } | null }, turbines: Array<{ __typename?: 'Turbine', data?: { __typename?: 'RawData', WTUR1_status?: number | null } | null }> }> }> };

export type OverviewParkSubscriptionVariables = Exact<{
  name: Scalars['String']['input'];
  turbineIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type OverviewParkSubscription = { __typename?: 'Subscription', parks: Array<{ __typename?: 'Park', data: { __typename?: 'Data', WNAC1_WdDir_mag_f?: { __typename?: 'Aggregation', avg?: number | null } | null }, turbines: Array<{ __typename?: 'Turbine', serialNav: number, serialDisplay: string, code: string, metaData: { __typename?: 'MetaData', dataAquisitionMax?: { __typename?: 'Date', unixTimestamp?: number | null } | null }, data?: { __typename?: 'RawData', WTUR1_MW_theoretical?: number | null, WTUR1_kW_theoretical?: number | null, WTUR1_MW_rated?: number | null, WTUR1_kW_rated?: number | null, WTUR1_MW_mag_f?: number | null, WTUR1_kW_mag_f?: number | null, WNAC1_WdSpd_mag_f?: number | null, WNAC1_WdDir_mag_f?: number | null, WNAC1_ExTmp_mag_f?: number | null, WTUR1_per_loadFactor?: number | null, WTUR1_per_efficiency?: number | null, WTUR1_MW_loss?: number | null, WTUR1_kW_loss?: number | null, WTUR1_status?: number | null, LDAT1_TmUTC_setTm?: string | null, WNAC1_Dir_mag_f?: number | null } | null }> }> };

export type PerformanceFactsPortfolioSubscriptionVariables = Exact<{
  portfolioId: Scalars['String']['input'];
  parksIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type PerformanceFactsPortfolioSubscription = { __typename?: 'Subscription', portfolios: Array<{ __typename?: 'Portfolio', totalSignalCount: number, availableSignalCount: number, data: { __typename?: 'Data', WTUR1_MW_theoretical?: { __typename?: 'Aggregation', sum?: number | null } | null, WTUR1_MW_rated?: { __typename?: 'Aggregation', sum?: number | null } | null, WTUR1_MW_mag_f?: { __typename?: 'Aggregation', sum?: number | null } | null, WTUR1_MW_loss?: { __typename?: 'Aggregation', sum?: number | null } | null, WTUR1_per_loadFactor?: { __typename?: 'Aggregation', avg?: number | null } | null }, dataDebbug: { __typename?: 'Data', WTUR1_MW_rated?: { __typename?: 'Aggregation', sum?: number | null } | null }, metaData: { __typename?: 'MetaData', dataAquisitionMax?: { __typename?: 'Date', unixTimestamp?: number | null } | null } }> };

export type PerformanceFactsParkSubscriptionVariables = Exact<{
  name: Scalars['String']['input'];
  turbineIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type PerformanceFactsParkSubscription = { __typename?: 'Subscription', parks: Array<{ __typename?: 'Park', totalSignalCount: number, availableSignalCount: number, fe_name: string, data: { __typename?: 'Data', WTUR1_MW_theoretical?: { __typename?: 'Aggregation', sum?: number | null } | null, WTUR1_MW_rated?: { __typename?: 'Aggregation', sum?: number | null } | null, WTUR1_MW_mag_f?: { __typename?: 'Aggregation', sum?: number | null } | null, WTUR1_MW_loss?: { __typename?: 'Aggregation', sum?: number | null } | null, WTUR1_per_efficiency?: { __typename?: 'Aggregation', avg?: number | null } | null, WTUR1_per_loadFactor?: { __typename?: 'Aggregation', avg?: number | null } | null }, dataDebbug: { __typename?: 'Data', WTUR1_MW_rated?: { __typename?: 'Aggregation', sum?: number | null } | null }, metaData: { __typename?: 'MetaData', dataAquisitionMax?: { __typename?: 'Date', unixTimestamp?: number | null } | null } }> };

export type PerformanceFactsTurbineSubscriptionVariables = Exact<{
  serialNav: Scalars['Float']['input'];
}>;


export type PerformanceFactsTurbineSubscription = { __typename?: 'Subscription', turbines: Array<{ __typename?: 'Turbine', name: string, serial: string, serialNav: number, code: string, data?: { __typename?: 'RawData', WTUR1_TurSt_actSt_stVal?: number | null, WTUR1_kW_theoretical?: number | null, WTUR1_kW_rated?: number | null, WTUR1_kW_mag_f?: number | null, WTUR1_kW_loss?: number | null, WTUR1_per_efficiency?: number | null, WTUR1_per_loadFactor?: number | null, WTUR1_status?: number | null, LPHD1_PhyHealth_stVal?: number | null, WNAC1_WdSpd_mag_f?: number | null } | null, dataDebbug?: { __typename?: 'RawData', WTUR1_kW_rated?: number | null } | null, park: { __typename?: 'Park', turbines: Array<{ __typename?: 'Turbine', code: string, serial: string, serialNav: number }> } }> };

export type PerformanceMonitoringPortfolioSubscriptionVariables = Exact<{
  hours: Scalars['Int']['input'];
  portfolioId: Scalars['String']['input'];
  parkIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type PerformanceMonitoringPortfolioSubscription = { __typename?: 'Subscription', portfolios: Array<{ __typename?: 'Portfolio', totalSignalCount: number, availableSignalCount: number, metaData: { __typename?: 'MetaData', dataAquisitionMax?: { __typename?: 'Date', unixTimestamp?: number | null } | null }, dataDebbug: { __typename?: 'Data', WTUR1_MW_rated?: { __typename?: 'Aggregation', sum?: number | null } | null }, data: { __typename?: 'Data', WTUR1_MW_rated?: { __typename?: 'Aggregation', sum?: number | null } | null }, dataSeries: { __typename?: 'DataSeries', turbinesAvailable: { __typename?: 'DataSerieResult', data?: Array<number | null> | null } }, analyze: { __typename?: 'Analyze', performanceDataSeriesDifferentSources: { __typename?: 'MixedGroupedDataSeries', WTUR1_W_avg_theoretical: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null, intervalTS?: number | null, startingTS?: number | null, lastTS?: number | null }, WTUR1_W_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null, startingTS?: number | null, intervalTS?: number | null, lastTS?: number | null } } }, alarms?: Array<{ __typename?: 'Alarm', _id_alarm?: string | null, closeTS?: number | null, createTS?: number | null, code?: string | null, description?: string | null, alarmCategory: AlarmCategory, isOpen: boolean, turbine: { __typename?: 'Turbine', serialNav: number, code: string } } | null> | null }> };

export type PerformanceMonitoringParkSubscriptionVariables = Exact<{
  name: Scalars['String']['input'];
  hours: Scalars['Int']['input'];
  turbineIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type PerformanceMonitoringParkSubscription = { __typename?: 'Subscription', parks: Array<{ __typename?: 'Park', totalSignalCount: number, availableSignalCount: number, metaData: { __typename?: 'MetaData', dataAquisitionMax?: { __typename?: 'Date', unixTimestamp?: number | null } | null }, dataDebbug: { __typename?: 'Data', WTUR1_MW_rated?: { __typename?: 'Aggregation', sum?: number | null } | null }, data: { __typename?: 'Data', WTUR1_MW_rated?: { __typename?: 'Aggregation', sum?: number | null } | null }, analyze: { __typename?: 'Analyze', performanceDataSeriesDifferentSources: { __typename?: 'MixedGroupedDataSeries', WTUR1_W_avg_theoretical: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null, intervalTS?: number | null, startingTS?: number | null, lastTS?: number | null }, WTUR1_W_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null, startingTS?: number | null, intervalTS?: number | null, lastTS?: number | null } } }, dataSeries?: { __typename?: 'DataSeries', turbinesAvailable: { __typename?: 'DataSerieResult', data?: Array<number | null> | null }, WEATHER_Park_history_icon: { __typename?: 'IconDataSerieResult', data?: Array<string | null> | null }, WNAC1_ExTmp_avg_mag_f: { __typename?: 'DataSerieResult', data?: Array<number | null> | null }, WNAC1_WdSpd_avg_mag_f: { __typename?: 'DataSerieResult', data?: Array<number | null> | null }, WNAC1_WdDir_avg_mag_f: { __typename?: 'DataSerieResult', data?: Array<number | null> | null } } | null, alarms?: Array<{ __typename?: 'Alarm', _id_alarm?: string | null, closeTS?: number | null, createTS?: number | null, code?: string | null, description?: string | null, alarmCategory: AlarmCategory, isOpen: boolean, turbine: { __typename?: 'Turbine', serialNav: number, code: string } } | null> | null }> };

export type PerformanceMonitoringTurbineSubscriptionVariables = Exact<{
  serialNav: Scalars['Float']['input'];
  hours: Scalars['Int']['input'];
}>;


export type PerformanceMonitoringTurbineSubscription = { __typename?: 'Subscription', turbines: Array<{ __typename?: 'Turbine', code: string, data?: { __typename?: 'RawData', WTUR1_kW_rated?: number | null } | null, dataDebbug?: { __typename?: 'RawData', WTUR1_kW_rated?: number | null } | null, analyze: { __typename?: 'Analyze', performanceDataSeriesDifferentSources: { __typename?: 'MixedGroupedDataSeries', WTUR1_W_avg_theoretical: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null, intervalTS?: number | null, startingTS?: number | null, lastTS?: number | null }, WTUR1_W_avg_mag_f: { __typename?: 'SignalGroupedDataSeriesResult', data?: Array<number | null> | null, startingTS?: number | null, intervalTS?: number | null, lastTS?: number | null } } }, alarms: Array<{ __typename?: 'Alarm', _id_alarm?: string | null, closeTS?: number | null, createTS?: number | null, code?: string | null, description?: string | null, alarmCategory: AlarmCategory, isOpen: boolean, turbine: { __typename?: 'Turbine', serialNav: number, code: string } } | null>, dataSeries?: { __typename?: 'DataSeries', WNAC1_WdSpd_avg_mag_f: { __typename?: 'DataSerieResult', data?: Array<number | null> | null } } | null }> };

export type PowerForecastPortfolioOldSubscriptionVariables = Exact<{
  hours: Scalars['Int']['input'];
  parkIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type PowerForecastPortfolioOldSubscription = { __typename?: 'Subscription', portfolios: Array<{ __typename?: 'Portfolio', dataDebbug: { __typename?: 'Data', WTUR1_MW_rated?: { __typename?: 'Aggregation', sum?: number | null } | null }, data: { __typename?: 'Data', WTUR1_MW_rated?: { __typename?: 'Aggregation', sum?: number | null } | null }, dataSeries: { __typename?: 'DataSeries', theoPower: { __typename?: 'DataSerieResult', data?: Array<number | null> | null, intervalTS?: number | null, startingTS?: number | null, lastTS?: number | null } } }> };

export type PowerForecastPortfolioSubscriptionVariables = Exact<{
  hours: Scalars['Int']['input'];
  provider: Array<InputMaybe<ForecastProvidersEnum>> | InputMaybe<ForecastProvidersEnum>;
  portfolioId: Scalars['String']['input'];
  parkIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type PowerForecastPortfolioSubscription = { __typename?: 'Subscription', portfolios: Array<{ __typename?: 'Portfolio', dataDebbug: { __typename?: 'Data', WTUR1_MW_rated?: { __typename?: 'Aggregation', sum?: number | null } | null }, data: { __typename?: 'Data', WTUR1_MW_rated?: { __typename?: 'Aggregation', sum?: number | null } | null }, forecastDataSeries?: { __typename?: 'ForecastDataSeries', theoPower?: Array<{ __typename?: 'DataSerieResult', provider?: string | null, data?: Array<number | null> | null, intervalTS?: number | null, startingTS?: number | null, lastTS?: number | null }> | null } | null }> };

export type PowerForecastParkSubscriptionVariables = Exact<{
  name: Scalars['String']['input'];
  hours: Scalars['Int']['input'];
  provider: Array<InputMaybe<ForecastProvidersEnum>> | InputMaybe<ForecastProvidersEnum>;
  turbineIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type PowerForecastParkSubscription = { __typename?: 'Subscription', parks: Array<{ __typename?: 'Park', name: string, dataDebbug: { __typename?: 'Data', WTUR1_MW_rated?: { __typename?: 'Aggregation', sum?: number | null } | null }, data: { __typename?: 'Data', WTUR1_MW_rated?: { __typename?: 'Aggregation', sum?: number | null } | null }, forecastDataSeries?: { __typename?: 'ForecastDataSeries', theoPower?: Array<{ __typename?: 'DataSerieResult', provider?: string | null, data?: Array<number | null> | null, startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null }> | null, windSpd?: Array<{ __typename?: 'DataSerieResult', data?: Array<number | null> | null, startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null }> | null, temp?: Array<{ __typename?: 'DataSerieResult', data?: Array<number | null> | null, startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null }> | null, windDir?: Array<{ __typename?: 'DataSerieResult', data?: Array<number | null> | null, startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null }> | null } | null }> };

export type PowerForecastParkOldSubscriptionVariables = Exact<{
  name: Scalars['String']['input'];
  hours: Scalars['Int']['input'];
  turbineIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type PowerForecastParkOldSubscription = { __typename?: 'Subscription', parks: Array<{ __typename?: 'Park', name: string, dataDebbug: { __typename?: 'Data', WTUR1_MW_rated?: { __typename?: 'Aggregation', sum?: number | null } | null }, data: { __typename?: 'Data', WTUR1_MW_rated?: { __typename?: 'Aggregation', sum?: number | null } | null }, dataSeries?: { __typename?: 'DataSeries', windSpd: { __typename?: 'DataSerieResult', data?: Array<number | null> | null, startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null }, temp: { __typename?: 'DataSerieResult', data?: Array<number | null> | null, startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null }, icon: { __typename?: 'IconDataSerieResult', data?: Array<string | null> | null, startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null }, theoPower: { __typename?: 'DataSerieResult', data?: Array<number | null> | null, startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null }, windDir: { __typename?: 'DataSerieResult', data?: Array<number | null> | null, startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null } } | null }> };

export type IconForecastParkSubscriptionVariables = Exact<{
  name: Scalars['String']['input'];
  hours: Scalars['Int']['input'];
  turbineIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type IconForecastParkSubscription = { __typename?: 'Subscription', parks: Array<{ __typename?: 'Park', forecastDataSeries?: { __typename?: 'ForecastDataSeries', icon?: Array<{ __typename?: 'IconDataSerieResult', data?: Array<string | null> | null, startingTS?: number | null, lastTS?: number | null, intervalTS?: number | null }> | null } | null }> };

export type TurbineCockpitSubscriptionVariables = Exact<{
  serialNav: Scalars['Float']['input'];
  requestedSignals: Array<Scalars['String']['input']> | Scalars['String']['input'];
  requestedTtempSignals: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type TurbineCockpitSubscription = { __typename?: 'Subscription', turbines: Array<{ __typename?: 'Turbine', hubHeight: number, name: string, ratedPower: number, diameter: number, type: string, serialNav: number, serial: string, serialDisplay: string, lat: number, lon: number, code: string, metaData: { __typename?: 'MetaData', dataAquisitionMax?: { __typename?: 'Date', unixTimestamp?: number | null } | null }, turbineManufacturer?: { __typename?: 'TurbineManufacturer', name?: string | null } | null, park: { __typename?: 'Park', currentWeather?: { __typename?: 'IconWeather', icon?: string | null } | null, filteredData: Array<{ __typename?: 'ParkFilteredData', signalName: string, dataValue?: number | null }> }, filteredData: Array<{ __typename?: 'FilteredData', signalName: string, dataValue?: { __typename?: 'FloatData', numericValue?: number | null } | { __typename?: 'StringData', stringValue?: string | null } | null } | null>, data?: { __typename?: 'RawData', WTUR1_per_loadFactor?: number | null, WTUR1_per_efficiency?: number | null, WTUR1_kW_mag_f?: number | null, WTUR1_kW_loss?: number | null, WTUR1_status?: number | null, WTUR1_kW_theoretical?: number | null, LPHD1_PhyHealth_stVal?: number | null, WTUR1_TurSt_actSt_stVal?: number | null, WTUR1_TurMaint_actSt_stVal?: number | null, WNAC1_Dir_mag_f?: number | null, WNAC1_WdDir_mag_f?: number | null, WNAC1_WdSpd_c_mag_f?: number | null, WNAC1_ExTmp_mag_f?: number | null, WTRM1_GbxOilPres_mag_f?: number | null, WROT1_RotSpd_mag_f?: number | null, WROT1_PtAngValBl1_mag_f?: number | null, WROT1_PtAngValBl2_mag_f?: number | null, WROT1_PtAngValBl3_mag_f?: number | null, WROT1_PtHyPresBl1_mag_f?: number | null, WROT1_PtHyPresBl2_mag_f?: number | null, WROT1_PtHyPresBl3_mag_f?: number | null, WYAW1_BrkPres_mag_f?: number | null, WTRM1_BrkHyPres_mag_f?: number | null, WYAW1_CabWup_mag_f?: number | null, WROT1_PtAngValAvg_mag_f?: number | null, WROT1_PtHyPresAvg_mag_f?: number | null, WNAC1_WdSpd_mag_f?: number | null, WGEN1_Spd_mag_f?: number | null } | null }> };

export type ParkSignalsListQueryVariables = Exact<{
  serialNav: Scalars['Float']['input'];
  streamType: Array<InputMaybe<Stream>> | InputMaybe<Stream>;
}>;


export type ParkSignalsListQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, type: string, serialNav: number, code: string, temperature?: Array<{ __typename?: 'Signal', name?: string | null, displayName?: string | null, displayShortName?: string | null, signalGroupType?: string | null, description?: string | null, type?: string | null, unit?: string | null } | null> | null }> };

export type ParkTurbineMenuSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ParkTurbineMenuSubscription = { __typename?: 'Subscription', countries: Array<{ __typename?: 'Country', name: string, country_image: string, parks: Array<{ __typename?: 'Park', name: string, fe_name: string, energyMeterAvailable: boolean, isGreen: boolean, country: { __typename?: 'Country', name: string, country_image: string, code: string }, data: { __typename?: 'Data', WTUR1_status?: { __typename?: 'Aggregation', min?: number | null } | null, WTUR1_per_loadFactor?: { __typename?: 'Aggregation', avg?: number | null } | null }, turbines: Array<{ __typename?: 'Turbine', serialNav: number, codeDisplay: string, code: string, data?: { __typename?: 'RawData', WTUR1_status?: number | null, WTUR1_per_loadFactor?: number | null } | null }> }> }> };

export type ParkTurbineListQueryVariables = Exact<{ [key: string]: never; }>;


export type ParkTurbineListQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', name: string, energyMeterAvailable: boolean, turbines: Array<{ __typename?: 'Turbine', serialNav: number, code: string }> }> };

export type MenusDropDownSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type MenusDropDownSubscription = { __typename?: 'Subscription', user?: { __typename?: 'User', _id?: string | null, user_portfolios?: Array<{ __typename?: 'UserPortfolio', _id?: string | null, defaultPortfolio?: boolean | null, name?: string | null, parks?: Array<{ __typename?: 'Park', name: string, fe_name: string, energyMeterAvailable: boolean, isGreen: boolean, country: { __typename?: 'Country', name: string, country_image: string }, data: { __typename?: 'Data', WTUR1_status?: { __typename?: 'Aggregation', min?: number | null } | null, WTUR1_per_loadFactor?: { __typename?: 'Aggregation', avg?: number | null } | null }, turbines: Array<{ __typename?: 'Turbine', serialNav: number, code: string, data?: { __typename?: 'RawData', WTUR1_status?: number | null, WTUR1_per_loadFactor?: number | null } | null }> } | null> | null } | null> | null } | null };

export type OverviewBoardCustomPortfolioSubscriptionVariables = Exact<{
  portfolioId: Scalars['String']['input'];
  parkIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type OverviewBoardCustomPortfolioSubscription = { __typename?: 'Subscription', portfolios: Array<{ __typename?: 'Portfolio', groupedResults: { __typename?: 'GroupedResults', alarmsGroupedByPark: Array<{ __typename?: 'GroupedAlarms', _id_park: string, alarms: Array<{ __typename?: 'Alarm', _id: string } | null> } | null> }, parks: Array<{ __typename?: 'Park', _id: string, lat: number, lon: number, name: string, code: string, fe_name: string, country: { __typename?: 'Country', code: string, name: string, country_image: string }, currentWeather?: { __typename?: 'IconWeather', icon?: string | null } | null, dataDebbug: { __typename?: 'Data', WTUR1_MW_rated?: { __typename?: 'Aggregation', sum?: number | null } | null }, data: { __typename?: 'Data', WTUR1_status?: { __typename?: 'Aggregation', min?: number | null } | null, WTUR1_MW_mag_f?: { __typename?: 'Aggregation', sum?: number | null } | null, WTUR1_MW_theoretical?: { __typename?: 'Aggregation', sum?: number | null } | null, WTUR1_MW_rated?: { __typename?: 'Aggregation', sum?: number | null } | null, WTUR1_MW_loss?: { __typename?: 'Aggregation', sum?: number | null } | null, WTUR1_per_loadFactor?: { __typename?: 'Aggregation', avg?: number | null } | null, WTUR1_per_efficiency?: { __typename?: 'Aggregation', avg?: number | null } | null, WNAC1_ExTmp_mag_f?: { __typename?: 'Aggregation', avg?: number | null } | null, WNAC1_WdSpd_mag_f?: { __typename?: 'Aggregation', avg?: number | null } | null, WNAC1_WdDir_mag_f?: { __typename?: 'Aggregation', avg?: number | null } | null, WNAC1_Dir_mag_f?: { __typename?: 'Aggregation', avg?: number | null } | null }, metaData: { __typename?: 'MetaData', dataAquisitionMax?: { __typename?: 'Date', unixTimestamp?: number | null } | null }, parkSubType: Array<{ __typename?: 'ParkSubType', name?: string | null, info?: { __typename?: 'Information', type?: string | null, qty?: number | null, hubHeight?: number | null, ratedPower?: number | null, diameter?: number | null } | null }>, turbines: Array<{ __typename?: 'Turbine', serialNav: number, serial: string, hubHeight: number, type: string, code: string, data?: { __typename?: 'RawData', WTUR1_status?: number | null, WTUR1_kW_mag_f?: number | null, WTUR1_kW_theoretical?: number | null, WTUR1_kW_loss?: number | null, WTUR1_kW_rated?: number | null, WTUR1_per_loadFactor?: number | null, WTUR1_per_efficiency?: number | null, LPHD1_PhyHealth_stVal?: number | null, WNAC1_WdDir_mag_f?: number | null, WNAC1_WdSpd_mag_f?: number | null, WNAC1_ExTmp_mag_f?: number | null } | null }> }> }> };

export type OverviewBoardSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OverviewBoardSubscription = { __typename?: 'Subscription', parks: Array<{ __typename?: 'Park', lat: number, lon: number, name: string, code: string, fe_name: string, country: { __typename?: 'Country', code: string, name: string, country_image: string }, dataDebbug: { __typename?: 'Data', WTUR1_MW_rated?: { __typename?: 'Aggregation', sum?: number | null } | null }, data: { __typename?: 'Data', WTUR1_MW_mag_f?: { __typename?: 'Aggregation', sum?: number | null } | null, WTUR1_MW_theoretical?: { __typename?: 'Aggregation', sum?: number | null } | null, WTUR1_MW_rated?: { __typename?: 'Aggregation', sum?: number | null } | null, WTUR1_MW_loss?: { __typename?: 'Aggregation', sum?: number | null } | null }, turbines: Array<{ __typename?: 'Turbine', serialNav: number, serial: string, hubHeight: number, type: string, code: string, data?: { __typename?: 'RawData', WTUR1_status?: number | null, WTUR1_kW_mag_f?: number | null, WTUR1_kW_theoretical?: number | null, WTUR1_kW_loss?: number | null, WTUR1_kW_rated?: number | null, LPHD1_PhyHealth_stVal?: number | null, WNAC1_WdDir_mag_f?: number | null, WNAC1_WdSpd_mag_f?: number | null, WNAC1_ExTmp_mag_f?: number | null } | null }> }> };

export type OverviewBoardParkSubscriptionVariables = Exact<{
  parkCode: Scalars['String']['input'];
}>;


export type OverviewBoardParkSubscription = { __typename?: 'Subscription', parks: Array<{ __typename?: 'Park', lat: number, lon: number, name: string, code: string, fe_name: string, country: { __typename?: 'Country', code: string, name: string, country_image: string }, dataDebbug: { __typename?: 'Data', WTUR1_MW_rated?: { __typename?: 'Aggregation', sum?: number | null } | null }, data: { __typename?: 'Data', WTUR1_MW_mag_f?: { __typename?: 'Aggregation', sum?: number | null } | null, WTUR1_MW_theoretical?: { __typename?: 'Aggregation', sum?: number | null } | null, WTUR1_MW_rated?: { __typename?: 'Aggregation', sum?: number | null } | null, WTUR1_MW_loss?: { __typename?: 'Aggregation', sum?: number | null } | null }, turbines: Array<{ __typename?: 'Turbine', serialNav: number, serial: string, hubHeight: number, type: string, code: string, data?: { __typename?: 'RawData', WTUR1_status?: number | null, WTUR1_kW_mag_f?: number | null, WTUR1_kW_theoretical?: number | null, WTUR1_kW_loss?: number | null, WTUR1_kW_rated?: number | null, LPHD1_PhyHealth_stVal?: number | null, WNAC1_WdDir_mag_f?: number | null, WNAC1_WdSpd_mag_f?: number | null, WNAC1_ExTmp_mag_f?: number | null } | null }> }> };

export type ParkModalInfoQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type ParkModalInfoQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', name: string, anualProdEst?: number | null, commissioned?: string | null, lat: number, lon: number, country: { __typename?: 'Country', name: string, code: string, country_image: string }, dataDebbug: { __typename?: 'Data', WTUR1_MW_rated?: { __typename?: 'Aggregation', sum?: number | null } | null }, parkSubType: Array<{ __typename?: 'ParkSubType', name?: string | null, info?: { __typename?: 'Information', type?: string | null, qty?: number | null, diameter?: number | null, oem?: string | null, ratedPower?: number | null, hubHeight?: number | null } | null }> }> };

export type UnassignProcessToTurbineLogbookMutationVariables = Exact<{
  _id?: InputMaybe<Scalars['String']['input']>;
  mutTS?: InputMaybe<Scalars['Float']['input']>;
  blockActionsLog?: InputMaybe<Scalars['String']['input']>;
}>;


export type UnassignProcessToTurbineLogbookMutation = { __typename?: 'Mutation', unassignProcessToTurbineLogbook: boolean };

export type GetTemplatesQueryVariables = Exact<{
  whereInput?: InputMaybe<ReportTemplateWhereInput>;
}>;


export type GetTemplatesQuery = { __typename?: 'Query', reportTemplates?: Array<{ __typename?: 'ReportTemplate', _id: string, _id_portfolio?: string | null, createdBy?: string | null, createdTs?: number | null, editedBy?: string | null, editedTs?: number | null, name?: string | null, report?: string | null, schedule?: string | null, isDefaultTemplate?: boolean | null, creatorName?: string | null } | null> | null };

export type GetReportsQueryVariables = Exact<{
  whereInput?: InputMaybe<ReportWhereInput>;
}>;


export type GetReportsQuery = { __typename?: 'Query', reports?: Array<{ __typename?: 'Reportb', _id: string, createdBy?: string | null, createdTs?: number | null, editedBy?: string | null, editedTs?: number | null, fkPortfolio_id?: string | null, report_id?: string | null, name?: string | null, report?: string | null, shared?: number | null, schedule?: string | null, isDefaultTemplate?: boolean | null, creatorName?: string | null } | null> | null };

export type GetImagesQueryVariables = Exact<{
  whereInput?: InputMaybe<ImagesWhereInput>;
}>;


export type GetImagesQuery = { __typename?: 'Query', images?: Array<{ __typename?: 'Images', _id?: string | null, name?: string | null, originalName?: string | null, description?: string | null, createdBy?: string | null, createdTs?: number | null, fileExtension?: string | null, username?: string | null, scope?: string | null } | null> | null };

export type CreateReportMutationVariables = Exact<{
  report?: InputMaybe<ReportSchemaInput>;
}>;


export type CreateReportMutation = { __typename?: 'Mutation', createReport: { __typename?: 'Reportb', _id: string, createdBy?: string | null, createdTs?: number | null, editedBy?: string | null, editedTs?: number | null, fkPortfolio_id?: string | null, report_id?: string | null, name?: string | null, report?: string | null, shared?: number | null, schedule?: string | null, isDefaultTemplate?: boolean | null } };

export type DeleteReportMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteReportMutation = { __typename?: 'Mutation', deleteReport: boolean };

export type UpdateReportMutationVariables = Exact<{
  report?: InputMaybe<ReportSchemaInput>;
}>;


export type UpdateReportMutation = { __typename?: 'Mutation', updateReport: boolean };

export type CreateTemplateMutationVariables = Exact<{
  schedule?: InputMaybe<Scalars['String']['input']>;
  isDefaultTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  report?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateTemplateMutation = { __typename?: 'Mutation', createReportTemplate: { __typename?: 'ReportTemplateResponse', success: boolean, message: string, reportTemplate?: { __typename?: 'ReportTemplate', _id: string, _id_portfolio?: string | null, createdBy?: string | null, createdTs?: number | null, editedBy?: string | null, editedTs?: number | null, name?: string | null, report?: string | null, schedule?: string | null, isDefaultTemplate?: boolean | null } | null } };

export type UpdateTemplateMutationVariables = Exact<{
  id: Scalars['String']['input'];
  schedule?: InputMaybe<Scalars['String']['input']>;
  isDefaultTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  report?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateTemplateMutation = { __typename?: 'Mutation', editReportTemplate: { __typename?: 'ReportTemplateResponse', success: boolean, message: string, reportTemplate?: { __typename?: 'ReportTemplate', _id: string, editedTs?: number | null, name?: string | null } | null } };

export type DeleteTemplateMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteTemplateMutation = { __typename?: 'Mutation', deleteReportTemplate: { __typename?: 'ReportTemplateResponse', success: boolean, message: string } };

export type SendReportEmailMutationVariables = Exact<{
  reportId: Scalars['String']['input'];
  emails: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type SendReportEmailMutation = { __typename?: 'Mutation', sendReportEmail: boolean };

export type ParkStoreQueryVariables = Exact<{ [key: string]: never; }>;


export type ParkStoreQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', name: string, fe_name: string }> };

export type LastSeenTurbinesQueryVariables = Exact<{
  serialNav: Scalars['Float']['input'];
}>;


export type LastSeenTurbinesQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', serialNav: number, code: string, data?: { __typename?: 'RawData', WTUR1_status?: number | null } | null }> };

export type TurbineSerialQueryVariables = Exact<{
  serialNav: Scalars['Float']['input'];
}>;


export type TurbineSerialQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', serial: string }> };

export type SignalsByTurbineQueryVariables = Exact<{
  serialNav: Scalars['Float']['input'];
}>;


export type SignalsByTurbineQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', code: string, signalsList?: Array<{ __typename?: 'Signal', name?: string | null } | null> | null }> };

export type SignalsListByTurbineQueryVariables = Exact<{
  serialNav: Scalars['Float']['input'];
}>;


export type SignalsListByTurbineQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', serialNav: number, signalsList30s?: Array<{ __typename?: 'Signal', unit?: string | null, name?: string | null, signalGroupType?: string | null } | null> | null, temperature30s?: Array<{ __typename?: 'Signal', name?: string | null, unit?: string | null } | null> | null, signalsList10m?: Array<{ __typename?: 'Signal', unit?: string | null, name?: string | null, signalGroupType?: string | null } | null> | null, temperature10m?: Array<{ __typename?: 'Signal', name?: string | null, unit?: string | null } | null> | null }> };

export type PortfolioQueryVariables = Exact<{ [key: string]: never; }>;


export type PortfolioQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', name: string }> };

export type ControlroomAckMutationVariables = Exact<{
  userName: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
  turbineCode: Scalars['String']['input'];
  _id_alarm: Scalars['String']['input'];
}>;


export type ControlroomAckMutation = { __typename?: 'Mutation', controlroomAck: boolean };

export type ControlroomCreateTicketMutationVariables = Exact<{
  _id_alarm: Scalars['String']['input'];
  alarmCategory: Scalars['Int']['input'];
  code: Scalars['String']['input'];
  description: Scalars['String']['input'];
  createTS: Scalars['Float']['input'];
  isOpen: Scalars['Boolean']['input'];
  userName: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
  turbineCode: Scalars['String']['input'];
  turbineStatus: Scalars['String']['input'];
}>;


export type ControlroomCreateTicketMutation = { __typename?: 'Mutation', controlroomCreateTicket: boolean };

export type LiveInformationPortfolioSubscriptionVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  parks?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type LiveInformationPortfolioSubscription = { __typename?: 'Subscription', portfolios: Array<{ __typename?: 'Portfolio', data: { __typename?: 'Data', WTUR1_W_mag_f?: { __typename?: 'Aggregation', sum?: number | null } | null, WTUR1_W_loss?: { __typename?: 'Aggregation', sum?: number | null } | null, WTUR1_W_theoretical?: { __typename?: 'Aggregation', sum?: number | null } | null }, dataDebbug: { __typename?: 'Data', WTUR1_W_rated?: { __typename?: 'Aggregation', sum?: number | null } | null }, alarms?: Array<{ __typename?: 'Alarm', _id: string } | null> | null }> };

export type LiveInformationParkSubscriptionVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  turbines?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type LiveInformationParkSubscription = { __typename?: 'Subscription', parks: Array<{ __typename?: 'Park', fe_name: string, availableSignalCount: number, totalSignalCount: number, metaData: { __typename?: 'MetaData', dataAquisitionMax?: { __typename?: 'Date', unixTimestamp?: number | null } | null }, alarms?: Array<{ __typename?: 'Alarm', isOpen: boolean } | null> | null, data: { __typename?: 'Data', WTUR1_W_mag_f?: { __typename?: 'Aggregation', sum?: number | null } | null, WTUR1_W_loss?: { __typename?: 'Aggregation', sum?: number | null } | null, WTUR1_W_theoretical?: { __typename?: 'Aggregation', sum?: number | null } | null, WTUR1_per_loadFactor?: { __typename?: 'Aggregation', avg?: number | null } | null, WTUR1_per_efficiency?: { __typename?: 'Aggregation', avg?: number | null } | null }, dataDebbug: { __typename?: 'Data', WTUR1_W_rated?: { __typename?: 'Aggregation', sum?: number | null } | null } }> };

export type LiveInformationTurbineSubscriptionVariables = Exact<{
  serialNav: Scalars['Float']['input'];
}>;


export type LiveInformationTurbineSubscription = { __typename?: 'Subscription', turbines: Array<{ __typename?: 'Turbine', serialNav: number, ratedPower: number, alarmCount: number, code: string, data?: { __typename?: 'RawData', LDAT1_TmUTC_setTm_rounded?: string | null, WTUR1_status?: number | null, LPHD1_PhyHealth_stVal?: number | null, WTUR1_TurSt_actSt_stVal?: number | null, WTUR1_kW_mag_f?: number | null, WTUR1_kW_loss?: number | null, WTUR1_kW_theoretical?: number | null } | null }> };

export type OverviewAlarmsPortfolioSubscriptionVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<AlarmSortInput>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  hours: Scalars['Int']['input'];
  code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  alarmCategory?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  controlroomAck?: InputMaybe<Scalars['Boolean']['input']>;
  controlroomTicketing?: InputMaybe<Scalars['Boolean']['input']>;
  parks?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type OverviewAlarmsPortfolioSubscription = { __typename?: 'Subscription', portfolios: Array<{ __typename?: 'Portfolio', alarmCount: number, alarms?: Array<{ __typename?: 'Alarm', _id: string, _id_alarm?: string | null, createTS?: number | null, closeTS?: number | null, duration?: string | null, durationLong?: string | null, productionLoss?: number | null, code?: string | null, description?: string | null, isOpen: boolean, alarmCategory: AlarmCategory, controlroomAck?: boolean | null, controlroomAckLog?: Array<string | null> | null, controlroomTicketing?: Array<string | null> | null, controlroomTicketingLog?: Array<string | null> | null, hasPlannedEvent: boolean, tickets?: Array<{ __typename?: 'AlarmTicket', id?: string | null, number_id?: string | null } | null> | null, events?: Array<{ __typename?: 'PlannedEvent', _id?: string | null, _id_process?: string | null, startTs?: number | null, endTs?: number | null, description?: string | null, category?: string | null, title?: string | null } | null> | null, turbine: { __typename?: 'Turbine', _id: string, name: string, serial: string, serialNav: number, serialDisplay: string, code: string, park: { __typename?: 'Park', name: string, fe_name: string }, data?: { __typename?: 'RawData', WTUR1_status?: number | null } | null } } | null> | null }> };

export type OverviewAlarmsParkSubscriptionVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  sort?: InputMaybe<AlarmSortInput>;
  hours: Scalars['Int']['input'];
  alarmCategory?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  controlroomAck?: InputMaybe<Scalars['Boolean']['input']>;
  controlroomTicketing?: InputMaybe<Scalars['Boolean']['input']>;
  turbines?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  code?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type OverviewAlarmsParkSubscription = { __typename?: 'Subscription', parks: Array<{ __typename?: 'Park', alarmCount: number, alarms?: Array<{ __typename?: 'Alarm', _id: string, _id_alarm?: string | null, createTS?: number | null, closeTS?: number | null, duration?: string | null, durationLong?: string | null, productionLoss?: number | null, code?: string | null, description?: string | null, isOpen: boolean, alarmCategory: AlarmCategory, controlroomAck?: boolean | null, controlroomAckLog?: Array<string | null> | null, controlroomTicketing?: Array<string | null> | null, controlroomTicketingLog?: Array<string | null> | null, hasPlannedEvent: boolean, tickets?: Array<{ __typename?: 'AlarmTicket', id?: string | null, number_id?: string | null } | null> | null, events?: Array<{ __typename?: 'PlannedEvent', _id?: string | null, _id_process?: string | null, startTs?: number | null, endTs?: number | null, category?: string | null, description?: string | null, title?: string | null } | null> | null, turbine: { __typename?: 'Turbine', _id: string, name: string, serial: string, serialNav: number, serialDisplay: string, code: string, park: { __typename?: 'Park', name: string, fe_name: string }, data?: { __typename?: 'RawData', WTUR1_status?: number | null } | null } } | null> | null }> };

export type UserPreferencesOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPreferencesOverviewQuery = { __typename?: 'Query', user?: { __typename?: 'User', preferences?: { __typename?: 'PreferenceList', overviewBoardSortingConfiguration?: { __typename?: 'PreferenceLabels', active?: { __typename?: 'PreferencesValues', label?: string | null, value?: string | null } | null, options: Array<{ __typename?: 'PreferencesValues', label?: string | null, value?: string | null }> } | null } | null } | null };

export type SetOverviewBoardSortMutationVariables = Exact<{
  preferences: PreferencesInput;
}>;


export type SetOverviewBoardSortMutation = { __typename?: 'Mutation', setPreferences: { __typename?: 'PreferenceList', overviewBoardSortingConfiguration?: { __typename?: 'PreferenceLabels', active?: { __typename?: 'PreferencesValues', label?: string | null, value?: string | null } | null, options: Array<{ __typename?: 'PreferencesValues', label?: string | null, value?: string | null }> } | null } };

export type UserPortfoliosQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPortfoliosQuery = { __typename?: 'Query', user?: { __typename?: 'User', _id?: string | null, username?: string | null, preferences?: { __typename?: 'PreferenceList', parkMenu?: { __typename?: 'PreferenceLabels', active?: { __typename?: 'PreferencesValues', value?: string | null } | null } | null, headerDropdownColorType?: { __typename?: 'PreferenceLabels', active?: { __typename?: 'PreferencesValues', label?: string | null, value?: string | null } | null, options: Array<{ __typename?: 'PreferencesValues', label?: string | null, value?: string | null }> } | null } | null, user_portfolios?: Array<{ __typename?: 'UserPortfolio', _id?: string | null, defaultPortfolio?: boolean | null, name?: string | null, parks?: Array<{ __typename?: 'Park', _id: string, name: string, fe_name: string, code: string, displayCode?: string | null, energyMeterAvailable: boolean, lat: number, lon: number, country: { __typename?: 'Country', name: string, code: string, country_image: string }, data: { __typename?: 'Data', WTUR1_status?: { __typename?: 'Aggregation', min?: number | null } | null, WTUR1_per_efficiency?: { __typename?: 'Aggregation', avg?: number | null } | null, WTUR1_per_loadFactor?: { __typename?: 'Aggregation', avg?: number | null } | null }, turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, codeDisplay: string, serial: string, serialNav: number, code: string, data?: { __typename?: 'RawData', WTUR1_status?: number | null, WTUR1_per_efficiency?: number | null, WTUR1_per_loadFactor?: number | null } | null }> } | null> | null } | null> | null, available_parks?: Array<{ __typename?: 'Park', name: string, _id: string } | null> | null } | null };

export type UserPortfoliosWithAllParksAndTurbinesSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UserPortfoliosWithAllParksAndTurbinesSubscription = { __typename?: 'Subscription', user?: { __typename?: 'User', _id?: string | null, username?: string | null, preferences?: { __typename?: 'PreferenceList', parkMenu?: { __typename?: 'PreferenceLabels', active?: { __typename?: 'PreferencesValues', value?: string | null } | null } | null, headerDropdownColorType?: { __typename?: 'PreferenceLabels', active?: { __typename?: 'PreferencesValues', label?: string | null, value?: string | null } | null, options: Array<{ __typename?: 'PreferencesValues', label?: string | null, value?: string | null }> } | null } | null, user_portfolios?: Array<{ __typename?: 'UserPortfolio', _id?: string | null, defaultPortfolio?: boolean | null, name?: string | null, parks?: Array<{ __typename?: 'Park', _id: string, name: string, fe_name: string, code: string, displayCode?: string | null, energyMeterAvailable: boolean, lat: number, lon: number, country: { __typename?: 'Country', name: string, code: string, country_image: string }, data: { __typename?: 'Data', WTUR1_status?: { __typename?: 'Aggregation', min?: number | null } | null, WTUR1_per_efficiency?: { __typename?: 'Aggregation', avg?: number | null } | null, WTUR1_per_loadFactor?: { __typename?: 'Aggregation', avg?: number | null } | null }, turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, codeDisplay: string, serial: string, serialNav: number, serialDisplay: string, code: string, data?: { __typename?: 'RawData', WTUR1_status?: number | null, WTUR1_per_efficiency?: number | null, WTUR1_per_loadFactor?: number | null } | null }> } | null> | null } | null> | null } | null };

export type UserCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserCountriesQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'Country', _id: string, name: string, parks: Array<{ __typename?: 'Park', _id: string, name: string }> }> };

export type UserPortfolioDropdownQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPortfolioDropdownQuery = { __typename?: 'Query', user?: { __typename?: 'User', _id?: string | null, user_portfolios?: Array<{ __typename?: 'UserPortfolio', _id?: string | null, defaultPortfolio?: boolean | null, name?: string | null, parks?: Array<{ __typename?: 'Park', _id: string, name: string, code: string, turbines: Array<{ __typename?: 'Turbine', _id: string, name: string, serial: string, serialNav: number, codeDisplay: string, code: string }> } | null> | null } | null> | null } | null };

export type DefaultUserPortfolioQueryVariables = Exact<{ [key: string]: never; }>;


export type DefaultUserPortfolioQuery = { __typename?: 'Query', user?: { __typename?: 'User', _id?: string | null, user_portfolios?: Array<{ __typename?: 'UserPortfolio', _id?: string | null } | null> | null } | null };

export type CreatePortfolioMutationVariables = Exact<{
  portfolio: UserCustomPortfolioInput;
}>;


export type CreatePortfolioMutation = { __typename?: 'Mutation', createUserCustomPortfolio?: { __typename?: 'UserPortfolio', _id?: string | null, defaultPortfolio?: boolean | null, name?: string | null, parks?: Array<{ __typename?: 'Park', _id: string, name: string } | null> | null } | null };

export type DeletePortfolioMutationVariables = Exact<{
  portfolio: Scalars['String']['input'];
}>;


export type DeletePortfolioMutation = { __typename?: 'Mutation', deleteUserCustomPortfolio?: boolean | null };

export type UpdatePortfolioMutationVariables = Exact<{
  portfolio: UserCustomPortfolioInput;
}>;


export type UpdatePortfolioMutation = { __typename?: 'Mutation', updateUserCustomPortfolio?: { __typename?: 'UserPortfolio', _id?: string | null, name?: string | null, parks?: Array<{ __typename?: 'Park', _id: string, name: string } | null> | null } | null };

export type SetDefaultPortfolioMutationVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type SetDefaultPortfolioMutation = { __typename?: 'Mutation', setDefaultCustomPortfolio?: boolean | null };

export type AllUserPortfoliosQueryVariables = Exact<{ [key: string]: never; }>;


export type AllUserPortfoliosQuery = { __typename?: 'Query', user?: { __typename?: 'User', user_portfolios?: Array<{ __typename?: 'UserPortfolio', _id?: string | null, defaultPortfolio?: boolean | null, name?: string | null, parks?: Array<{ __typename?: 'Park', _id: string, energyMeterAvailable: boolean, name: string, code: string } | null> | null } | null> | null } | null };

export type GetKpiVsTargetTableCustomSettingsQueryVariables = Exact<{
  parkName: Scalars['String']['input'];
  tableUniqueName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetKpiVsTargetTableCustomSettingsQuery = { __typename?: 'Query', user?: { __typename?: 'User', _id?: string | null, getKpiVsTargetTableCustomSettings?: { __typename?: 'KpiVsTargetTableCustomSettings', customizationTable: string } | null } | null };

export type SetKpiVsTargetTableSettingMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  parkName: Scalars['String']['input'];
  customizationTable: Scalars['String']['input'];
  tableUniqueName?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetKpiVsTargetTableSettingMutation = { __typename?: 'Mutation', setKpiVsTargetTableCustomSettings?: boolean | null };

export type IsOtpEnabledQueryVariables = Exact<{ [key: string]: never; }>;


export type IsOtpEnabledQuery = { __typename?: 'Query', user?: { __typename?: 'User', securityPreferences: { __typename?: 'SecurityPreferences', isTotpEnabled: boolean } } | null };

export type RequestOtpConfigEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestOtpConfigEmailMutation = { __typename?: 'Mutation', requestOtpConfigEmail: boolean };

export type RequestPasswordResetEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestPasswordResetEmailMutation = { __typename?: 'Mutation', requestPasswordResetEmail: boolean };

export type RemoveConfiguredToptMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveConfiguredToptMutation = { __typename?: 'Mutation', removeConfiguredTopt: boolean };

export type SetPreferencesMutationVariables = Exact<{
  preferences: PreferencesInput;
}>;


export type SetPreferencesMutation = { __typename?: 'Mutation', setPreferences: { __typename?: 'PreferenceList', parkMenu?: { __typename?: 'PreferenceLabels', active?: { __typename?: 'PreferencesValues', label?: string | null, value?: string | null } | null, options: Array<{ __typename?: 'PreferencesValues', label?: string | null, value?: string | null }> } | null, headerDropdownColorType?: { __typename?: 'PreferenceLabels', active?: { __typename?: 'PreferencesValues', label?: string | null, value?: string | null } | null, options: Array<{ __typename?: 'PreferencesValues', label?: string | null, value?: string | null }> } | null } };

export type GetUserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserInfoQuery = { __typename?: 'Query', user?: { __typename?: 'User', _id?: string | null, preferences?: { __typename?: 'PreferenceList', parkMenu?: { __typename?: 'PreferenceLabels', active?: { __typename?: 'PreferencesValues', label?: string | null, value?: string | null } | null, options: Array<{ __typename?: 'PreferencesValues', label?: string | null, value?: string | null }> } | null, headerDropdownColorType?: { __typename?: 'PreferenceLabels', active?: { __typename?: 'PreferencesValues', label?: string | null, value?: string | null } | null, options: Array<{ __typename?: 'PreferencesValues', label?: string | null, value?: string | null }> } | null } | null } | null };

export type GetAllUserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllUserInfoQuery = { __typename?: 'Query', user?: { __typename?: 'User', _id?: string | null, username?: string | null, full_name?: string | null, name?: string | null, last_name?: string | null, email?: string | null, position?: string | null, portfolioRights?: string | null, attributes?: { __typename?: 'Attributes', country?: string | null, company?: string | null, language?: string | null } | null, preferences?: { __typename?: 'PreferenceList', parkMenu?: { __typename?: 'PreferenceLabels', active?: { __typename?: 'PreferencesValues', label?: string | null, value?: string | null } | null, options: Array<{ __typename?: 'PreferencesValues', label?: string | null, value?: string | null }> } | null, headerDropdownColorType?: { __typename?: 'PreferenceLabels', active?: { __typename?: 'PreferencesValues', label?: string | null, value?: string | null } | null, options: Array<{ __typename?: 'PreferencesValues', label?: string | null, value?: string | null }> } | null } | null } | null };

export type BindUserMutationVariables = Exact<{ [key: string]: never; }>;


export type BindUserMutation = { __typename?: 'Mutation', bindUser: boolean };

export type GetAlarmsForTicketsQueryVariables = Exact<{
  parks?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  hours?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAlarmsForTicketsQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', alarms?: Array<{ __typename?: 'Alarm', _id: string, createTS?: number | null, closeTS?: number | null, isOpen: boolean, duration?: string | null, code?: string | null, description?: string | null, alarmCategory: AlarmCategory, turbine: { __typename?: 'Turbine', _id: string, serialNav: number, code: string } } | null> | null }> };

export type ChangeColumnOrderMutationVariables = Exact<{
  input?: InputMaybe<ChangeOrderStatusInput>;
}>;


export type ChangeColumnOrderMutation = { __typename?: 'Mutation', changeStatusOrder?: { __typename?: 'Board', statuses?: Array<{ __typename?: 'Status', _id: string, name: string, hide: boolean, color: string, order: number } | null> | null } | null };

export type HideColumnMutationVariables = Exact<{
  input?: InputMaybe<HideColumnInput>;
}>;


export type HideColumnMutation = { __typename?: 'Mutation', hideColumn?: { __typename?: 'Board', statuses?: Array<{ __typename?: 'Status', _id: string, name: string, hide: boolean, color: string, order: number } | null> | null } | null };

export type GetTicketsForPortfolioQueryVariables = Exact<{
  boardId: Scalars['ID']['input'];
  parks?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  ifArchive?: InputMaybe<Scalars['Boolean']['input']>;
  ifDelete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetTicketsForPortfolioQuery = { __typename?: 'Query', portfolios: Array<{ __typename?: 'Portfolio', tickets?: Array<{ __typename?: 'Ticket', _id: string, _id_board: string, _id_status: string, _id_template?: string | null, number: number, title: string, priority?: TicketPriority | null, totalComments: number, createdBy_id: string, createdBy_username: string, createdOn: number, modifiedBy_id: string, modifiedOn: number, modifiedBy_username: string, assets?: Array<string | null> | null, assignees?: Array<string | null> | null, modules?: Array<string | null> | null, isFavorite?: boolean | null, isArchive: boolean, timeToDelete: number, dueDate?: { __typename?: 'TicketDueDate', start?: number | null, end?: number | null } | null, notification?: { __typename?: 'Notification', id: string, notify_assignee: boolean, notify_comment: boolean, notify_status: boolean } | null } | null> | null }> };

export type GetTicketsForParkQueryVariables = Exact<{
  boardId: Scalars['ID']['input'];
  parkId: Scalars['ID']['input'];
  turbines?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  ifArchive?: InputMaybe<Scalars['Boolean']['input']>;
  ifDelete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetTicketsForParkQuery = { __typename?: 'Query', parks: Array<{ __typename?: 'Park', tickets?: Array<{ __typename?: 'Ticket', _id: string, _id_board: string, _id_status: string, _id_template?: string | null, number: number, title: string, priority?: TicketPriority | null, totalComments: number, createdBy_id: string, createdBy_username: string, createdOn: number, modifiedBy_id: string, modifiedOn: number, modifiedBy_username: string, assets?: Array<string | null> | null, assignees?: Array<string | null> | null, modules?: Array<string | null> | null, isFavorite?: boolean | null, isArchive: boolean, timeToDelete: number, dueDate?: { __typename?: 'TicketDueDate', start?: number | null, end?: number | null } | null, notification?: { __typename?: 'Notification', id: string, notify_assignee: boolean, notify_comment: boolean, notify_status: boolean } | null } | null> | null }> };

export type GetTicketsForTurbineQueryVariables = Exact<{
  boardId: Scalars['ID']['input'];
  turbineId: Scalars['String']['input'];
  ifArchive?: InputMaybe<Scalars['Boolean']['input']>;
  ifDelete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetTicketsForTurbineQuery = { __typename?: 'Query', turbines: Array<{ __typename?: 'Turbine', tickets?: Array<{ __typename?: 'Ticket', _id: string, _id_board: string, _id_status: string, _id_template?: string | null, number: number, title: string, priority?: TicketPriority | null, totalComments: number, createdBy_id: string, createdBy_username: string, createdOn: number, modifiedBy_id: string, modifiedOn: number, modifiedBy_username: string, assets?: Array<string | null> | null, assignees?: Array<string | null> | null, modules?: Array<string | null> | null, isFavorite?: boolean | null, isArchive: boolean, timeToDelete: number, dueDate?: { __typename?: 'TicketDueDate', start?: number | null, end?: number | null } | null, notification?: { __typename?: 'Notification', id: string, notify_assignee: boolean, notify_comment: boolean, notify_status: boolean } | null } | null> | null }> };

export type CreateTicketMutationVariables = Exact<{
  id_board: Scalars['ID']['input'];
  id_status: Scalars['ID']['input'];
  id_template: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  assets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateTicketMutation = { __typename?: 'Mutation', createTicket: { __typename?: 'Ticket', _id: string, _id_board: string, _id_status: string, _id_template?: string | null, number: number, title: string, priority?: TicketPriority | null, totalComments: number, createdBy_id: string, createdBy_username: string, createdOn: number, modifiedBy_id: string, modifiedOn: number, modifiedBy_username: string, assets?: Array<string | null> | null, assignees?: Array<string | null> | null, modules?: Array<string | null> | null, isFavorite?: boolean | null, dueDate?: { __typename?: 'TicketDueDate', start?: number | null, end?: number | null } | null, notification?: { __typename?: 'Notification', id: string, notify_assignee: boolean, notify_comment: boolean, notify_status: boolean } | null } };

export type GetTicketQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetTicketQuery = { __typename?: 'Query', ticket?: { __typename?: 'Ticket', _id: string, _id_board: string, _id_status: string, _id_template?: string | null, number: number, title: string, priority?: TicketPriority | null, totalComments: number, createdBy_id: string, createdBy_username: string, createdOn: number, modifiedBy_id: string, modifiedOn: number, modifiedBy_username: string, assets?: Array<string | null> | null, assignees?: Array<string | null> | null, modules?: Array<string | null> | null, isFavorite?: boolean | null, isArchive: boolean, timeToDelete: number, dueDate?: { __typename?: 'TicketDueDate', start?: number | null, end?: number | null } | null, notification?: { __typename?: 'Notification', id: string, notify_assignee: boolean, notify_comment: boolean, notify_status: boolean } | null } | null };

export type GetTicketInformationQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetTicketInformationQuery = { __typename?: 'Query', ticket?: { __typename?: 'Ticket', information?: { __typename?: 'TicketInformation', description?: string | null, attachments?: Array<{ __typename?: 'TicketAttachment', id?: string | null, id_ticket?: string | null, name?: string | null, originalName?: string | null, createdBy?: string | null, createdTs?: number | null, fileExtension?: string | null, size?: number | null, username?: string | null, id_comment?: string | null } | null> | null, customFields?: Array<{ __typename?: 'CustomFieldCheckbox', id: string, name?: string | null, type?: string | null, order?: number | null, parentId: string, boolean?: boolean | null } | { __typename?: 'CustomFieldChecklist', id: string, name?: string | null, type?: string | null, order?: number | null, parentId: string, value?: Array<{ __typename?: 'CustomOption', name?: string | null, checked?: boolean | null } | null> | null } | { __typename?: 'CustomFieldDate', id: string, name?: string | null, type?: string | null, order?: number | null, parentId: string, number?: number | null } | { __typename?: 'CustomFieldDropdown', id: string, name?: string | null, type?: string | null, order?: number | null, parentId: string, value?: Array<{ __typename?: 'CustomOption', name?: string | null, checked?: boolean | null } | null> | null } | { __typename?: 'CustomFieldGroup', id: string, name?: string | null, type?: string | null, order?: number | null, parentId: string, value?: Array<{ __typename?: 'CustomFieldCheckbox', id: string, name?: string | null, order?: number | null, parentId: string, type?: string | null, boolean?: boolean | null } | { __typename?: 'CustomFieldChecklist', id: string, name?: string | null, order?: number | null, parentId: string, type?: string | null, value?: Array<{ __typename?: 'CustomOption', name?: string | null, checked?: boolean | null } | null> | null } | { __typename?: 'CustomFieldDate', id: string, name?: string | null, order?: number | null, parentId: string, type?: string | null, number?: number | null } | { __typename?: 'CustomFieldDropdown', id: string, name?: string | null, order?: number | null, parentId: string, type?: string | null, value?: Array<{ __typename?: 'CustomOption', name?: string | null, checked?: boolean | null } | null> | null } | { __typename?: 'CustomFieldGroup', id: string, name?: string | null, order?: number | null, parentId: string, type?: string | null } | { __typename?: 'CustomFieldNumber', id: string, name?: string | null, order?: number | null, parentId: string, type?: string | null, number?: number | null } | { __typename?: 'CustomFieldString', id: string, name?: string | null, order?: number | null, parentId: string, type?: string | null, string?: string | null } | null> | null } | { __typename?: 'CustomFieldNumber', id: string, name?: string | null, type?: string | null, order?: number | null, parentId: string, number?: number | null } | { __typename?: 'CustomFieldString', id: string, name?: string | null, type?: string | null, order?: number | null, parentId: string, string?: string | null } | null> | null } | null } | null };

export type GetTicketIntegrationsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetTicketIntegrationsQuery = { __typename?: 'Query', ticket?: { __typename?: 'Ticket', integrations?: Array<{ __typename: 'Troubleshoot', code?: string | null, description?: string | null, assetId?: string | null, isOpen?: boolean | null, category?: string | null, _id_integration: string, type?: IntegrationType | null, productionLoss?: number | null, turbineInfo?: { __typename?: 'TurbineIntegration', id: string, serial?: string | null, code?: string | null } | null, dateRange?: { __typename?: 'DateRange', start?: number | null, end?: number | null } | null } | null> | null } | null };

export type GetTicketCommentsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetTicketCommentsQuery = { __typename?: 'Query', ticket?: { __typename?: 'Ticket', comments?: Array<{ __typename?: 'TicketComment', username: string, _id: string, _id_user: string, content: string, createTs?: number | null } | null> | null } | null };

export type GetTicketChangeLogQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetTicketChangeLogQuery = { __typename?: 'Query', ticket?: { __typename?: 'Ticket', changeLogs?: Array<{ __typename: 'CommenteCreateChangeLog', action: string, date: number, subject?: { __typename?: 'Subject', username: string } | null } | { __typename: 'CommenteDeleteChangeLog', action: string, date: number, subject?: { __typename?: 'Subject', username: string } | null } | { __typename: 'CreatedChangeLog', ticketNumber: number, action: string, date: number, subject?: { __typename?: 'Subject', username: string } | null } | { __typename: 'CustomChangeLog', field: string, previous?: string | null, current: string, action: string, date: number, subject?: { __typename?: 'Subject', username: string } | null } | { __typename: 'MultiUpdatedChangeLog', action: string, date: number, subject?: { __typename?: 'Subject', username: string } | null } | { __typename: 'UpdatedChangeLog', previous?: string | null, field: string, current: string, action: string, date: number, subject?: { __typename?: 'Subject', username: string } | null } | null> | null } | null };

export type AddTicketCommentMutationVariables = Exact<{
  id_ticket: Scalars['ID']['input'];
  content: Scalars['String']['input'];
}>;


export type AddTicketCommentMutation = { __typename?: 'Mutation', addTicketComment?: { __typename?: 'TicketComment', _id: string, _id_user: string, username: string, content: string, createTs?: number | null } | null };

export type ChangePriorityMutationVariables = Exact<{
  id_ticket: Scalars['ID']['input'];
  priority: TicketPriority;
}>;


export type ChangePriorityMutation = { __typename?: 'Mutation', changeTicketPriority?: { __typename?: 'Ticket', _id: string, priority?: TicketPriority | null, modifiedOn: number, modifiedBy_username: string } | null };

export type ChangeTitleMutationVariables = Exact<{
  id_ticket: Scalars['ID']['input'];
  title: Scalars['String']['input'];
}>;


export type ChangeTitleMutation = { __typename?: 'Mutation', changeTicketTitle?: { __typename?: 'Ticket', _id: string, title: string, modifiedOn: number, modifiedBy_username: string } | null };

export type ChangeDueDateMutationVariables = Exact<{
  id_ticket: Scalars['ID']['input'];
  start?: InputMaybe<Scalars['Float']['input']>;
  end?: InputMaybe<Scalars['Float']['input']>;
}>;


export type ChangeDueDateMutation = { __typename?: 'Mutation', updateDueDate?: { __typename?: 'Ticket', _id: string, modifiedOn: number, modifiedBy_username: string, dueDate?: { __typename?: 'TicketDueDate', start?: number | null, end?: number | null } | null } | null };

export type UpdateTicketAssetsMutationVariables = Exact<{
  id_ticket: Scalars['ID']['input'];
  assets?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type UpdateTicketAssetsMutation = { __typename?: 'Mutation', addAssets?: { __typename?: 'Ticket', _id: string, assets?: Array<string | null> | null, modifiedOn: number, modifiedBy_username: string } | null };

export type ChangeTicketStatusMutationVariables = Exact<{
  id_ticket: Scalars['ID']['input'];
  id_status: Scalars['ID']['input'];
}>;


export type ChangeTicketStatusMutation = { __typename?: 'Mutation', changeTicketStatus?: { __typename?: 'Ticket', _id: string, _id_status: string, modifiedOn: number, modifiedBy_username: string } | null };

export type ChangeTicketAssigneesMutationVariables = Exact<{
  id_ticket: Scalars['ID']['input'];
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type ChangeTicketAssigneesMutation = { __typename?: 'Mutation', setTicketAssignees?: { __typename?: 'Ticket', _id: string, assignees?: Array<string | null> | null, modifiedOn: number, modifiedBy_username: string, notification?: { __typename?: 'Notification', id: string, notify_assignee: boolean, notify_comment: boolean, notify_status: boolean } | null } | null };

export type ChangeTicketBoardMutationVariables = Exact<{
  id_ticket: Scalars['ID']['input'];
  id_board: Scalars['ID']['input'];
}>;


export type ChangeTicketBoardMutation = { __typename?: 'Mutation', updateTicketBoard?: { __typename?: 'Ticket', _id: string, _id_board: string, modifiedOn: number, modifiedBy_username: string } | null };

export type ChangeTicketModulesMutationVariables = Exact<{
  id_ticket: Scalars['ID']['input'];
  modules: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type ChangeTicketModulesMutation = { __typename?: 'Mutation', setTicketModules?: { __typename?: 'Ticket', _id: string, modules?: Array<string | null> | null, modifiedOn: number, modifiedBy_username: string } | null };

export type ChangeTicketTemplateMutationVariables = Exact<{
  id_ticket: Scalars['ID']['input'];
  id_template: Scalars['ID']['input'];
}>;


export type ChangeTicketTemplateMutation = { __typename?: 'Mutation', updateTicketTemplate?: { __typename?: 'Ticket', _id: string, _id_template?: string | null, modifiedOn: number, modifiedBy_username: string } | null };

export type ChangeTicketDescriptionMutationVariables = Exact<{
  id_ticket: Scalars['ID']['input'];
  description: Scalars['String']['input'];
}>;


export type ChangeTicketDescriptionMutation = { __typename?: 'Mutation', setTicketDescription?: { __typename?: 'TicketInformation', description?: string | null } | null };

export type ChangeTicketIsFavoriteMutationVariables = Exact<{
  id_ticket: Scalars['ID']['input'];
  isFavorite: Scalars['Boolean']['input'];
}>;


export type ChangeTicketIsFavoriteMutation = { __typename?: 'Mutation', changeFavState?: { __typename?: 'Ticket', _id: string, isFavorite?: boolean | null, modifiedOn: number, modifiedBy_username: string } | null };

export type ChangeTicketIsArchiveMutationVariables = Exact<{
  id_ticket: Scalars['ID']['input'];
  isArchive: Scalars['Boolean']['input'];
}>;


export type ChangeTicketIsArchiveMutation = { __typename?: 'Mutation', changeArchState?: { __typename?: 'Ticket', _id: string, isArchive: boolean, modifiedOn: number, modifiedBy_username: string } | null };

export type ChangeTicketNotificationMutationVariables = Exact<{
  id_notification: Scalars['ID']['input'];
  notify_assignee: Scalars['Boolean']['input'];
  notify_comment: Scalars['Boolean']['input'];
  notify_status: Scalars['Boolean']['input'];
}>;


export type ChangeTicketNotificationMutation = { __typename?: 'Mutation', updateNotification?: { __typename?: 'Notification', id: string, notify_assignee: boolean, notify_comment: boolean, notify_status: boolean } | null };

export type ChangeDeleteTicketStateMutationVariables = Exact<{
  id_ticket: Scalars['ID']['input'];
}>;


export type ChangeDeleteTicketStateMutation = { __typename?: 'Mutation', setDeleteTicketState?: { __typename?: 'Ticket', _id: string, timeToDelete: number, modifiedOn: number, modifiedBy_username: string } | null };

export type DeleteTicketPermanentlyMutationVariables = Exact<{
  id_ticket: Scalars['ID']['input'];
}>;


export type DeleteTicketPermanentlyMutation = { __typename?: 'Mutation', deleteTicket: boolean };

export type AddTicketCustomFieldMutationVariables = Exact<{
  parent_id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
}>;


export type AddTicketCustomFieldMutation = { __typename?: 'Mutation', addTicketCustomField?: { __typename?: 'TicketInformation', customFields?: Array<{ __typename?: 'CustomFieldCheckbox', id: string, name?: string | null, type?: string | null, order?: number | null, parentId: string, boolean?: boolean | null } | { __typename?: 'CustomFieldChecklist', id: string, name?: string | null, type?: string | null, order?: number | null, parentId: string, value?: Array<{ __typename?: 'CustomOption', name?: string | null, checked?: boolean | null } | null> | null } | { __typename?: 'CustomFieldDate', id: string, name?: string | null, type?: string | null, order?: number | null, parentId: string, number?: number | null } | { __typename?: 'CustomFieldDropdown', id: string, name?: string | null, type?: string | null, order?: number | null, parentId: string, value?: Array<{ __typename?: 'CustomOption', name?: string | null, checked?: boolean | null } | null> | null } | { __typename?: 'CustomFieldGroup', id: string, name?: string | null, type?: string | null, order?: number | null, parentId: string, value?: Array<{ __typename?: 'CustomFieldCheckbox', id: string, name?: string | null, order?: number | null, parentId: string, type?: string | null, boolean?: boolean | null } | { __typename?: 'CustomFieldChecklist', id: string, name?: string | null, order?: number | null, parentId: string, type?: string | null, value?: Array<{ __typename?: 'CustomOption', name?: string | null, checked?: boolean | null } | null> | null } | { __typename?: 'CustomFieldDate', id: string, name?: string | null, order?: number | null, parentId: string, type?: string | null, number?: number | null } | { __typename?: 'CustomFieldDropdown', id: string, name?: string | null, order?: number | null, parentId: string, type?: string | null, value?: Array<{ __typename?: 'CustomOption', name?: string | null, checked?: boolean | null } | null> | null } | { __typename?: 'CustomFieldGroup', id: string, name?: string | null, order?: number | null, parentId: string, type?: string | null } | { __typename?: 'CustomFieldNumber', id: string, name?: string | null, order?: number | null, parentId: string, type?: string | null, number?: number | null } | { __typename?: 'CustomFieldString', id: string, name?: string | null, order?: number | null, parentId: string, type?: string | null, string?: string | null } | null> | null } | { __typename?: 'CustomFieldNumber', id: string, name?: string | null, type?: string | null, order?: number | null, parentId: string, number?: number | null } | { __typename?: 'CustomFieldString', id: string, name?: string | null, type?: string | null, order?: number | null, parentId: string, string?: string | null } | null> | null } | null };

export type ChangeTicketCustomFieldNameMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChangeTicketCustomFieldNameMutation = { __typename?: 'Mutation', changeTicketCustomFieldName?: boolean | null };

export type ChangeTicketCustomFieldMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  parent_id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChangeTicketCustomFieldMutation = { __typename?: 'Mutation', changeTicketCustomField?: { __typename?: 'TicketInformation', customFields?: Array<{ __typename?: 'CustomFieldCheckbox', id: string, name?: string | null, type?: string | null, order?: number | null, parentId: string, boolean?: boolean | null } | { __typename?: 'CustomFieldChecklist', id: string, name?: string | null, type?: string | null, order?: number | null, parentId: string, value?: Array<{ __typename?: 'CustomOption', name?: string | null, checked?: boolean | null } | null> | null } | { __typename?: 'CustomFieldDate', id: string, name?: string | null, type?: string | null, order?: number | null, parentId: string, number?: number | null } | { __typename?: 'CustomFieldDropdown', id: string, name?: string | null, type?: string | null, order?: number | null, parentId: string, value?: Array<{ __typename?: 'CustomOption', name?: string | null, checked?: boolean | null } | null> | null } | { __typename?: 'CustomFieldGroup', id: string, name?: string | null, type?: string | null, order?: number | null, parentId: string, value?: Array<{ __typename?: 'CustomFieldCheckbox', id: string, name?: string | null, order?: number | null, parentId: string, type?: string | null, boolean?: boolean | null } | { __typename?: 'CustomFieldChecklist', id: string, name?: string | null, order?: number | null, parentId: string, type?: string | null, value?: Array<{ __typename?: 'CustomOption', name?: string | null, checked?: boolean | null } | null> | null } | { __typename?: 'CustomFieldDate', id: string, name?: string | null, order?: number | null, parentId: string, type?: string | null, number?: number | null } | { __typename?: 'CustomFieldDropdown', id: string, name?: string | null, order?: number | null, parentId: string, type?: string | null, value?: Array<{ __typename?: 'CustomOption', name?: string | null, checked?: boolean | null } | null> | null } | { __typename?: 'CustomFieldGroup', id: string, name?: string | null, order?: number | null, parentId: string, type?: string | null } | { __typename?: 'CustomFieldNumber', id: string, name?: string | null, order?: number | null, parentId: string, type?: string | null, number?: number | null } | { __typename?: 'CustomFieldString', id: string, name?: string | null, order?: number | null, parentId: string, type?: string | null, string?: string | null } | null> | null } | { __typename?: 'CustomFieldNumber', id: string, name?: string | null, type?: string | null, order?: number | null, parentId: string, number?: number | null } | { __typename?: 'CustomFieldString', id: string, name?: string | null, type?: string | null, order?: number | null, parentId: string, string?: string | null } | null> | null } | null };

export type DeleteTicketCustomFieldMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTicketCustomFieldMutation = { __typename?: 'Mutation', deleteTicketCustomField?: { __typename?: 'TicketInformation', customFields?: Array<{ __typename?: 'CustomFieldCheckbox', id: string, name?: string | null, type?: string | null, order?: number | null, parentId: string, boolean?: boolean | null } | { __typename?: 'CustomFieldChecklist', id: string, name?: string | null, type?: string | null, order?: number | null, parentId: string, value?: Array<{ __typename?: 'CustomOption', name?: string | null, checked?: boolean | null } | null> | null } | { __typename?: 'CustomFieldDate', id: string, name?: string | null, type?: string | null, order?: number | null, parentId: string, number?: number | null } | { __typename?: 'CustomFieldDropdown', id: string, name?: string | null, type?: string | null, order?: number | null, parentId: string, value?: Array<{ __typename?: 'CustomOption', name?: string | null, checked?: boolean | null } | null> | null } | { __typename?: 'CustomFieldGroup', id: string, name?: string | null, type?: string | null, order?: number | null, parentId: string, value?: Array<{ __typename?: 'CustomFieldCheckbox', id: string, name?: string | null, order?: number | null, parentId: string, type?: string | null, boolean?: boolean | null } | { __typename?: 'CustomFieldChecklist', id: string, name?: string | null, order?: number | null, parentId: string, type?: string | null, value?: Array<{ __typename?: 'CustomOption', name?: string | null, checked?: boolean | null } | null> | null } | { __typename?: 'CustomFieldDate', id: string, name?: string | null, order?: number | null, parentId: string, type?: string | null, number?: number | null } | { __typename?: 'CustomFieldDropdown', id: string, name?: string | null, order?: number | null, parentId: string, type?: string | null, value?: Array<{ __typename?: 'CustomOption', name?: string | null, checked?: boolean | null } | null> | null } | { __typename?: 'CustomFieldGroup', id: string, name?: string | null, order?: number | null, parentId: string, type?: string | null } | { __typename?: 'CustomFieldNumber', id: string, name?: string | null, order?: number | null, parentId: string, type?: string | null, number?: number | null } | { __typename?: 'CustomFieldString', id: string, name?: string | null, order?: number | null, parentId: string, type?: string | null, string?: string | null } | null> | null } | { __typename?: 'CustomFieldNumber', id: string, name?: string | null, type?: string | null, order?: number | null, parentId: string, number?: number | null } | { __typename?: 'CustomFieldString', id: string, name?: string | null, type?: string | null, order?: number | null, parentId: string, string?: string | null } | null> | null } | null };

export type DeleteTicketCommentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  id_ticket: Scalars['ID']['input'];
}>;


export type DeleteTicketCommentMutation = { __typename?: 'Mutation', deleteTicketComment?: boolean | null };

export type DeleteTicketIntegrationMutationVariables = Exact<{
  id_ticket: Scalars['ID']['input'];
  id_integration: Scalars['ID']['input'];
}>;


export type DeleteTicketIntegrationMutation = { __typename?: 'Mutation', deleteTicketIntegration?: boolean | null };

export type ChangeTicketIntegrationMutationVariables = Exact<{
  id_ticket: Scalars['ID']['input'];
  integrations: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  type: IntegrationType;
}>;


export type ChangeTicketIntegrationMutation = { __typename?: 'Mutation', setTicketIntegration: Array<{ __typename: 'Troubleshoot', code?: string | null, description?: string | null, assetId?: string | null, isOpen?: boolean | null, category?: string | null, _id_integration: string, type?: IntegrationType | null, productionLoss?: number | null, turbineInfo?: { __typename?: 'TurbineIntegration', id: string, serial?: string | null, code?: string | null } | null, dateRange?: { __typename?: 'DateRange', start?: number | null, end?: number | null } | null } | null> };

export type SetMultipleTicketsToMultipleIntegrationsMutationVariables = Exact<{
  tickets: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  integrations: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  devices: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  type: IntegrationType;
}>;


export type SetMultipleTicketsToMultipleIntegrationsMutation = { __typename?: 'Mutation', setMultipleTicketsToMultipleIntegrations?: boolean | null };

export type AddTicketAttachmentMutationVariables = Exact<{
  id_ticket: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  originalName: Scalars['String']['input'];
  fileExtension: Scalars['String']['input'];
  size: Scalars['Int']['input'];
}>;


export type AddTicketAttachmentMutation = { __typename?: 'Mutation', addTicketAttachment: boolean };

export type DeleteTicketAttachmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTicketAttachmentMutation = { __typename?: 'Mutation', deleteTicketAttachment: boolean };

export type GetUserInformationForTicketingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserInformationForTicketingQuery = { __typename?: 'Query', user?: { __typename?: 'User', collegues?: Array<{ __typename?: 'User', _id?: string | null, full_name?: string | null } | null> | null, ticketTemplates?: Array<{ __typename?: 'TicketTemplate', _id: string, name: string, customFields?: Array<{ __typename?: 'TemplateCustomField', name?: string | null, type?: string | null, order?: number | null } | null> | null } | null> | null, boards?: Array<{ __typename?: 'Board', _id: string, name: string, statuses?: Array<{ __typename?: 'Status', _id: string, name: string, hide: boolean, color: string, order: number } | null> | null } | null> | null, ticketModules?: Array<{ __typename?: 'TicketModule', name: string, _id?: string | null } | null> | null } | null };

export type AlarmErrorsWarningSubscriptionVariables = Exact<{
  serialNav: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type AlarmErrorsWarningSubscription = { __typename?: 'Subscription', turbines: Array<{ __typename?: 'Turbine', alarms: Array<{ __typename?: 'Alarm', code?: string | null, alarms?: Array<{ __typename?: 'AlarmError', code: string, description: string, createTS: number, type?: string | null } | null> | null } | null> }> };

export type AlarmLogbookSubscriptionVariables = Exact<{
  serialNav: Scalars['Float']['input'];
  startTS: Scalars['Float']['input'];
  endTS?: InputMaybe<Scalars['Float']['input']>;
}>;


export type AlarmLogbookSubscription = { __typename?: 'Subscription', turbines: Array<{ __typename?: 'Turbine', logbook: Array<{ __typename?: 'Logbook', createTS: number, code: string, type?: string | null, description: string } | null> }> };

export type AlarmInformationSubscriptionVariables = Exact<{
  serialNav: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type AlarmInformationSubscription = { __typename?: 'Subscription', turbines: Array<{ __typename?: 'Turbine', alarms: Array<{ __typename?: 'Alarm', _id: string, _id_alarm?: string | null, code?: string | null, description?: string | null, createTS?: number | null, closeTS?: number | null, durationLong?: string | null, production?: number | null, productionLoss?: number | null, theoreticalProduction?: number | null, isOpen: boolean, alarmCategory: AlarmCategory, subBlocks?: Array<string | null> | null, controlroomAck?: boolean | null, controlroomAckLog?: Array<string | null> | null, controlroomTicketing?: Array<string | null> | null, controlroomTicketingLog?: Array<string | null> | null, turbine: { __typename?: 'Turbine', name: string, serial: string, serialNav: number, code: string } } | null> }> };

export type AlarmMainSubscriptionVariables = Exact<{
  serialNav: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type AlarmMainSubscription = { __typename?: 'Subscription', turbines: Array<{ __typename?: 'Turbine', _id: string, code: string, codeDisplay: string, serialNav: number, alarms: Array<{ __typename?: 'Alarm', _id: string, code?: string | null, description?: string | null, processed?: boolean | null, createTS?: number | null, isOpen: boolean } | null> }> };

export const RevenuesFragmentDoc = gql`
    fragment Revenues on RevenuesDataseriesValue {
  timestamp
  productionScada
  productionGrid
  productionLosses
  productionGridCount
  marketPrice
  data {
    metric
    value
  }
}
    `;
export const TotalsFragmentDoc = gql`
    fragment Totals on EnergyMeterTotals {
  productionGrid
  productionGridCount
  productionScada
  productionLosses
  scadaRevenue
  revenueLosses
  consumptionLosses
  totalRevenue
  marketPrice
  electricitySalesRevenue
  incentiveRevenue
  consumptionGrid
  marketPriceRevenues
  referencePrice
  referencePriceRevenues
  PPAElectricityPrice
  incentive
  totalTariff
  realizedPPA
}
    `;
export const SeriesTotalsFragmentDoc = gql`
    fragment SeriesTotals on EnergyMeterDataseriesValue {
  period
  productionGrid
  productionGridCount
  productionScada
  productionLosses
  scadaRevenue
  revenueLosses
  consumptionLosses
  totalRevenue
  marketPrice
  electricitySalesRevenue
  incentiveRevenue
  consumptionGrid
  marketPriceRevenues
  referencePrice
  referencePriceRevenues
  PPAElectricityPrice
  incentive
  totalTariff
  realizedPPA
}
    `;
export const ParkMetadataDocument = gql`
    query ParkMetadata($parkId: ID!) {
  parks(where: {_id: $parkId}) {
    co2
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ParkMetadataGQL extends Apollo.Query<ParkMetadataQuery, ParkMetadataQueryVariables> {
    document = ParkMetadataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TurbineMetadataDocument = gql`
    query TurbineMetadata($turbineId: Float!) {
  turbines(where: {serialNav: $turbineId}) {
    park {
      co2
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TurbineMetadataGQL extends Apollo.Query<TurbineMetadataQuery, TurbineMetadataQueryVariables> {
    document = TurbineMetadataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TurbineDataTableDocument = gql`
    query TurbineDataTable($date: Int!, $serialNav: Float!, $sector: SectorCategoryEnum = JOIN, $historical: Boolean!) {
  turbines(where: {serialNav: $serialNav}) {
    _id
    name
    code
    powerCurve {
      manufacturerPC
      monthlyPC(date: $date, sector: $sector) @skip(if: $historical) {
        powerCurveData {
          windSpeed
          sector
          outPutPower
          binSize
          frequency
        }
      }
      historicalPC(sector: $sector) @include(if: $historical) {
        powerCurveData {
          windSpeed
          sector
          outPutPower
          binSize
          frequency
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TurbineDataTableGQL extends Apollo.Query<TurbineDataTableQuery, TurbineDataTableQueryVariables> {
    document = TurbineDataTableDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PowerCurveDocument = gql`
    query PowerCurve($historicalFilter: [TurbineWhereInput!], $monthlyFilter: [TurbineWhereInput!], $manufacturerFilter: [TurbineWhereInput!], $scatterPlotFilter: [TurbineWhereInput!], $monthlyStatFilter: [TurbineWhereInput!], $scatterplotStarTs: Float!, $scatterploteEndTs: Float!, $sector: SectorCategoryEnum!, $date: Int!) {
  forMonthly: turbines(where: {OR: $monthlyFilter}) {
    code: codeDisplay
    id: _id
    powerCurve {
      monthlyPC(date: $date, sector: $sector) {
        powerCurveData {
          windSpeed
          outPutPower
          sector
        }
      }
    }
  }
  forMonthlyStat: turbines(where: {OR: $monthlyStatFilter}) {
    code: codeDisplay
    id: _id
    powerCurve {
      statisticalMonthlyPC(date: $date) {
        windSpeed
        outPutPower
      }
    }
  }
  forHistorical: turbines(where: {OR: $historicalFilter}) {
    code: codeDisplay
    id: _id
    powerCurve {
      historicalPC(sector: $sector) {
        powerCurveData {
          windSpeed
          outPutPower
          sector
        }
      }
    }
  }
  forScatterPlot: turbines(where: {OR: $scatterPlotFilter}) {
    code: codeDisplay
    id: _id
    powerCurve {
      scatterPlot(start: $scatterplotStarTs, end: $scatterploteEndTs) {
        x
        y
      }
    }
  }
  forManufacturer: turbines(where: {OR: $manufacturerFilter}) {
    code: codeDisplay
    id: _id
    powerCurve {
      manufacturerPC
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PowerCurveGQL extends Apollo.Query<PowerCurveQuery, PowerCurveQueryVariables> {
    document = PowerCurveDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TurbineRatedPowerDocument = gql`
    query TurbineRatedPower($serialNav: Float!) {
  turbines(where: {serialNav: $serialNav}) {
    ratedPower
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TurbineRatedPowerGQL extends Apollo.Query<TurbineRatedPowerQuery, TurbineRatedPowerQueryVariables> {
    document = TurbineRatedPowerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ParkRatedPowerDocument = gql`
    query ParkRatedPower($parkName: String!) {
  parks(where: {name: $parkName}) {
    dataDebbug {
      WTUR1_kW_rated {
        avg
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ParkRatedPowerGQL extends Apollo.Query<ParkRatedPowerQuery, ParkRatedPowerQueryVariables> {
    document = ParkRatedPowerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTurbinesByParkDocument = gql`
    query getTurbinesByPark($parkName: String!, $turbines: [ID]) {
  parks(where: {name: $parkName}, turbines: $turbines) {
    turbines {
      _id
      hubHeight
      type
      code
      codeDisplay
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTurbinesByParkGQL extends Apollo.Query<GetTurbinesByParkQuery, GetTurbinesByParkQueryVariables> {
    document = GetTurbinesByParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTurbineBySerialDocument = gql`
    query getTurbineBySerial($serialNav: Float!) {
  turbines(where: {serialNav: $serialNav}) {
    _id
    hubHeight
    type
    code
    codeDisplay
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTurbineBySerialGQL extends Apollo.Query<GetTurbineBySerialQuery, GetTurbineBySerialQueryVariables> {
    document = GetTurbineBySerialDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSignalsListDocument = gql`
    query getSignalsList($serialNav: Float) {
  turbines(where: {serialNav: $serialNav}) {
    name
    signalsList(stream: s10m, filter: tmp) {
      name
      displayName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSignalsListGQL extends Apollo.Query<GetSignalsListQuery, GetSignalsListQueryVariables> {
    document = GetSignalsListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetParkTemperatureListDocument = gql`
    query getParkTemperatureList($id: ID!) {
  parks(where: {_id: $id}) {
    turbines {
      type
      signalsList(stream: s10m, filter: tmp) {
        name
        displayName
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetParkTemperatureListGQL extends Apollo.Query<GetParkTemperatureListQuery, GetParkTemperatureListQueryVariables> {
    document = GetParkTemperatureListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTemperatureLimitsSettingsDocument = gql`
    query GetTemperatureLimitsSettings($id: ID!, $idPark: ID!) {
  turbineHeatmapThresholds(_id_turbine: $id) {
    turbineThresholds {
      signal
      max
      min
    }
  }
  parkHeatmapThresholds(_id_park: $idPark) {
    parkThresholds {
      turbineType
      thresholds {
        signal
        min
        max
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTemperatureLimitsSettingsGQL extends Apollo.Query<GetTemperatureLimitsSettingsQuery, GetTemperatureLimitsSettingsQueryVariables> {
    document = GetTemperatureLimitsSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTemperatureLimitsSettingsDocument = gql`
    mutation UpdateTemperatureLimitsSettings($id: ID!, $limits: [TurbineSignalThresholdInput!]!, $parkLimits: [ParkTurbineTypeThresholdInput!]!, $parkId: ID!) {
  saveTurbineHeatmapThresholds(_id_turbine: $id, thresholds: $limits)
  saveParkHeatmapThresholds(_id_park: $parkId, turbineTypes: $parkLimits)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTemperatureLimitsSettingsGQL extends Apollo.Mutation<UpdateTemperatureLimitsSettingsMutation, UpdateTemperatureLimitsSettingsMutationVariables> {
    document = UpdateTemperatureLimitsSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WindDirectionTurbineDocument = gql`
    query WindDirectionTurbine($serialNav: Float!, $sector: SectorCategoryEnum = ALL, $date: Int!, $historical: Boolean!) {
  turbines(where: {serialNav: $serialNav}) {
    powerCurve {
      monthlyPC(date: $date, sector: $sector) @skip(if: $historical) {
        windRose {
          sector
          values
        }
      }
      historicalPC(sector: $sector) @include(if: $historical) {
        windRose {
          sector
          values
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WindDirectionTurbineGQL extends Apollo.Query<WindDirectionTurbineQuery, WindDirectionTurbineQueryVariables> {
    document = WindDirectionTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WindSpeedDistributionTurbineDocument = gql`
    query WindSpeedDistributionTurbine($date: Int!, $serialNav: Float!, $historical: Boolean!) {
  turbines(where: {serialNav: $serialNav}) {
    code: codeDisplay
    powerCurve {
      monthlyPC(date: $date, sector: JOIN) @skip(if: $historical) {
        powerCurveData {
          frequency
          windSpeed
        }
      }
      historicalPC(sector: JOIN) @include(if: $historical) {
        powerCurveData {
          frequency
          windSpeed
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WindSpeedDistributionTurbineGQL extends Apollo.Query<WindSpeedDistributionTurbineQuery, WindSpeedDistributionTurbineQueryVariables> {
    document = WindSpeedDistributionTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForecastAccuracyActualDocument = gql`
    query ForecastAccuracyActual($id: ID, $timeZone: String!, $startTs: Float!, $endTs: Float!) {
  parks(where: {_id: $id}) {
    _id
    forecastAccuracy(startTs: $startTs, endTs: $endTs, timeZone: $timeZone) {
      actualPowerVsForecast {
        actualPower
        regularForecast
        dayAheadForecast
        unixTs
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForecastAccuracyActualGQL extends Apollo.Query<ForecastAccuracyActualQuery, ForecastAccuracyActualQueryVariables> {
    document = ForecastAccuracyActualDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForecastAccuracyErrorPercentageDocument = gql`
    query ForecastAccuracyErrorPercentage($id: ID, $timeZone: String!, $startTs: Float!, $endTs: Float!, $aggregation: String) {
  parks(where: {_id: $id}) {
    _id
    forecastAccuracy(startTs: $startTs, endTs: $endTs, timeZone: $timeZone) {
      forecastErrorTarget(aggregation: $aggregation) {
        percentage
        unixTs
      }
      forecastErrorPercentage(aggregation: $aggregation) {
        positiveErrorPercentage
        negativeErrorPercentage
        totalErrorPercentage
        unixTs
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForecastAccuracyErrorPercentageGQL extends Apollo.Query<ForecastAccuracyErrorPercentageQuery, ForecastAccuracyErrorPercentageQueryVariables> {
    document = ForecastAccuracyErrorPercentageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForecastAccuracyErrorValueDocument = gql`
    query ForecastAccuracyErrorValue($id: ID, $timeZone: String!, $startTs: Float!, $endTs: Float!, $aggregation: String) {
  parks(where: {_id: $id}) {
    _id
    forecastAccuracy(startTs: $startTs, endTs: $endTs, timeZone: $timeZone) {
      forecastErrorTarget(aggregation: $aggregation) {
        MWh
        unixTs
      }
      forecastErrorMWh(aggregation: $aggregation) {
        positiveErrorMWh
        negativeErrorMWh
        totalErrorMWh
        unixTs
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForecastAccuracyErrorValueGQL extends Apollo.Query<ForecastAccuracyErrorValueQuery, ForecastAccuracyErrorValueQueryVariables> {
    document = ForecastAccuracyErrorValueDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForecastAccuracyErrorRevenueDocument = gql`
    query ForecastAccuracyErrorRevenue($id: ID, $timeZone: String!, $startTs: Float!, $endTs: Float!, $aggregation: String) {
  parks(where: {_id: $id}) {
    _id
    forecastAccuracy(startTs: $startTs, endTs: $endTs, timeZone: $timeZone) {
      forecastErrorTarget(aggregation: $aggregation) {
        EUR
        unixTs
      }
      forecastErrorEUR(aggregation: $aggregation) {
        totalError
        unixTs
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForecastAccuracyErrorRevenueGQL extends Apollo.Query<ForecastAccuracyErrorRevenueQuery, ForecastAccuracyErrorRevenueQueryVariables> {
    document = ForecastAccuracyErrorRevenueDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PortfolioWaterfallDocument = gql`
    query PortfolioWaterfall($startTs: Float!, $endTs: Float!, $parks: [ID]) {
  portfolios(parks: $parks) {
    performanceAnalytics(startTS: $startTs, endTS: $endTs) {
      waterfall {
        actualPower {
          flagName
          energy
          percentEnergy
          revenue
          percentRevenue
          parentFlag
        }
        delta {
          flagName
          energy
          percentEnergy
          revenue
          percentRevenue
          parentFlag
        }
        theoreticalPower {
          flagName
          energy
          percentEnergy
          revenue
          percentRevenue
          parentFlag
        }
        lostPower {
          flagName
          energy
          percentEnergy
          revenue
          percentRevenue
          parentFlag
        }
        availabilityPower {
          flagName
          energy
          percentEnergy
          revenue
          percentRevenue
          parentFlag
        }
        curtailmentPower {
          flagName
          energy
          percentEnergy
          revenue
          percentRevenue
          parentFlag
        }
        partialPerformancePower {
          flagName
          energy
          percentEnergy
          revenue
          percentRevenue
          parentFlag
        }
        deratingPower {
          flagName
          energy
          percentEnergy
          revenue
          percentRevenue
          parentFlag
        }
        otherUnderperformancePower {
          flagName
          energy
          percentEnergy
          revenue
          percentRevenue
          parentFlag
        }
        overratingPower {
          flagName
          energy
          percentEnergy
          revenue
          percentRevenue
          parentFlag
        }
        hysteresisPower {
          flagName
          energy
          percentEnergy
          revenue
          percentRevenue
          parentFlag
        }
        budget {
          flagName
          energy
          percentEnergy
          revenue
          percentRevenue
          parentFlag
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PortfolioWaterfallGQL extends Apollo.Query<PortfolioWaterfallQuery, PortfolioWaterfallQueryVariables> {
    document = PortfolioWaterfallDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ParkWaterfallDocument = gql`
    query ParkWaterfall($id: ID, $startTs: Float!, $endTs: Float!, $turbines: [ID]!) {
  parks(where: {_id: $id}, turbines: $turbines) {
    name
    performanceAnalytics(startTS: $startTs, endTS: $endTs) {
      waterfall {
        actualPower {
          flagName
          energy
          percentEnergy
          revenue
          percentRevenue
          parentFlag
        }
        delta {
          flagName
          energy
          percentEnergy
          revenue
          percentRevenue
          parentFlag
        }
        theoreticalPower {
          flagName
          energy
          percentEnergy
          revenue
          percentRevenue
          parentFlag
        }
        lostPower {
          flagName
          energy
          percentEnergy
          revenue
          percentRevenue
          parentFlag
        }
        availabilityPower {
          flagName
          energy
          percentEnergy
          revenue
          percentRevenue
          parentFlag
        }
        curtailmentPower {
          flagName
          energy
          percentEnergy
          revenue
          percentRevenue
          parentFlag
        }
        partialPerformancePower {
          flagName
          energy
          percentEnergy
          revenue
          percentRevenue
          parentFlag
        }
        deratingPower {
          flagName
          energy
          percentEnergy
          revenue
          percentRevenue
          parentFlag
        }
        otherUnderperformancePower {
          flagName
          energy
          percentEnergy
          revenue
          percentRevenue
          parentFlag
        }
        overratingPower {
          flagName
          energy
          percentEnergy
          revenue
          percentRevenue
          parentFlag
        }
        hysteresisPower {
          flagName
          energy
          percentEnergy
          revenue
          percentRevenue
          parentFlag
        }
        budget {
          flagName
          energy
          percentEnergy
          revenue
          percentRevenue
          parentFlag
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ParkWaterfallGQL extends Apollo.Query<ParkWaterfallQuery, ParkWaterfallQueryVariables> {
    document = ParkWaterfallDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PortfolioAssetDocument = gql`
    query PortfolioAsset($flag: String!, $start: Float!, $end: Float!, $idParks: [ID]!) {
  portfolios(parks: $idParks) {
    name
    performanceAnalytics(startTS: $start, endTS: $end) {
      assets(flag: $flag) {
        id
        prod
        rev
        percentageVsTheo
        duration
      }
    }
    name
    parks {
      _id
      code
      displayCode
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PortfolioAssetGQL extends Apollo.Query<PortfolioAssetQuery, PortfolioAssetQueryVariables> {
    document = PortfolioAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ParkAssetDocument = gql`
    query ParkAsset($idPark: ID, $flag: String!, $start: Float!, $end: Float!, $idTurbines: [ID]!) {
  parks(where: {_id: $idPark}, turbines: $idTurbines) {
    name
    performanceAnalytics(startTS: $start, endTS: $end) {
      assets(flag: $flag) {
        id
        prod
        rev
        percentageVsTheo
        duration
      }
    }
    turbines {
      _id
      name
      code: codeDisplay
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ParkAssetGQL extends Apollo.Query<ParkAssetQuery, ParkAssetQueryVariables> {
    document = ParkAssetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindingsByFlagDocument = gql`
    query FindingsByFlag($id: ID, $flag: String!, $startTs: Float!, $endTs: Float!, $turbines: [ID]!) {
  parks(where: {_id: $id}, turbines: $turbines) {
    code
    name
    performanceAnalytics(startTS: $startTs, endTS: $endTs) {
      findings(flag: $flag) {
        prod
        startTs
        startDate
        endTs
        endDate
        flagName
        parentFlag
        duration
        _id_turbine
        rev
      }
    }
    turbines {
      code: codeDisplay
      name
      _id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FindingsByFlagGQL extends Apollo.Query<FindingsByFlagQuery, FindingsByFlagQueryVariables> {
    document = FindingsByFlagDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindingsDocument = gql`
    query Findings($id: ID, $startTs: Float!, $endTs: Float!, $turbines: [ID]!) {
  parks(where: {_id: $id}, turbines: $turbines) {
    code
    name
    performanceAnalytics(startTS: $startTs, endTS: $endTs) {
      findings {
        prod
        startTs
        endTs
        flagName
        parentFlag
        duration
        rev
        _id_turbine
      }
    }
    turbines {
      code: codeDisplay
      name
      _id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FindingsGQL extends Apollo.Query<FindingsQuery, FindingsQueryVariables> {
    document = FindingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevenuesFactsParkByPeriodDocument = gql`
    query RevenuesFactsParkByPeriod($name: String!, $dayFrom: Float!, $dayTo: Float!, $monthFrom: Float!, $monthTo: Float!, $monthToEnd: Float!, $yearFrom: Float!, $yearTo: Float!, $yearToEnd: Float!) {
  parks(where: {name: $name}) {
    _id
    name
    country {
      name
      code
    }
    ratedPower: dataDebbug {
      WTUR1_MW_rated {
        sum
      }
    }
    fe_name
    dayTotals: revenuesDataseries(from: $dayFrom, to: $dayTo, granularity: TOTAL) {
      ...Revenues
    }
    monthTotals: revenuesDataseries(
      from: $monthFrom
      to: $monthTo
      granularity: TOTAL
    ) {
      ...Revenues
    }
    monthEndTotals: revenuesDataseries(
      from: $monthFrom
      to: $monthToEnd
      granularity: TOTAL
    ) {
      ...Revenues
    }
    yearTotals: revenuesDataseries(from: $yearFrom, to: $yearTo, granularity: TOTAL) {
      ...Revenues
    }
    yearMonthEndTotals: revenuesDataseries(
      from: $yearFrom
      to: $monthToEnd
      granularity: TOTAL
    ) {
      ...Revenues
    }
    yearEndTotals: revenuesDataseries(
      from: $yearFrom
      to: $yearToEnd
      granularity: TOTAL
    ) {
      ...Revenues
    }
  }
}
    ${RevenuesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RevenuesFactsParkByPeriodGQL extends Apollo.Query<RevenuesFactsParkByPeriodQuery, RevenuesFactsParkByPeriodQueryVariables> {
    document = RevenuesFactsParkByPeriodDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevenuesDataSeriesParkByPeriodDocument = gql`
    query RevenuesDataSeriesParkByPeriod($name: String!, $dayFrom: Float!, $dayTo: Float!, $granularity: RevenuesGranularityEnum!, $timezone: String!) {
  parks(where: {name: $name}) {
    _id
    name
    fe_name
    country {
      name
      code
    }
    revenuesDataseries(
      from: $dayFrom
      to: $dayTo
      granularity: $granularity
      timezone: $timezone
    ) {
      ...Revenues
    }
  }
}
    ${RevenuesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RevenuesDataSeriesParkByPeriodGQL extends Apollo.Query<RevenuesDataSeriesParkByPeriodQuery, RevenuesDataSeriesParkByPeriodQueryVariables> {
    document = RevenuesDataSeriesParkByPeriodDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevenuesDataSeriesPortfolioByPeriodDocument = gql`
    query RevenuesDataSeriesPortfolioByPeriod($monthFrom: Float!, $monthTo: Float!, $granularity: RevenuesGranularityEnum!, $timezone: String!, $portfolioId: String, $parks: [ID]) {
  portfolios(when: {_id: $portfolioId}, parks: $parks) {
    revenuesDataseries(
      from: $monthFrom
      to: $monthTo
      granularity: $granularity
      timezone: $timezone
    ) {
      ...Revenues
    }
    parks {
      _id
      code
      name
      fe_name
    }
  }
}
    ${RevenuesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RevenuesDataSeriesPortfolioByPeriodGQL extends Apollo.Query<RevenuesDataSeriesPortfolioByPeriodQuery, RevenuesDataSeriesPortfolioByPeriodQueryVariables> {
    document = RevenuesDataSeriesPortfolioByPeriodDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevenuesDataSeriesPortfolioByPeriodAndParkDocument = gql`
    query RevenuesDataSeriesPortfolioByPeriodAndPark($monthFrom: Float!, $monthTo: Float!, $granularity: RevenuesGranularityEnum!, $timezone: String!, $portfolioId: String, $parks: [ID]) {
  portfolios(when: {_id: $portfolioId}, parks: $parks) {
    parks {
      _id
      code
      name
      fe_name
    }
    revenuesDataseries(
      from: $monthFrom
      to: $monthTo
      granularity: $granularity
      timezone: $timezone
      groupBy: CHILDREN
    ) {
      ...Revenues
      _id_park
    }
  }
}
    ${RevenuesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RevenuesDataSeriesPortfolioByPeriodAndParkGQL extends Apollo.Query<RevenuesDataSeriesPortfolioByPeriodAndParkQuery, RevenuesDataSeriesPortfolioByPeriodAndParkQueryVariables> {
    document = RevenuesDataSeriesPortfolioByPeriodAndParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevenuesFactsPortfolioByPeriodDocument = gql`
    query RevenuesFactsPortfolioByPeriod($dayFrom: Float!, $dayTo: Float!, $monthFrom: Float!, $monthTo: Float!, $monthToEnd: Float!, $yearFrom: Float!, $yearTo: Float!, $yearToEnd: Float!, $portfolioId: String, $parks: [ID]) {
  portfolios(when: {_id: $portfolioId}, parks: $parks) {
    parks {
      _id
      name
      ratedPower: dataDebbug {
        WTUR1_MW_rated {
          sum
        }
      }
      fe_name
      code
      country {
        name
      }
      dayTotals: revenuesDataseries(from: $dayFrom, to: $dayTo, granularity: TOTAL) {
        ...Revenues
      }
      monthTotals: revenuesDataseries(
        from: $monthFrom
        to: $monthTo
        granularity: TOTAL
      ) {
        ...Revenues
      }
      monthEndTotals: revenuesDataseries(
        from: $monthFrom
        to: $monthToEnd
        granularity: TOTAL
      ) {
        ...Revenues
      }
      yearTotals: revenuesDataseries(from: $yearFrom, to: $yearTo, granularity: TOTAL) {
        ...Revenues
      }
      yearEndTotals: revenuesDataseries(
        from: $yearFrom
        to: $yearToEnd
        granularity: TOTAL
      ) {
        ...Revenues
      }
      yearMonthEndTotals: revenuesDataseries(
        from: $yearFrom
        to: $monthToEnd
        granularity: TOTAL
      ) {
        ...Revenues
      }
    }
  }
}
    ${RevenuesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RevenuesFactsPortfolioByPeriodGQL extends Apollo.Query<RevenuesFactsPortfolioByPeriodQuery, RevenuesFactsPortfolioByPeriodQueryVariables> {
    document = RevenuesFactsPortfolioByPeriodDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ParkCapturedPriceDocument = gql`
    query ParkCapturedPrice($id: ID, $from: Float!, $to: Float!, $timezone: String) {
  parks(where: {_id: $id}) {
    targetPrice(from: $from, to: $to, timezone: $timezone) {
      month
      targetPrice
    }
    windCaptureRatio(from: $from, to: $to, timezone: $timezone) {
      month
      windCaptureRatio
    }
    targetCaptureRatio(from: $from, to: $to, timezone: $timezone) {
      month
      targetCaptureRatio
    }
    revenuesDataseries(
      from: $from
      to: $to
      granularity: MONTHLY
      timezone: $timezone
    ) {
      ...Revenues
    }
  }
}
    ${RevenuesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ParkCapturedPriceGQL extends Apollo.Query<ParkCapturedPriceQuery, ParkCapturedPriceQueryVariables> {
    document = ParkCapturedPriceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevenuesParkFormulasDocument = gql`
    query RevenuesParkFormulas($name: String!, $from: Float!, $to: Float!, $timezone: String!) {
  parks(where: {name: $name}) {
    revenuesDataseries(
      from: $from
      to: $to
      granularity: TOTAL
      timezone: $timezone
    ) {
      data {
        metric
        value
        order
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RevenuesParkFormulasGQL extends Apollo.Query<RevenuesParkFormulasQuery, RevenuesParkFormulasQueryVariables> {
    document = RevenuesParkFormulasDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevenuesPortfolioFormulasDocument = gql`
    query RevenuesPortfolioFormulas($portfolioId: String!, $parks: [ID], $from: Float!, $to: Float!, $timezone: String!) {
  portfolios(when: {_id: $portfolioId}, parks: $parks) {
    revenuesDataseries(
      from: $from
      to: $to
      granularity: TOTAL
      timezone: $timezone
    ) {
      data {
        metric
        value
        order
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RevenuesPortfolioFormulasGQL extends Apollo.Query<RevenuesPortfolioFormulasQuery, RevenuesPortfolioFormulasQueryVariables> {
    document = RevenuesPortfolioFormulasDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PortfolioCurrencyDocument = gql`
    query PortfolioCurrency {
  portfolios {
    currency {
      _id
      name
      code
      symbol
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PortfolioCurrencyGQL extends Apollo.Query<PortfolioCurrencyQuery, PortfolioCurrencyQueryVariables> {
    document = PortfolioCurrencyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WindSpeedDocument = gql`
    query WindSpeed($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [ID!]) {
  parks(where: {name: $park}, turbines: $turbines) {
    name
    code
    turbines {
      _id
      name
      code: codeDisplay
      serialNav
    }
    groupedDataSeries(startTime: $starTs, endTime: $endTs) {
      windSpeed: WNAC1_WdSpd_avg_mag_f {
        _id_turbine
        data
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WindSpeedGQL extends Apollo.Query<WindSpeedQuery, WindSpeedQueryVariables> {
    document = WindSpeedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WindDirDocument = gql`
    query WindDir($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [ID!]) {
  parks(where: {name: $park}, turbines: $turbines) {
    name
    code
    turbines {
      _id
      name
      code: codeDisplay
      serialNav
    }
    groupedDataSeries(startTime: $starTs, endTime: $endTs) {
      windDir: WNAC1_WdDir_avg_mag_f {
        _id_turbine
        data
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WindDirGQL extends Apollo.Query<WindDirQuery, WindDirQueryVariables> {
    document = WindDirDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NacDirDocument = gql`
    query NacDir($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [ID!]) {
  parks(where: {name: $park}, turbines: $turbines) {
    name
    code
    turbines {
      _id
      name
      code: codeDisplay
      serialNav
    }
    groupedDataSeries(startTime: $starTs, endTime: $endTs) {
      nacDir: WNAC1_Dir_avg_mag_f {
        _id_turbine
        data
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NacDirGQL extends Apollo.Query<NacDirQuery, NacDirQueryVariables> {
    document = NacDirDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AmbTempDocument = gql`
    query AmbTemp($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [ID!]) {
  parks(where: {name: $park}, turbines: $turbines) {
    name
    code
    turbines {
      _id
      name
      code: codeDisplay
      serialNav
    }
    groupedDataSeries(startTime: $starTs, endTime: $endTs) {
      ambTemp: WNAC1_ExTmp_avg_mag_f {
        _id_turbine
        data
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AmbTempGQL extends Apollo.Query<AmbTempQuery, AmbTempQueryVariables> {
    document = AmbTempDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RotorSpeedDocument = gql`
    query RotorSpeed($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [ID!]) {
  parks(where: {name: $park}, turbines: $turbines) {
    name
    code
    turbines {
      _id
      name
      code: codeDisplay
      serialNav
    }
    groupedDataSeries(startTime: $starTs, endTime: $endTs) {
      rotorSpeed: WROT1_RotSpd_avg_mag_f {
        _id_turbine
        data
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RotorSpeedGQL extends Apollo.Query<RotorSpeedQuery, RotorSpeedQueryVariables> {
    document = RotorSpeedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GeneratorSpeedDocument = gql`
    query GeneratorSpeed($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [ID!]) {
  parks(where: {name: $park}, turbines: $turbines) {
    name
    code
    turbines {
      _id
      name
      code: codeDisplay
      serialNav
    }
    groupedDataSeries(startTime: $starTs, endTime: $endTs) {
      generatorSpeed: WGEN1_Spd_avg_mag_f {
        _id_turbine
        data
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GeneratorSpeedGQL extends Apollo.Query<GeneratorSpeedQuery, GeneratorSpeedQueryVariables> {
    document = GeneratorSpeedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PitchAngleParkDocument = gql`
    query PitchAnglePark($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [ID!]) {
  parks(where: {name: $park}, turbines: $turbines) {
    name
    code
    turbines {
      _id
      name
      code: codeDisplay
      serialNav
    }
    groupedDataSeries(startTime: $starTs, endTime: $endTs) {
      pitchAngle1: WROT1_PtAngValBl1_avg_mag_f {
        _id_turbine
        data
      }
      pitchAngle2: WROT1_PtAngValBl2_avg_mag_f {
        _id_turbine
        data
      }
      pitchAngle3: WROT1_PtAngValBl3_avg_mag_f {
        _id_turbine
        data
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PitchAngleParkGQL extends Apollo.Query<PitchAngleParkQuery, PitchAngleParkQueryVariables> {
    document = PitchAngleParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ScatterPlotChartsDataDocument = gql`
    query ScatterPlotChartsData($starTs: Float!, $endTs: Float!, $turbine: String!) {
  turbines(where: {OR: [{name: $turbine}, {code: $turbine}, {serial: $turbine}]}) {
    code: codeDisplay
    serial
    analyze {
      performanceDataSeries(startTs: $starTs, endTs: $endTs) {
        actualPower: WTUR1_W_avg_mag_f {
          startingTS
          lastTS
          intervalTS
          data
        }
        theoPower: WTUR1_W_avg_theoretical {
          data
        }
        status: WTUR1_status {
          data
        }
        ambTemp: WNAC1_ExTmp_avg_mag_f {
          data
        }
        windSpeed: WNAC1_WdSpd_avg_mag_f {
          data
        }
        windDir: WNAC1_WdDir_avg_mag_f {
          data
        }
        nacDir: WNAC1_Dir_avg_mag_f {
          data
        }
        rotorSpeed: WROT1_RotSpd_avg_mag_f {
          data
        }
        pitchAngle1: WROT1_PtAngValBl1_avg_mag_f {
          data
        }
        pitchAngle2: WROT1_PtAngValBl2_avg_mag_f {
          data
        }
        pitchAngle3: WROT1_PtAngValBl3_avg_mag_f {
          data
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ScatterPlotChartsDataGQL extends Apollo.Query<ScatterPlotChartsDataQuery, ScatterPlotChartsDataQueryVariables> {
    document = ScatterPlotChartsDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ScatterPlotChartsDataPerformanceAnalyticsDocument = gql`
    query ScatterPlotChartsDataPerformanceAnalytics($startTs: Float!, $endTs: Float!, $turbine: String!) {
  turbines(where: {_id: $turbine}) {
    code: codeDisplay
    serial
    analyze {
      performanceDataSeries(startTs: $startTs, endTs: $endTs) {
        actualPower: WTUR1_W_avg_mag_f {
          startingTS
          lastTS
          intervalTS
          data
        }
        windSpeed: WNAC1_WdSpd_avg_mag_f {
          data
        }
        rotorSpeed: WROT1_RotSpd_avg_mag_f {
          data
        }
        pitchAngle1: WROT1_PtAngValBl1_avg_mag_f {
          data
        }
        pitchAngle2: WROT1_PtAngValBl2_avg_mag_f {
          data
        }
        pitchAngle3: WROT1_PtAngValBl3_avg_mag_f {
          data
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ScatterPlotChartsDataPerformanceAnalyticsGQL extends Apollo.Query<ScatterPlotChartsDataPerformanceAnalyticsQuery, ScatterPlotChartsDataPerformanceAnalyticsQueryVariables> {
    document = ScatterPlotChartsDataPerformanceAnalyticsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PortfolioKpiDocument = gql`
    query PortfolioKpi($starTs: Float!, $endTs: Float!, $portfolioId: String!, $parkIds: [ID!]) {
  portfolios(when: {_id: $portfolioId}, parks: $parkIds) {
    _id
    parks {
      _id
      code
      displayCode
      name
    }
    analyze {
      performanceFacts(startTs: $starTs, endTs: $endTs) {
        WTUR1_W_avg_loss {
          dataValue
        }
        WTUR1_revenueLosses_avg {
          dataValue
        }
        WTUR1_per_avg_availability(aggregation: "AVG") {
          dataValue
        }
        WTUR1_per_avg_efficiency(aggregation: "AVG") {
          dataValue
        }
      }
    }
    groupedFacts(startTime: $starTs, endTime: $endTs) {
      WTUR1_W_avg_loss {
        _id_park
        dataValue
      }
      WTUR1_revenueLosses_avg {
        _id_park
        dataValue
      }
      WTUR1_per_avg_availability(aggregation: "AVG") {
        _id_park
        dataValue
      }
      WTUR1_per_avg_efficiency(aggregation: "AVG") {
        _id_park
        dataValue
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PortfolioKpiGQL extends Apollo.Query<PortfolioKpiQuery, PortfolioKpiQueryVariables> {
    document = PortfolioKpiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ParksKpiDocument = gql`
    query ParksKpi($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [ID!]) {
  parks(where: {OR: [{name: $park}, {code: $park}]}, turbines: $turbines) {
    code
    turbines {
      _id
      code: codeDisplay
      serialNav
    }
    analyze {
      performanceFacts(startTs: $starTs, endTs: $endTs) {
        WTUR1_W_avg_loss {
          dataValue
        }
        WTUR1_revenueLosses_avg {
          dataValue
        }
        WTUR1_per_avg_availability(aggregation: "AVG") {
          dataValue
        }
        WTUR1_per_avg_efficiency(aggregation: "AVG") {
          dataValue
        }
      }
    }
    groupedFacts(startTime: $starTs, endTime: $endTs) {
      WTUR1_W_avg_loss {
        _id_turbine
        dataValue
      }
      WTUR1_revenueLosses_avg {
        _id_turbine
        dataValue
      }
      WTUR1_per_avg_availability(aggregation: "AVG") {
        _id_turbine
        dataValue
      }
      WTUR1_per_avg_efficiency(aggregation: "AVG") {
        _id_turbine
        dataValue
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ParksKpiGQL extends Apollo.Query<ParksKpiQuery, ParksKpiQueryVariables> {
    document = ParksKpiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevPortfolioDocument = gql`
    query RevPortfolio($starTs: Float!, $endTs: Float!, $portfolioId: String!) {
  portfolios(when: {_id: $portfolioId}) {
    _id
    parks {
      _id
      code
      displayCode
      name
    }
    groupedFacts(startTime: $starTs, endTime: $endTs) {
      WTUR1_revenue_avg {
        _id_park
        dataValue
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RevPortfolioGQL extends Apollo.Query<RevPortfolioQuery, RevPortfolioQueryVariables> {
    document = RevPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ComparativeTableReportPortfolioDocument = gql`
    query ComparativeTableReportPortfolio($starTs: Float!, $endTs: Float!, $portfolioId: String!) {
  portfolios(when: {_id: $portfolioId}) {
    _id
    parks(sort: {name: ASC}) {
      _id
      name
      code
      displayCode
    }
    groupedFacts(startTime: $starTs, endTime: $endTs) {
      WTUR1_revenue_avg {
        _id_park
        dataValue
      }
      WTUR1_revenueLosses_avg {
        _id_park
        dataValue
      }
      Wh_avg_mag_f: WTUR1_Wh_avg_mag_f_corrected {
        _id_park
        dataValue
      }
      WTUR1_W_avg_theoretical {
        _id_park
        dataValue
      }
      WTUR1_W_avg_loss {
        _id_park
        dataValue
      }
      WTUR1_per_avg_availability(aggregation: "AVG") {
        _id_park
        dataValue
      }
      WTUR1_per_avg_efficiency(aggregation: "AVG") {
        _id_park
        dataValue
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ComparativeTableReportPortfolioGQL extends Apollo.Query<ComparativeTableReportPortfolioQuery, ComparativeTableReportPortfolioQueryVariables> {
    document = ComparativeTableReportPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ComparativeTableReportParkDocument = gql`
    query ComparativeTableReportPark($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [ID!]) {
  parks(where: {OR: [{name: $park}, {code: $park}]}, turbines: $turbines) {
    name
    turbines {
      _id
      name
      code: codeDisplay
      serial
    }
    groupedFacts(startTime: $starTs, endTime: $endTs) {
      WTUR1_revenue_avg {
        _id_turbine
        dataValue
      }
      WTUR1_revenueLosses_avg {
        _id_turbine
        dataValue
      }
      Wh_avg_mag_f: WTUR1_Wh_avg_mag_f_corrected {
        _id_turbine
        dataValue
      }
      WTUR1_W_avg_theoretical {
        _id_turbine
        dataValue
      }
      WTUR1_W_avg_loss {
        _id_turbine
        dataValue
      }
      WTUR1_per_avg_availability(aggregation: "AVG") {
        _id_turbine
        dataValue
      }
      WTUR1_per_avg_efficiency(aggregation: "AVG") {
        _id_turbine
        dataValue
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ComparativeTableReportParkGQL extends Apollo.Query<ComparativeTableReportParkQuery, ComparativeTableReportParkQueryVariables> {
    document = ComparativeTableReportParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProdPortfolioDocument = gql`
    query ProdPortfolio($starTs: Float!, $endTs: Float!, $portfolioId: String!) {
  portfolios(when: {_id: $portfolioId}) {
    _id
    parks {
      _id
      name
      code
      displayCode
    }
    groupedFacts(startTime: $starTs, endTime: $endTs) {
      Wh_avg_mag_f: WTUR1_Wh_avg_mag_f_corrected {
        _id_park
        dataValue
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProdPortfolioGQL extends Apollo.Query<ProdPortfolioQuery, ProdPortfolioQueryVariables> {
    document = ProdPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AvailabilityPortfolioDocument = gql`
    query AvailabilityPortfolio($starTs: Float!, $endTs: Float!, $portfolioId: String!) {
  portfolios(when: {_id: $portfolioId}) {
    _id
    parks {
      _id
      name
      code
      displayCode
    }
    groupedFacts(startTime: $starTs, endTime: $endTs) {
      WTUR1_per_avg_availability(aggregation: "AVG") {
        _id_park
        dataValue
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AvailabilityPortfolioGQL extends Apollo.Query<AvailabilityPortfolioQuery, AvailabilityPortfolioQueryVariables> {
    document = AvailabilityPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProdLossPortfolioDocument = gql`
    query ProdLossPortfolio($starTs: Float!, $endTs: Float!, $portfolioId: String!) {
  portfolios(when: {_id: $portfolioId}) {
    _id
    parks {
      _id
      name
      code
      displayCode
    }
    groupedFacts(startTime: $starTs, endTime: $endTs) {
      WTUR1_W_avg_loss {
        _id_park
        dataValue
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProdLossPortfolioGQL extends Apollo.Query<ProdLossPortfolioQuery, ProdLossPortfolioQueryVariables> {
    document = ProdLossPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevLossPortfolioDocument = gql`
    query RevLossPortfolio($starTs: Float!, $endTs: Float!, $portfolioId: String!) {
  portfolios(when: {_id: $portfolioId}) {
    _id
    parks {
      _id
      name
      code
      displayCode
    }
    groupedFacts(startTime: $starTs, endTime: $endTs) {
      WTUR1_revenueLosses_avg {
        _id_park
        dataValue
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RevLossPortfolioGQL extends Apollo.Query<RevLossPortfolioQuery, RevLossPortfolioQueryVariables> {
    document = RevLossPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevLossParkDocument = gql`
    query RevLossPark($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [ID!]) {
  parks(where: {OR: [{name: $park}, {code: $park}]}, turbines: $turbines) {
    _id
    turbines {
      _id
      name
      code: codeDisplay
      serial
    }
    groupedFacts(startTime: $starTs, endTime: $endTs) {
      WTUR1_revenueLosses_avg {
        _id_turbine
        dataValue
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RevLossParkGQL extends Apollo.Query<RevLossParkQuery, RevLossParkQueryVariables> {
    document = RevLossParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProdParkDocument = gql`
    query ProdPark($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [ID!]) {
  parks(where: {OR: [{name: $park}, {code: $park}]}, turbines: $turbines) {
    _id
    turbines {
      _id
      name
      code: codeDisplay
      serial
    }
    groupedFacts(startTime: $starTs, endTime: $endTs) {
      Wh_avg_mag_f: WTUR1_Wh_avg_mag_f_corrected {
        _id_turbine
        dataValue
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProdParkGQL extends Apollo.Query<ProdParkQuery, ProdParkQueryVariables> {
    document = ProdParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AvailabilityParkDocument = gql`
    query AvailabilityPark($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [ID!]) {
  parks(where: {OR: [{name: $park}, {code: $park}]}, turbines: $turbines) {
    _id
    turbines {
      _id
      name
      code: codeDisplay
      serial
    }
    groupedFacts(startTime: $starTs, endTime: $endTs) {
      WTUR1_per_avg_availability(aggregation: "AVG") {
        _id_turbine
        dataValue
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AvailabilityParkGQL extends Apollo.Query<AvailabilityParkQuery, AvailabilityParkQueryVariables> {
    document = AvailabilityParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProdLossParkDocument = gql`
    query ProdLossPark($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [ID!]) {
  parks(where: {OR: [{name: $park}, {code: $park}]}, turbines: $turbines) {
    _id
    turbines {
      _id
      name
      code: codeDisplay
      serial
    }
    groupedFacts(startTime: $starTs, endTime: $endTs) {
      WTUR1_W_avg_loss {
        _id_turbine
        dataValue
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProdLossParkGQL extends Apollo.Query<ProdLossParkQuery, ProdLossParkQueryVariables> {
    document = ProdLossParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevParkDocument = gql`
    query RevPark($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [ID!]) {
  parks(where: {OR: [{name: $park}, {code: $park}]}, turbines: $turbines) {
    _id
    turbines {
      _id
      name
      code: codeDisplay
      serial
    }
    groupedFacts(startTime: $starTs, endTime: $endTs) {
      WTUR1_revenue_avg {
        _id_turbine
        dataValue
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RevParkGQL extends Apollo.Query<RevParkQuery, RevParkQueryVariables> {
    document = RevParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PerformanceGroupedByTurbineDocument = gql`
    query PerformanceGroupedByTurbine($startTime: Float!, $endTime: Float!, $parkName: String!, $turbines: [ID!]) {
  parks(where: {name: $parkName}, turbines: $turbines) {
    name
    turbines {
      _id
      ratedPower
      name
      code: codeDisplay
      serialNav
    }
    groupedDataSeries(startTime: $startTime, endTime: $endTime) {
      WTUR1_W_avg_mag_f(aggregation: "SUM", convert: KW) {
        _id_turbine
        data
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PerformanceGroupedByTurbineGQL extends Apollo.Query<PerformanceGroupedByTurbineQuery, PerformanceGroupedByTurbineQueryVariables> {
    document = PerformanceGroupedByTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PerformanceGroupedByParkDocument = gql`
    query PerformanceGroupedByPark($startTime: Float!, $endTime: Float!, $portfolioId: String!, $parkIds: [ID!]) {
  portfolios(when: {_id: $portfolioId}, parks: $parkIds) {
    _id
    dataDebbug {
      WTUR1_kW_rated {
        sum
      }
    }
    groupedDataSeries(startTime: $startTime, endTime: $endTime) {
      WTUR1_W_avg_mag_f(aggregation: "SUM") {
        _id_park
        data
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PerformanceGroupedByParkGQL extends Apollo.Query<PerformanceGroupedByParkQuery, PerformanceGroupedByParkQueryVariables> {
    document = PerformanceGroupedByParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QualityPortfolioDocument = gql`
    query QualityPortfolio($starTs: Float!, $endTs: Float!, $portfolioId: String!, $parkIds: [ID!]) {
  portfolios(when: {_id: $portfolioId}, parks: $parkIds) {
    parks {
      turbines {
        code: codeDisplay
      }
    }
    analyze {
      performanceFacts(startTs: $starTs, endTs: $endTs) {
        WTUR1_W_avg_mag_f(aggregation: "COUNT") {
          dataValue
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QualityPortfolioGQL extends Apollo.Query<QualityPortfolioQuery, QualityPortfolioQueryVariables> {
    document = QualityPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FactsPortfolioDocument = gql`
    query FactsPortfolio($starTs: Float!, $endTs: Float!, $portfolioId: String!, $parkIds: [ID!]) {
  portfolios(when: {_id: $portfolioId}, parks: $parkIds) {
    analyze {
      performanceFacts(startTs: $starTs, endTs: $endTs) {
        WTUR1_Wh_avg_mag_f: WTUR1_Wh_avg_mag_f_corrected(aggregation: "SUM") {
          dataValue
        }
        WTUR1_W_avg_theoretical(aggregation: "SUM") {
          dataValue
        }
        WTUR1_W_avg_loss(aggregation: "SUM") {
          dataValue
        }
        WTUR1_co2Avoided(aggregation: "SUM") {
          dataValue
        }
        WTUR1_per_avg_loadFactor(aggregation: "AVG") {
          dataValue
        }
        WTUR1_revenue_avg(aggregation: "SUM") {
          dataValue
        }
        WTUR1_revenueLosses_avg(aggregation: "SUM") {
          dataValue
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FactsPortfolioGQL extends Apollo.Query<FactsPortfolioQuery, FactsPortfolioQueryVariables> {
    document = FactsPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FactsParkDocument = gql`
    query FactsPark($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [ID!]) {
  parks(where: {name: $park}, turbines: $turbines) {
    turbines {
      comissioningDate
    }
    analyze {
      performanceFacts(startTs: $starTs, endTs: $endTs) {
        WTUR1_Wh_avg_mag_f: WTUR1_Wh_avg_mag_f_corrected(aggregation: "SUM") {
          dataValue
        }
        WTUR1_W_avg_theoretical(aggregation: "SUM") {
          dataValue
        }
        WTUR1_W_avg_loss(aggregation: "SUM") {
          dataValue
        }
        WTUR1_co2Avoided(aggregation: "SUM") {
          dataValue
        }
        WTUR1_per_avg_loadFactor(aggregation: "AVG") {
          dataValue
        }
        WTUR1_revenue_avg(aggregation: "SUM") {
          dataValue
        }
        WTUR1_revenueLosses_avg(aggregation: "SUM") {
          dataValue
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FactsParkGQL extends Apollo.Query<FactsParkQuery, FactsParkQueryVariables> {
    document = FactsParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QualityParkDocument = gql`
    query QualityPark($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [ID!]) {
  parks(where: {name: $park}, turbines: $turbines) {
    turbines {
      code: codeDisplay
    }
    code
    analyze {
      performanceFacts(startTs: $starTs, endTs: $endTs) {
        WTUR1_W_avg_mag_f(aggregation: "COUNT") {
          dataValue
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QualityParkGQL extends Apollo.Query<QualityParkQuery, QualityParkQueryVariables> {
    document = QualityParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PerformancePortfolioDocument = gql`
    query PerformancePortfolio($starTs: Float!, $endTs: Float!, $portfolioId: String!, $parkIds: [ID!]) {
  portfolios(when: {_id: $portfolioId}, parks: $parkIds) {
    _id
    reference {
      turbines {
        ratedPower
      }
    }
    analyze {
      performanceDataSeries(startTs: $starTs, endTs: $endTs) {
        WTUR1_W_avg_mag_f(convert: KW) {
          data
        }
        WTUR1_W_avg_theoretical(convert: KW) {
          data
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PerformancePortfolioGQL extends Apollo.Query<PerformancePortfolioQuery, PerformancePortfolioQueryVariables> {
    document = PerformancePortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StatusLoadByParkDocument = gql`
    query StatusLoadByPark($starTs: Float!, $endTs: Float!, $portfolioId: String!, $parkIds: [ID!]) {
  portfolios(when: {_id: $portfolioId}, parks: $parkIds) {
    _id
    parks {
      _id
      code
      displayCode
      name
      fe_name
    }
    groupedFacts(startTime: $starTs, endTime: $endTs) {
      WTUR1_per_avg_loadFactor {
        _id_park
        dataValue
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StatusLoadByParkGQL extends Apollo.Query<StatusLoadByParkQuery, StatusLoadByParkQueryVariables> {
    document = StatusLoadByParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductionByParkDocument = gql`
    query ProductionByPark($starTs: Float!, $endTs: Float!, $portfolioId: String!, $parkIds: [ID!]) {
  portfolios(when: {_id: $portfolioId}, parks: $parkIds) {
    _id
    parks {
      _id
      code
      displayCode
      name
      fe_name
    }
    groupedFacts(startTime: $starTs, endTime: $endTs) {
      WTUR1_W_avg_loss {
        _id_park
        dataValue
        startingTS
        lastTS
        intervalTS
      }
      WTUR1_Wh_avg_mag_f: WTUR1_Wh_avg_mag_f_corrected {
        _id_park
        dataValue
        startingTS
        lastTS
        intervalTS
      }
      WTUR1_W_avg_theoretical {
        _id_park
        dataValue
        startingTS
        lastTS
        intervalTS
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductionByParkGQL extends Apollo.Query<ProductionByParkQuery, ProductionByParkQueryVariables> {
    document = ProductionByParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevenuesByParkDocument = gql`
    query RevenuesByPark($starTs: Float!, $endTs: Float!, $portfolioId: String!, $parkIds: [ID!]) {
  portfolios(when: {_id: $portfolioId}, parks: $parkIds) {
    _id
    parks {
      _id
      code
      displayCode
      name
      fe_name
    }
    groupedFacts(startTime: $starTs, endTime: $endTs) {
      WTUR1_revenueLosses_avg {
        _id_park
        dataValue
        startingTS
        lastTS
        intervalTS
      }
      WTUR1_revenue_avg {
        _id_park
        dataValue
        startingTS
        lastTS
        intervalTS
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RevenuesByParkGQL extends Apollo.Query<RevenuesByParkQuery, RevenuesByParkQueryVariables> {
    document = RevenuesByParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EfficiencyByParkDocument = gql`
    query EfficiencyByPark($starTs: Float!, $endTs: Float!, $portfolioId: String!, $parkIds: [ID!]) {
  portfolios(when: {_id: $portfolioId}, parks: $parkIds) {
    _id
    parks {
      _id
      code
      displayCode
      name
      fe_name
    }
    groupedFacts(startTime: $starTs, endTime: $endTs) {
      WTUR1_per_avg_efficiency {
        _id_park
        dataValue
        startingTS
        lastTS
        intervalTS
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EfficiencyByParkGQL extends Apollo.Query<EfficiencyByParkQuery, EfficiencyByParkQueryVariables> {
    document = EfficiencyByParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PerformanceParksDocument = gql`
    query PerformanceParks($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [ID!]) {
  parks(where: {OR: [{name: $park}, {code: $park}]}, turbines: $turbines) {
    name
    fe_name
    turbines {
      ratedPower
    }
    analyze {
      performanceDataSeries(startTs: $starTs, endTs: $endTs) {
        WTUR1_W_avg_mag_f(convert: KW) {
          data
        }
        WTUR1_W_avg_theoretical(convert: KW) {
          data
        }
        WNAC1_WdSpd_avg_mag_f {
          data
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PerformanceParksGQL extends Apollo.Query<PerformanceParksQuery, PerformanceParksQueryVariables> {
    document = PerformanceParksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PerformanceTurbineOneQueryDocument = gql`
    query PerformanceTurbineOneQuery($starTs: Float!, $endTs: Float!, $park: String, $turbines: [ID!]) {
  parks(where: {OR: [{name: $park}, {code: $park}]}, turbines: $turbines) {
    _id
    code
    name
    fe_name
    turbines {
      _id
      code: codeDisplay
      name
      serial
      serialNav
      ratedPower
      analyze {
        performanceDataSeries(startTs: $starTs, endTs: $endTs) {
          WTUR1_W_avg_mag_f(convert: KW) {
            data
          }
          WTUR1_W_avg_theoretical(convert: KW) {
            data
          }
          WTUR1_status {
            data
          }
          WNAC1_ExTmp_avg_mag_f {
            data
          }
          WNAC1_WdSpd_avg_mag_f {
            data
          }
          WNAC1_WdDir_avg_mag_f {
            data
          }
          WROT1_RotSpd_avg_mag_f {
            data
          }
          WNAC1_Dir_avg_mag_f {
            data
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PerformanceTurbineOneQueryGQL extends Apollo.Query<PerformanceTurbineOneQueryQuery, PerformanceTurbineOneQueryQueryVariables> {
    document = PerformanceTurbineOneQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PerformanceTurbineOneQueryPerTurbineDocument = gql`
    query PerformanceTurbineOneQueryPerTurbine($starTs: Float!, $endTs: Float!, $code: String) {
  turbines(where: {code: $code}) {
    _id
    code
    name
    serial
    serialNav
    ratedPower
    analyze {
      performanceDataSeries(startTs: $starTs, endTs: $endTs) {
        WTUR1_W_avg_mag_f(convert: KW) {
          data
        }
        WTUR1_W_avg_theoretical(convert: KW) {
          data
        }
        WTUR1_status {
          data
        }
        WNAC1_ExTmp_avg_mag_f {
          data
        }
        WNAC1_WdSpd_avg_mag_f {
          data
        }
        WNAC1_WdDir_avg_mag_f {
          data
        }
        WROT1_RotSpd_avg_mag_f {
          data
        }
        WNAC1_Dir_avg_mag_f {
          data
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PerformanceTurbineOneQueryPerTurbineGQL extends Apollo.Query<PerformanceTurbineOneQueryPerTurbineQuery, PerformanceTurbineOneQueryPerTurbineQueryVariables> {
    document = PerformanceTurbineOneQueryPerTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PerformanceParksOneQueryDocument = gql`
    query PerformanceParksOneQuery($starTs: Float!, $endTs: Float!, $portfolioId: String!, $parkIds: [ID!]) {
  portfolios(when: {_id: $portfolioId}, parks: $parkIds) {
    _id
    parks {
      _id
      code
      name
      fe_name
      turbines {
        ratedPower
      }
      analyze {
        performanceDataSeries(startTs: $starTs, endTs: $endTs) {
          WTUR1_W_avg_mag_f(convert: KW) {
            data
          }
          WTUR1_W_avg_theoretical(convert: KW) {
            data
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PerformanceParksOneQueryGQL extends Apollo.Query<PerformanceParksOneQueryQuery, PerformanceParksOneQueryQueryVariables> {
    document = PerformanceParksOneQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PerformanceParksGroupedDocument = gql`
    query PerformanceParksGrouped($starTs: Float!, $endTs: Float!, $portfolioId: String!, $parkIds: [ID!]) {
  portfolios(when: {_id: $portfolioId}, parks: $parkIds) {
    _id
    parks {
      _id
      code
      name
      turbines {
        ratedPower
      }
    }
    groupedDataSeries(startTime: $starTs, endTime: $endTs) {
      WTUR1_W_avg_mag_f(aggregation: "SUM") {
        _id_park
        data
      }
      WTUR1_W_avg_theoretical(aggregation: "SUM") {
        _id_park
        data
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PerformanceParksGroupedGQL extends Apollo.Query<PerformanceParksGroupedQuery, PerformanceParksGroupedQueryVariables> {
    document = PerformanceParksGroupedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PerformanceTurbineDocument = gql`
    query PerformanceTurbine($starTs: Float!, $endTs: Float!, $serial: String!) {
  turbines(where: {serial: $serial}) {
    ratedPower
    analyze {
      performanceDataSeries(startTs: $starTs, endTs: $endTs) {
        WTUR1_W_avg_mag_f(convert: KW) {
          data
        }
        WTUR1_W_avg_theoretical(convert: KW) {
          data
        }
        WNAC1_WdSpd_avg_mag_f {
          data
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PerformanceTurbineGQL extends Apollo.Query<PerformanceTurbineQuery, PerformanceTurbineQueryVariables> {
    document = PerformanceTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FactsTurbineDocument = gql`
    query FactsTurbine($starTs: Float!, $endTs: Float!, $turbine: String!) {
  turbines(where: {serial: $turbine}) {
    code: codeDisplay
    type
    ratedPower
    comissioningDate
    analyze {
      performanceFacts(startTs: $starTs, endTs: $endTs) {
        WTUR1_Wh_avg_mag_f: WTUR1_Wh_avg_mag_f_corrected(aggregation: "SUM") {
          dataValue
        }
        WTUR1_W_avg_theoretical(aggregation: "SUM") {
          dataValue
        }
        WTUR1_W_avg_loss(aggregation: "SUM") {
          dataValue
        }
        WTUR1_co2Avoided(aggregation: "SUM") {
          dataValue
        }
        WTUR1_per_avg_loadFactor(aggregation: "AVG") {
          dataValue
        }
        WTUR1_revenue_avg(aggregation: "SUM") {
          dataValue
        }
        WTUR1_revenueLosses_avg(aggregation: "SUM") {
          dataValue
        }
      }
    }
    data {
      WTUR1_TotWh_actVal
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FactsTurbineGQL extends Apollo.Query<FactsTurbineQuery, FactsTurbineQueryVariables> {
    document = FactsTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QualityTurbineDocument = gql`
    query QualityTurbine($starTs: Float!, $endTs: Float!, $turbine: String!) {
  turbines(where: {serial: $turbine}) {
    analyze {
      performanceFacts(startTs: $starTs, endTs: $endTs) {
        WTUR1_W_avg_mag_f(aggregation: "COUNT") {
          dataValue
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QualityTurbineGQL extends Apollo.Query<QualityTurbineQuery, QualityTurbineQueryVariables> {
    document = QualityTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PerformanceGraphTurbineDocument = gql`
    query PerformanceGraphTurbine($starTs: Float!, $endTs: Float!, $turbine: String!) {
  turbines(where: {serial: $turbine}) {
    name
    code
    codeDisplay
    serial
    serialDisplay
    serialNav
    ratedPower
    analyze {
      performanceDataSeries(startTs: $starTs, endTs: $endTs) {
        WTUR1_W_avg_mag_f(convert: KW) {
          data
        }
        WTUR1_W_avg_theoretical(convert: KW) {
          data
        }
        WTUR1_status {
          data
        }
        WNAC1_ExTmp_avg_mag_f {
          data
        }
        WNAC1_WdSpd_avg_mag_f {
          data
        }
        WNAC1_WdDir_avg_mag_f {
          data
        }
        WROT1_RotSpd_avg_mag_f {
          data
        }
        WNAC1_Dir_avg_mag_f {
          data
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PerformanceGraphTurbineGQL extends Apollo.Query<PerformanceGraphTurbineQuery, PerformanceGraphTurbineQueryVariables> {
    document = PerformanceGraphTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadByTurbineDocument = gql`
    query LoadByTurbine($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [ID!]) {
  parks(where: {OR: [{name: $park}, {code: $park}]}, turbines: $turbines) {
    code
    name
    turbines {
      _id
      code: codeDisplay
      serial
      serialNav
      name
    }
    groupedFacts(startTime: $starTs, endTime: $endTs) {
      WTUR1_per_avg_loadFactor {
        _id_turbine
        dataValue
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadByTurbineGQL extends Apollo.Query<LoadByTurbineQuery, LoadByTurbineQueryVariables> {
    document = LoadByTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevenuesByTurbineDocument = gql`
    query RevenuesByTurbine($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [ID!]) {
  parks(where: {OR: [{name: $park}, {code: $park}]}, turbines: $turbines) {
    code
    name
    turbines {
      _id
      code: codeDisplay
      serial
      serialNav
      name
    }
    groupedFacts(startTime: $starTs, endTime: $endTs) {
      WTUR1_revenueLosses_avg {
        _id_turbine
        dataValue
        startingTS
        lastTS
        intervalTS
      }
      WTUR1_revenue_avg {
        _id_turbine
        dataValue
        startingTS
        lastTS
        intervalTS
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RevenuesByTurbineGQL extends Apollo.Query<RevenuesByTurbineQuery, RevenuesByTurbineQueryVariables> {
    document = RevenuesByTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EfficiencyByTurbineDocument = gql`
    query EfficiencyByTurbine($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [ID!]) {
  parks(where: {OR: [{name: $park}, {code: $park}]}, turbines: $turbines) {
    code
    name
    turbines {
      _id
      code: codeDisplay
      serial
      serialNav
      name
    }
    groupedFacts(startTime: $starTs, endTime: $endTs) {
      WTUR1_per_avg_efficiency {
        _id_turbine
        dataValue
        startingTS
        lastTS
        intervalTS
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EfficiencyByTurbineGQL extends Apollo.Query<EfficiencyByTurbineQuery, EfficiencyByTurbineQueryVariables> {
    document = EfficiencyByTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductionByTurbineDocument = gql`
    query ProductionByTurbine($starTs: Float!, $endTs: Float!, $park: String!, $turbines: [ID!]) {
  parks(where: {OR: [{name: $park}, {code: $park}]}, turbines: $turbines) {
    code
    name
    turbines {
      _id
      code: codeDisplay
      serial
      serialNav
      name
    }
    groupedFacts(startTime: $starTs, endTime: $endTs) {
      WTUR1_W_avg_loss {
        _id_turbine
        dataValue
        startingTS
        lastTS
        intervalTS
      }
      WTUR1_Wh_avg_mag_f: WTUR1_Wh_avg_mag_f_corrected {
        _id_turbine
        dataValue
        startingTS
        lastTS
        intervalTS
      }
      WTUR1_W_avg_theoretical {
        _id_turbine
        dataValue
        startingTS
        lastTS
        intervalTS
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductionByTurbineGQL extends Apollo.Query<ProductionByTurbineQuery, ProductionByTurbineQueryVariables> {
    document = ProductionByTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PowerCurveFlagByTurbineReportDocument = gql`
    query PowerCurveFlagByTurbineReport($starTs: Float!, $endTs: Float!, $turbine: String!) {
  turbines(where: {OR: [{name: $turbine}, {code: $turbine}, {serial: $turbine}]}) {
    analyze {
      performanceDataSeries(startTs: $starTs, endTs: $endTs) {
        WTUR1_W_avg_mag_f {
          startingTS
          lastTS
          intervalTS
          data
        }
        WNAC1_WdSpd_avg_mag_f {
          data
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PowerCurveFlagByTurbineReportGQL extends Apollo.Query<PowerCurveFlagByTurbineReportQuery, PowerCurveFlagByTurbineReportQueryVariables> {
    document = PowerCurveFlagByTurbineReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PowerCurveFlagByTurbineDocument = gql`
    query PowerCurveFlagByTurbine($starTs: Float!, $endTs: Float!, $turbine: String!) {
  turbines(where: {OR: [{name: $turbine}, {code: $turbine}, {serial: $turbine}]}) {
    analyze {
      performanceDataSeries(startTs: $starTs, endTs: $endTs) {
        WTUR1_W_avg_mag_f {
          startingTS
          lastTS
          intervalTS
          data
        }
        WTUR1_W_avg_theoretical {
          data
        }
        WTUR1_status {
          data
        }
        WNAC1_ExTmp_avg_mag_f {
          data
        }
        WNAC1_WdSpd_avg_mag_f {
          data
        }
        WNAC1_WdDir_avg_mag_f {
          data
        }
        WNAC1_Dir_avg_mag_f {
          data
        }
        WROT1_RotSpd_avg_mag_f {
          data
        }
        WROT1_PtAngValBl1_avg_mag_f {
          data
        }
        WROT1_PtAngValBl2_avg_mag_f {
          data
        }
        WROT1_PtAngValBl3_avg_mag_f {
          data
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PowerCurveFlagByTurbineGQL extends Apollo.Query<PowerCurveFlagByTurbineQuery, PowerCurveFlagByTurbineQueryVariables> {
    document = PowerCurveFlagByTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StatusPortfolioDocument = gql`
    query StatusPortfolio($startTime: Float!, $endTime: Float!, $portfolioId: String!, $parkIds: [ID!]) {
  portfolios(when: {_id: $portfolioId}, parks: $parkIds) {
    name
    parks {
      _id
      name
      fe_name
      code
      displayCode
    }
    groupedDataSeries(startTime: $startTime, endTime: $endTime) {
      WTUR1_status {
        _id_park
        data
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StatusPortfolioGQL extends Apollo.Query<StatusPortfolioQuery, StatusPortfolioQueryVariables> {
    document = StatusPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StatusParkDocument = gql`
    query StatusPark($startTime: Float!, $endTime: Float!, $parkName: String!, $turbines: [ID!]) {
  parks(where: {name: $parkName}, turbines: $turbines) {
    name
    turbines {
      _id
      name
      code: codeDisplay
      serialNav
      serialDisplay
    }
    groupedDataSeries(startTime: $startTime, endTime: $endTime) {
      WTUR1_status {
        _id_turbine
        data
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StatusParkGQL extends Apollo.Query<StatusParkQuery, StatusParkQueryVariables> {
    document = StatusParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadStatusPortfolioDocument = gql`
    query LoadStatusPortfolio($startTime: Float!, $endTime: Float!, $portfolioId: String!, $parkIds: [ID!], $aggregation: TimeseriesAggregation = null, $timezone: String) {
  portfolios(when: {_id: $portfolioId}, parks: $parkIds) {
    name
    parks {
      _id
      name
      fe_name
      code
      displayCode
    }
    groupedDataSeries(
      startTime: $startTime
      endTime: $endTime
      aggregation: $aggregation
      timezone: $timezone
    ) {
      WTUR1_per_avg_loadFactor {
        _id_park
        data
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadStatusPortfolioGQL extends Apollo.Query<LoadStatusPortfolioQuery, LoadStatusPortfolioQueryVariables> {
    document = LoadStatusPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadStatusParkDocument = gql`
    query LoadStatusPark($startTime: Float!, $endTime: Float!, $parkName: String!, $turbines: [ID!], $aggregation: TimeseriesAggregation = null, $timezone: String) {
  parks(where: {name: $parkName}, turbines: $turbines) {
    name
    turbines {
      _id
      name
      code: codeDisplay
      serialNav
      serialDisplay
    }
    groupedDataSeries(
      startTime: $startTime
      endTime: $endTime
      aggregation: $aggregation
      timezone: $timezone
    ) {
      WTUR1_per_avg_loadFactor {
        _id_turbine
        data
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadStatusParkGQL extends Apollo.Query<LoadStatusParkQuery, LoadStatusParkQueryVariables> {
    document = LoadStatusParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductionPortfolioDocument = gql`
    query ProductionPortfolio($startTime: Float!, $endTime: Float!, $portfolioId: String!, $parkIds: [ID!], $aggregation: TimeseriesAggregation = null, $timezone: String) {
  portfolios(when: {_id: $portfolioId}, parks: $parkIds) {
    name
    parks {
      _id
      name
      fe_name
      code
      displayCode
    }
    groupedDataSeries(
      startTime: $startTime
      endTime: $endTime
      aggregation: $aggregation
      timezone: $timezone
    ) {
      WTUR1_Wh_avg_mag_f: WTUR1_Wh_avg_mag_f_corrected {
        _id_park
        data
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductionPortfolioGQL extends Apollo.Query<ProductionPortfolioQuery, ProductionPortfolioQueryVariables> {
    document = ProductionPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductionParkDocument = gql`
    query ProductionPark($startTime: Float!, $endTime: Float!, $parkName: String!, $turbines: [ID!], $aggregation: TimeseriesAggregation = null, $timezone: String) {
  parks(where: {name: $parkName}, turbines: $turbines) {
    name
    turbines {
      _id
      name
      code: codeDisplay
      serialNav
      serialDisplay
    }
    groupedDataSeries(
      startTime: $startTime
      endTime: $endTime
      aggregation: $aggregation
      timezone: $timezone
    ) {
      WTUR1_Wh_avg_mag_f_corrected {
        _id_turbine
        data
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductionParkGQL extends Apollo.Query<ProductionParkQuery, ProductionParkQueryVariables> {
    document = ProductionParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevenuesPortfolioDocument = gql`
    query RevenuesPortfolio($startTime: Float!, $endTime: Float!, $portfolioId: String!, $parkIds: [ID!], $aggregation: TimeseriesAggregation = null, $timezone: String) {
  portfolios(when: {_id: $portfolioId}, parks: $parkIds) {
    name
    parks {
      _id
      name
      fe_name
      code
      displayCode
    }
    groupedDataSeries(
      startTime: $startTime
      endTime: $endTime
      aggregation: $aggregation
      timezone: $timezone
    ) {
      WTUR1_revenue_avg {
        _id_park
        data
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RevenuesPortfolioGQL extends Apollo.Query<RevenuesPortfolioQuery, RevenuesPortfolioQueryVariables> {
    document = RevenuesPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevenuesParkDocument = gql`
    query RevenuesPark($startTime: Float!, $endTime: Float!, $parkName: String!, $turbines: [ID!], $aggregation: TimeseriesAggregation = null, $timezone: String) {
  parks(where: {name: $parkName}, turbines: $turbines) {
    name
    turbines {
      _id
      name
      code: codeDisplay
      serialNav
      serialDisplay
    }
    groupedDataSeries(
      startTime: $startTime
      endTime: $endTime
      aggregation: $aggregation
      timezone: $timezone
    ) {
      WTUR1_revenue_avg {
        _id_turbine
        data
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RevenuesParkGQL extends Apollo.Query<RevenuesParkQuery, RevenuesParkQueryVariables> {
    document = RevenuesParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EfficiencyPortfolioDocument = gql`
    query EfficiencyPortfolio($startTime: Float!, $endTime: Float!, $portfolioId: String!, $parkIds: [ID!], $aggregation: TimeseriesAggregation = null, $timezone: String) {
  portfolios(when: {_id: $portfolioId}, parks: $parkIds) {
    name
    parks {
      _id
      name
      fe_name
      code
      displayCode
    }
    groupedDataSeries(
      startTime: $startTime
      endTime: $endTime
      aggregation: $aggregation
      timezone: $timezone
    ) {
      WTUR1_per_avg_efficiency {
        _id_park
        data
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EfficiencyPortfolioGQL extends Apollo.Query<EfficiencyPortfolioQuery, EfficiencyPortfolioQueryVariables> {
    document = EfficiencyPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EfficiencyParkDocument = gql`
    query EfficiencyPark($startTime: Float!, $endTime: Float!, $parkName: String!, $turbines: [ID!], $aggregation: TimeseriesAggregation = null, $timezone: String) {
  parks(where: {name: $parkName}, turbines: $turbines) {
    name
    turbines {
      _id
      name
      code: codeDisplay
      serialNav
      serialDisplay
    }
    groupedDataSeries(
      startTime: $startTime
      endTime: $endTime
      aggregation: $aggregation
      timezone: $timezone
    ) {
      WTUR1_per_avg_efficiency {
        _id_turbine
        data
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EfficiencyParkGQL extends Apollo.Query<EfficiencyParkQuery, EfficiencyParkQueryVariables> {
    document = EfficiencyParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const HeatmapDocument = gql`
    query Heatmap($starTs: Float!, $endTs: Float!, $turbine: Float!, $requestedSignals: [String!]!) {
  turbines(where: {serialNav: $turbine}) {
    _id
    name
    code: codeDisplay
    serial
    serialNav
    ratedPower
    analyze {
      filteredDataSeriesDeviation(
        startTs: $starTs
        endTs: $endTs
        requestedSignals: $requestedSignals
      ) {
        signalName
        dataValue {
          data
          avgValues
          absValues
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class HeatmapGQL extends Apollo.Query<HeatmapQuery, HeatmapQueryVariables> {
    document = HeatmapDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTemperatureDocument = gql`
    query getTemperature($startTime: Float!, $endTime: Float!, $serialNav: Float!, $requestedSignals: [String!]!) {
  turbines(where: {serialNav: $serialNav}) {
    park {
      name
      turbines {
        _id
        code: codeDisplay
        serialNav
      }
      filteredGroupedDataSeries(
        startTime: $startTime
        endTime: $endTime
        requestedSignals: $requestedSignals
      ) {
        signalName
        groupedData {
          startingTS
          _id_park
          _id_turbine
          data
        }
      }
      analyze {
        filteredDataSeries(
          startTime: $startTime
          endTime: $endTime
          requestedSignals: $requestedSignals
        ) {
          signalName
          groupedData {
            startingTS
            _id_park
            _id_turbine
            data
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTemperatureGQL extends Apollo.Query<GetTemperatureQuery, GetTemperatureQueryVariables> {
    document = GetTemperatureDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WindRoseParkDocument = gql`
    query WindRosePark($starTs: Float!, $endTs: Float!, $park: String!, $period: String!, $turbines: [ID]) {
  parks(where: {name: $park}, turbines: $turbines) {
    name
    windRose(from: $starTs, to: $endTs, period: $period) {
      sector
      values
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WindRoseParkGQL extends Apollo.Query<WindRoseParkQuery, WindRoseParkQueryVariables> {
    document = WindRoseParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WindRoseTurbineDocument = gql`
    query WindRoseTurbine($starTs: Float!, $endTs: Float!, $turbine: Float!, $period: String!) {
  turbines(where: {serialNav: $turbine}) {
    name
    code: codeDisplay
    windRose(from: $starTs, to: $endTs, period: $period) {
      sector
      values
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WindRoseTurbineGQL extends Apollo.Query<WindRoseTurbineQuery, WindRoseTurbineQueryVariables> {
    document = WindRoseTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WindRoseTurbineFlaggedPointsDocument = gql`
    query WindRoseTurbineFlaggedPoints($starTs: Float!, $endTs: Float!, $turbine: Float!, $period: String!) {
  turbines(where: {serialNav: $turbine}) {
    windRoseDataQualityFullInfo(from: $starTs, to: $endTs, period: $period) {
      qualityInPercentage
      totalPoints
      flaggedPointsCount
      unflaggedPointsCount
      flaggedPoints {
        timestamp
        turbineId
        flag
        description
        windSpeedValue
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WindRoseTurbineFlaggedPointsGQL extends Apollo.Query<WindRoseTurbineFlaggedPointsQuery, WindRoseTurbineFlaggedPointsQueryVariables> {
    document = WindRoseTurbineFlaggedPointsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WindRoseParkFlaggedPointsDocument = gql`
    query WindRoseParkFlaggedPoints($starTs: Float!, $endTs: Float!, $park: String!, $period: String!, $turbines: [ID]) {
  parks(where: {name: $park}, turbines: $turbines) {
    windRoseDataQualityFullInfo(from: $starTs, to: $endTs, period: $period) {
      qualityInPercentage
      totalPoints
      flaggedPointsCount
      unflaggedPointsCount
      flaggedPoints {
        timestamp
        turbineId
        flag
        description
        windSpeedValue
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WindRoseParkFlaggedPointsGQL extends Apollo.Query<WindRoseParkFlaggedPointsQuery, WindRoseParkFlaggedPointsQueryVariables> {
    document = WindRoseParkFlaggedPointsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPortfolioParksBfuDocument = gql`
    query getPortfolioParksBFU($id: String!, $parkIds: [ID!]) {
  portfolios(when: {_id: $id}, parks: $parkIds) {
    parks {
      _id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPortfolioParksBfuGQL extends Apollo.Query<GetPortfolioParksBfuQuery, GetPortfolioParksBfuQueryVariables> {
    document = GetPortfolioParksBfuDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CheckRevenuesFactsParkByPeriodDocument = gql`
    query CheckRevenuesFactsParkByPeriod($name: String!, $dayFrom: Float!, $dayTo: Float!, $monthFrom: Float!, $monthTo: Float!, $monthToEnd: Float!, $yearFrom: Float!, $yearTo: Float!, $yearToEnd: Float!) {
  parks(where: {name: $name}) {
    _id
    isGreen
    name
    country {
      name
      code
    }
    ratedPower: dataDebbug {
      WTUR1_MW_rated {
        sum
      }
    }
    fe_name
    dayTotals: energyMeterTotals(from: $dayFrom, to: $dayTo) {
      lastUpdated
      ...Totals
    }
    monthTotals: energyMeterTotals(from: $monthFrom, to: $monthTo) {
      ...Totals
    }
    monthEndTotals: energyMeterTotals(from: $monthFrom, to: $monthToEnd) {
      ...Totals
    }
    yearTotals: energyMeterTotals(from: $yearFrom, to: $yearTo) {
      ...Totals
    }
    yearMonthEndTotals: energyMeterTotals(from: $yearFrom, to: $monthToEnd) {
      ...Totals
    }
    yearEndTotals: energyMeterTotals(from: $yearFrom, to: $yearToEnd) {
      ...Totals
    }
  }
}
    ${TotalsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckRevenuesFactsParkByPeriodGQL extends Apollo.Query<CheckRevenuesFactsParkByPeriodQuery, CheckRevenuesFactsParkByPeriodQueryVariables> {
    document = CheckRevenuesFactsParkByPeriodDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CheckRevenuesDataSeriesParkByPeriodDocument = gql`
    query CheckRevenuesDataSeriesParkByPeriod($name: String!, $dayFrom: Float!, $dayTo: Float!, $granularity: TimeGranularityEnum!, $timezone: String!) {
  parks(where: {name: $name}) {
    _id
    isGreen
    name
    fe_name
    country {
      name
      code
    }
    energyMeterDataseries(
      from: $dayFrom
      to: $dayTo
      granularity: $granularity
      timezone: $timezone
    ) {
      ...SeriesTotals
      neasFee
      statnettFee
      estimatedBalancingFee
      elcertsHedgePrice
      hedgedPpaCapacity
      monthlyPpaVolume
      financialHedge
      powerHedgePrice
      ppaPrice
      ppaRevenue
      riskPremium
    }
  }
}
    ${SeriesTotalsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckRevenuesDataSeriesParkByPeriodGQL extends Apollo.Query<CheckRevenuesDataSeriesParkByPeriodQuery, CheckRevenuesDataSeriesParkByPeriodQueryVariables> {
    document = CheckRevenuesDataSeriesParkByPeriodDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CheckRevenuesFactsPortfolioByPeriodDocument = gql`
    query CheckRevenuesFactsPortfolioByPeriod($monthFrom: Float!, $monthTo: Float!, $monthToEnd: Float!, $yearFrom: Float!, $yearTo: Float!, $yearToEnd: Float!, $portfolioId: String, $parks: [ID]) {
  portfolios(when: {_id: $portfolioId}, parks: $parks) {
    parks(where: {energyMeterAvailable: true}) {
      _id
      isGreen
      name
      ratedPower: dataDebbug {
        WTUR1_MW_rated {
          sum
        }
      }
      fe_name
      code
      country {
        name
      }
      monthTotals: energyMeterTotals(from: $monthFrom, to: $monthTo) {
        lastUpdated
        ...Totals
      }
      monthEndTotals: energyMeterTotals(from: $monthFrom, to: $monthToEnd) {
        ...Totals
      }
      yearTotals: energyMeterTotals(from: $yearFrom, to: $yearTo) {
        ...Totals
      }
      yearEndTotals: energyMeterTotals(from: $yearFrom, to: $yearToEnd) {
        ...Totals
      }
      yearMonthEndTotals: energyMeterTotals(from: $yearFrom, to: $monthToEnd) {
        ...Totals
      }
    }
  }
}
    ${TotalsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckRevenuesFactsPortfolioByPeriodGQL extends Apollo.Query<CheckRevenuesFactsPortfolioByPeriodQuery, CheckRevenuesFactsPortfolioByPeriodQueryVariables> {
    document = CheckRevenuesFactsPortfolioByPeriodDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CheckRevenuesDataSeriesPortfolioByPeriodDocument = gql`
    query CheckRevenuesDataSeriesPortfolioByPeriod($monthFrom: Float!, $monthTo: Float!, $granularity: TimeGranularityEnum!, $timezone: String!, $portfolioId: String, $parks: [ID]) {
  portfolios(when: {_id: $portfolioId}, parks: $parks) {
    energyMeterDataseries(
      from: $monthFrom
      to: $monthTo
      granularity: $granularity
      timezone: $timezone
    ) {
      ...SeriesTotals
    }
    parks {
      _id
      code
      isGreen
      name
      fe_name
    }
  }
}
    ${SeriesTotalsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckRevenuesDataSeriesPortfolioByPeriodGQL extends Apollo.Query<CheckRevenuesDataSeriesPortfolioByPeriodQuery, CheckRevenuesDataSeriesPortfolioByPeriodQueryVariables> {
    document = CheckRevenuesDataSeriesPortfolioByPeriodDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CheckRevenuesDataSeriesPortfolioByPeriodAndParkDocument = gql`
    query CheckRevenuesDataSeriesPortfolioByPeriodAndPark($monthFrom: Float!, $monthTo: Float!, $granularity: TimeGranularityEnum!, $timezone: String!, $portfolioId: String, $parks: [ID]) {
  portfolios(when: {_id: $portfolioId}, parks: $parks) {
    parks {
      _id
      code
      isGreen
      name
      fe_name
      energyMeterDataseries(
        from: $monthFrom
        to: $monthTo
        granularity: $granularity
        timezone: $timezone
      ) {
        ...SeriesTotals
      }
    }
  }
}
    ${SeriesTotalsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckRevenuesDataSeriesPortfolioByPeriodAndParkGQL extends Apollo.Query<CheckRevenuesDataSeriesPortfolioByPeriodAndParkQuery, CheckRevenuesDataSeriesPortfolioByPeriodAndParkQueryVariables> {
    document = CheckRevenuesDataSeriesPortfolioByPeriodAndParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ParksAndCountriesDocument = gql`
    query ParksAndCountries($portfolioId: String, $parkIds: [ID!]) {
  portfolios(when: {_id: $portfolioId}, parks: $parkIds) {
    parks {
      _id
      name
      fe_name
      code
      energyMeterAvailable
      country {
        name
        code
        country_image
        energyMeterAvailable
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ParksAndCountriesGQL extends Apollo.Query<ParksAndCountriesQuery, ParksAndCountriesQueryVariables> {
    document = ParksAndCountriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ParksCapturedPriceDocument = gql`
    query ParksCapturedPrice($id: ID, $from: Float!, $to: Float!, $timezone: String) {
  parks(where: {_id: $id}) {
    avgCapturedPrice(from: $from, to: $to, timezone: $timezone) {
      month
      avgCapturedPrice
    }
    avgAreaPrice(from: $from, to: $to, timezone: $timezone) {
      month
      avgAreaPrice
    }
    targetPrice(from: $from, to: $to, timezone: $timezone) {
      month
      targetPrice
    }
    windCaptureRatio(from: $from, to: $to, timezone: $timezone) {
      month
      windCaptureRatio
    }
    targetCaptureRatio(from: $from, to: $to, timezone: $timezone) {
      month
      targetCaptureRatio
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ParksCapturedPriceGQL extends Apollo.Query<ParksCapturedPriceQuery, ParksCapturedPriceQueryVariables> {
    document = ParksCapturedPriceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetParksAndTurbinesDataStudioDocument = gql`
    query getParksAndTurbinesDataStudio {
  parks {
    name
    code
    fe_name
    data30sAvailable
    energyMeterAvailable
    turbines {
      _id
      name
      type
      code: codeDisplay
      serialNav
    }
    controlSystem {
      _id
      name
      code: codeDisplay
    }
    metmasts {
      _id
      name
      code: name
      sensorsList {
        _id
        name
        code: name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetParksAndTurbinesDataStudioGQL extends Apollo.Query<GetParksAndTurbinesDataStudioQuery, GetParksAndTurbinesDataStudioQueryVariables> {
    document = GetParksAndTurbinesDataStudioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllTurbinesDocument = gql`
    query AllTurbines {
  turbines {
    _id
    name
    type
    code: codeDisplay
    serialNav
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllTurbinesGQL extends Apollo.Query<AllTurbinesQuery, AllTurbinesQueryVariables> {
    document = AllTurbinesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllTurbineByTypesDataStudioDocument = gql`
    query getAllTurbineByTypesDataStudio {
  parks {
    turbines {
      type
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllTurbineByTypesDataStudioGQL extends Apollo.Query<GetAllTurbineByTypesDataStudioQuery, GetAllTurbineByTypesDataStudioQueryVariables> {
    document = GetAllTurbineByTypesDataStudioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SignalsByTurbineDsDocument = gql`
    query signalsByTurbineDS($name: String!, $streamType: [Stream]!) {
  turbines(where: {name: $name}) {
    signalsList(stream: $streamType, filter: all, signalGroup: all) {
      name
      displayName
      displayShortName
      signalGroupType
      description
      unit
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SignalsByTurbineDsGQL extends Apollo.Query<SignalsByTurbineDsQuery, SignalsByTurbineDsQueryVariables> {
    document = SignalsByTurbineDsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSignalsByTurbineTypesDocument = gql`
    query getSignalsByTurbineTypes($turbineType: String!, $streamType: [Stream]!) {
  turbines(where: {type: $turbineType}) {
    _id
    name
    type
    code: codeDisplay
    serialNav
    temperature: signalsList(
      stream: $streamType
      filter: all
      signalGroup: temperature
    ) {
      name
      displayName
      displayShortName
      signalGroupType
      description
      unit
    }
    ambient: signalsList(stream: $streamType, filter: all, signalGroup: ambient) {
      name
      displayName
      displayShortName
      signalGroupType
      description
      unit
    }
    electrical: signalsList(
      stream: $streamType
      filter: all
      signalGroup: electrical
    ) {
      name
      displayName
      displayShortName
      signalGroupType
      description
      unit
    }
    technical: signalsList(stream: $streamType, filter: all, signalGroup: technical) {
      name
      displayName
      displayShortName
      signalGroupType
      description
      unit
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSignalsByTurbineTypesGQL extends Apollo.Query<GetSignalsByTurbineTypesQuery, GetSignalsByTurbineTypesQueryVariables> {
    document = GetSignalsByTurbineTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSignalsByParkNameDocument = gql`
    query getSignalsByParkName($parkname: String!, $streamType: [Stream]!) {
  parks(where: {name: $parkname}) {
    turbines {
      _id
      name
      type
      code: codeDisplay
      serialNav
      type
      temperature: signalsList(
        stream: $streamType
        filter: all
        signalGroup: temperature
      ) {
        name
        displayName
        displayShortName
        signalGroupType
        description
        type
        unit
      }
      ambient: signalsList(stream: $streamType, filter: all, signalGroup: ambient) {
        name
        displayName
        displayShortName
        signalGroupType
        description
        type
        unit
      }
      electrical: signalsList(
        stream: $streamType
        filter: all
        signalGroup: electrical
      ) {
        name
        displayName
        displayShortName
        signalGroupType
        description
        type
        unit
      }
      technical: signalsList(stream: $streamType, filter: all, signalGroup: technical) {
        name
        displayName
        displayShortName
        signalGroupType
        description
        type
        unit
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSignalsByParkNameGQL extends Apollo.Query<GetSignalsByParkNameQuery, GetSignalsByParkNameQueryVariables> {
    document = GetSignalsByParkNameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCsSignalsParkNameDocument = gql`
    query getCSSignalsParkName($parkname: String!) {
  parks(where: {name: $parkname}) {
    controlSystem {
      _id
      code
      codeDisplay
      signalsList {
        displayName
        dbName
        unit
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCsSignalsParkNameGQL extends Apollo.Query<GetCsSignalsParkNameQuery, GetCsSignalsParkNameQueryVariables> {
    document = GetCsSignalsParkNameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMetMastsSignalsParkNameDocument = gql`
    query getMetMastsSignalsParkName($parkname: String!) {
  parks(where: {name: $parkname}) {
    metmasts {
      _id
      name
      code: name
      sensorsList {
        _id
        _id_metmast
        name
        signalsList(stream: s30s) {
          dbName
          displayName
          unit
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMetMastsSignalsParkNameGQL extends Apollo.Query<GetMetMastsSignalsParkNameQuery, GetMetMastsSignalsParkNameQueryVariables> {
    document = GetMetMastsSignalsParkNameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSignalsByTurbineNameDocument = gql`
    query getSignalsByTurbineName($turbinename: String!, $streamType: [Stream]!) {
  turbines(where: {name: $turbinename}) {
    _id
    name
    type
    code: codeDisplay
    serialNav
    temperature: signalsList(
      stream: $streamType
      filter: all
      signalGroup: temperature
    ) {
      name
      displayName
      displayShortName
      signalGroupType
      description
      unit
    }
    ambient: signalsList(stream: $streamType, filter: all, signalGroup: ambient) {
      name
      displayName
      displayShortName
      signalGroupType
      description
      unit
    }
    electrical: signalsList(
      stream: $streamType
      filter: all
      signalGroup: electrical
    ) {
      name
      displayName
      displayShortName
      signalGroupType
      description
      unit
    }
    technical: signalsList(stream: $streamType, filter: all, signalGroup: technical) {
      name
      displayName
      displayShortName
      signalGroupType
      description
      unit
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSignalsByTurbineNameGQL extends Apollo.Query<GetSignalsByTurbineNameQuery, GetSignalsByTurbineNameQueryVariables> {
    document = GetSignalsByTurbineNameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMetadataByParkNameDocument = gql`
    query getMetadataByParkName($parkname: String!) {
  parks(where: {code: $parkname}) {
    energyMeterAvailable
    data30sAvailable
    timezone
    lat
    lon
    dataGranularity
    co2
    turbines {
      _id
      name
      type
      code: codeDisplay
      serialNav
      turbineManufacturer {
        name
      }
      modelType
      diameter
      hubHeight
      basementHeight
      lat
      lon
      windSpeedCutIn
      windSpeedCutOut
      networkSwitch
      serial
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMetadataByParkNameGQL extends Apollo.Query<GetMetadataByParkNameQuery, GetMetadataByParkNameQueryVariables> {
    document = GetMetadataByParkNameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FileListDocument = gql`
    subscription FileList {
  user {
    dataStudioFiles {
      fileName
      fileSize
      link
      state
      fileType
      path
      _id
      from
      to
      params
      signals
      queryType
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FileListGQL extends Apollo.Subscription<FileListSubscription, FileListSubscriptionVariables> {
    document = FileListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FileListNewDocument = gql`
    subscription FileListNew {
  user {
    dataStudioUploadedFiles {
      _id
      originalName
      fileType
      fileName
      link
      status
      fileSize
      queryType
      requestedAt
      requestedParams {
        signals
        translatedSignals
        granularity
        queryType
        startTS
        endTS
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FileListNewGQL extends Apollo.Subscription<FileListNewSubscription, FileListNewSubscriptionVariables> {
    document = FileListNewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFileRequestStatusDocument = gql`
    query getFileRequestStatus($trackerId: ID!) {
  dataStudioUploadedFileStatus(trackerId: $trackerId) {
    status
    fileName
    link
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFileRequestStatusGQL extends Apollo.Query<GetFileRequestStatusQuery, GetFileRequestStatusQueryVariables> {
    document = GetFileRequestStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteFileDocument = gql`
    mutation DeleteFile($fileLink: String!) {
  deleteDataStudioFile(fileLink: $fileLink)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteFileGQL extends Apollo.Mutation<DeleteFileMutation, DeleteFileMutationVariables> {
    document = DeleteFileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDataAnalysisParkTurbineSignalDocument = gql`
    query getDataAnalysisParkTurbineSignal($streamType: [Stream]!) {
  parks {
    _id
    name
    code
    fe_name
    data30sAvailable
    signalList {
      _id
      name
      displayName
      unit
      currency
      signalGroupType
    }
    turbines {
      _id
      name
      type
      code: codeDisplay
      serialNav
      signalsList(stream: $streamType, filter: all, signalGroup: all) {
        name
        displayName
        displayShortName
        signalGroupType
        description
        unit
      }
    }
    controlSystem {
      _id
      name
      code
      fe_name: code
      signalsList {
        _id
        name: dbName
        displayName
        unit
      }
    }
    metmasts {
      _id
      name
      code: name
      sensorsList {
        _id
        _id_metmast
        name
        signalsList {
          dbName
          displayName
          unit
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDataAnalysisParkTurbineSignalGQL extends Apollo.Query<GetDataAnalysisParkTurbineSignalQuery, GetDataAnalysisParkTurbineSignalQueryVariables> {
    document = GetDataAnalysisParkTurbineSignalDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetControlSystemListDocument = gql`
    query getControlSystemList {
  parks {
    controlSystem {
      _id
      name
      code
      fe_name: codeDisplay
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetControlSystemListGQL extends Apollo.Query<GetControlSystemListQuery, GetControlSystemListQueryVariables> {
    document = GetControlSystemListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMetmastListDocument = gql`
    query getMetmastList {
  parks {
    metmasts {
      _id
      sensorsList {
        _id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMetmastListGQL extends Apollo.Query<GetMetmastListQuery, GetMetmastListQueryVariables> {
    document = GetMetmastListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetQueriesListDocument = gql`
    query GetQueriesList($pageSize: Int!, $pageNumber: Int!, $isSharedQuery: Boolean, $titleFilter: String) {
  portfolios {
    dataAnalysisQueries(
      pageSize: $pageSize
      pageNumber: $pageNumber
      isSharedQuery: $isSharedQuery
      titleFilter: $titleFilter
    ) {
      totalCount
      dataAnalysisQueries {
        _id
        queryNumber
        title
        period
        granularity
        startTs
        endTs
        assetIds
        assetIdYs
        parkIds
        isSharedQuery
        numberOfSeries
        createdByUsername
        queryType
        relatedReports {
          reportName
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetQueriesListGQL extends Apollo.Query<GetQueriesListQuery, GetQueriesListQueryVariables> {
    document = GetQueriesListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetQueriesListForReportDocument = gql`
    query GetQueriesListForReport {
  portfolios {
    dataAnalysisQueries(isSharedQuery: false) {
      dataAnalysisQueries {
        _id
        queryNumber
        title
        queryType
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetQueriesListForReportGQL extends Apollo.Query<GetQueriesListForReportQuery, GetQueriesListForReportQueryVariables> {
    document = GetQueriesListForReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDataAnalysisQueryDetailsDocument = gql`
    query GetDataAnalysisQueryDetails($id: ID!) {
  dataAnalysisQuery(id: $id) {
    title
    period
    startTs
    endTs
    parkIds
    assetIds
    granularity
    numberOfSeries
    queryNumber
    series {
      query_id: _id
      assetId
      assetIdY
      deviceCode
      deviceCodeY
      parkId
      parkName
      parkDisplayName
      deviceType
      deviceTypeY
      signal
      signalName
      signalUnit
      signalY
      yAxisMin
      yAxisMax
      signalNameY
      signalUnitY
      granularity
      visible
      aggregation
      colorHex
      graphType
      queryDataType
      deviceName
      deviceNameY
      graphDataType
      graphDataMarker {
        symbol
      }
      graphDashStyle
      graphIsStep
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDataAnalysisQueryDetailsGQL extends Apollo.Query<GetDataAnalysisQueryDetailsQuery, GetDataAnalysisQueryDetailsQueryVariables> {
    document = GetDataAnalysisQueryDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDataAnalysisQueryDocument = gql`
    mutation CreateDataAnalysisQuery($query: CreateDataAnalysisQueryInput!) {
  createDataAnalysisQuery(query: $query) {
    _id
    queryNumber
    title
    series {
      _id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDataAnalysisQueryGQL extends Apollo.Mutation<CreateDataAnalysisQueryMutation, CreateDataAnalysisQueryMutationVariables> {
    document = CreateDataAnalysisQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDataAnalysisQueryDocument = gql`
    mutation UpdateDataAnalysisQuery($query: UpdateDataAnalysisQueryInput!) {
  updateDataAnalysisQuery(query: $query)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDataAnalysisQueryGQL extends Apollo.Mutation<UpdateDataAnalysisQueryMutation, UpdateDataAnalysisQueryMutationVariables> {
    document = UpdateDataAnalysisQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDataAnalysisQueryDocument = gql`
    mutation DeleteDataAnalysisQuery($id: ID!) {
  deleteDataAnalysisQuery(_id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDataAnalysisQueryGQL extends Apollo.Mutation<DeleteDataAnalysisQueryMutation, DeleteDataAnalysisQueryMutationVariables> {
    document = DeleteDataAnalysisQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeIceDocument = gql`
    subscription DeIce($serialNav: Float!) {
  turbines(where: {serialNav: $serialNav}) {
    deIcingData {
      forecastDuration
      energyWithBH
      energyWithoutBH
      startRHBSNow
      benefitBH
      efficiency
      statusBH
      bestStartTime
      prodLossFactor
      wind_speed {
        value
        timestamp
      }
      ice_mass_kgm {
        value
        timestamp
      }
      powerTheor_kW {
        value
        timestamp
      }
      temperature_celsius {
        value
        timestamp
      }
      powerWithRBHS_kW {
        value
        timestamp
      }
      powerWithoutRBHS_kW {
        value
        timestamp
      }
      referencePC {
        wind_speed
        power
      }
      modelledPC {
        wind_speed
        power
      }
      production {
        wind_speed
        power
      }
      operatingPoint {
        rawWindSpeed
        ambientTemperature
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeIceGQL extends Apollo.Subscription<DeIceSubscription, DeIceSubscriptionVariables> {
    document = DeIceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeIceTurbinesDocument = gql`
    query DeIceTurbines {
  turbines(deIcing: true) {
    code: codeDisplay
    serialNav
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeIceTurbinesGQL extends Apollo.Query<DeIceTurbinesQuery, DeIceTurbinesQueryVariables> {
    document = DeIceTurbinesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ActualPowerPortfolioDocument = gql`
    subscription ActualPowerPortfolio {
  portfolios {
    dataSeries(hours: 24) {
      WTUR1_MW_avg_mag_f {
        data
        startingTS
        lastTS
        intervalTS
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ActualPowerPortfolioGQL extends Apollo.Subscription<ActualPowerPortfolioSubscription, ActualPowerPortfolioSubscriptionVariables> {
    document = ActualPowerPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ActualPowerCountryDocument = gql`
    subscription ActualPowerCountry($name: String!) {
  countries(where: {name: $name}) {
    dataSeries(hours: 24) {
      WTUR1_MW_avg_mag_f {
        data
        startingTS
        lastTS
        intervalTS
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ActualPowerCountryGQL extends Apollo.Subscription<ActualPowerCountrySubscription, ActualPowerCountrySubscriptionVariables> {
    document = ActualPowerCountryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ActualPowerParkDocument = gql`
    subscription ActualPowerPark($name: String!) {
  parks(where: {name: $name}) {
    dataSeries(hours: 24) {
      WTUR1_MW_avg_mag_f {
        data
        startingTS
        lastTS
        intervalTS
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ActualPowerParkGQL extends Apollo.Subscription<ActualPowerParkSubscription, ActualPowerParkSubscriptionVariables> {
    document = ActualPowerParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ActualPowerTurbineDocument = gql`
    subscription ActualPowerTurbine($serialNav: Float!) {
  turbines(where: {serialNav: $serialNav}) {
    dataSeries(hours: 24) {
      WTUR1_MW_avg_mag_f {
        data
        startingTS
        lastTS
        intervalTS
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ActualPowerTurbineGQL extends Apollo.Subscription<ActualPowerTurbineSubscription, ActualPowerTurbineSubscriptionVariables> {
    document = ActualPowerTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WindlogForecastAvailableDocument = gql`
    query WindlogForecastAvailable {
  parks {
    _id
    name
    fe_name
    country {
      code
      name
    }
    isWindlogForecastAvailable
    isMeteologicaForecastAvailable
    isDNVForecastAvailable
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WindlogForecastAvailableGQL extends Apollo.Query<WindlogForecastAvailableQuery, WindlogForecastAvailableQueryVariables> {
    document = WindlogForecastAvailableDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FirstAvailableDataTimeStampDocument = gql`
    query firstAvailableDataTimeStamp {
  parks {
    code
    initialData
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FirstAvailableDataTimeStampGQL extends Apollo.Query<FirstAvailableDataTimeStampQuery, FirstAvailableDataTimeStampQueryVariables> {
    document = FirstAvailableDataTimeStampDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FirstAvailableDataTimeStampByParkDocument = gql`
    query firstAvailableDataTimeStampByPark($parkname: String!) {
  parks(where: {name: $parkname}) {
    initialData
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FirstAvailableDataTimeStampByParkGQL extends Apollo.Query<FirstAvailableDataTimeStampByParkQuery, FirstAvailableDataTimeStampByParkQueryVariables> {
    document = FirstAvailableDataTimeStampByParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TurbinesMonthlyAvailabilitiesDocument = gql`
    query TurbinesMonthlyAvailabilities($startTS: Float!, $endTS: Float!, $_id: ID, $timezone: String) {
  parks(where: {_id: $_id}) {
    turbines {
      code
      monthlyAvailabilities(startTS: $startTS, endTS: $endTS, timezone: $timezone) {
        date
        availabilities {
          name
          rangeResult
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TurbinesMonthlyAvailabilitiesGQL extends Apollo.Query<TurbinesMonthlyAvailabilitiesQuery, TurbinesMonthlyAvailabilitiesQueryVariables> {
    document = TurbinesMonthlyAvailabilitiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ParksMonthlyAvailabilitiesDocument = gql`
    query ParksMonthlyAvailabilities($startTS: Float!, $endTS: Float!, $_id: String) {
  portfolios(when: {_id: $_id}) {
    parks {
      code
      monthlyAvailabilities(startTS: $startTS, endTS: $endTS) {
        date
        availabilities {
          name
          rangeResult
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ParksMonthlyAvailabilitiesGQL extends Apollo.Query<ParksMonthlyAvailabilitiesQuery, ParksMonthlyAvailabilitiesQueryVariables> {
    document = ParksMonthlyAvailabilitiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsPortfolioCustomDocument = gql`
    subscription AlarmsPortfolioCustom($showAll: Boolean, $portfolioId: String!, $hours: Int, $sort: AlarmSortInput, $parkIds: [ID!]) {
  portfolios(when: {_id: $portfolioId}, parks: $parkIds) {
    alarms(open: $showAll, hours: $hours, sort: $sort) {
      _id
      createTS
      closeTS
      duration
      code
      description
      isOpen
      productionLoss
      alarmCategory
      turbine {
        _id
        serialNav
        code: codeDisplay
      }
    }
    parks {
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsPortfolioCustomGQL extends Apollo.Subscription<AlarmsPortfolioCustomSubscription, AlarmsPortfolioCustomSubscriptionVariables> {
    document = AlarmsPortfolioCustomDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsPortfolioDocument = gql`
    subscription AlarmsPortfolio($showAll: Boolean, $parkIds: [ID!]) {
  portfolios(parks: $parkIds) {
    alarms(open: $showAll) {
      _id
      createTS
      closeTS
      duration
      code
      description
      isOpen
      productionLoss
      alarmCategory
      turbine {
        _id
        serialNav
        code: codeDisplay
      }
    }
    parks {
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsPortfolioGQL extends Apollo.Subscription<AlarmsPortfolioSubscription, AlarmsPortfolioSubscriptionVariables> {
    document = AlarmsPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsParkDocument = gql`
    subscription AlarmsPark($name: String!, $showAll: Boolean, $hours: Int, $sort: AlarmSortInput, $turbineIds: [ID!]) {
  parks(where: {name: $name}, turbines: $turbineIds) {
    alarms(open: $showAll, hours: $hours, sort: $sort) {
      _id
      createTS
      closeTS
      duration
      code
      description
      isOpen
      productionLoss
      alarmCategory
      turbine {
        _id
        serialNav
        code: codeDisplay
      }
    }
    turbines {
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsParkGQL extends Apollo.Subscription<AlarmsParkSubscription, AlarmsParkSubscriptionVariables> {
    document = AlarmsParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsTurbineDocument = gql`
    subscription AlarmsTurbine($serialNav: Float!, $showAll: Boolean, $hours: Int, $sort: AlarmSortInput) {
  turbines(where: {serialNav: $serialNav}) {
    alarms(open: $showAll, hours: $hours, sort: $sort) {
      _id
      createTS
      closeTS
      duration
      code
      description
      isOpen
      productionLoss
      alarmCategory
      turbine {
        _id
        serialNav
        code: codeDisplay
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsTurbineGQL extends Apollo.Subscription<AlarmsTurbineSubscription, AlarmsTurbineSubscriptionVariables> {
    document = AlarmsTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsPortfolioReportDocument = gql`
    query AlarmsPortfolioReport($showAll: Boolean, $hours: Int) {
  portfolios {
    alarms(open: $showAll, hours: $hours) {
      _id
      createTS
      closeTS
      duration
      code
      description
      isOpen
      productionLoss
      alarmCategory
      turbine {
        _id
        serialNav
        code: codeDisplay
      }
    }
    parks {
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsPortfolioReportGQL extends Apollo.Query<AlarmsPortfolioReportQuery, AlarmsPortfolioReportQueryVariables> {
    document = AlarmsPortfolioReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsParkReportDocument = gql`
    query AlarmsParkReport($name: String!, $showAll: Boolean, $hours: Int, $sort: AlarmSortInput) {
  parks(where: {name: $name}) {
    alarms(open: $showAll, hours: $hours, sort: $sort) {
      _id
      createTS
      closeTS
      duration
      code
      description
      isOpen
      productionLoss
      alarmCategory
      turbine {
        _id
        serialNav
        code: codeDisplay
      }
    }
    turbines {
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsParkReportGQL extends Apollo.Query<AlarmsParkReportQuery, AlarmsParkReportQueryVariables> {
    document = AlarmsParkReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmsTurbineReportDocument = gql`
    query AlarmsTurbineReport($serialNav: Float!, $showAll: Boolean, $hours: Int, $sort: AlarmSortInput) {
  turbines(where: {serialNav: $serialNav}) {
    alarms(open: $showAll, hours: $hours, sort: $sort) {
      _id
      createTS
      closeTS
      duration
      code
      description
      isOpen
      productionLoss
      alarmCategory
      turbine {
        _id
        serialNav
        code: codeDisplay
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmsTurbineReportGQL extends Apollo.Query<AlarmsTurbineReportQuery, AlarmsTurbineReportQueryVariables> {
    document = AlarmsTurbineReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BudgetFollowUpPortfolioDocument = gql`
    query BudgetFollowUpPortfolio($portfolioId: String!, $year: Int!, $parksIds: [ID!]) {
  portfolios(when: {_id: $portfolioId}, parks: $parksIds) {
    name
    budget(granularity: MONTHLY, year: $year, month: 12) {
      month
      budget {
        production {
          total {
            value
          }
        }
      }
      total {
        production {
          total {
            value
          }
        }
      }
      delivered {
        scada {
          production {
            total {
              value
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BudgetFollowUpPortfolioGQL extends Apollo.Query<BudgetFollowUpPortfolioQuery, BudgetFollowUpPortfolioQueryVariables> {
    document = BudgetFollowUpPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BudgetFollowUpParkDocument = gql`
    query BudgetFollowUpPark($name: String!, $year: Int!) {
  parks(where: {name: $name}) {
    name
    budget2(granularity: MONTHLY, year: $year, month: 12) {
      month
      budget {
        production {
          total {
            value
          }
        }
      }
      total {
        production {
          total {
            value
          }
        }
      }
      delivered {
        scada {
          production {
            total {
              value
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BudgetFollowUpParkGQL extends Apollo.Query<BudgetFollowUpParkQuery, BudgetFollowUpParkQueryVariables> {
    document = BudgetFollowUpParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BudgetFollowUpTurbineMonitorDocument = gql`
    query BudgetFollowUpTurbineMonitor($serialNav: Float!, $year: Int!) {
  turbines(where: {serialNav: $serialNav}) {
    name
    park {
      turbines {
        name
      }
      budget2(granularity: MONTHLY, year: $year, month: 12) {
        month
        budget {
          production {
            total {
              value
            }
          }
        }
        total {
          production {
            total {
              value
            }
          }
        }
        delivered {
          scada {
            production {
              total {
                value
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BudgetFollowUpTurbineMonitorGQL extends Apollo.Query<BudgetFollowUpTurbineMonitorQuery, BudgetFollowUpTurbineMonitorQueryVariables> {
    document = BudgetFollowUpTurbineMonitorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BudgetFollowUpTurbineDocument = gql`
    query BudgetFollowUpTurbine($serialNav: Float!) {
  turbines(where: {serialNav: $serialNav}) {
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BudgetFollowUpTurbineGQL extends Apollo.Query<BudgetFollowUpTurbineQuery, BudgetFollowUpTurbineQueryVariables> {
    document = BudgetFollowUpTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BudgetFollowUpReportModuleDocument = gql`
    query BudgetFollowUpReportModule($actualYear: Int!, $lastYear: Int!) {
  parks {
    name
    fe_name
    code
    country {
      code
    }
    actual: budget2(year: $actualYear, month: 12, granularity: MONTHLY) {
      budget {
        production {
          total {
            value
          }
        }
        revenue {
          total {
            value
          }
        }
      }
      delivered {
        production {
          total {
            value
          }
        }
        revenue {
          total {
            value
          }
        }
      }
      theoretical {
        production {
          total {
            value
          }
        }
        revenue {
          total {
            value
          }
        }
      }
    }
    last: budget2(year: $lastYear, month: 12, granularity: MONTHLY) {
      budget {
        production {
          total {
            value
          }
        }
        revenue {
          total {
            value
          }
        }
      }
      delivered {
        production {
          total {
            value
          }
        }
        revenue {
          total {
            value
          }
        }
      }
      theoretical {
        production {
          total {
            value
          }
        }
        revenue {
          total {
            value
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BudgetFollowUpReportModuleGQL extends Apollo.Query<BudgetFollowUpReportModuleQuery, BudgetFollowUpReportModuleQueryVariables> {
    document = BudgetFollowUpReportModuleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CmsAlarmsPortfolioCustomDocument = gql`
    subscription CmsAlarmsPortfolioCustom($showAll: Boolean, $hours: Int, $portfolioId: String!, $parkIds: [ID!]) {
  portfolios(when: {_id: $portfolioId}, parks: $parkIds) {
    parks {
      name
    }
    cmsAlarms(showAll: $showAll, hours: $hours) {
      signal
      signalName
      turbineCode
      turbineSerial
      trend
      deviation
      tempAvg
      temp
      detectionTS
      turbineSerialNav
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CmsAlarmsPortfolioCustomGQL extends Apollo.Subscription<CmsAlarmsPortfolioCustomSubscription, CmsAlarmsPortfolioCustomSubscriptionVariables> {
    document = CmsAlarmsPortfolioCustomDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CmsAlarmsPortfolioDocument = gql`
    subscription CmsAlarmsPortfolio($showAll: Boolean, $startTS: Float, $endTS: Float, $parkIds: [ID!]) {
  portfolios(parks: $parkIds) {
    parks {
      name
    }
    cmsAlarms(showAll: $showAll, startTS: $startTS, endTS: $endTS) {
      signal
      signalName
      turbineCode
      turbineSerial
      trend
      deviation
      tempAvg
      temp
      detectionTS
      turbineSerialNav
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CmsAlarmsPortfolioGQL extends Apollo.Subscription<CmsAlarmsPortfolioSubscription, CmsAlarmsPortfolioSubscriptionVariables> {
    document = CmsAlarmsPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CmsAlarmsParkDocument = gql`
    subscription CmsAlarmsPark($name: String!, $showAll: Boolean, $hours: Int, $turbineIds: [ID!]) {
  parks(where: {name: $name}, turbines: $turbineIds) {
    cmsAlarms(showAll: $showAll, hours: $hours) {
      signal
      signalName
      turbineCode
      turbineSerial
      trend
      deviation
      tempAvg
      temp
      detectionTS
      turbineSerialNav
    }
    turbines {
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CmsAlarmsParkGQL extends Apollo.Subscription<CmsAlarmsParkSubscription, CmsAlarmsParkSubscriptionVariables> {
    document = CmsAlarmsParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CmsAlarmsTurbineDocument = gql`
    subscription CmsAlarmsTurbine($serialNav: Float!, $showAll: Boolean, $hours: Int) {
  turbines(where: {serialNav: $serialNav}) {
    cmsAlarms(showAll: $showAll, hours: $hours) {
      signal
      signalName
      turbineCode
      turbineSerial
      trend
      deviation
      tempAvg
      temp
      detectionTS
      turbineSerialNav
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CmsAlarmsTurbineGQL extends Apollo.Subscription<CmsAlarmsTurbineSubscription, CmsAlarmsTurbineSubscriptionVariables> {
    document = CmsAlarmsTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CmsAlarmsPortfolioReportDocument = gql`
    query CmsAlarmsPortfolioReport($showAll: Boolean, $startTS: Float, $endTS: Float, $portfolioId: String!) {
  portfolios(when: {_id: $portfolioId}) {
    parks {
      name
    }
    cmsAlarms(showAll: $showAll, startTS: $startTS, endTS: $endTS) {
      signal
      signalName
      turbineCode
      turbineSerial
      trend
      deviation
      tempAvg
      temp
      detectionTS
      turbineSerialNav
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CmsAlarmsPortfolioReportGQL extends Apollo.Query<CmsAlarmsPortfolioReportQuery, CmsAlarmsPortfolioReportQueryVariables> {
    document = CmsAlarmsPortfolioReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CmsAlarmsParkReportDocument = gql`
    query CmsAlarmsParkReport($name: String!, $showAll: Boolean, $startTS: Float, $endTS: Float, $turbineIds: [ID!]) {
  parks(where: {name: $name}, turbines: $turbineIds) {
    cmsAlarms(showAll: $showAll, startTS: $startTS, endTS: $endTS) {
      signal
      signalName
      turbineCode
      turbineSerial
      trend
      deviation
      tempAvg
      temp
      detectionTS
      turbineSerialNav
    }
    turbines {
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CmsAlarmsParkReportGQL extends Apollo.Query<CmsAlarmsParkReportQuery, CmsAlarmsParkReportQueryVariables> {
    document = CmsAlarmsParkReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ComponentModelDocument = gql`
    subscription ComponentModel($serialNav: Float!) {
  turbines(where: {serialNav: $serialNav}) {
    name
    code: codeDisplay
    serialNav
    type
    modelType
    componentModel {
      id
      name
      alarms {
        signal
        signalName
        temp
        tempAvg
        deviation
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ComponentModelGQL extends Apollo.Subscription<ComponentModelSubscription, ComponentModelSubscriptionVariables> {
    document = ComponentModelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TurbineSignalsDocument = gql`
    query TurbineSignals($serialNav: Float!) {
  turbines(where: {serialNav: $serialNav}) {
    code: codeDisplay
    serialNav
    signalsList(stream: s10m, filter: [tmp]) {
      name
      displayName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TurbineSignalsGQL extends Apollo.Query<TurbineSignalsQuery, TurbineSignalsQueryVariables> {
    document = TurbineSignalsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TurbineSignalDataSeriesDocument = gql`
    subscription TurbineSignalDataSeries($serialNav: Float!, $signal: String!, $hours: Int!) {
  turbines(where: {serialNav: $serialNav}) {
    reference {
      turbineSubTypes {
        componentConditionDataSeries(
          aggregation: "avg2"
          hours: $hours
          signal: $signal
        ) {
          data
        }
      }
    }
    parkSubType {
      turbines {
        code: codeDisplay
        serialNav
        componentConditionDataSeries(signal: $signal, hours: $hours) {
          name
          startingTS
          lastTS
          intervalTS
          data
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TurbineSignalDataSeriesGQL extends Apollo.Subscription<TurbineSignalDataSeriesSubscription, TurbineSignalDataSeriesSubscriptionVariables> {
    document = TurbineSignalDataSeriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConditionComponentDocument = gql`
    subscription ConditionComponent($serialNav: Float!) {
  turbines(where: {serialNav: $serialNav}) {
    parkSubType {
      turbines {
        serialNav
        code: codeDisplay
        componentCondition {
          name
          deviation
          status
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConditionComponentGQL extends Apollo.Subscription<ConditionComponentSubscription, ConditionComponentSubscriptionVariables> {
    document = ConditionComponentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MapPortfolioDocument = gql`
    subscription MapPortfolio($portfolioId: String!, $parkIds: [ID!]) {
  portfolios(when: {_id: $portfolioId}, parks: $parkIds) {
    parks {
      name
      fe_name
      code
      displayCode
      lat
      lon
      dataDebbug {
        WTUR1_W_rated {
          sum
        }
      }
      data {
        WTUR1_status {
          min
        }
        WTUR1_W_mag_f {
          sum
        }
        WTUR1_W_loss {
          sum
        }
        WTUR1_W_rated {
          sum
        }
        WTUR1_W_theoretical {
          sum
        }
      }
      turbines {
        name
        serial
        hubHeight
        serialNav
        code: codeDisplay
        data {
          WTUR1_status
        }
        type
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MapPortfolioGQL extends Apollo.Subscription<MapPortfolioSubscription, MapPortfolioSubscriptionVariables> {
    document = MapPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MapParkDocument = gql`
    subscription MapPark($name: String!, $turbineIds: [ID!]) {
  parks(where: {name: $name}, turbines: $turbineIds) {
    portfolio {
      name
    }
    lat
    lon
    fe_name
    name
    code
    data {
      WNAC1_WdDir_mag_f {
        avg
      }
      WNAC1_Dir_mag_f {
        avg
      }
    }
    turbines {
      lat
      lon
      code: codeDisplay
      serial
      serialNav
      serialDisplay
      data {
        WTUR1_W_mag_f
        WTUR1_status
        WNAC1_Dir_mag_f
        WTUR1_status
        WTUR1_W_theoretical
        WNAC1_WdDir_mag_f
        WNAC1_WdSpd_mag_f
        WROT1_RotSpd_mag_f
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MapParkGQL extends Apollo.Subscription<MapParkSubscription, MapParkSubscriptionVariables> {
    document = MapParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OverviewPortfolioDocument = gql`
    subscription OverviewPortfolio($portfolioId: String!, $parkIds: [ID!]) {
  portfolios(when: {_id: $portfolioId}, parks: $parkIds) {
    parks(sort: {name: ASC}) {
      name
      fe_name
      currentWeather {
        icon
      }
      metaData {
        dataAquisitionMax {
          unixTimestamp
        }
      }
      dataDebbug {
        WTUR1_MW_rated {
          sum
        }
      }
      data {
        WTUR1_MW_theoretical {
          sum
        }
        WTUR1_MW_mag_f {
          sum
        }
        WNAC1_WdSpd_mag_f {
          avg
        }
        WNAC1_WdDir_mag_f {
          avg
        }
        WNAC1_ExTmp_mag_f {
          avg
        }
        WTUR1_MW_loss {
          sum
        }
        WTUR1_per_efficiency {
          avg
        }
        WTUR1_per_loadFactor {
          avg
        }
        WNAC1_Dir_mag_f {
          avg
        }
        WTUR1_status {
          min
        }
      }
      turbines {
        data {
          WTUR1_status
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OverviewPortfolioGQL extends Apollo.Subscription<OverviewPortfolioSubscription, OverviewPortfolioSubscriptionVariables> {
    document = OverviewPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OverviewParkDocument = gql`
    subscription OverviewPark($name: String!, $turbineIds: [ID!]) {
  parks(where: {name: $name}, turbines: $turbineIds) {
    data {
      WNAC1_WdDir_mag_f {
        avg
      }
    }
    turbines {
      metaData {
        dataAquisitionMax {
          unixTimestamp
        }
      }
      code: codeDisplay
      serialNav
      serialDisplay
      data {
        WTUR1_MW_theoretical
        WTUR1_kW_theoretical
        WTUR1_MW_rated
        WTUR1_kW_rated
        WTUR1_MW_mag_f
        WTUR1_kW_mag_f
        WNAC1_WdSpd_mag_f
        WNAC1_WdDir_mag_f
        WNAC1_ExTmp_mag_f
        WTUR1_per_loadFactor
        WTUR1_per_efficiency
        WTUR1_MW_loss
        WTUR1_kW_loss
        WTUR1_status
        LDAT1_TmUTC_setTm
        WNAC1_Dir_mag_f
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OverviewParkGQL extends Apollo.Subscription<OverviewParkSubscription, OverviewParkSubscriptionVariables> {
    document = OverviewParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PerformanceFactsPortfolioDocument = gql`
    subscription PerformanceFactsPortfolio($portfolioId: String!, $parksIds: [ID!]) {
  portfolios(when: {_id: $portfolioId}, parks: $parksIds) {
    totalSignalCount
    availableSignalCount
    data {
      WTUR1_MW_theoretical {
        sum
      }
      WTUR1_MW_rated {
        sum
      }
      WTUR1_MW_mag_f {
        sum
      }
      WTUR1_MW_loss {
        sum
      }
      WTUR1_per_loadFactor {
        avg
      }
    }
    dataDebbug {
      WTUR1_MW_rated {
        sum
      }
    }
    metaData {
      dataAquisitionMax {
        unixTimestamp
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PerformanceFactsPortfolioGQL extends Apollo.Subscription<PerformanceFactsPortfolioSubscription, PerformanceFactsPortfolioSubscriptionVariables> {
    document = PerformanceFactsPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PerformanceFactsParkDocument = gql`
    subscription PerformanceFactsPark($name: String!, $turbineIds: [ID!]) {
  parks(where: {name: $name}, turbines: $turbineIds) {
    totalSignalCount
    availableSignalCount
    fe_name
    data {
      WTUR1_MW_theoretical {
        sum
      }
      WTUR1_MW_rated {
        sum
      }
      WTUR1_MW_mag_f {
        sum
      }
      WTUR1_MW_loss {
        sum
      }
      WTUR1_per_efficiency {
        avg
      }
      WTUR1_per_loadFactor {
        avg
      }
    }
    dataDebbug {
      WTUR1_MW_rated {
        sum
      }
    }
    metaData {
      dataAquisitionMax {
        unixTimestamp
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PerformanceFactsParkGQL extends Apollo.Subscription<PerformanceFactsParkSubscription, PerformanceFactsParkSubscriptionVariables> {
    document = PerformanceFactsParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PerformanceFactsTurbineDocument = gql`
    subscription PerformanceFactsTurbine($serialNav: Float!) {
  turbines(where: {serialNav: $serialNav}) {
    name
    code: codeDisplay
    serial
    serialNav
    data {
      WTUR1_TurSt_actSt_stVal
      WTUR1_kW_theoretical
      WTUR1_kW_rated
      WTUR1_kW_mag_f
      WTUR1_kW_loss
      WTUR1_per_efficiency
      WTUR1_per_loadFactor
      WTUR1_status
      LPHD1_PhyHealth_stVal
      WTUR1_TurSt_actSt_stVal
      WNAC1_WdSpd_mag_f
    }
    dataDebbug {
      WTUR1_kW_rated
    }
    park {
      turbines {
        code
        serial
        serialNav
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PerformanceFactsTurbineGQL extends Apollo.Subscription<PerformanceFactsTurbineSubscription, PerformanceFactsTurbineSubscriptionVariables> {
    document = PerformanceFactsTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PerformanceMonitoringPortfolioDocument = gql`
    subscription PerformanceMonitoringPortfolio($hours: Int!, $portfolioId: String!, $parkIds: [ID!]) {
  portfolios(when: {_id: $portfolioId}, parks: $parkIds) {
    totalSignalCount
    availableSignalCount
    metaData {
      dataAquisitionMax {
        unixTimestamp
      }
    }
    dataDebbug {
      WTUR1_MW_rated {
        sum
      }
    }
    data {
      WTUR1_MW_rated {
        sum
      }
    }
    dataSeries(hours: $hours) {
      turbinesAvailable {
        data
      }
    }
    analyze {
      performanceDataSeriesDifferentSources(hours: $hours) {
        WTUR1_W_avg_theoretical {
          data
          intervalTS
          startingTS
          lastTS
        }
        WTUR1_W_avg_mag_f {
          data
          startingTS
          intervalTS
          lastTS
        }
      }
    }
    alarms(open: true) {
      turbine {
        code: codeDisplay
        serialNav
      }
      _id_alarm
      closeTS
      createTS
      code
      description
      alarmCategory
      isOpen
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PerformanceMonitoringPortfolioGQL extends Apollo.Subscription<PerformanceMonitoringPortfolioSubscription, PerformanceMonitoringPortfolioSubscriptionVariables> {
    document = PerformanceMonitoringPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PerformanceMonitoringParkDocument = gql`
    subscription PerformanceMonitoringPark($name: String!, $hours: Int!, $turbineIds: [ID!]) {
  parks(where: {name: $name}, turbines: $turbineIds) {
    totalSignalCount
    availableSignalCount
    metaData {
      dataAquisitionMax {
        unixTimestamp
      }
    }
    dataDebbug {
      WTUR1_MW_rated {
        sum
      }
    }
    data {
      WTUR1_MW_rated {
        sum
      }
    }
    analyze {
      performanceDataSeriesDifferentSources(hours: $hours) {
        WTUR1_W_avg_theoretical {
          data
          intervalTS
          startingTS
          lastTS
        }
        WTUR1_W_avg_mag_f {
          data
          startingTS
          intervalTS
          lastTS
        }
      }
    }
    dataSeries(hours: $hours) {
      turbinesAvailable {
        data
      }
      WEATHER_Park_history_icon {
        data
      }
      WNAC1_ExTmp_avg_mag_f(aggregation: "avg") {
        data
      }
      WNAC1_WdSpd_avg_mag_f(aggregation: "avg") {
        data
      }
      WNAC1_WdDir_avg_mag_f(aggregation: "avg") {
        data
      }
    }
    alarms(hours: $hours) {
      turbine {
        code: codeDisplay
        serialNav
      }
      _id_alarm
      closeTS
      createTS
      code
      description
      alarmCategory
      isOpen
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PerformanceMonitoringParkGQL extends Apollo.Subscription<PerformanceMonitoringParkSubscription, PerformanceMonitoringParkSubscriptionVariables> {
    document = PerformanceMonitoringParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PerformanceMonitoringTurbineDocument = gql`
    subscription PerformanceMonitoringTurbine($serialNav: Float!, $hours: Int!) {
  turbines(where: {serialNav: $serialNav}) {
    code: codeDisplay
    data {
      WTUR1_kW_rated
    }
    dataDebbug {
      WTUR1_kW_rated
    }
    analyze {
      performanceDataSeriesDifferentSources(hours: $hours) {
        WTUR1_W_avg_theoretical {
          data
          intervalTS
          startingTS
          lastTS
        }
        WTUR1_W_avg_mag_f {
          data
          startingTS
          intervalTS
          lastTS
        }
      }
    }
    alarms(hours: $hours) {
      turbine {
        code: codeDisplay
        serialNav
      }
      _id_alarm
      closeTS
      createTS
      code
      description
      alarmCategory
      isOpen
    }
    dataSeries(hours: $hours) {
      WNAC1_WdSpd_avg_mag_f(aggregation: "avg") {
        data
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PerformanceMonitoringTurbineGQL extends Apollo.Subscription<PerformanceMonitoringTurbineSubscription, PerformanceMonitoringTurbineSubscriptionVariables> {
    document = PerformanceMonitoringTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PowerForecastPortfolioOldDocument = gql`
    subscription PowerForecastPortfolioOLD($hours: Int!, $parkIds: [ID!]) {
  portfolios(parks: $parkIds) {
    dataDebbug {
      WTUR1_MW_rated {
        sum
      }
    }
    data {
      WTUR1_MW_rated {
        sum
      }
    }
    dataSeries(hours: $hours) {
      theoPower {
        data
        intervalTS
        startingTS
        lastTS
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PowerForecastPortfolioOldGQL extends Apollo.Subscription<PowerForecastPortfolioOldSubscription, PowerForecastPortfolioOldSubscriptionVariables> {
    document = PowerForecastPortfolioOldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PowerForecastPortfolioDocument = gql`
    subscription PowerForecastPortfolio($hours: Int!, $provider: [ForecastProvidersEnum]!, $portfolioId: String!, $parkIds: [ID!]) {
  portfolios(when: {_id: $portfolioId}, parks: $parkIds) {
    dataDebbug {
      WTUR1_MW_rated {
        sum
      }
    }
    data {
      WTUR1_MW_rated {
        sum
      }
    }
    forecastDataSeries(hours: $hours, provider: $provider) {
      theoPower {
        provider
        data
        intervalTS
        startingTS
        lastTS
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PowerForecastPortfolioGQL extends Apollo.Subscription<PowerForecastPortfolioSubscription, PowerForecastPortfolioSubscriptionVariables> {
    document = PowerForecastPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PowerForecastParkDocument = gql`
    subscription PowerForecastPark($name: String!, $hours: Int!, $provider: [ForecastProvidersEnum]!, $turbineIds: [ID!]) {
  parks(where: {name: $name}, turbines: $turbineIds) {
    name
    dataDebbug {
      WTUR1_MW_rated {
        sum
      }
    }
    data {
      WTUR1_MW_rated {
        sum
      }
    }
    forecastDataSeries(hours: $hours, provider: $provider) {
      theoPower {
        provider
        data
        startingTS
        lastTS
        intervalTS
      }
      windSpd {
        data
        startingTS
        lastTS
        intervalTS
      }
      temp {
        data
        startingTS
        lastTS
        intervalTS
      }
      windDir {
        data
        startingTS
        lastTS
        intervalTS
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PowerForecastParkGQL extends Apollo.Subscription<PowerForecastParkSubscription, PowerForecastParkSubscriptionVariables> {
    document = PowerForecastParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PowerForecastParkOldDocument = gql`
    subscription PowerForecastParkOLD($name: String!, $hours: Int!, $turbineIds: [ID!]) {
  parks(where: {name: $name}, turbines: $turbineIds) {
    name
    dataDebbug {
      WTUR1_MW_rated {
        sum
      }
    }
    data {
      WTUR1_MW_rated {
        sum
      }
    }
    dataSeries(hours: $hours) {
      windSpd {
        data
        startingTS
        lastTS
        intervalTS
      }
      temp {
        data
        startingTS
        lastTS
        intervalTS
      }
      icon {
        data
        startingTS
        lastTS
        intervalTS
      }
      theoPower {
        data
        startingTS
        lastTS
        intervalTS
      }
      windDir {
        data
        startingTS
        lastTS
        intervalTS
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PowerForecastParkOldGQL extends Apollo.Subscription<PowerForecastParkOldSubscription, PowerForecastParkOldSubscriptionVariables> {
    document = PowerForecastParkOldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IconForecastParkDocument = gql`
    subscription IconForecastPark($name: String!, $hours: Int!, $turbineIds: [ID!]) {
  parks(where: {name: $name}, turbines: $turbineIds) {
    forecastDataSeries(hours: $hours, provider: [openweather]) {
      icon {
        data
        startingTS
        lastTS
        intervalTS
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IconForecastParkGQL extends Apollo.Subscription<IconForecastParkSubscription, IconForecastParkSubscriptionVariables> {
    document = IconForecastParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TurbineCockpitDocument = gql`
    subscription TurbineCockpit($serialNav: Float!, $requestedSignals: [String!]!, $requestedTtempSignals: [String!]!) {
  turbines(where: {serialNav: $serialNav}) {
    metaData {
      dataAquisitionMax {
        unixTimestamp
      }
    }
    hubHeight
    turbineManufacturer {
      name
    }
    name
    ratedPower
    diameter
    type
    serialNav
    serial
    serialDisplay
    code: codeDisplay
    lat
    lon
    park {
      currentWeather {
        icon
      }
      filteredData(requestedSignals: $requestedTtempSignals, aggregation: avg) {
        signalName
        dataValue
      }
    }
    filteredData(requestedSignals: $requestedSignals) {
      signalName
      dataValue {
        ... on StringData {
          stringValue
        }
        ... on FloatData {
          numericValue
        }
      }
    }
    data {
      WTUR1_per_loadFactor
      WTUR1_per_efficiency
      WTUR1_kW_mag_f
      WTUR1_kW_loss
      WTUR1_status
      WTUR1_kW_theoretical
      LPHD1_PhyHealth_stVal
      WTUR1_TurSt_actSt_stVal
      WTUR1_TurMaint_actSt_stVal
      WNAC1_Dir_mag_f
      WNAC1_WdDir_mag_f
      WNAC1_WdSpd_c_mag_f
      WNAC1_ExTmp_mag_f
      WTRM1_GbxOilPres_mag_f
      WROT1_RotSpd_mag_f
      WROT1_PtAngValBl1_mag_f
      WROT1_PtAngValBl2_mag_f
      WROT1_PtAngValBl3_mag_f
      WROT1_PtHyPresBl1_mag_f
      WROT1_PtHyPresBl2_mag_f
      WROT1_PtHyPresBl3_mag_f
      WYAW1_BrkPres_mag_f
      WTRM1_BrkHyPres_mag_f
      WYAW1_CabWup_mag_f
      WROT1_PtAngValAvg_mag_f
      WROT1_PtHyPresAvg_mag_f
      WNAC1_WdSpd_mag_f
      WGEN1_Spd_mag_f
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TurbineCockpitGQL extends Apollo.Subscription<TurbineCockpitSubscription, TurbineCockpitSubscriptionVariables> {
    document = TurbineCockpitDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ParkSignalsListDocument = gql`
    query ParkSignalsList($serialNav: Float!, $streamType: [Stream]!) {
  turbines(where: {serialNav: $serialNav}) {
    _id
    name
    type
    code: codeDisplay
    serialNav
    type
    temperature: signalsList(
      stream: $streamType
      filter: tmp
      signalGroup: temperature
    ) {
      name
      displayName
      displayShortName
      signalGroupType
      description
      type
      unit
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ParkSignalsListGQL extends Apollo.Query<ParkSignalsListQuery, ParkSignalsListQueryVariables> {
    document = ParkSignalsListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ParkTurbineMenuDocument = gql`
    subscription ParkTurbineMenu {
  countries(sort: {name: ASC}) {
    name
    country_image
    parks(sort: {name: ASC}) {
      name
      fe_name
      energyMeterAvailable
      isGreen
      country {
        name
        country_image
        code
      }
      data {
        WTUR1_status {
          min
        }
        WTUR1_per_loadFactor {
          avg
        }
      }
      turbines {
        serialNav
        code: codeDisplay
        codeDisplay
        data {
          WTUR1_status
          WTUR1_per_loadFactor
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ParkTurbineMenuGQL extends Apollo.Subscription<ParkTurbineMenuSubscription, ParkTurbineMenuSubscriptionVariables> {
    document = ParkTurbineMenuDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ParkTurbineListDocument = gql`
    query ParkTurbineList {
  parks(sort: {name: ASC}) {
    name
    energyMeterAvailable
    turbines(sort: {name: ASC}) {
      code: codeDisplay
      serialNav
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ParkTurbineListGQL extends Apollo.Query<ParkTurbineListQuery, ParkTurbineListQueryVariables> {
    document = ParkTurbineListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MenusDropDownDocument = gql`
    subscription MenusDropDown {
  user {
    _id
    user_portfolios {
      _id
      defaultPortfolio
      name
      parks {
        name
        fe_name
        energyMeterAvailable
        isGreen
        country {
          name
          country_image
        }
        data {
          WTUR1_status {
            min
          }
          WTUR1_per_loadFactor {
            avg
          }
        }
        turbines {
          serialNav
          code
          data {
            WTUR1_status
            WTUR1_per_loadFactor
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MenusDropDownGQL extends Apollo.Subscription<MenusDropDownSubscription, MenusDropDownSubscriptionVariables> {
    document = MenusDropDownDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OverviewBoardCustomPortfolioDocument = gql`
    subscription OverviewBoardCustomPortfolio($portfolioId: String!, $parkIds: [ID!]) {
  portfolios(when: {_id: $portfolioId}, parks: $parkIds) {
    groupedResults {
      alarmsGroupedByPark(open: true) {
        _id_park
        alarms {
          _id
        }
      }
    }
    parks(sort: {name: ASC}) {
      _id
      country {
        code
        name
        country_image
      }
      lat
      lon
      name
      code
      fe_name
      currentWeather {
        icon
      }
      dataDebbug {
        WTUR1_MW_rated {
          sum
        }
      }
      data {
        WTUR1_status {
          min
        }
        WTUR1_MW_mag_f {
          sum
        }
        WTUR1_MW_theoretical {
          sum
        }
        WTUR1_MW_rated {
          sum
        }
        WTUR1_MW_loss {
          sum
        }
        WTUR1_per_loadFactor {
          avg
        }
        WTUR1_per_efficiency {
          avg
        }
        WNAC1_ExTmp_mag_f {
          avg
        }
        WNAC1_WdSpd_mag_f {
          avg
        }
        WNAC1_WdDir_mag_f {
          avg
        }
        WNAC1_Dir_mag_f {
          avg
        }
      }
      metaData {
        dataAquisitionMax {
          unixTimestamp
        }
      }
      parkSubType {
        name
        info {
          type
          qty
          hubHeight
          ratedPower
          diameter
        }
      }
      turbines {
        code: codeDisplay
        serialNav
        serial
        hubHeight
        type
        data {
          WTUR1_status
          WTUR1_kW_mag_f
          WTUR1_kW_theoretical
          WTUR1_kW_loss
          WTUR1_kW_rated
          WTUR1_per_loadFactor
          WTUR1_per_efficiency
          LPHD1_PhyHealth_stVal
          WNAC1_WdDir_mag_f
          WNAC1_WdSpd_mag_f
          WNAC1_ExTmp_mag_f
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OverviewBoardCustomPortfolioGQL extends Apollo.Subscription<OverviewBoardCustomPortfolioSubscription, OverviewBoardCustomPortfolioSubscriptionVariables> {
    document = OverviewBoardCustomPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OverviewBoardDocument = gql`
    subscription OverviewBoard {
  parks(sort: {name: ASC}) {
    country {
      code
      name
      country_image
    }
    lat
    lon
    name
    code
    fe_name
    dataDebbug {
      WTUR1_MW_rated {
        sum
      }
    }
    data {
      WTUR1_MW_mag_f {
        sum
      }
      WTUR1_MW_theoretical {
        sum
      }
      WTUR1_MW_rated {
        sum
      }
      WTUR1_MW_loss {
        sum
      }
    }
    turbines {
      code: codeDisplay
      serialNav
      serial
      hubHeight
      type
      data {
        WTUR1_status
        WTUR1_kW_mag_f
        WTUR1_kW_theoretical
        WTUR1_kW_loss
        WTUR1_kW_rated
        LPHD1_PhyHealth_stVal
        WNAC1_WdDir_mag_f
        WNAC1_WdSpd_mag_f
        WNAC1_ExTmp_mag_f
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OverviewBoardGQL extends Apollo.Subscription<OverviewBoardSubscription, OverviewBoardSubscriptionVariables> {
    document = OverviewBoardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OverviewBoardParkDocument = gql`
    subscription OverviewBoardPark($parkCode: String!) {
  parks(where: {code: $parkCode}) {
    country {
      code
      name
      country_image
    }
    lat
    lon
    name
    code
    fe_name
    dataDebbug {
      WTUR1_MW_rated {
        sum
      }
    }
    data {
      WTUR1_MW_mag_f {
        sum
      }
      WTUR1_MW_theoretical {
        sum
      }
      WTUR1_MW_rated {
        sum
      }
      WTUR1_MW_loss {
        sum
      }
    }
    turbines {
      code: codeDisplay
      serialNav
      serial
      hubHeight
      type
      data {
        WTUR1_status
        WTUR1_kW_mag_f
        WTUR1_kW_theoretical
        WTUR1_kW_loss
        WTUR1_kW_rated
        LPHD1_PhyHealth_stVal
        WNAC1_WdDir_mag_f
        WNAC1_WdSpd_mag_f
        WNAC1_ExTmp_mag_f
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OverviewBoardParkGQL extends Apollo.Subscription<OverviewBoardParkSubscription, OverviewBoardParkSubscriptionVariables> {
    document = OverviewBoardParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ParkModalInfoDocument = gql`
    query ParkModalInfo($name: String) {
  parks(where: {name: $name}) {
    name
    anualProdEst
    commissioned
    lat
    lon
    country {
      name
      code
      country_image
    }
    dataDebbug {
      WTUR1_MW_rated {
        sum
      }
    }
    parkSubType {
      name
      info {
        type
        qty
        diameter
        oem
        ratedPower
        hubHeight
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ParkModalInfoGQL extends Apollo.Query<ParkModalInfoQuery, ParkModalInfoQueryVariables> {
    document = ParkModalInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnassignProcessToTurbineLogbookDocument = gql`
    mutation unassignProcessToTurbineLogbook($_id: String, $mutTS: Float, $blockActionsLog: String) {
  unassignProcessToTurbineLogbook(
    _id: $_id
    mutTS: $mutTS
    blockActionsLog: $blockActionsLog
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnassignProcessToTurbineLogbookGQL extends Apollo.Mutation<UnassignProcessToTurbineLogbookMutation, UnassignProcessToTurbineLogbookMutationVariables> {
    document = UnassignProcessToTurbineLogbookDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTemplatesDocument = gql`
    query getTemplates($whereInput: ReportTemplateWhereInput) {
  reportTemplates(where: $whereInput) {
    _id
    _id_portfolio
    createdBy
    createdTs
    editedBy
    editedTs
    name
    report
    schedule
    isDefaultTemplate
    creatorName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTemplatesGQL extends Apollo.Query<GetTemplatesQuery, GetTemplatesQueryVariables> {
    document = GetTemplatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReportsDocument = gql`
    query getReports($whereInput: ReportWhereInput = {}) {
  reports(where: $whereInput) {
    _id
    createdBy
    createdTs
    editedBy
    editedTs
    fkPortfolio_id
    report_id
    name
    report
    shared
    schedule
    isDefaultTemplate
    creatorName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetReportsGQL extends Apollo.Query<GetReportsQuery, GetReportsQueryVariables> {
    document = GetReportsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetImagesDocument = gql`
    query getImages($whereInput: ImagesWhereInput = {}) {
  images(where: $whereInput) {
    _id
    name
    originalName
    description
    createdBy
    createdTs
    fileExtension
    username
    scope
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetImagesGQL extends Apollo.Query<GetImagesQuery, GetImagesQueryVariables> {
    document = GetImagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateReportDocument = gql`
    mutation createReport($report: ReportSchemaInput) {
  createReport(report: $report) {
    _id
    createdBy
    createdTs
    editedBy
    editedTs
    fkPortfolio_id
    report_id
    name
    report
    shared
    schedule
    isDefaultTemplate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateReportGQL extends Apollo.Mutation<CreateReportMutation, CreateReportMutationVariables> {
    document = CreateReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteReportDocument = gql`
    mutation deleteReport($id: ID) {
  deleteReport(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteReportGQL extends Apollo.Mutation<DeleteReportMutation, DeleteReportMutationVariables> {
    document = DeleteReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateReportDocument = gql`
    mutation updateReport($report: ReportSchemaInput) {
  updateReport(report: $report)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateReportGQL extends Apollo.Mutation<UpdateReportMutation, UpdateReportMutationVariables> {
    document = UpdateReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTemplateDocument = gql`
    mutation createTemplate($schedule: String, $isDefaultTemplate: Boolean, $report: String, $name: String) {
  createReportTemplate(
    schedule: $schedule
    isDefaultTemplate: $isDefaultTemplate
    report: $report
    name: $name
  ) {
    success
    message
    reportTemplate {
      _id
      _id_portfolio
      createdBy
      createdTs
      editedBy
      editedTs
      name
      report
      schedule
      isDefaultTemplate
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTemplateGQL extends Apollo.Mutation<CreateTemplateMutation, CreateTemplateMutationVariables> {
    document = CreateTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTemplateDocument = gql`
    mutation updateTemplate($id: String!, $schedule: String, $isDefaultTemplate: Boolean, $report: String, $name: String) {
  editReportTemplate(
    id: $id
    schedule: $schedule
    isDefaultTemplate: $isDefaultTemplate
    report: $report
    name: $name
  ) {
    success
    message
    reportTemplate {
      _id
      editedTs
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTemplateGQL extends Apollo.Mutation<UpdateTemplateMutation, UpdateTemplateMutationVariables> {
    document = UpdateTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteTemplateDocument = gql`
    mutation deleteTemplate($id: String!) {
  deleteReportTemplate(id: $id) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteTemplateGQL extends Apollo.Mutation<DeleteTemplateMutation, DeleteTemplateMutationVariables> {
    document = DeleteTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendReportEmailDocument = gql`
    mutation sendReportEmail($reportId: String!, $emails: [String]!) {
  sendReportEmail(reportId: $reportId, emails: $emails)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendReportEmailGQL extends Apollo.Mutation<SendReportEmailMutation, SendReportEmailMutationVariables> {
    document = SendReportEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ParkStoreDocument = gql`
    query ParkStore {
  parks {
    name
    fe_name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ParkStoreGQL extends Apollo.Query<ParkStoreQuery, ParkStoreQueryVariables> {
    document = ParkStoreDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LastSeenTurbinesDocument = gql`
    query LastSeenTurbines($serialNav: Float!) {
  turbines(where: {serialNav: $serialNav}) {
    code: codeDisplay
    serialNav
    data {
      WTUR1_status
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LastSeenTurbinesGQL extends Apollo.Query<LastSeenTurbinesQuery, LastSeenTurbinesQueryVariables> {
    document = LastSeenTurbinesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TurbineSerialDocument = gql`
    query TurbineSerial($serialNav: Float!) {
  turbines(where: {serialNav: $serialNav}) {
    serial
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TurbineSerialGQL extends Apollo.Query<TurbineSerialQuery, TurbineSerialQueryVariables> {
    document = TurbineSerialDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SignalsByTurbineDocument = gql`
    query SignalsByTurbine($serialNav: Float!) {
  turbines(where: {serialNav: $serialNav}) {
    code: codeDisplay
    signalsList(stream: s10m, filter: tmp) {
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SignalsByTurbineGQL extends Apollo.Query<SignalsByTurbineQuery, SignalsByTurbineQueryVariables> {
    document = SignalsByTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SignalsListByTurbineDocument = gql`
    query SignalsListByTurbine($serialNav: Float!) {
  turbines(where: {serialNav: $serialNav}) {
    serialNav
    signalsList30s: signalsList(stream: s30s, filter: all) {
      unit
      name
      signalGroupType
    }
    temperature30s: signalsList(stream: s30s, filter: tmp) {
      name
      unit
    }
    signalsList10m: signalsList(stream: s10m, filter: all) {
      unit
      name
      signalGroupType
    }
    temperature10m: signalsList(stream: s10m, filter: tmp) {
      name
      unit
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SignalsListByTurbineGQL extends Apollo.Query<SignalsListByTurbineQuery, SignalsListByTurbineQueryVariables> {
    document = SignalsListByTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PortfolioDocument = gql`
    query portfolio {
  portfolios {
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PortfolioGQL extends Apollo.Query<PortfolioQuery, PortfolioQueryVariables> {
    document = PortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ControlroomAckDocument = gql`
    mutation controlroomAck($userName: String!, $userEmail: String!, $turbineCode: String!, $_id_alarm: String!) {
  controlroomAck(
    userName: $userName
    userEmail: $userEmail
    turbineCode: $turbineCode
    _id_alarm: $_id_alarm
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ControlroomAckGQL extends Apollo.Mutation<ControlroomAckMutation, ControlroomAckMutationVariables> {
    document = ControlroomAckDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ControlroomCreateTicketDocument = gql`
    mutation controlroomCreateTicket($_id_alarm: String!, $alarmCategory: Int!, $code: String!, $description: String!, $createTS: Float!, $isOpen: Boolean!, $userName: String!, $userEmail: String!, $turbineCode: String!, $turbineStatus: String!) {
  controlroomCreateTicket(
    _id_alarm: $_id_alarm
    alarmCategory: $alarmCategory
    code: $code
    description: $description
    createTS: $createTS
    isOpen: $isOpen
    userName: $userName
    userEmail: $userEmail
    turbineCode: $turbineCode
    turbineStatus: $turbineStatus
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ControlroomCreateTicketGQL extends Apollo.Mutation<ControlroomCreateTicketMutation, ControlroomCreateTicketMutationVariables> {
    document = ControlroomCreateTicketDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LiveInformationPortfolioDocument = gql`
    subscription LiveInformationPortfolio($id: String, $parks: [ID]) {
  portfolios(when: {_id: $id}, parks: $parks) {
    data {
      WTUR1_W_mag_f {
        sum
      }
      WTUR1_W_loss {
        sum
      }
      WTUR1_W_theoretical {
        sum
      }
    }
    dataDebbug {
      WTUR1_W_rated {
        sum
      }
    }
    alarms(open: true) {
      _id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LiveInformationPortfolioGQL extends Apollo.Subscription<LiveInformationPortfolioSubscription, LiveInformationPortfolioSubscriptionVariables> {
    document = LiveInformationPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LiveInformationParkDocument = gql`
    subscription LiveInformationPark($name: String, $turbines: [ID]) {
  parks(where: {name: $name}, turbines: $turbines) {
    fe_name
    availableSignalCount
    totalSignalCount
    metaData {
      dataAquisitionMax {
        unixTimestamp
      }
    }
    alarms(open: true, sort: {createTS: DESC}) {
      isOpen
    }
    data {
      WTUR1_W_mag_f {
        sum
      }
      WTUR1_W_loss {
        sum
      }
      WTUR1_W_theoretical {
        sum
      }
      WTUR1_per_loadFactor {
        avg
      }
      WTUR1_per_efficiency {
        avg
      }
    }
    dataDebbug {
      WTUR1_W_rated {
        sum
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LiveInformationParkGQL extends Apollo.Subscription<LiveInformationParkSubscription, LiveInformationParkSubscriptionVariables> {
    document = LiveInformationParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LiveInformationTurbineDocument = gql`
    subscription LiveInformationTurbine($serialNav: Float!) {
  turbines(where: {serialNav: $serialNav}) {
    code: codeDisplay
    serialNav
    ratedPower
    data {
      LDAT1_TmUTC_setTm_rounded
      WTUR1_status
      LPHD1_PhyHealth_stVal
      WTUR1_TurSt_actSt_stVal
      WTUR1_kW_mag_f
      WTUR1_kW_loss
      WTUR1_kW_theoretical
    }
    alarmCount(open: true)
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LiveInformationTurbineGQL extends Apollo.Subscription<LiveInformationTurbineSubscription, LiveInformationTurbineSubscriptionVariables> {
    document = LiveInformationTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OverviewAlarmsPortfolioDocument = gql`
    subscription OverviewAlarmsPortfolio($id: String, $sort: AlarmSortInput, $limit: Int!, $offset: Int!, $hours: Int!, $code: [String], $alarmCategory: [Int], $open: Boolean, $controlroomAck: Boolean, $controlroomTicketing: Boolean, $parks: [ID]) {
  portfolios(when: {_id: $id}, subscriptionInterval: 60, parks: $parks) {
    alarmCount(
      hours: $hours
      open: $open
      code: $code
      alarmCategory: $alarmCategory
      controlroomAck: $controlroomAck
      controlroomTicketing: $controlroomTicketing
    )
    alarms(
      limit: $limit
      offset: $offset
      sort: $sort
      hours: $hours
      open: $open
      code: $code
      alarmCategory: $alarmCategory
      controlroomAck: $controlroomAck
      controlroomTicketing: $controlroomTicketing
    ) {
      _id
      _id_alarm
      createTS
      closeTS
      duration
      durationLong
      productionLoss
      code
      description
      isOpen
      alarmCategory
      controlroomAck
      controlroomAckLog
      controlroomTicketing
      controlroomTicketingLog
      tickets {
        id
        number_id
      }
      hasPlannedEvent
      events {
        _id
        _id_process
        startTs
        endTs
        description
        category
        title
      }
      turbine {
        _id
        code: codeDisplay
        name
        serial
        serialNav
        serialDisplay
        park {
          name
          fe_name
        }
        data {
          WTUR1_status
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OverviewAlarmsPortfolioGQL extends Apollo.Subscription<OverviewAlarmsPortfolioSubscription, OverviewAlarmsPortfolioSubscriptionVariables> {
    document = OverviewAlarmsPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OverviewAlarmsParkDocument = gql`
    subscription OverviewAlarmsPark($name: String, $limit: Int!, $offset: Int!, $sort: AlarmSortInput, $hours: Int!, $alarmCategory: [Int], $open: Boolean, $controlroomAck: Boolean, $controlroomTicketing: Boolean, $turbines: [ID], $code: [String]) {
  parks(where: {name: $name}, turbines: $turbines) {
    alarmCount(
      hours: $hours
      open: $open
      alarmCategory: $alarmCategory
      controlroomAck: $controlroomAck
      controlroomTicketing: $controlroomTicketing
      code: $code
    )
    alarms(
      limit: $limit
      offset: $offset
      sort: $sort
      hours: $hours
      open: $open
      alarmCategory: $alarmCategory
      controlroomAck: $controlroomAck
      controlroomTicketing: $controlroomTicketing
      code: $code
    ) {
      _id
      _id_alarm
      createTS
      closeTS
      duration
      durationLong
      productionLoss
      code
      description
      isOpen
      alarmCategory
      controlroomAck
      controlroomAckLog
      controlroomTicketing
      controlroomTicketingLog
      tickets {
        id
        number_id
      }
      hasPlannedEvent
      events {
        _id
        _id_process
        startTs
        endTs
        category
        description
        title
      }
      turbine {
        _id
        code: codeDisplay
        name
        serial
        serialNav
        serialDisplay
        park {
          name
          fe_name
        }
        data {
          WTUR1_status
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OverviewAlarmsParkGQL extends Apollo.Subscription<OverviewAlarmsParkSubscription, OverviewAlarmsParkSubscriptionVariables> {
    document = OverviewAlarmsParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserPreferencesOverviewDocument = gql`
    query UserPreferencesOverview {
  user {
    preferences {
      overviewBoardSortingConfiguration {
        active {
          label
          value
        }
        options {
          label
          value
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserPreferencesOverviewGQL extends Apollo.Query<UserPreferencesOverviewQuery, UserPreferencesOverviewQueryVariables> {
    document = UserPreferencesOverviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetOverviewBoardSortDocument = gql`
    mutation SetOverviewBoardSort($preferences: PreferencesInput!) {
  setPreferences(preferences: $preferences) {
    overviewBoardSortingConfiguration {
      active {
        label
        value
      }
      options {
        label
        value
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetOverviewBoardSortGQL extends Apollo.Mutation<SetOverviewBoardSortMutation, SetOverviewBoardSortMutationVariables> {
    document = SetOverviewBoardSortDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserPortfoliosDocument = gql`
    query UserPortfolios {
  user {
    _id
    username
    preferences {
      parkMenu {
        active {
          value
        }
      }
      headerDropdownColorType {
        active {
          label
          value
        }
        options {
          label
          value
        }
      }
    }
    user_portfolios {
      _id
      defaultPortfolio
      name
      parks {
        _id
        name
        fe_name
        code
        displayCode
        energyMeterAvailable
        country {
          name
          code
          country_image
        }
        lat
        lon
        data {
          WTUR1_status {
            min
          }
          WTUR1_per_efficiency {
            avg
          }
          WTUR1_per_loadFactor {
            avg
          }
        }
        turbines {
          _id
          name
          code: codeDisplay
          codeDisplay
          serial
          serialNav
          data {
            WTUR1_status
            WTUR1_per_efficiency
            WTUR1_per_loadFactor
          }
        }
      }
    }
    available_parks {
      name
      _id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserPortfoliosGQL extends Apollo.Query<UserPortfoliosQuery, UserPortfoliosQueryVariables> {
    document = UserPortfoliosDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserPortfoliosWithAllParksAndTurbinesDocument = gql`
    subscription UserPortfoliosWithAllParksAndTurbines {
  user {
    _id
    username
    preferences {
      parkMenu {
        active {
          value
        }
      }
      headerDropdownColorType {
        active {
          label
          value
        }
        options {
          label
          value
        }
      }
    }
    user_portfolios {
      _id
      defaultPortfolio
      name
      parks {
        _id
        name
        fe_name
        code
        displayCode
        energyMeterAvailable
        country {
          name
          code
          country_image
        }
        lat
        lon
        data {
          WTUR1_status {
            min
          }
          WTUR1_per_efficiency {
            avg
          }
          WTUR1_per_loadFactor {
            avg
          }
        }
        turbines {
          _id
          name
          code: codeDisplay
          codeDisplay
          serial
          serialNav
          serialDisplay
          data {
            WTUR1_status
            WTUR1_per_efficiency
            WTUR1_per_loadFactor
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserPortfoliosWithAllParksAndTurbinesGQL extends Apollo.Subscription<UserPortfoliosWithAllParksAndTurbinesSubscription, UserPortfoliosWithAllParksAndTurbinesSubscriptionVariables> {
    document = UserPortfoliosWithAllParksAndTurbinesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserCountriesDocument = gql`
    query UserCountries {
  countries {
    _id
    name
    parks {
      _id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserCountriesGQL extends Apollo.Query<UserCountriesQuery, UserCountriesQueryVariables> {
    document = UserCountriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserPortfolioDropdownDocument = gql`
    query UserPortfolioDropdown {
  user {
    _id
    user_portfolios {
      _id
      defaultPortfolio
      name
      parks {
        _id
        name
        code
        turbines {
          _id
          code: codeDisplay
          name
          serial
          serialNav
          codeDisplay
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserPortfolioDropdownGQL extends Apollo.Query<UserPortfolioDropdownQuery, UserPortfolioDropdownQueryVariables> {
    document = UserPortfolioDropdownDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DefaultUserPortfolioDocument = gql`
    query DefaultUserPortfolio {
  user {
    _id
    user_portfolios(when: {defaultPortfolio: true}) {
      _id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DefaultUserPortfolioGQL extends Apollo.Query<DefaultUserPortfolioQuery, DefaultUserPortfolioQueryVariables> {
    document = DefaultUserPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePortfolioDocument = gql`
    mutation createPortfolio($portfolio: UserCustomPortfolioInput!) {
  createUserCustomPortfolio(userPortfolios: $portfolio) {
    _id
    defaultPortfolio
    name
    parks {
      _id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePortfolioGQL extends Apollo.Mutation<CreatePortfolioMutation, CreatePortfolioMutationVariables> {
    document = CreatePortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePortfolioDocument = gql`
    mutation deletePortfolio($portfolio: String!) {
  deleteUserCustomPortfolio(_id: $portfolio)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePortfolioGQL extends Apollo.Mutation<DeletePortfolioMutation, DeletePortfolioMutationVariables> {
    document = DeletePortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePortfolioDocument = gql`
    mutation updatePortfolio($portfolio: UserCustomPortfolioInput!) {
  updateUserCustomPortfolio(userPortfolios: $portfolio) {
    _id
    name
    parks {
      _id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePortfolioGQL extends Apollo.Mutation<UpdatePortfolioMutation, UpdatePortfolioMutationVariables> {
    document = UpdatePortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetDefaultPortfolioDocument = gql`
    mutation setDefaultPortfolio($_id: String!) {
  setDefaultCustomPortfolio(_id: $_id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetDefaultPortfolioGQL extends Apollo.Mutation<SetDefaultPortfolioMutation, SetDefaultPortfolioMutationVariables> {
    document = SetDefaultPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllUserPortfoliosDocument = gql`
    query AllUserPortfolios {
  user {
    user_portfolios {
      _id
      defaultPortfolio
      name
      parks {
        _id
        energyMeterAvailable
        name
        code
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllUserPortfoliosGQL extends Apollo.Query<AllUserPortfoliosQuery, AllUserPortfoliosQueryVariables> {
    document = AllUserPortfoliosDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetKpiVsTargetTableCustomSettingsDocument = gql`
    query getKpiVsTargetTableCustomSettings($parkName: String!, $tableUniqueName: String) {
  user {
    _id
    getKpiVsTargetTableCustomSettings(
      parkName: $parkName
      tableUniqueName: $tableUniqueName
    ) {
      customizationTable
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetKpiVsTargetTableCustomSettingsGQL extends Apollo.Query<GetKpiVsTargetTableCustomSettingsQuery, GetKpiVsTargetTableCustomSettingsQueryVariables> {
    document = GetKpiVsTargetTableCustomSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetKpiVsTargetTableSettingDocument = gql`
    mutation setKpiVsTargetTableSetting($userId: ID!, $parkName: String!, $customizationTable: String!, $tableUniqueName: String) {
  setKpiVsTargetTableCustomSettings(
    userId: $userId
    parkName: $parkName
    customizationTable: $customizationTable
    tableUniqueName: $tableUniqueName
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetKpiVsTargetTableSettingGQL extends Apollo.Mutation<SetKpiVsTargetTableSettingMutation, SetKpiVsTargetTableSettingMutationVariables> {
    document = SetKpiVsTargetTableSettingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IsOtpEnabledDocument = gql`
    query isOTPEnabled {
  user {
    securityPreferences {
      isTotpEnabled
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IsOtpEnabledGQL extends Apollo.Query<IsOtpEnabledQuery, IsOtpEnabledQueryVariables> {
    document = IsOtpEnabledDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RequestOtpConfigEmailDocument = gql`
    mutation requestOTPConfigEmail {
  requestOtpConfigEmail
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RequestOtpConfigEmailGQL extends Apollo.Mutation<RequestOtpConfigEmailMutation, RequestOtpConfigEmailMutationVariables> {
    document = RequestOtpConfigEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RequestPasswordResetEmailDocument = gql`
    mutation requestPasswordResetEmail {
  requestPasswordResetEmail
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RequestPasswordResetEmailGQL extends Apollo.Mutation<RequestPasswordResetEmailMutation, RequestPasswordResetEmailMutationVariables> {
    document = RequestPasswordResetEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveConfiguredToptDocument = gql`
    mutation removeConfiguredTopt {
  removeConfiguredTopt
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveConfiguredToptGQL extends Apollo.Mutation<RemoveConfiguredToptMutation, RemoveConfiguredToptMutationVariables> {
    document = RemoveConfiguredToptDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetPreferencesDocument = gql`
    mutation setPreferences($preferences: PreferencesInput!) {
  setPreferences(preferences: $preferences) {
    parkMenu {
      active {
        label
        value
      }
      options {
        label
        value
      }
    }
    headerDropdownColorType {
      active {
        label
        value
      }
      options {
        label
        value
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetPreferencesGQL extends Apollo.Mutation<SetPreferencesMutation, SetPreferencesMutationVariables> {
    document = SetPreferencesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserInfoDocument = gql`
    query getUserInfo {
  user {
    _id
    preferences {
      parkMenu {
        active {
          label
          value
        }
        options {
          label
          value
        }
      }
      headerDropdownColorType {
        active {
          label
          value
        }
        options {
          label
          value
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserInfoGQL extends Apollo.Query<GetUserInfoQuery, GetUserInfoQueryVariables> {
    document = GetUserInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllUserInfoDocument = gql`
    query getAllUserInfo {
  user {
    _id
    username
    full_name
    name
    last_name
    email
    position
    portfolioRights
    attributes {
      country
      company
      language
    }
    preferences {
      parkMenu {
        active {
          label
          value
        }
        options {
          label
          value
        }
      }
      headerDropdownColorType {
        active {
          label
          value
        }
        options {
          label
          value
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllUserInfoGQL extends Apollo.Query<GetAllUserInfoQuery, GetAllUserInfoQueryVariables> {
    document = GetAllUserInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BindUserDocument = gql`
    mutation bindUser {
  bindUser
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BindUserGQL extends Apollo.Mutation<BindUserMutation, BindUserMutationVariables> {
    document = BindUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAlarmsForTicketsDocument = gql`
    query getAlarmsForTickets($parks: [ID], $hours: Int) {
  portfolios(parks: $parks) {
    alarms(hours: $hours) {
      _id
      createTS
      closeTS
      isOpen
      duration
      code
      description
      alarmCategory
      turbine {
        _id
        code: codeDisplay
        serialNav
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAlarmsForTicketsGQL extends Apollo.Query<GetAlarmsForTicketsQuery, GetAlarmsForTicketsQueryVariables> {
    document = GetAlarmsForTicketsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeColumnOrderDocument = gql`
    mutation changeColumnOrder($input: ChangeOrderStatusInput) {
  changeStatusOrder(input: $input) {
    statuses {
      _id
      name
      hide
      color
      order
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeColumnOrderGQL extends Apollo.Mutation<ChangeColumnOrderMutation, ChangeColumnOrderMutationVariables> {
    document = ChangeColumnOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const HideColumnDocument = gql`
    mutation hideColumn($input: HideColumnInput) {
  hideColumn(input: $input) {
    statuses {
      _id
      name
      hide
      color
      order
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class HideColumnGQL extends Apollo.Mutation<HideColumnMutation, HideColumnMutationVariables> {
    document = HideColumnDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTicketsForPortfolioDocument = gql`
    query getTicketsForPortfolio($boardId: ID!, $parks: [ID], $ifArchive: Boolean, $ifDelete: Boolean) {
  portfolios(parks: $parks) {
    tickets(boardId: $boardId, ifArchive: $ifArchive, ifDelete: $ifDelete) {
      _id
      _id_board
      _id_status
      _id_template
      number
      title
      priority
      totalComments
      createdBy_id
      createdBy_username
      createdOn
      modifiedBy_id
      modifiedOn
      modifiedBy_username
      assets
      assignees
      modules
      isFavorite
      isArchive
      dueDate {
        start
        end
      }
      notification {
        id
        notify_assignee
        notify_comment
        notify_status
      }
      timeToDelete
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTicketsForPortfolioGQL extends Apollo.Query<GetTicketsForPortfolioQuery, GetTicketsForPortfolioQueryVariables> {
    document = GetTicketsForPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTicketsForParkDocument = gql`
    query getTicketsForPark($boardId: ID!, $parkId: ID!, $turbines: [ID!], $ifArchive: Boolean, $ifDelete: Boolean) {
  parks(where: {_id: $parkId}, turbines: $turbines) {
    tickets(boardId: $boardId, ifArchive: $ifArchive, ifDelete: $ifDelete) {
      _id
      _id_board
      _id_status
      _id_template
      number
      title
      priority
      totalComments
      createdBy_id
      createdBy_username
      createdOn
      modifiedBy_id
      modifiedOn
      modifiedBy_username
      assets
      assignees
      modules
      isFavorite
      isArchive
      dueDate {
        start
        end
      }
      notification {
        id
        notify_assignee
        notify_comment
        notify_status
      }
      timeToDelete
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTicketsForParkGQL extends Apollo.Query<GetTicketsForParkQuery, GetTicketsForParkQueryVariables> {
    document = GetTicketsForParkDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTicketsForTurbineDocument = gql`
    query getTicketsForTurbine($boardId: ID!, $turbineId: String!, $ifArchive: Boolean, $ifDelete: Boolean) {
  turbines(where: {_id: $turbineId}) {
    tickets(boardId: $boardId, ifArchive: $ifArchive, ifDelete: $ifDelete) {
      _id
      _id_board
      _id_status
      _id_template
      number
      title
      priority
      totalComments
      createdBy_id
      createdBy_username
      createdOn
      modifiedBy_id
      modifiedOn
      modifiedBy_username
      assets
      assignees
      modules
      isFavorite
      isArchive
      dueDate {
        start
        end
      }
      notification {
        id
        notify_assignee
        notify_comment
        notify_status
      }
      timeToDelete
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTicketsForTurbineGQL extends Apollo.Query<GetTicketsForTurbineQuery, GetTicketsForTurbineQueryVariables> {
    document = GetTicketsForTurbineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTicketDocument = gql`
    mutation createTicket($id_board: ID!, $id_status: ID!, $id_template: ID!, $title: String!, $assets: [String]) {
  createTicket(
    input: {id_board: $id_board, id_status: $id_status, id_template: $id_template, title: $title, assets: $assets}
  ) {
    _id
    _id_board
    _id_status
    _id_template
    number
    title
    priority
    totalComments
    createdBy_id
    createdBy_username
    createdOn
    modifiedBy_id
    modifiedOn
    modifiedBy_username
    assets
    assignees
    modules
    isFavorite
    dueDate {
      start
      end
    }
    notification {
      id
      notify_assignee
      notify_comment
      notify_status
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTicketGQL extends Apollo.Mutation<CreateTicketMutation, CreateTicketMutationVariables> {
    document = CreateTicketDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTicketDocument = gql`
    query getTicket($id: Int!) {
  ticket(id: $id) {
    _id
    _id_board
    _id_status
    _id_template
    number
    title
    priority
    totalComments
    createdBy_id
    createdBy_username
    createdOn
    modifiedBy_id
    modifiedOn
    modifiedBy_username
    assets
    assignees
    modules
    isFavorite
    isArchive
    dueDate {
      start
      end
    }
    notification {
      id
      notify_assignee
      notify_comment
      notify_status
    }
    timeToDelete
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTicketGQL extends Apollo.Query<GetTicketQuery, GetTicketQueryVariables> {
    document = GetTicketDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTicketInformationDocument = gql`
    query getTicketInformation($id: Int!) {
  ticket(id: $id) {
    information {
      description
      attachments {
        id
        id_ticket
        name
        originalName
        createdBy
        createdTs
        fileExtension
        size
        username
        id_comment
      }
      customFields {
        id
        name
        type
        order
        parentId
        ... on CustomFieldNumber {
          number: value
        }
        ... on CustomFieldString {
          string: value
        }
        ... on CustomFieldDate {
          number: value
        }
        ... on CustomFieldCheckbox {
          boolean: value
        }
        ... on CustomFieldChecklist {
          value {
            name
            checked
          }
        }
        ... on CustomFieldDropdown {
          value {
            name
            checked
          }
        }
        ... on CustomFieldGroup {
          value {
            id
            name
            order
            parentId
            type
            ... on CustomFieldDate {
              number: value
            }
            ... on CustomFieldNumber {
              number: value
            }
            ... on CustomFieldString {
              string: value
            }
            ... on CustomFieldCheckbox {
              boolean: value
            }
            ... on CustomFieldChecklist {
              value {
                name
                checked
              }
            }
            ... on CustomFieldDropdown {
              value {
                name
                checked
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTicketInformationGQL extends Apollo.Query<GetTicketInformationQuery, GetTicketInformationQueryVariables> {
    document = GetTicketInformationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTicketIntegrationsDocument = gql`
    query getTicketIntegrations($id: Int!) {
  ticket(id: $id) {
    integrations {
      _id_integration
      type
      productionLoss
      dateRange {
        start
        end
      }
      __typename
      ... on Troubleshoot {
        code
        description
        assetId
        isOpen
        category
        turbineInfo {
          id
          serial
          code: codeDisplay
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTicketIntegrationsGQL extends Apollo.Query<GetTicketIntegrationsQuery, GetTicketIntegrationsQueryVariables> {
    document = GetTicketIntegrationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTicketCommentsDocument = gql`
    query getTicketComments($id: Int!) {
  ticket(id: $id) {
    comments {
      username
      _id
      _id_user
      content
      createTs
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTicketCommentsGQL extends Apollo.Query<GetTicketCommentsQuery, GetTicketCommentsQueryVariables> {
    document = GetTicketCommentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTicketChangeLogDocument = gql`
    query getTicketChangeLog($id: Int!) {
  ticket(id: $id) {
    changeLogs {
      __typename
      action
      date
      subject {
        username
      }
      ... on CreatedChangeLog {
        ticketNumber
      }
      ... on UpdatedChangeLog {
        previous
        field
        current
      }
      ... on CustomChangeLog {
        field
        previous
        current
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTicketChangeLogGQL extends Apollo.Query<GetTicketChangeLogQuery, GetTicketChangeLogQueryVariables> {
    document = GetTicketChangeLogDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddTicketCommentDocument = gql`
    mutation addTicketComment($id_ticket: ID!, $content: String!) {
  addTicketComment(input: {id_ticket: $id_ticket, content: $content}) {
    _id
    _id_user
    username
    content
    createTs
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddTicketCommentGQL extends Apollo.Mutation<AddTicketCommentMutation, AddTicketCommentMutationVariables> {
    document = AddTicketCommentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangePriorityDocument = gql`
    mutation changePriority($id_ticket: ID!, $priority: TicketPriority!) {
  changeTicketPriority(input: {id_ticket: $id_ticket, priority: $priority}) {
    _id
    priority
    modifiedOn
    modifiedBy_username
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangePriorityGQL extends Apollo.Mutation<ChangePriorityMutation, ChangePriorityMutationVariables> {
    document = ChangePriorityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeTitleDocument = gql`
    mutation changeTitle($id_ticket: ID!, $title: String!) {
  changeTicketTitle(input: {id_ticket: $id_ticket, title: $title}) {
    _id
    title
    modifiedOn
    modifiedBy_username
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeTitleGQL extends Apollo.Mutation<ChangeTitleMutation, ChangeTitleMutationVariables> {
    document = ChangeTitleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeDueDateDocument = gql`
    mutation changeDueDate($id_ticket: ID!, $start: Float, $end: Float) {
  updateDueDate(
    input: {id_ticket: $id_ticket, dueDate: {start: $start, end: $end}}
  ) {
    _id
    dueDate {
      start
      end
    }
    modifiedOn
    modifiedBy_username
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeDueDateGQL extends Apollo.Mutation<ChangeDueDateMutation, ChangeDueDateMutationVariables> {
    document = ChangeDueDateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTicketAssetsDocument = gql`
    mutation updateTicketAssets($id_ticket: ID!, $assets: [ID]) {
  addAssets(input: {id_ticket: $id_ticket, assets: $assets}) {
    _id
    assets
    modifiedOn
    modifiedBy_username
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTicketAssetsGQL extends Apollo.Mutation<UpdateTicketAssetsMutation, UpdateTicketAssetsMutationVariables> {
    document = UpdateTicketAssetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeTicketStatusDocument = gql`
    mutation changeTicketStatus($id_ticket: ID!, $id_status: ID!) {
  changeTicketStatus(input: {id_ticket: $id_ticket, id_status: $id_status}) {
    _id
    _id_status
    modifiedOn
    modifiedBy_username
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeTicketStatusGQL extends Apollo.Mutation<ChangeTicketStatusMutation, ChangeTicketStatusMutationVariables> {
    document = ChangeTicketStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeTicketAssigneesDocument = gql`
    mutation changeTicketAssignees($id_ticket: ID!, $users: [ID]) {
  setTicketAssignees(input: {id_ticket: $id_ticket, users: $users}) {
    _id
    assignees
    modifiedOn
    modifiedBy_username
    notification {
      id
      notify_assignee
      notify_comment
      notify_status
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeTicketAssigneesGQL extends Apollo.Mutation<ChangeTicketAssigneesMutation, ChangeTicketAssigneesMutationVariables> {
    document = ChangeTicketAssigneesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeTicketBoardDocument = gql`
    mutation changeTicketBoard($id_ticket: ID!, $id_board: ID!) {
  updateTicketBoard(input: {id_ticket: $id_ticket, id_board: $id_board}) {
    _id
    _id_board
    modifiedOn
    modifiedBy_username
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeTicketBoardGQL extends Apollo.Mutation<ChangeTicketBoardMutation, ChangeTicketBoardMutationVariables> {
    document = ChangeTicketBoardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeTicketModulesDocument = gql`
    mutation changeTicketModules($id_ticket: ID!, $modules: [ID]!) {
  setTicketModules(input: {id_ticket: $id_ticket, modules: $modules}) {
    _id
    modules
    modifiedOn
    modifiedBy_username
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeTicketModulesGQL extends Apollo.Mutation<ChangeTicketModulesMutation, ChangeTicketModulesMutationVariables> {
    document = ChangeTicketModulesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeTicketTemplateDocument = gql`
    mutation changeTicketTemplate($id_ticket: ID!, $id_template: ID!) {
  updateTicketTemplate(input: {id_ticket: $id_ticket, id_template: $id_template}) {
    _id
    _id_template
    modifiedOn
    modifiedBy_username
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeTicketTemplateGQL extends Apollo.Mutation<ChangeTicketTemplateMutation, ChangeTicketTemplateMutationVariables> {
    document = ChangeTicketTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeTicketDescriptionDocument = gql`
    mutation changeTicketDescription($id_ticket: ID!, $description: String!) {
  setTicketDescription(input: {id_ticket: $id_ticket, description: $description}) {
    description
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeTicketDescriptionGQL extends Apollo.Mutation<ChangeTicketDescriptionMutation, ChangeTicketDescriptionMutationVariables> {
    document = ChangeTicketDescriptionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeTicketIsFavoriteDocument = gql`
    mutation changeTicketIsFavorite($id_ticket: ID!, $isFavorite: Boolean!) {
  changeFavState(input: {id_ticket: $id_ticket, isFavorite: $isFavorite}) {
    _id
    isFavorite
    modifiedOn
    modifiedBy_username
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeTicketIsFavoriteGQL extends Apollo.Mutation<ChangeTicketIsFavoriteMutation, ChangeTicketIsFavoriteMutationVariables> {
    document = ChangeTicketIsFavoriteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeTicketIsArchiveDocument = gql`
    mutation changeTicketIsArchive($id_ticket: ID!, $isArchive: Boolean!) {
  changeArchState(input: {id_ticket: $id_ticket, isArchive: $isArchive}) {
    _id
    isArchive
    modifiedOn
    modifiedBy_username
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeTicketIsArchiveGQL extends Apollo.Mutation<ChangeTicketIsArchiveMutation, ChangeTicketIsArchiveMutationVariables> {
    document = ChangeTicketIsArchiveDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeTicketNotificationDocument = gql`
    mutation changeTicketNotification($id_notification: ID!, $notify_assignee: Boolean!, $notify_comment: Boolean!, $notify_status: Boolean!) {
  updateNotification(
    input: {id_notification: $id_notification, notify_assignee: $notify_assignee, notify_comment: $notify_comment, notify_status: $notify_status}
  ) {
    id
    notify_assignee
    notify_comment
    notify_status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeTicketNotificationGQL extends Apollo.Mutation<ChangeTicketNotificationMutation, ChangeTicketNotificationMutationVariables> {
    document = ChangeTicketNotificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeDeleteTicketStateDocument = gql`
    mutation changeDeleteTicketState($id_ticket: ID!) {
  setDeleteTicketState(input: {id_ticket: $id_ticket}) {
    _id
    timeToDelete
    modifiedOn
    modifiedBy_username
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeDeleteTicketStateGQL extends Apollo.Mutation<ChangeDeleteTicketStateMutation, ChangeDeleteTicketStateMutationVariables> {
    document = ChangeDeleteTicketStateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteTicketPermanentlyDocument = gql`
    mutation deleteTicketPermanently($id_ticket: ID!) {
  deleteTicket(input: {id_ticket: $id_ticket})
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteTicketPermanentlyGQL extends Apollo.Mutation<DeleteTicketPermanentlyMutation, DeleteTicketPermanentlyMutationVariables> {
    document = DeleteTicketPermanentlyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddTicketCustomFieldDocument = gql`
    mutation addTicketCustomField($parent_id: ID!, $name: String!, $type: String!) {
  addTicketCustomField(input: {parent_id: $parent_id, name: $name, type: $type}) {
    customFields {
      id
      name
      type
      order
      parentId
      ... on CustomFieldNumber {
        number: value
      }
      ... on CustomFieldString {
        string: value
      }
      ... on CustomFieldDate {
        number: value
      }
      ... on CustomFieldCheckbox {
        boolean: value
      }
      ... on CustomFieldChecklist {
        value {
          name
          checked
        }
      }
      ... on CustomFieldDropdown {
        value {
          name
          checked
        }
      }
      ... on CustomFieldGroup {
        value {
          id
          name
          order
          parentId
          type
          ... on CustomFieldDate {
            number: value
          }
          ... on CustomFieldNumber {
            number: value
          }
          ... on CustomFieldString {
            string: value
          }
          ... on CustomFieldCheckbox {
            boolean: value
          }
          ... on CustomFieldChecklist {
            value {
              name
              checked
            }
          }
          ... on CustomFieldDropdown {
            value {
              name
              checked
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddTicketCustomFieldGQL extends Apollo.Mutation<AddTicketCustomFieldMutation, AddTicketCustomFieldMutationVariables> {
    document = AddTicketCustomFieldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeTicketCustomFieldNameDocument = gql`
    mutation changeTicketCustomFieldName($id: ID!, $value: String) {
  changeTicketCustomFieldName(input: {id: $id, value: $value})
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeTicketCustomFieldNameGQL extends Apollo.Mutation<ChangeTicketCustomFieldNameMutation, ChangeTicketCustomFieldNameMutationVariables> {
    document = ChangeTicketCustomFieldNameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeTicketCustomFieldDocument = gql`
    mutation changeTicketCustomField($id: ID!, $value: String, $order: Int, $parent_id: ID, $name: String) {
  changeTicketCustomField(
    input: {id: $id, value: $value, order: $order, parent_id: $parent_id, name: $name}
  ) {
    customFields {
      id
      name
      type
      order
      parentId
      ... on CustomFieldNumber {
        number: value
      }
      ... on CustomFieldString {
        string: value
      }
      ... on CustomFieldDate {
        number: value
      }
      ... on CustomFieldCheckbox {
        boolean: value
      }
      ... on CustomFieldChecklist {
        value {
          name
          checked
        }
      }
      ... on CustomFieldDropdown {
        value {
          name
          checked
        }
      }
      ... on CustomFieldGroup {
        value {
          id
          name
          order
          parentId
          type
          ... on CustomFieldDate {
            number: value
          }
          ... on CustomFieldNumber {
            number: value
          }
          ... on CustomFieldString {
            string: value
          }
          ... on CustomFieldCheckbox {
            boolean: value
          }
          ... on CustomFieldChecklist {
            value {
              name
              checked
            }
          }
          ... on CustomFieldDropdown {
            value {
              name
              checked
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeTicketCustomFieldGQL extends Apollo.Mutation<ChangeTicketCustomFieldMutation, ChangeTicketCustomFieldMutationVariables> {
    document = ChangeTicketCustomFieldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteTicketCustomFieldDocument = gql`
    mutation deleteTicketCustomField($id: ID!) {
  deleteTicketCustomField(input: {id: $id}) {
    customFields {
      id
      name
      type
      order
      parentId
      ... on CustomFieldNumber {
        number: value
      }
      ... on CustomFieldString {
        string: value
      }
      ... on CustomFieldDate {
        number: value
      }
      ... on CustomFieldCheckbox {
        boolean: value
      }
      ... on CustomFieldChecklist {
        value {
          name
          checked
        }
      }
      ... on CustomFieldDropdown {
        value {
          name
          checked
        }
      }
      ... on CustomFieldGroup {
        value {
          id
          name
          order
          parentId
          type
          ... on CustomFieldDate {
            number: value
          }
          ... on CustomFieldNumber {
            number: value
          }
          ... on CustomFieldString {
            string: value
          }
          ... on CustomFieldCheckbox {
            boolean: value
          }
          ... on CustomFieldChecklist {
            value {
              name
              checked
            }
          }
          ... on CustomFieldDropdown {
            value {
              name
              checked
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteTicketCustomFieldGQL extends Apollo.Mutation<DeleteTicketCustomFieldMutation, DeleteTicketCustomFieldMutationVariables> {
    document = DeleteTicketCustomFieldDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteTicketCommentDocument = gql`
    mutation deleteTicketComment($id: ID!, $id_ticket: ID!) {
  deleteTicketComment(input: {id: $id, id_ticket: $id_ticket})
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteTicketCommentGQL extends Apollo.Mutation<DeleteTicketCommentMutation, DeleteTicketCommentMutationVariables> {
    document = DeleteTicketCommentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteTicketIntegrationDocument = gql`
    mutation deleteTicketIntegration($id_ticket: ID!, $id_integration: ID!) {
  deleteTicketIntegration(
    input: {id_integration: $id_integration, id_ticket: $id_ticket}
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteTicketIntegrationGQL extends Apollo.Mutation<DeleteTicketIntegrationMutation, DeleteTicketIntegrationMutationVariables> {
    document = DeleteTicketIntegrationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeTicketIntegrationDocument = gql`
    mutation changeTicketIntegration($id_ticket: ID!, $integrations: [ID]!, $type: IntegrationType!) {
  setTicketIntegration(
    input: {id_ticket: $id_ticket, integrations: $integrations, type: $type}
  ) {
    _id_integration
    type
    productionLoss
    dateRange {
      start
      end
    }
    __typename
    ... on Troubleshoot {
      code
      description
      assetId
      isOpen
      category
      turbineInfo {
        id
        serial
        code: codeDisplay
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeTicketIntegrationGQL extends Apollo.Mutation<ChangeTicketIntegrationMutation, ChangeTicketIntegrationMutationVariables> {
    document = ChangeTicketIntegrationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetMultipleTicketsToMultipleIntegrationsDocument = gql`
    mutation setMultipleTicketsToMultipleIntegrations($tickets: [ID]!, $integrations: [ID]!, $devices: [ID]!, $type: IntegrationType!) {
  setMultipleTicketsToMultipleIntegrations(
    input: {id_tickets: $tickets, id_integrations: $integrations, id_devices: $devices, type: $type}
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetMultipleTicketsToMultipleIntegrationsGQL extends Apollo.Mutation<SetMultipleTicketsToMultipleIntegrationsMutation, SetMultipleTicketsToMultipleIntegrationsMutationVariables> {
    document = SetMultipleTicketsToMultipleIntegrationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddTicketAttachmentDocument = gql`
    mutation addTicketAttachment($id_ticket: ID!, $name: String!, $originalName: String!, $fileExtension: String!, $size: Int!) {
  addTicketAttachment(
    input: {id_ticket: $id_ticket, name: $name, originalName: $originalName, fileExtension: $fileExtension, size: $size}
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddTicketAttachmentGQL extends Apollo.Mutation<AddTicketAttachmentMutation, AddTicketAttachmentMutationVariables> {
    document = AddTicketAttachmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteTicketAttachmentDocument = gql`
    mutation deleteTicketAttachment($id: ID!) {
  deleteTicketAttachment(_id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteTicketAttachmentGQL extends Apollo.Mutation<DeleteTicketAttachmentMutation, DeleteTicketAttachmentMutationVariables> {
    document = DeleteTicketAttachmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserInformationForTicketingDocument = gql`
    query getUserInformationForTicketing {
  user {
    collegues {
      _id
      full_name
    }
    ticketTemplates {
      _id
      name
      customFields {
        name
        type
        order
      }
    }
    boards {
      _id
      name
      statuses {
        _id
        name
        hide
        color
        order
      }
    }
    ticketModules {
      name
      _id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserInformationForTicketingGQL extends Apollo.Query<GetUserInformationForTicketingQuery, GetUserInformationForTicketingQueryVariables> {
    document = GetUserInformationForTicketingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmErrorsWarningDocument = gql`
    subscription AlarmErrorsWarning($serialNav: Float!, $id: String) {
  turbines(where: {serialNav: $serialNav}) {
    alarms(_id: $id) {
      code
      alarms {
        code
        description
        createTS
        type
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmErrorsWarningGQL extends Apollo.Subscription<AlarmErrorsWarningSubscription, AlarmErrorsWarningSubscriptionVariables> {
    document = AlarmErrorsWarningDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmLogbookDocument = gql`
    subscription AlarmLogbook($serialNav: Float!, $startTS: Float!, $endTS: Float) {
  turbines(where: {serialNav: $serialNav}) {
    logbook(where: {startTS: $startTS, endTS: $endTS}, limit: 100, offset: 0) {
      createTS
      code
      type
      description
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmLogbookGQL extends Apollo.Subscription<AlarmLogbookSubscription, AlarmLogbookSubscriptionVariables> {
    document = AlarmLogbookDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmInformationDocument = gql`
    subscription AlarmInformation($serialNav: Float!, $id: String) {
  turbines(where: {serialNav: $serialNav}) {
    alarms(_id: $id) {
      _id
      _id_alarm
      code
      description
      createTS
      closeTS
      durationLong
      production
      productionLoss
      theoreticalProduction
      isOpen
      alarmCategory
      subBlocks
      controlroomAck
      controlroomAckLog
      controlroomTicketing
      controlroomTicketingLog
      turbine {
        code: codeDisplay
        name
        serial
        serialNav
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmInformationGQL extends Apollo.Subscription<AlarmInformationSubscription, AlarmInformationSubscriptionVariables> {
    document = AlarmInformationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlarmMainDocument = gql`
    subscription AlarmMain($serialNav: Float!, $id: String) {
  turbines(where: {serialNav: $serialNav}) {
    _id
    code
    codeDisplay
    serialNav
    alarms(_id: $id) {
      _id
      code
      description
      processed
      createTS
      isOpen
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlarmMainGQL extends Apollo.Subscription<AlarmMainSubscription, AlarmMainSubscriptionVariables> {
    document = AlarmMainDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }